import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CodeFeatures: any;
  CropinkJson: any;
  FigmaJson: any;
  Iterable: any;
  Json: any;
  LayerSettingsJson: any;
  ProductDataJson: any;
  StyleDefinitionJson: any;
  Survey: any;
  Upload: any;
};

export type AdAccount = Node & {
  adAccountId?: Maybe<Scalars['String']>;
  business?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdAccount. */
export type AdAccountCursorConnection = {
  edges?: Maybe<Array<Maybe<AdAccountEdge>>>;
  pageInfo: AdAccountPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdAccount. */
export type AdAccountEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdAccount>;
};

/** Information about the current page. */
export type AdAccountPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/**
 * User list for external integrations (role SYSTEM_ADMIN_API_READ): profile, teams and what each user pays for.
 * Exposes `fetchCollectionAdminBillingUsers` only - no item query, no mutations.
 */
export type AdminBillingUser = Node & {
  createdAt?: Maybe<Scalars['String']>;
  customers?: Maybe<Scalars['Iterable']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['Iterable']>;
  onboarding?: Maybe<Scalars['String']>;
  onboardingType?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  teams?: Maybe<Scalars['Iterable']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Page connection for AdminBillingUser. */
export type AdminBillingUserPageConnection = {
  collection?: Maybe<Array<Maybe<AdminBillingUser>>>;
  paginationInfo: AdminBillingUserPaginationInfo;
};

/** Information about the pagination. */
export type AdminBillingUserPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminDesign = Node & {
  designId?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  previewImageId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminDesign. */
export type AdminDesignCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminDesignEdge>>>;
  pageInfo: AdminDesignPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminDesign. */
export type AdminDesignEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminDesign>;
};

/** Information about the current page. */
export type AdminDesignPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type AdminElement = Node & {
  _id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  cropinkCode?: Maybe<Scalars['Iterable']>;
  cropinkCodeMeta?: Maybe<Scalars['Iterable']>;
  elementCategoryResources?: Maybe<Scalars['Iterable']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  previewImageId?: Maybe<Scalars['String']>;
};

export type AdminElementCategory = Node & {
  elementCategoryId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminElement. */
export type AdminElementCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminElementEdge>>>;
  pageInfo: AdminElementPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminElement. */
export type AdminElementEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminElement>;
};

/** Page connection for AdminElement. */
export type AdminElementPageConnection = {
  collection?: Maybe<Array<Maybe<AdminElement>>>;
  paginationInfo: AdminElementPaginationInfo;
};

/** Information about the current page. */
export type AdminElementPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminElementPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminFont = Node & {
  createdAt?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  fontId?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  postScript?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  weightName?: Maybe<Scalars['String']>;
};

export type AdminFonts = Node & {
  fonts?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
};

export type AdminLogo = Node & {
  createdAt?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  team?: Maybe<Scalars['Iterable']>;
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for AdminLogo. */
export type AdminLogoCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminLogoEdge>>>;
  pageInfo: AdminLogoPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminLogo. */
export type AdminLogoEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminLogo>;
};

/** Page connection for AdminLogo. */
export type AdminLogoPageConnection = {
  collection?: Maybe<Array<Maybe<AdminLogo>>>;
  paginationInfo: AdminLogoPaginationInfo;
};

/** Information about the current page. */
export type AdminLogoPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminLogoPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminProject = Node & {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  currentUpdate?: Maybe<Scalars['Iterable']>;
  currentUpdateId?: Maybe<Scalars['String']>;
  designs?: Maybe<Scalars['Iterable']>;
  feed?: Maybe<Scalars['Iterable']>;
  feedDownloadedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdate?: Maybe<Scalars['Iterable']>;
  lastUpdateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  projectInfo?: Maybe<Scalars['Iterable']>;
  projectTokens?: Maybe<Scalars['Iterable']>;
  settings?: Maybe<Scalars['Iterable']>;
  shouldProjectBeUpdated?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['Iterable']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminProject. */
export type AdminProjectCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminProjectEdge>>>;
  pageInfo: AdminProjectPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminProject. */
export type AdminProjectEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminProject>;
};

/** Page connection for AdminProject. */
export type AdminProjectPageConnection = {
  collection?: Maybe<Array<Maybe<AdminProject>>>;
  paginationInfo: AdminProjectPaginationInfo;
};

/** Information about the current page. */
export type AdminProjectPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminProjectPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminProjectUpdate = Node & {
  createdAt?: Maybe<Scalars['String']>;
  feed?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  isSourceFileExists?: Maybe<Scalars['Boolean']>;
  isTargetFileExists?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageArguments?: Maybe<Scalars['Iterable']>;
  messageSeverity?: Maybe<Scalars['String']>;
  planDetails?: Maybe<Scalars['Iterable']>;
  priority?: Maybe<Scalars['Int']>;
  processingMode?: Maybe<Scalars['String']>;
  projectSettings?: Maybe<Scalars['Iterable']>;
  projectUpdateId?: Maybe<Scalars['String']>;
  statistics?: Maybe<Scalars['Iterable']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  usedDesigns?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for AdminProjectUpdate. */
export type AdminProjectUpdateCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminProjectUpdateEdge>>>;
  pageInfo: AdminProjectUpdatePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminProjectUpdate. */
export type AdminProjectUpdateEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminProjectUpdate>;
};

export type AdminProjectUpdateFileUrl = Node & {
  id: Scalars['ID'];
  projectUpdateId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Page connection for AdminProjectUpdate. */
export type AdminProjectUpdatePageConnection = {
  collection?: Maybe<Array<Maybe<AdminProjectUpdate>>>;
  paginationInfo: AdminProjectUpdatePaginationInfo;
};

/** Information about the current page. */
export type AdminProjectUpdatePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminProjectUpdatePaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminProjectUpdateStatistics = Node & {
  clientImages?: Maybe<Scalars['Int']>;
  clientMaximalImagesInProduct?: Maybe<Scalars['Int']>;
  clientMinimalImagesInProduct?: Maybe<Scalars['Int']>;
  clientProductItems?: Maybe<Scalars['Int']>;
  cropinkImages?: Maybe<Scalars['Int']>;
  cropinkProductItems?: Maybe<Scalars['Int']>;
  feedProcessingFinished?: Maybe<Scalars['Boolean']>;
  feedReadingFinished?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  objectsProcessedSuccessfully?: Maybe<Scalars['Int']>;
  objectsProcessedUnsuccessfully?: Maybe<Scalars['Int']>;
  objectsReadFromCache?: Maybe<Scalars['Int']>;
  objectsToBeProcessed?: Maybe<Scalars['Int']>;
  projectUpdateId?: Maybe<Scalars['String']>;
};

export type AdminStyle = Node & {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  styleId?: Maybe<Scalars['String']>;
  templates?: Maybe<Scalars['Iterable']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminStyle. */
export type AdminStyleCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminStyleEdge>>>;
  pageInfo: AdminStylePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminStyle. */
export type AdminStyleEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminStyle>;
};

/** Page connection for AdminStyle. */
export type AdminStylePageConnection = {
  collection?: Maybe<Array<Maybe<AdminStyle>>>;
  paginationInfo: AdminStylePaginationInfo;
};

/** Information about the current page. */
export type AdminStylePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminStylePaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminTeam = Node & {
  active?: Maybe<Scalars['Boolean']>;
  assetImages?: Maybe<Scalars['Iterable']>;
  connectors?: Maybe<Scalars['Iterable']>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invitations?: Maybe<Scalars['Iterable']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  members?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Iterable']>;
  projects?: Maybe<Scalars['Iterable']>;
  settings?: Maybe<Scalars['Iterable']>;
  styles?: Maybe<Scalars['Iterable']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminTeam. */
export type AdminTeamCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminTeamEdge>>>;
  pageInfo: AdminTeamPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminTeam. */
export type AdminTeamEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminTeam>;
};

/** Page connection for AdminTeam. */
export type AdminTeamPageConnection = {
  collection?: Maybe<Array<Maybe<AdminTeam>>>;
  paginationInfo: AdminTeamPaginationInfo;
};

/** Information about the current page. */
export type AdminTeamPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminTeamPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminTemplate = Node & {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  cropinkCode?: Maybe<Scalars['Iterable']>;
  features?: Maybe<Scalars['Iterable']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  isBaseTemplate?: Maybe<Scalars['Boolean']>;
  isFavourite?: Maybe<Scalars['Boolean']>;
  mainSize?: Maybe<Scalars['Iterable']>;
  manageableLayersNested?: Maybe<Scalars['Iterable']>;
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  mappedFonts?: Maybe<Scalars['Iterable']>;
  mappedStyles?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  onboarding?: Maybe<Scalars['Boolean']>;
  previewImageId?: Maybe<Scalars['String']>;
  styles?: Maybe<Scalars['Iterable']>;
  stylizable?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['Iterable']>;
  templateGroupId?: Maybe<Scalars['String']>;
  templateGroupName?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminTemplate. */
export type AdminTemplateCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminTemplateEdge>>>;
  pageInfo: AdminTemplatePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminTemplate. */
export type AdminTemplateEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminTemplate>;
};

export type AdminTemplateGroup = Node & {
  baseTemplate?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  templateGroupId?: Maybe<Scalars['String']>;
  templates?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for AdminTemplateGroup. */
export type AdminTemplateGroupCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminTemplateGroupEdge>>>;
  pageInfo: AdminTemplateGroupPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminTemplateGroup. */
export type AdminTemplateGroupEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminTemplateGroup>;
};

/** Page connection for AdminTemplateGroup. */
export type AdminTemplateGroupPageConnection = {
  collection?: Maybe<Array<Maybe<AdminTemplateGroup>>>;
  paginationInfo: AdminTemplateGroupPaginationInfo;
};

/** Information about the current page. */
export type AdminTemplateGroupPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminTemplateGroupPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Page connection for AdminTemplate. */
export type AdminTemplatePageConnection = {
  collection?: Maybe<Array<Maybe<AdminTemplate>>>;
  paginationInfo: AdminTemplatePaginationInfo;
};

/** Information about the current page. */
export type AdminTemplatePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminTemplatePaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminUser = Node & {
  createdAt?: Maybe<Scalars['String']>;
  defaultTeamId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industryId?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['Iterable']>;
  onboarding?: Maybe<Scalars['String']>;
  onboardingType?: Maybe<Scalars['String']>;
  projects?: Maybe<Scalars['Iterable']>;
  roles?: Maybe<Scalars['Iterable']>;
  survey?: Maybe<Scalars['Iterable']>;
  teams?: Maybe<Scalars['Iterable']>;
  tracking?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Cursor connection for AdminUser. */
export type AdminUserCursorConnection = {
  edges?: Maybe<Array<Maybe<AdminUserEdge>>>;
  pageInfo: AdminUserPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AdminUser. */
export type AdminUserEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AdminUser>;
};

/** Page connection for AdminUser. */
export type AdminUserPageConnection = {
  collection?: Maybe<Array<Maybe<AdminUser>>>;
  paginationInfo: AdminUserPaginationInfo;
};

/** Information about the current page. */
export type AdminUserPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type AdminUserPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AssetImage = Node & {
  assetImageId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Cursor connection for AssetImage. */
export type AssetImageCursorConnection = {
  edges?: Maybe<Array<Maybe<AssetImageEdge>>>;
  pageInfo: AssetImagePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of AssetImage. */
export type AssetImageEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AssetImage>;
};

/** Information about the current page. */
export type AssetImagePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type AuthUserPassword = Node & {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

export type Authorization = {
  protocol?: InputMaybe<Protocol>;
  type?: InputMaybe<ProtocolType>;
};

export type BackgroundRemovalStatus = Node & {
  all?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  inProgress?: Maybe<Scalars['Boolean']>;
  projectUpdateId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Int']>;
};

export type BillingPortalSession = Node & {
  id: Scalars['ID'];
  sessionId?: Maybe<Scalars['String']>;
  sessionUrl?: Maybe<Scalars['String']>;
};

export type BusinessClient = Node & {
  businessClientId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Cursor connection for BusinessClient. */
export type BusinessClientCursorConnection = {
  edges?: Maybe<Array<Maybe<BusinessClientEdge>>>;
  pageInfo: BusinessClientPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of BusinessClient. */
export type BusinessClientEdge = {
  cursor: Scalars['String'];
  node?: Maybe<BusinessClient>;
};

/** Information about the current page. */
export type BusinessClientPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Catalog = Node & {
  catalogId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Cursor connection for Catalog. */
export type CatalogCursorConnection = {
  edges?: Maybe<Array<Maybe<CatalogEdge>>>;
  pageInfo: CatalogPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Catalog. */
export type CatalogEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Catalog>;
};

/** Information about the current page. */
export type CatalogPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CheckoutSession = Node & {
  clientSecret?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
};

export type ClientImage = Node & {
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum ConditionType {
  /** Value equal to */
  EQ = 'EQ',
  /** Value greater than */
  GT = 'GT',
  /** Value greater or equal than */
  GTE = 'GTE',
  /** Not null value */
  IS_NOT_NULL = 'IS_NOT_NULL',
  /** Null value */
  IS_NULL = 'IS_NULL',
  /** Value like */
  LIKE = 'LIKE',
  /** Value lower than */
  LT = 'LT',
  /** Value lower or equal than */
  LTE = 'LTE',
}

export type ConnectionData = {
  access_token?: InputMaybe<Scalars['String']>;
  business_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Connector = Node & {
  businessId?: Maybe<Scalars['String']>;
  connectorId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['Iterable']>;
  status?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CustomHeader = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DebugOptions = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type Design = Node & {
  createdAt?: Maybe<Scalars['String']>;
  cropinkCode?: Maybe<Scalars['Iterable']>;
  cropinkStyledCode?: Maybe<Scalars['Iterable']>;
  currentStyleIdUsedAt?: Maybe<Scalars['String']>;
  customStyle?: Maybe<Scalars['Iterable']>;
  designId?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['Iterable']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  images?: Maybe<Scalars['Iterable']>;
  isEmpty?: Maybe<Scalars['Boolean']>;
  mainSize?: Maybe<Scalars['Iterable']>;
  manageableLayersNested?: Maybe<Scalars['Iterable']>;
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  mappedFonts?: Maybe<Scalars['Iterable']>;
  mappedStyles?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  previewImageId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Iterable']>;
  style?: Maybe<Scalars['Iterable']>;
  styleId?: Maybe<Scalars['String']>;
  stylizable?: Maybe<Scalars['Boolean']>;
  teamId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DesignCodes = Node & {
  cropinkCodeMeta?: Maybe<Scalars['Iterable']>;
  designId?: Maybe<Scalars['String']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  projectId?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
};

/** Cursor connection for Design. */
export type DesignCursorConnection = {
  edges?: Maybe<Array<Maybe<DesignEdge>>>;
  pageInfo: DesignPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Design. */
export type DesignEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Design>;
};

/** Page connection for Design. */
export type DesignPageConnection = {
  collection?: Maybe<Array<Maybe<Design>>>;
  paginationInfo: DesignPaginationInfo;
};

/** Information about the current page. */
export type DesignPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type DesignPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Designs = Node & {
  designs?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
};

export type Dictionary = Node & {
  _id?: Maybe<Scalars['Int']>;
  dictionary?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
};

export type Element = Node & {
  active?: Maybe<Scalars['Boolean']>;
  cropinkCode?: Maybe<Scalars['Iterable']>;
  cropinkCodeMeta?: Maybe<Scalars['Iterable']>;
  elementCategoryResources?: Maybe<Scalars['Iterable']>;
  elementId?: Maybe<Scalars['String']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  previewImageId?: Maybe<Scalars['String']>;
};

export type ElementCategory = Node & {
  elementCategoryId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ElementCodes = Node & {
  cropinkCodeMeta?: Maybe<Scalars['Iterable']>;
  elementId?: Maybe<Scalars['String']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  teamId?: Maybe<Scalars['String']>;
};

/** Cursor connection for Element. */
export type ElementCursorConnection = {
  edges?: Maybe<Array<Maybe<ElementEdge>>>;
  pageInfo: ElementPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Element. */
export type ElementEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Element>;
};

/** Information about the current page. */
export type ElementPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type EventLog = Node & {
  createdAt: Scalars['String'];
  eventLogId: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  projectUpdateId: Scalars['String'];
  type: Scalars['String'];
  visibility: Scalars['String'];
};

/** Cursor connection for EventLog. */
export type EventLogCursorConnection = {
  edges?: Maybe<Array<Maybe<EventLogEdge>>>;
  pageInfo: EventLogPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of EventLog. */
export type EventLogEdge = {
  cursor: Scalars['String'];
  node?: Maybe<EventLog>;
};

/** Information about the current page. */
export type EventLogPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type FacebookAd = Node & {
  adId?: Maybe<Scalars['String']>;
  adSetId?: Maybe<Scalars['String']>;
  adSetName?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  effectiveStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insights?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  projectObjectId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for FacebookAd. */
export type FacebookAdCursorConnection = {
  edges?: Maybe<Array<Maybe<FacebookAdEdge>>>;
  pageInfo: FacebookAdPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of FacebookAd. */
export type FacebookAdEdge = {
  cursor: Scalars['String'];
  node?: Maybe<FacebookAd>;
};

/** Page connection for FacebookAd. */
export type FacebookAdPageConnection = {
  collection?: Maybe<Array<Maybe<FacebookAd>>>;
  paginationInfo: FacebookAdPaginationInfo;
};

/** Information about the current page. */
export type FacebookAdPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type FacebookAdPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type FacebookFeed = Node & {
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type FacebookLogin = Node & {
  id: Scalars['ID'];
  loginUrl?: Maybe<Scalars['String']>;
  sessionTokenId?: Maybe<Scalars['String']>;
};

export type FacebookPermissionReport = Node & {
  id: Scalars['ID'];
  items?: Maybe<Scalars['Iterable']>;
  satisfied?: Maybe<Scalars['Boolean']>;
};

export type Feed = {
  options?: InputMaybe<Options>;
  sourceType?: InputMaybe<SourceType>;
};

export type Filter = {
  condition?: InputMaybe<ConditionType>;
  name?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Font = Node & {
  createdAt?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  fontId?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  postScript?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  weightName?: Maybe<Scalars['String']>;
};

/** Cursor connection for Font. */
export type FontCursorConnection = {
  edges?: Maybe<Array<Maybe<FontEdge>>>;
  pageInfo: FontPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Font. */
export type FontEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Font>;
};

/** Information about the current page. */
export type FontPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type HttpParam = {
  param?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Logo = Node & {
  createdAt?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Cursor connection for Logo. */
export type LogoCursorConnection = {
  edges?: Maybe<Array<Maybe<LogoEdge>>>;
  pageInfo: LogoPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Logo. */
export type LogoEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Logo>;
};

/** Information about the current page. */
export type LogoPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Mutation = {
  /** Activates a AdminElement. */
  activateAdminElement?: Maybe<ActivateAdminElementPayload>;
  /** Activates a AdminProject. */
  activateAdminProject?: Maybe<ActivateAdminProjectPayload>;
  /** Activates a AdminStyle. */
  activateAdminStyle?: Maybe<ActivateAdminStylePayload>;
  /** Activates a AdminTeam. */
  activateAdminTeam?: Maybe<ActivateAdminTeamPayload>;
  /** Activates a AdminTemplate. */
  activateAdminTemplate?: Maybe<ActivateAdminTemplatePayload>;
  /** ActivateDesigns a ProjectObjectBehavior. */
  activateDesignProjectObjectBehavior?: Maybe<ActivateDesignProjectObjectBehaviorPayload>;
  /** Activates a Project. */
  activateProject?: Maybe<ActivateProjectPayload>;
  /** AddFavourites a Template. */
  addFavouriteTemplate?: Maybe<AddFavouriteTemplatePayload>;
  /** AssignAdminRoles a AdminUser. */
  assignAdminRoleAdminUser?: Maybe<AssignAdminRoleAdminUserPayload>;
  /** AssignDefaults a Font. */
  assignDefaultFont?: Maybe<AssignDefaultFontPayload>;
  /** AssignDefaults a Logo. */
  assignDefaultLogo?: Maybe<AssignDefaultLogoPayload>;
  /** AssignDesignToProjectObjectBehaviors a ProjectObject. */
  assignDesignToProjectObjectBehaviorProjectObject?: Maybe<AssignDesignToProjectObjectBehaviorProjectObjectPayload>;
  /** AssignFacebookCatalogTos a Project. */
  assignFacebookCatalogToProject?: Maybe<AssignFacebookCatalogToProjectPayload>;
  /** AssignProjectObjectToFacebookAds a Project. */
  assignProjectObjectToFacebookAdProject?: Maybe<AssignProjectObjectToFacebookAdProjectPayload>;
  /** AssignStyles a AdminTemplate. */
  assignStyleAdminTemplate?: Maybe<AssignStyleAdminTemplatePayload>;
  /** AssignToOnboardings a AdminTemplate. */
  assignToOnboardingAdminTemplate?: Maybe<AssignToOnboardingAdminTemplatePayload>;
  /** AssignToTeams a Connector. */
  assignToTeamConnector?: Maybe<AssignToTeamConnectorPayload>;
  /** Auths a Websocket. */
  authWebsocket?: Maybe<AuthWebsocketPayload>;
  /** CancelFeedProcessings a Project. */
  cancelFeedProcessingProject?: Maybe<CancelFeedProcessingProjectPayload>;
  /** Cancels a Subscription. */
  cancelSubscription?: Maybe<CancelSubscriptionPayload>;
  /** Changes a AuthUserPassword. */
  changeAuthUserPassword?: Maybe<ChangeAuthUserPasswordPayload>;
  /** ChangeOrders a ProjectObject. */
  changeOrderProjectObject?: Maybe<ChangeOrderProjectObjectPayload>;
  /** ChangeOrders a ProjectObjectBehavior. */
  changeOrderProjectObjectBehavior?: Maybe<ChangeOrderProjectObjectBehaviorPayload>;
  /** ChangePasswords a AuthResetPasswordToken. */
  changePasswordUserResetPassword?: Maybe<ChangePasswordUserResetPasswordPayload>;
  /** ChangeRoles a TeamUser. */
  changeRoleTeamUser?: Maybe<ChangeRoleTeamUserPayload>;
  /** ClaimShopifyInstallations a Connector. */
  claimShopifyInstallationConnector?: Maybe<ClaimShopifyInstallationConnectorPayload>;
  /** Clones a Design. */
  cloneDesign?: Maybe<CloneDesignPayload>;
  /** Clones a Project. */
  cloneProject?: Maybe<CloneProjectPayload>;
  /** Clones a Team. */
  cloneTeam?: Maybe<CloneTeamPayload>;
  /** CloneToProjects a Designs. */
  cloneToProjectDesigns?: Maybe<CloneToProjectDesignsPayload>;
  /** Confirms a TeamInvitationConfirmation. */
  confirmTeamInvitationConfirmation?: Maybe<ConfirmTeamInvitationConfirmationPayload>;
  /** Creates a AdminElementCategory. */
  createAdminElementCategory?: Maybe<CreateAdminElementCategoryPayload>;
  /** Creates a AdminStyle. */
  createAdminStyle?: Maybe<CreateAdminStylePayload>;
  /** Creates a AdminTeam. */
  createAdminTeam?: Maybe<CreateAdminTeamPayload>;
  /** Creates a AdminTemplateGroup. */
  createAdminTemplateGroup?: Maybe<CreateAdminTemplateGroupPayload>;
  /** Creates a BillingPortalSession. */
  createBillingPortalSession?: Maybe<CreateBillingPortalSessionPayload>;
  /** Creates a Connector. */
  createConnector?: Maybe<CreateConnectorPayload>;
  /** Creates a Design. */
  createDesign?: Maybe<CreateDesignPayload>;
  /** CreateFromDesigns a AdminTemplate. */
  createFromDesignAdminTemplate?: Maybe<CreateFromDesignAdminTemplatePayload>;
  /** CreateFromTeamElements a AdminElement. */
  createFromTeamElementAdminElement?: Maybe<CreateFromTeamElementAdminElementPayload>;
  /** CreateFromTemplates a Design. */
  createFromTemplateDesign?: Maybe<CreateFromTemplateDesignPayload>;
  /** CreateMultiparts a AdminTemplate. */
  createMultipartAdminTemplate?: Maybe<CreateMultipartAdminTemplatePayload>;
  /** CreateMultipartFromFigmaCodes a Element. */
  createMultipartFromFigmaCodeElement?: Maybe<CreateMultipartFromFigmaCodeElementPayload>;
  /** CreateMultipartObjectPreviewFromFigmaCodes a Object. */
  createMultipartObjectPreviewFromFigmaCodeObject?: Maybe<CreateMultipartObjectPreviewFromFigmaCodeObjectPayload>;
  /** CreateObjectPreviewFromDesigns a Object. */
  createObjectPreviewFromDesignObject?: Maybe<CreateObjectPreviewFromDesignObjectPayload>;
  /** CreateObjectPreviewFromTemplates a Object. */
  createObjectPreviewFromTemplateObject?: Maybe<CreateObjectPreviewFromTemplateObjectPayload>;
  /** Creates a Project. */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a ProjectObject. */
  createProjectObject?: Maybe<CreateProjectObjectPayload>;
  /** Creates a ProjectToken. */
  createProjectToken?: Maybe<CreateProjectTokenPayload>;
  /** CreateSamples a Project. */
  createSampleProject?: Maybe<CreateSampleProjectPayload>;
  /** Creates a Style. */
  createStyle?: Maybe<CreateStylePayload>;
  /** CreateStyledTemplatePreviews a Object. */
  createStyledTemplatePreviewObject?: Maybe<CreateStyledTemplatePreviewObjectPayload>;
  /** CreateSubscriptions a CheckoutSession. */
  createSubscriptionCheckoutSession?: Maybe<CreateSubscriptionCheckoutSessionPayload>;
  /** Creates a Team. */
  createTeam?: Maybe<CreateTeamPayload>;
  /** Creates a TeamInvitationCreation. */
  createTeamInvitationCreation?: Maybe<CreateTeamInvitationCreationPayload>;
  /** Creates a TeamToken. */
  createTeamToken?: Maybe<CreateTeamTokenPayload>;
  /** Creates a AuthVerificationCode. */
  createUserVerification?: Maybe<CreateUserVerificationPayload>;
  /** Deactivates a AdminElement. */
  deactivateAdminElement?: Maybe<DeactivateAdminElementPayload>;
  /** Deactivates a AdminProject. */
  deactivateAdminProject?: Maybe<DeactivateAdminProjectPayload>;
  /** Deactivates a AdminStyle. */
  deactivateAdminStyle?: Maybe<DeactivateAdminStylePayload>;
  /** Deactivates a AdminTeam. */
  deactivateAdminTeam?: Maybe<DeactivateAdminTeamPayload>;
  /** Deactivates a AdminTemplate. */
  deactivateAdminTemplate?: Maybe<DeactivateAdminTemplatePayload>;
  /** DeactivateDesigns a ProjectObjectBehavior. */
  deactivateDesignProjectObjectBehavior?: Maybe<DeactivateDesignProjectObjectBehaviorPayload>;
  /** Deactivates a Project. */
  deactivateProject?: Maybe<DeactivateProjectPayload>;
  /** Disconnects a ProjectFeed. */
  disconnectProjectFeed?: Maybe<DisconnectProjectFeedPayload>;
  /** EditNames a AdminTemplateGroup. */
  editNameAdminTemplateGroup?: Maybe<EditNameAdminTemplateGroupPayload>;
  /** FinishOnboardings a User. */
  finishOnboardingUser?: Maybe<FinishOnboardingUserPayload>;
  /** ForceFeeds a Project. */
  forceFeedProject?: Maybe<ForceFeedProjectPayload>;
  /** Generates a AdminProjectUpdateFileUrl. */
  generateAdminProjectUpdateFileUrl?: Maybe<GenerateAdminProjectUpdateFileUrlPayload>;
  /** GenerateTokens a AuthResetPasswordToken. */
  generateTokenUserResetPassword?: Maybe<GenerateTokenUserResetPasswordPayload>;
  /** Initiates a FacebookLogin. */
  initiateFacebookLogin?: Maybe<InitiateFacebookLoginPayload>;
  /** Initiates a ShopifyLogin. */
  initiateShopifyLogin?: Maybe<InitiateShopifyLoginPayload>;
  /** InvalidateObjects a AdminProject. */
  invalidateObjectAdminProject?: Maybe<InvalidateObjectAdminProjectPayload>;
  /** Leaves a Team. */
  leaveTeam?: Maybe<LeaveTeamPayload>;
  /** LoginCredentialss a Auth. */
  loginCredentialsUser?: Maybe<LoginCredentialsUserPayload>;
  /** Logins a Auth. */
  loginProject?: Maybe<LoginProjectPayload>;
  /** LoginSharedDesigns a Auth. */
  loginSharedDesignAuth?: Maybe<LoginSharedDesignAuthPayload>;
  /** LoginSharedProjects a Auth. */
  loginSharedProjectAuth?: Maybe<LoginSharedProjectAuthPayload>;
  /** LoginTeams a Auth. */
  loginTeamAuth?: Maybe<LoginTeamAuthPayload>;
  /** LogoutProjects a Auth. */
  logoutProjectAuth?: Maybe<LogoutProjectAuthPayload>;
  /** LogoutTeams a Auth. */
  logoutTeamAuth?: Maybe<LogoutTeamAuthPayload>;
  /** LogoutUsers a Auth. */
  logoutUserAuth?: Maybe<LogoutUserAuthPayload>;
  /** RefreshCollectionAdss a Project. */
  refreshCollectionAdsProject?: Maybe<RefreshCollectionAdsProjectPayload>;
  /** Refreshs a Auth. */
  refreshSessionToken?: Maybe<RefreshSessionTokenPayload>;
  /** RegisterTeamInvitations a Auth. */
  registerTeamInvitationConfirmation?: Maybe<RegisterTeamInvitationConfirmationPayload>;
  /** Registers a Auth. */
  registerUser?: Maybe<RegisterUserPayload>;
  /** Removes a AdminElement. */
  removeAdminElement?: Maybe<RemoveAdminElementPayload>;
  /** Removes a AdminElementCategory. */
  removeAdminElementCategory?: Maybe<RemoveAdminElementCategoryPayload>;
  /** Removes a AdminFont. */
  removeAdminFont?: Maybe<RemoveAdminFontPayload>;
  /** Removes a AdminProject. */
  removeAdminProject?: Maybe<RemoveAdminProjectPayload>;
  /** Removes a AdminStyle. */
  removeAdminStyle?: Maybe<RemoveAdminStylePayload>;
  /** Removes a AdminTeam. */
  removeAdminTeam?: Maybe<RemoveAdminTeamPayload>;
  /** Removes a AdminTemplate. */
  removeAdminTemplate?: Maybe<RemoveAdminTemplatePayload>;
  /** Removes a AdminTemplateGroup. */
  removeAdminTemplateGroup?: Maybe<RemoveAdminTemplateGroupPayload>;
  /** Removes a AdminUser. */
  removeAdminUser?: Maybe<RemoveAdminUserPayload>;
  /** Removes a AssetImage. */
  removeAssetImage?: Maybe<RemoveAssetImagePayload>;
  /** Removes a Connector. */
  removeConnector?: Maybe<RemoveConnectorPayload>;
  /** Removes a Design. */
  removeDesign?: Maybe<RemoveDesignPayload>;
  /** RemoveDesignFroms a ProjectObjectBehavior. */
  removeDesignFromProjectObjectBehavior?: Maybe<RemoveDesignFromProjectObjectBehaviorPayload>;
  /** RemoveFavourites a Template. */
  removeFavouriteTemplate?: Maybe<RemoveFavouriteTemplatePayload>;
  /** Removes a Font. */
  removeFont?: Maybe<RemoveFontPayload>;
  /** Removes a Logo. */
  removeLogo?: Maybe<RemoveLogoPayload>;
  /** Removes a Project. */
  removeProject?: Maybe<RemoveProjectPayload>;
  /** Removes a ProjectObject. */
  removeProjectObject?: Maybe<RemoveProjectObjectPayload>;
  /** Removes a ProjectObjectBehavior. */
  removeProjectObjectBehavior?: Maybe<RemoveProjectObjectBehaviorPayload>;
  /** Removes a ProjectToken. */
  removeProjectToken?: Maybe<RemoveProjectTokenPayload>;
  /** Removes a Style. */
  removeStyle?: Maybe<RemoveStylePayload>;
  /** RemoveSupplementaryFeedFors a Project. */
  removeSupplementaryFeedForProject?: Maybe<RemoveSupplementaryFeedForProjectPayload>;
  /** Removes a Team. */
  removeTeam?: Maybe<RemoveTeamPayload>;
  /** Removes a TeamInvitation. */
  removeTeamInvitation?: Maybe<RemoveTeamInvitationPayload>;
  /** Removes a TeamToken. */
  removeTeamToken?: Maybe<RemoveTeamTokenPayload>;
  /** Removes a User. */
  removeUser?: Maybe<RemoveUserPayload>;
  /** ReplaceImages a AdminTemplate. */
  replaceImageAdminTemplate?: Maybe<ReplaceImageAdminTemplatePayload>;
  /** TransferOwnerships a Team. */
  transferOwnershipTeam?: Maybe<TransferOwnershipTeamPayload>;
  /** UnassignDefaults a Font. */
  unassignDefaultFont?: Maybe<UnassignDefaultFontPayload>;
  /** UnassignDefaults a Logo. */
  unassignDefaultLogo?: Maybe<UnassignDefaultLogoPayload>;
  /** UnassignFacebookIntegrationFroms a Project. */
  unassignFacebookIntegrationFromProject?: Maybe<UnassignFacebookIntegrationFromProjectPayload>;
  /** UnassignFromGroups a AdminTemplate. */
  unassignFromGroupAdminTemplate?: Maybe<UnassignFromGroupAdminTemplatePayload>;
  /** UnassignFromOnboardings a AdminTemplate. */
  unassignFromOnboardingAdminTemplate?: Maybe<UnassignFromOnboardingAdminTemplatePayload>;
  /** UnassignProjectObjectFromFacebookAds a Project. */
  unassignProjectObjectFromFacebookAdProject?: Maybe<UnassignProjectObjectFromFacebookAdProjectPayload>;
  /** UnassignStyles a AdminTemplate. */
  unassignStyleAdminTemplate?: Maybe<UnassignStyleAdminTemplatePayload>;
  /** UnassignUsers a AdminTeam. */
  unassignUserAdminTeam?: Maybe<UnassignUserAdminTeamPayload>;
  /** UnassignUsers a Team. */
  unassignUserTeam?: Maybe<UnassignUserTeamPayload>;
  /** Updates a AdminElementCategory. */
  updateAdminElementCategory?: Maybe<UpdateAdminElementCategoryPayload>;
  /** Updates a AdminStyle. */
  updateAdminStyle?: Maybe<UpdateAdminStylePayload>;
  /** Updates a AdminTeam. */
  updateAdminTeam?: Maybe<UpdateAdminTeamPayload>;
  /** Updates a AdminTemplate. */
  updateAdminTemplate?: Maybe<UpdateAdminTemplatePayload>;
  /** UpdateCategoriess a AdminElement. */
  updateCategoriesAdminElement?: Maybe<UpdateCategoriesAdminElementPayload>;
  /** UpdateCodeSettingss a AdminTemplate. */
  updateCodeSettingsAdminTemplate?: Maybe<UpdateCodeSettingsAdminTemplatePayload>;
  /** UpdateCodeSettingss a Design. */
  updateCodeSettingsDesign?: Maybe<UpdateCodeSettingsDesignPayload>;
  /** UpdateCodesMultiparts a AdminTemplate. */
  updateCodesMultipartAdminTemplate?: Maybe<UpdateCodesMultipartAdminTemplatePayload>;
  /** UpdateCodesMultiparts a Design. */
  updateCodesMultipartDesign?: Maybe<UpdateCodesMultipartDesignPayload>;
  /** UpdateCodesMultiparts a Element. */
  updateCodesMultipartElement?: Maybe<UpdateCodesMultipartElementPayload>;
  /** UpdateCustomHeaderss a AdminProject. */
  updateCustomHeadersAdminProject?: Maybe<UpdateCustomHeadersAdminProjectPayload>;
  /** UpdateDefinitions a AdminStyle. */
  updateDefinitionAdminStyle?: Maybe<UpdateDefinitionAdminStylePayload>;
  /** UpdateDefinitions a Style. */
  updateDefinitionStyle?: Maybe<UpdateDefinitionStylePayload>;
  /** Updates a Design. */
  updateDesign?: Maybe<UpdateDesignPayload>;
  /** UpdateErrorTolerances a Project. */
  updateErrorToleranceProject?: Maybe<UpdateErrorToleranceProjectPayload>;
  /** UpdateFeaturess a AdminDesign. */
  updateFeaturesAdminDesign?: Maybe<UpdateFeaturesAdminDesignPayload>;
  /** UpdateFeaturess a AdminTemplate. */
  updateFeaturesAdminTemplate?: Maybe<UpdateFeaturesAdminTemplatePayload>;
  /** UpdateFeedFieldss a Project. */
  updateFeedFieldsProject?: Maybe<UpdateFeedFieldsProjectPayload>;
  /** UpdateFeeds a Project. */
  updateFeedProject?: Maybe<UpdateFeedProjectPayload>;
  /** Updates a Logo. */
  updateLogo?: Maybe<UpdateLogoPayload>;
  /** UpdateNotificationEmailss a Project. */
  updateNotificationEmailsProject?: Maybe<UpdateNotificationEmailsProjectPayload>;
  /** UpdateOverrideDatas a Project. */
  updateOverrideDataProject?: Maybe<UpdateOverrideDataProjectPayload>;
  /** Updates a Project. */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** UpdateProxiess a AdminProject. */
  updateProxiesAdminProject?: Maybe<UpdateProxiesAdminProjectPayload>;
  /** UpdateRateLimitss a AdminTeam. */
  updateRateLimitsAdminTeam?: Maybe<UpdateRateLimitsAdminTeamPayload>;
  /** UpdateScheduleFrequencys a Project. */
  updateScheduleFrequencyProject?: Maybe<UpdateScheduleFrequencyProjectPayload>;
  /** UpdateSettingss a Design. */
  updateSettingsDesign?: Maybe<UpdateSettingsDesignPayload>;
  /** UpdateSettingss a ProjectObjectBehavior. */
  updateSettingsProjectObjectBehavior?: Maybe<UpdateSettingsProjectObjectBehaviorPayload>;
  /** UpdateShareSettingss a Project. */
  updateShareSettingsProject?: Maybe<UpdateShareSettingsProjectPayload>;
  /** UpdateSharedSettingss a Design. */
  updateSharedSettingsDesign?: Maybe<UpdateSharedSettingsDesignPayload>;
  /** UpdateStyless a AdminTemplate. */
  updateStylesAdminTemplate?: Maybe<UpdateStylesAdminTemplatePayload>;
  /** UpdateTagss a AdminTemplate. */
  updateTagsAdminTemplate?: Maybe<UpdateTagsAdminTemplatePayload>;
  /** Updates a Team. */
  updateTeam?: Maybe<UpdateTeamPayload>;
  /** UpdateTeams a Style. */
  updateTeamStyle?: Maybe<UpdateTeamStylePayload>;
  /** UpdateTemplatess a AdminTemplateGroup. */
  updateTemplatesAdminTemplateGroup?: Maybe<UpdateTemplatesAdminTemplateGroupPayload>;
  /** UpdateTextEngines a Project. */
  updateTextEngineProject?: Maybe<UpdateTextEngineProjectPayload>;
  /** Updates a User. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Uploads a AdminFonts. */
  uploadAdminFonts?: Maybe<UploadAdminFontsPayload>;
  /** Uploads a AssetImage. */
  uploadAssetImage?: Maybe<UploadAssetImagePayload>;
  /** Uploads a Font. */
  uploadFont?: Maybe<UploadFontPayload>;
  /** Uploads a Logo. */
  uploadLogo?: Maybe<UploadLogoPayload>;
};

export type MutationActivateAdminElementArgs = {
  input: ActivateAdminElementInput;
};

export type MutationActivateAdminProjectArgs = {
  input: ActivateAdminProjectInput;
};

export type MutationActivateAdminStyleArgs = {
  input: ActivateAdminStyleInput;
};

export type MutationActivateAdminTeamArgs = {
  input: ActivateAdminTeamInput;
};

export type MutationActivateAdminTemplateArgs = {
  input: ActivateAdminTemplateInput;
};

export type MutationActivateDesignProjectObjectBehaviorArgs = {
  input: ActivateDesignProjectObjectBehaviorInput;
};

export type MutationActivateProjectArgs = {
  input: ActivateProjectInput;
};

export type MutationAddFavouriteTemplateArgs = {
  input: AddFavouriteTemplateInput;
};

export type MutationAssignAdminRoleAdminUserArgs = {
  input: AssignAdminRoleAdminUserInput;
};

export type MutationAssignDefaultFontArgs = {
  input: AssignDefaultFontInput;
};

export type MutationAssignDefaultLogoArgs = {
  input: AssignDefaultLogoInput;
};

export type MutationAssignDesignToProjectObjectBehaviorProjectObjectArgs = {
  input: AssignDesignToProjectObjectBehaviorProjectObjectInput;
};

export type MutationAssignFacebookCatalogToProjectArgs = {
  input: AssignFacebookCatalogToProjectInput;
};

export type MutationAssignProjectObjectToFacebookAdProjectArgs = {
  input: AssignProjectObjectToFacebookAdProjectInput;
};

export type MutationAssignStyleAdminTemplateArgs = {
  input: AssignStyleAdminTemplateInput;
};

export type MutationAssignToOnboardingAdminTemplateArgs = {
  input: AssignToOnboardingAdminTemplateInput;
};

export type MutationAssignToTeamConnectorArgs = {
  input: AssignToTeamConnectorInput;
};

export type MutationAuthWebsocketArgs = {
  input: AuthWebsocketInput;
};

export type MutationCancelFeedProcessingProjectArgs = {
  input: CancelFeedProcessingProjectInput;
};

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};

export type MutationChangeAuthUserPasswordArgs = {
  input: ChangeAuthUserPasswordInput;
};

export type MutationChangeOrderProjectObjectArgs = {
  input: ChangeOrderProjectObjectInput;
};

export type MutationChangeOrderProjectObjectBehaviorArgs = {
  input: ChangeOrderProjectObjectBehaviorInput;
};

export type MutationChangePasswordUserResetPasswordArgs = {
  input: ChangePasswordUserResetPasswordInput;
};

export type MutationChangeRoleTeamUserArgs = {
  input: ChangeRoleTeamUserInput;
};

export type MutationClaimShopifyInstallationConnectorArgs = {
  input: ClaimShopifyInstallationConnectorInput;
};

export type MutationCloneDesignArgs = {
  input: CloneDesignInput;
};

export type MutationCloneProjectArgs = {
  input: CloneProjectInput;
};

export type MutationCloneTeamArgs = {
  input: CloneTeamInput;
};

export type MutationCloneToProjectDesignsArgs = {
  input: CloneToProjectDesignsInput;
};

export type MutationConfirmTeamInvitationConfirmationArgs = {
  input: ConfirmTeamInvitationConfirmationInput;
};

export type MutationCreateAdminElementCategoryArgs = {
  input: CreateAdminElementCategoryInput;
};

export type MutationCreateAdminStyleArgs = {
  input: CreateAdminStyleInput;
};

export type MutationCreateAdminTeamArgs = {
  input: CreateAdminTeamInput;
};

export type MutationCreateAdminTemplateGroupArgs = {
  input: CreateAdminTemplateGroupInput;
};

export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInput;
};

export type MutationCreateConnectorArgs = {
  input: CreateConnectorInput;
};

export type MutationCreateDesignArgs = {
  input: CreateDesignInput;
};

export type MutationCreateFromDesignAdminTemplateArgs = {
  input: CreateFromDesignAdminTemplateInput;
};

export type MutationCreateFromTeamElementAdminElementArgs = {
  input: CreateFromTeamElementAdminElementInput;
};

export type MutationCreateFromTemplateDesignArgs = {
  input: CreateFromTemplateDesignInput;
};

export type MutationCreateMultipartAdminTemplateArgs = {
  input: CreateMultipartAdminTemplateInput;
};

export type MutationCreateMultipartFromFigmaCodeElementArgs = {
  input: CreateMultipartFromFigmaCodeElementInput;
};

export type MutationCreateMultipartObjectPreviewFromFigmaCodeObjectArgs = {
  input: CreateMultipartObjectPreviewFromFigmaCodeObjectInput;
};

export type MutationCreateObjectPreviewFromDesignObjectArgs = {
  input: CreateObjectPreviewFromDesignObjectInput;
};

export type MutationCreateObjectPreviewFromTemplateObjectArgs = {
  input: CreateObjectPreviewFromTemplateObjectInput;
};

export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};

export type MutationCreateProjectObjectArgs = {
  input: CreateProjectObjectInput;
};

export type MutationCreateProjectTokenArgs = {
  input: CreateProjectTokenInput;
};

export type MutationCreateSampleProjectArgs = {
  input: CreateSampleProjectInput;
};

export type MutationCreateStyleArgs = {
  input: CreateStyleInput;
};

export type MutationCreateStyledTemplatePreviewObjectArgs = {
  input: CreateStyledTemplatePreviewObjectInput;
};

export type MutationCreateSubscriptionCheckoutSessionArgs = {
  input: CreateSubscriptionCheckoutSessionInput;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};

export type MutationCreateTeamInvitationCreationArgs = {
  input: CreateTeamInvitationCreationInput;
};

export type MutationCreateTeamTokenArgs = {
  input: CreateTeamTokenInput;
};

export type MutationCreateUserVerificationArgs = {
  input: CreateUserVerificationInput;
};

export type MutationDeactivateAdminElementArgs = {
  input: DeactivateAdminElementInput;
};

export type MutationDeactivateAdminProjectArgs = {
  input: DeactivateAdminProjectInput;
};

export type MutationDeactivateAdminStyleArgs = {
  input: DeactivateAdminStyleInput;
};

export type MutationDeactivateAdminTeamArgs = {
  input: DeactivateAdminTeamInput;
};

export type MutationDeactivateAdminTemplateArgs = {
  input: DeactivateAdminTemplateInput;
};

export type MutationDeactivateDesignProjectObjectBehaviorArgs = {
  input: DeactivateDesignProjectObjectBehaviorInput;
};

export type MutationDeactivateProjectArgs = {
  input: DeactivateProjectInput;
};

export type MutationDisconnectProjectFeedArgs = {
  input: DisconnectProjectFeedInput;
};

export type MutationEditNameAdminTemplateGroupArgs = {
  input: EditNameAdminTemplateGroupInput;
};

export type MutationFinishOnboardingUserArgs = {
  input: FinishOnboardingUserInput;
};

export type MutationForceFeedProjectArgs = {
  input: ForceFeedProjectInput;
};

export type MutationGenerateAdminProjectUpdateFileUrlArgs = {
  input: GenerateAdminProjectUpdateFileUrlInput;
};

export type MutationGenerateTokenUserResetPasswordArgs = {
  input: GenerateTokenUserResetPasswordInput;
};

export type MutationInitiateFacebookLoginArgs = {
  input: InitiateFacebookLoginInput;
};

export type MutationInitiateShopifyLoginArgs = {
  input: InitiateShopifyLoginInput;
};

export type MutationInvalidateObjectAdminProjectArgs = {
  input: InvalidateObjectAdminProjectInput;
};

export type MutationLeaveTeamArgs = {
  input: LeaveTeamInput;
};

export type MutationLoginCredentialsUserArgs = {
  input: LoginCredentialsUserInput;
};

export type MutationLoginProjectArgs = {
  input: LoginProjectInput;
};

export type MutationLoginSharedDesignAuthArgs = {
  input: LoginSharedDesignAuthInput;
};

export type MutationLoginSharedProjectAuthArgs = {
  input: LoginSharedProjectAuthInput;
};

export type MutationLoginTeamAuthArgs = {
  input: LoginTeamAuthInput;
};

export type MutationLogoutProjectAuthArgs = {
  input: LogoutProjectAuthInput;
};

export type MutationLogoutTeamAuthArgs = {
  input: LogoutTeamAuthInput;
};

export type MutationLogoutUserAuthArgs = {
  input: LogoutUserAuthInput;
};

export type MutationRefreshCollectionAdsProjectArgs = {
  input: RefreshCollectionAdsProjectInput;
};

export type MutationRefreshSessionTokenArgs = {
  input: RefreshSessionTokenInput;
};

export type MutationRegisterTeamInvitationConfirmationArgs = {
  input: RegisterTeamInvitationConfirmationInput;
};

export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};

export type MutationRemoveAdminElementArgs = {
  input: RemoveAdminElementInput;
};

export type MutationRemoveAdminElementCategoryArgs = {
  input: RemoveAdminElementCategoryInput;
};

export type MutationRemoveAdminFontArgs = {
  input: RemoveAdminFontInput;
};

export type MutationRemoveAdminProjectArgs = {
  input: RemoveAdminProjectInput;
};

export type MutationRemoveAdminStyleArgs = {
  input: RemoveAdminStyleInput;
};

export type MutationRemoveAdminTeamArgs = {
  input: RemoveAdminTeamInput;
};

export type MutationRemoveAdminTemplateArgs = {
  input: RemoveAdminTemplateInput;
};

export type MutationRemoveAdminTemplateGroupArgs = {
  input: RemoveAdminTemplateGroupInput;
};

export type MutationRemoveAdminUserArgs = {
  input: RemoveAdminUserInput;
};

export type MutationRemoveAssetImageArgs = {
  input: RemoveAssetImageInput;
};

export type MutationRemoveConnectorArgs = {
  input: RemoveConnectorInput;
};

export type MutationRemoveDesignArgs = {
  input: RemoveDesignInput;
};

export type MutationRemoveDesignFromProjectObjectBehaviorArgs = {
  input: RemoveDesignFromProjectObjectBehaviorInput;
};

export type MutationRemoveFavouriteTemplateArgs = {
  input: RemoveFavouriteTemplateInput;
};

export type MutationRemoveFontArgs = {
  input: RemoveFontInput;
};

export type MutationRemoveLogoArgs = {
  input: RemoveLogoInput;
};

export type MutationRemoveProjectArgs = {
  input: RemoveProjectInput;
};

export type MutationRemoveProjectObjectArgs = {
  input: RemoveProjectObjectInput;
};

export type MutationRemoveProjectObjectBehaviorArgs = {
  input: RemoveProjectObjectBehaviorInput;
};

export type MutationRemoveProjectTokenArgs = {
  input: RemoveProjectTokenInput;
};

export type MutationRemoveStyleArgs = {
  input: RemoveStyleInput;
};

export type MutationRemoveSupplementaryFeedForProjectArgs = {
  input: RemoveSupplementaryFeedForProjectInput;
};

export type MutationRemoveTeamArgs = {
  input: RemoveTeamInput;
};

export type MutationRemoveTeamInvitationArgs = {
  input: RemoveTeamInvitationInput;
};

export type MutationRemoveTeamTokenArgs = {
  input: RemoveTeamTokenInput;
};

export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};

export type MutationReplaceImageAdminTemplateArgs = {
  input: ReplaceImageAdminTemplateInput;
};

export type MutationTransferOwnershipTeamArgs = {
  input: TransferOwnershipTeamInput;
};

export type MutationUnassignDefaultFontArgs = {
  input: UnassignDefaultFontInput;
};

export type MutationUnassignDefaultLogoArgs = {
  input: UnassignDefaultLogoInput;
};

export type MutationUnassignFacebookIntegrationFromProjectArgs = {
  input: UnassignFacebookIntegrationFromProjectInput;
};

export type MutationUnassignFromGroupAdminTemplateArgs = {
  input: UnassignFromGroupAdminTemplateInput;
};

export type MutationUnassignFromOnboardingAdminTemplateArgs = {
  input: UnassignFromOnboardingAdminTemplateInput;
};

export type MutationUnassignProjectObjectFromFacebookAdProjectArgs = {
  input: UnassignProjectObjectFromFacebookAdProjectInput;
};

export type MutationUnassignStyleAdminTemplateArgs = {
  input: UnassignStyleAdminTemplateInput;
};

export type MutationUnassignUserAdminTeamArgs = {
  input: UnassignUserAdminTeamInput;
};

export type MutationUnassignUserTeamArgs = {
  input: UnassignUserTeamInput;
};

export type MutationUpdateAdminElementCategoryArgs = {
  input: UpdateAdminElementCategoryInput;
};

export type MutationUpdateAdminStyleArgs = {
  input: UpdateAdminStyleInput;
};

export type MutationUpdateAdminTeamArgs = {
  input: UpdateAdminTeamInput;
};

export type MutationUpdateAdminTemplateArgs = {
  input: UpdateAdminTemplateInput;
};

export type MutationUpdateCategoriesAdminElementArgs = {
  input: UpdateCategoriesAdminElementInput;
};

export type MutationUpdateCodeSettingsAdminTemplateArgs = {
  input: UpdateCodeSettingsAdminTemplateInput;
};

export type MutationUpdateCodeSettingsDesignArgs = {
  input: UpdateCodeSettingsDesignInput;
};

export type MutationUpdateCodesMultipartAdminTemplateArgs = {
  input: UpdateCodesMultipartAdminTemplateInput;
};

export type MutationUpdateCodesMultipartDesignArgs = {
  input: UpdateCodesMultipartDesignInput;
};

export type MutationUpdateCodesMultipartElementArgs = {
  input: UpdateCodesMultipartElementInput;
};

export type MutationUpdateCustomHeadersAdminProjectArgs = {
  input: UpdateCustomHeadersAdminProjectInput;
};

export type MutationUpdateDefinitionAdminStyleArgs = {
  input: UpdateDefinitionAdminStyleInput;
};

export type MutationUpdateDefinitionStyleArgs = {
  input: UpdateDefinitionStyleInput;
};

export type MutationUpdateDesignArgs = {
  input: UpdateDesignInput;
};

export type MutationUpdateErrorToleranceProjectArgs = {
  input: UpdateErrorToleranceProjectInput;
};

export type MutationUpdateFeaturesAdminDesignArgs = {
  input: UpdateFeaturesAdminDesignInput;
};

export type MutationUpdateFeaturesAdminTemplateArgs = {
  input: UpdateFeaturesAdminTemplateInput;
};

export type MutationUpdateFeedFieldsProjectArgs = {
  input: UpdateFeedFieldsProjectInput;
};

export type MutationUpdateFeedProjectArgs = {
  input: UpdateFeedProjectInput;
};

export type MutationUpdateLogoArgs = {
  input: UpdateLogoInput;
};

export type MutationUpdateNotificationEmailsProjectArgs = {
  input: UpdateNotificationEmailsProjectInput;
};

export type MutationUpdateOverrideDataProjectArgs = {
  input: UpdateOverrideDataProjectInput;
};

export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};

export type MutationUpdateProxiesAdminProjectArgs = {
  input: UpdateProxiesAdminProjectInput;
};

export type MutationUpdateRateLimitsAdminTeamArgs = {
  input: UpdateRateLimitsAdminTeamInput;
};

export type MutationUpdateScheduleFrequencyProjectArgs = {
  input: UpdateScheduleFrequencyProjectInput;
};

export type MutationUpdateSettingsDesignArgs = {
  input: UpdateSettingsDesignInput;
};

export type MutationUpdateSettingsProjectObjectBehaviorArgs = {
  input: UpdateSettingsProjectObjectBehaviorInput;
};

export type MutationUpdateShareSettingsProjectArgs = {
  input: UpdateShareSettingsProjectInput;
};

export type MutationUpdateSharedSettingsDesignArgs = {
  input: UpdateSharedSettingsDesignInput;
};

export type MutationUpdateStylesAdminTemplateArgs = {
  input: UpdateStylesAdminTemplateInput;
};

export type MutationUpdateTagsAdminTemplateArgs = {
  input: UpdateTagsAdminTemplateInput;
};

export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};

export type MutationUpdateTeamStyleArgs = {
  input: UpdateTeamStyleInput;
};

export type MutationUpdateTemplatesAdminTemplateGroupArgs = {
  input: UpdateTemplatesAdminTemplateGroupInput;
};

export type MutationUpdateTextEngineProjectArgs = {
  input: UpdateTextEngineProjectInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUploadAdminFontsArgs = {
  input: UploadAdminFontsInput;
};

export type MutationUploadAssetImageArgs = {
  input: UploadAssetImageInput;
};

export type MutationUploadFontArgs = {
  input: UploadFontInput;
};

export type MutationUploadLogoArgs = {
  input: UploadLogoInput;
};

/** A node, according to the Relay specification. */
export type Node = {
  /** The id of this node. */
  id: Scalars['ID'];
};

export type NotificationEmail = {
  email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NotificationType>;
};

export enum NotificationType {
  /** Send notification always */
  ALWAYS = 'always',
  /** Send notification on failure only */
  FAILURE_ONLY = 'failure_only',
}

export type Object = Node & {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['Iterable']>;
  resolvedFields?: Maybe<Scalars['Iterable']>;
  resolvedManageableLayers?: Maybe<Scalars['Iterable']>;
  resolvedManageableLayersConditions?: Maybe<Scalars['Iterable']>;
};

export enum ObjectPreviewType {
  IMAGE = 'image',
}

export type Options = {
  additionalData?: InputMaybe<OptionsAdditionalData>;
  authorization?: InputMaybe<Authorization>;
  connectorId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<ShopifyOptionsLanguage>;
  market?: InputMaybe<ShopifyOptionsMarket>;
  type?: InputMaybe<OptionsSourceType>;
  url?: InputMaybe<Scalars['String']>;
};

export type OptionsAdditionalData = {
  catalogId?: InputMaybe<Scalars['String']>;
  connectorId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OptionsAdditionalDataType>;
};

export enum OptionsAdditionalDataType {
  FACEBOOK = 'FACEBOOK',
}

export enum OptionsSourceType {
  SHOPIFY = 'SHOPIFY',
}

export enum OrderType {
  /** Order ascending */
  ASC = 'ASC',
  /** Order descending */
  DESC = 'DESC',
}

export type Paginate = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Payment = Node & {
  data?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
};

export type Product = Node & {
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  prices?: Maybe<Scalars['Iterable']>;
  productDescription?: Maybe<Scalars['String']>;
  productFeatures?: Maybe<Scalars['Iterable']>;
  productId?: Maybe<Scalars['String']>;
  productLimits?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
};

/** Cursor connection for Product. */
export type ProductCursorConnection = {
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  pageInfo: ProductPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Product. */
export type ProductEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Product>;
};

/** Information about the current page. */
export type ProductPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Profile = Node & {
  defaultTeamId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industryId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  onboarding?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Project = Node & {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  currentUpdate?: Maybe<Scalars['Iterable']>;
  currentUpdateId?: Maybe<Scalars['String']>;
  designs?: Maybe<Scalars['Iterable']>;
  estimatedScheduleAt?: Maybe<Scalars['String']>;
  feed?: Maybe<Scalars['Iterable']>;
  feedDownloadedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdate?: Maybe<Scalars['Iterable']>;
  lastUpdateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  outputSettings?: Maybe<Scalars['Iterable']>;
  projectId?: Maybe<Scalars['String']>;
  projectInfo?: Maybe<Scalars['Iterable']>;
  projectObjects?: Maybe<Scalars['Iterable']>;
  projectTokens?: Maybe<Scalars['Iterable']>;
  scheduledAt?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['Iterable']>;
  shouldProjectBeUpdated?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['Iterable']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for Project. */
export type ProjectCursorConnection = {
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  pageInfo: ProjectPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Project. */
export type ProjectEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Project>;
};

export type ProjectFeed = Node & {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

export type ProjectItem = Node & {
  id: Scalars['ID'];
  product?: Maybe<Scalars['Iterable']>;
  projectItemId?: Maybe<Scalars['String']>;
  projectObjectResults?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for ProjectItem. */
export type ProjectItemCursorConnection = {
  edges?: Maybe<Array<Maybe<ProjectItemEdge>>>;
  pageInfo: ProjectItemPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of ProjectItem. */
export type ProjectItemEdge = {
  cursor: Scalars['String'];
  node?: Maybe<ProjectItem>;
};

/** Page connection for ProjectItem. */
export type ProjectItemPageConnection = {
  collection?: Maybe<Array<Maybe<ProjectItem>>>;
  paginationInfo: ProjectItemPaginationInfo;
};

/** Information about the current page. */
export type ProjectItemPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type ProjectItemPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ProjectObject = Node & {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  options?: Maybe<Scalars['Iterable']>;
  ordering?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  projectObjectBehaviors?: Maybe<Scalars['Iterable']>;
  projectObjectId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ProjectObjectBehavior = Node & {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ordering?: Maybe<Scalars['Int']>;
  projectObjectBehaviorId?: Maybe<Scalars['String']>;
  projectObjectId?: Maybe<Scalars['String']>;
  rules?: Maybe<Scalars['Iterable']>;
  schedule?: Maybe<Scalars['Iterable']>;
  updatedAt?: Maybe<Scalars['String']>;
  usedDesigns?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for ProjectObjectBehavior. */
export type ProjectObjectBehaviorCursorConnection = {
  edges?: Maybe<Array<Maybe<ProjectObjectBehaviorEdge>>>;
  pageInfo: ProjectObjectBehaviorPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of ProjectObjectBehavior. */
export type ProjectObjectBehaviorEdge = {
  cursor: Scalars['String'];
  node?: Maybe<ProjectObjectBehavior>;
};

/** Page connection for ProjectObjectBehavior. */
export type ProjectObjectBehaviorPageConnection = {
  collection?: Maybe<Array<Maybe<ProjectObjectBehavior>>>;
  paginationInfo: ProjectObjectBehaviorPaginationInfo;
};

/** Information about the current page. */
export type ProjectObjectBehaviorPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type ProjectObjectBehaviorPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ProjectObjectBehaviorSettings = {
  rules?: InputMaybe<ProjectObjectBehaviorSettingsRules>;
  schedule?: InputMaybe<ProjectObjectBehaviorSettingsSchedule>;
};

export type ProjectObjectBehaviorSettingsRuleNode = {
  operator: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  values?: InputMaybe<Scalars['CropinkJson']>;
};

export type ProjectObjectBehaviorSettingsRules = {
  rules?: InputMaybe<ProjectObjectBehaviorSettingsRuleNode>;
  type: Scalars['String'];
};

export type ProjectObjectBehaviorSettingsSchedule = {
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Json']>;
};

/** Page connection for Project. */
export type ProjectPageConnection = {
  collection?: Maybe<Array<Maybe<Project>>>;
  paginationInfo: ProjectPaginationInfo;
};

/** Information about the current page. */
export type ProjectPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type ProjectPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ProjectSettingsOverrideData = {
  custom_label_0?: InputMaybe<
    Array<InputMaybe<ProjectSettingsOverrideItemLabel0>>
  >;
  custom_label_1?: InputMaybe<
    Array<InputMaybe<ProjectSettingsOverrideItemLabel1>>
  >;
  custom_label_2?: InputMaybe<
    Array<InputMaybe<ProjectSettingsOverrideItemLabel2>>
  >;
  custom_label_3?: InputMaybe<
    Array<InputMaybe<ProjectSettingsOverrideItemLabel3>>
  >;
  custom_label_4?: InputMaybe<
    Array<InputMaybe<ProjectSettingsOverrideItemLabel4>>
  >;
  link?: InputMaybe<Array<InputMaybe<ProjectSettingsOverrideItemLink>>>;
};

export type ProjectSettingsOverrideItemLabel0 = {
  isRaw?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectSettingsOverrideItemLabel1 = {
  isRaw?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectSettingsOverrideItemLabel2 = {
  isRaw?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectSettingsOverrideItemLabel3 = {
  isRaw?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectSettingsOverrideItemLabel4 = {
  isRaw?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectSettingsOverrideItemLink = {
  isRaw?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectToken = Node & {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLoginAt?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projectTokenId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Cursor connection for ProjectToken. */
export type ProjectTokenCursorConnection = {
  edges?: Maybe<Array<Maybe<ProjectTokenEdge>>>;
  pageInfo: ProjectTokenPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of ProjectToken. */
export type ProjectTokenEdge = {
  cursor: Scalars['String'];
  node?: Maybe<ProjectToken>;
};

/** Information about the current page. */
export type ProjectTokenPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ProjectUpdate = Node & {
  createdAt?: Maybe<Scalars['String']>;
  feed?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  isErrorReportFileExists?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageArguments?: Maybe<Scalars['Iterable']>;
  messageSeverity?: Maybe<Scalars['String']>;
  planDetails?: Maybe<Scalars['Iterable']>;
  priority?: Maybe<Scalars['Int']>;
  processingMode?: Maybe<Scalars['String']>;
  projectSettings?: Maybe<Scalars['Iterable']>;
  projectUpdateId?: Maybe<Scalars['String']>;
  statistics?: Maybe<Scalars['Iterable']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  usedDesigns?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for ProjectUpdate. */
export type ProjectUpdateCursorConnection = {
  edges?: Maybe<Array<Maybe<ProjectUpdateEdge>>>;
  pageInfo: ProjectUpdatePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of ProjectUpdate. */
export type ProjectUpdateEdge = {
  cursor: Scalars['String'];
  node?: Maybe<ProjectUpdate>;
};

/** Page connection for ProjectUpdate. */
export type ProjectUpdatePageConnection = {
  collection?: Maybe<Array<Maybe<ProjectUpdate>>>;
  paginationInfo: ProjectUpdatePaginationInfo;
};

/** Information about the current page. */
export type ProjectUpdatePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type ProjectUpdatePaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Protocol = {
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum ProtocolType {
  BASIC_AUTH = 'BASIC_AUTH',
  BEARER_TOKEN = 'BEARER_TOKEN',
  CREDENTIALS = 'CREDENTIALS',
  DIGEST = 'DIGEST',
}

export type Query = {
  adAccounts?: Maybe<AdAccountCursorConnection>;
  adminDesign?: Maybe<AdminDesign>;
  adminDesigns?: Maybe<AdminDesignCursorConnection>;
  adminElements?: Maybe<AdminElementCursorConnection>;
  adminLogos?: Maybe<AdminLogoCursorConnection>;
  adminProjectUpdateFileUrl?: Maybe<AdminProjectUpdateFileUrl>;
  adminProjectUpdateStatistics?: Maybe<AdminProjectUpdateStatistics>;
  adminProjectUpdates?: Maybe<AdminProjectUpdateCursorConnection>;
  adminProjects?: Maybe<AdminProjectCursorConnection>;
  adminStyle?: Maybe<AdminStyle>;
  adminStyles?: Maybe<AdminStyleCursorConnection>;
  adminTeam?: Maybe<AdminTeam>;
  adminTeams?: Maybe<AdminTeamCursorConnection>;
  adminTemplate?: Maybe<AdminTemplate>;
  adminTemplateGroup?: Maybe<AdminTemplateGroup>;
  adminTemplateGroups?: Maybe<AdminTemplateGroupCursorConnection>;
  adminTemplates?: Maybe<AdminTemplateCursorConnection>;
  adminUsers?: Maybe<AdminUserCursorConnection>;
  assetImages?: Maybe<AssetImageCursorConnection>;
  backgroundRemovalStatus?: Maybe<BackgroundRemovalStatus>;
  businessClients?: Maybe<BusinessClientCursorConnection>;
  callApiPayment?: Maybe<Payment>;
  catalogs?: Maybe<CatalogCursorConnection>;
  design?: Maybe<Design>;
  designCodes?: Maybe<DesignCodes>;
  designs?: Maybe<DesignCursorConnection>;
  dictionary?: Maybe<Dictionary>;
  elementCodes?: Maybe<ElementCodes>;
  elements?: Maybe<ElementCursorConnection>;
  eventLogs?: Maybe<EventLogCursorConnection>;
  facebookAds?: Maybe<FacebookAdCursorConnection>;
  fetchAdminProjectUpdateStatistics?: Maybe<AdminProjectUpdateStatistics>;
  fetchAdminStyle?: Maybe<AdminStyle>;
  fetchAdminTeam?: Maybe<AdminTeam>;
  fetchAdminTemplate?: Maybe<AdminTemplate>;
  fetchAdminTemplateGroup?: Maybe<AdminTemplateGroup>;
  fetchBackgroundRemovalStatus?: Maybe<BackgroundRemovalStatus>;
  fetchClientImage?: Maybe<ClientImage>;
  fetchCollectionAdAccounts?: Maybe<Array<Maybe<AdAccount>>>;
  /**
   * User list for external integrations (role SYSTEM_ADMIN_API_READ): profile, teams and what each user pays for.
   * Exposes `fetchCollectionAdminBillingUsers` only - no item query, no mutations.
   */
  fetchCollectionAdminBillingUsers?: Maybe<AdminBillingUserPageConnection>;
  fetchCollectionAdminElements?: Maybe<AdminElementPageConnection>;
  fetchCollectionAdminLogos?: Maybe<AdminLogoPageConnection>;
  fetchCollectionAdminProjectUpdates?: Maybe<AdminProjectUpdatePageConnection>;
  fetchCollectionAdminProjects?: Maybe<AdminProjectPageConnection>;
  fetchCollectionAdminStyles?: Maybe<AdminStylePageConnection>;
  fetchCollectionAdminTeams?: Maybe<AdminTeamPageConnection>;
  fetchCollectionAdminTemplateGroups?: Maybe<AdminTemplateGroupPageConnection>;
  fetchCollectionAdminTemplates?: Maybe<AdminTemplatePageConnection>;
  fetchCollectionAdminUsers?: Maybe<AdminUserPageConnection>;
  fetchCollectionBusinessClients?: Maybe<Array<Maybe<BusinessClient>>>;
  fetchCollectionCatalogs?: Maybe<Array<Maybe<Catalog>>>;
  fetchCollectionDesigns?: Maybe<DesignPageConnection>;
  fetchCollectionElementCategories?: Maybe<Array<Maybe<ElementCategory>>>;
  fetchCollectionElements?: Maybe<Array<Maybe<Element>>>;
  fetchCollectionEventLogs?: Maybe<Array<Maybe<EventLog>>>;
  fetchCollectionFacebookAds?: Maybe<FacebookAdPageConnection>;
  fetchCollectionFonts?: Maybe<Array<Maybe<Font>>>;
  fetchCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  fetchCollectionProjectItems?: Maybe<ProjectItemPageConnection>;
  fetchCollectionProjectObjectBehaviors?: Maybe<ProjectObjectBehaviorPageConnection>;
  fetchCollectionProjectTokens?: Maybe<Array<Maybe<ProjectToken>>>;
  fetchCollectionProjectUpdates?: Maybe<ProjectUpdatePageConnection>;
  fetchCollectionProjects?: Maybe<ProjectPageConnection>;
  fetchCollectionRecentDesigns?: Maybe<Array<Maybe<Design>>>;
  fetchCollectionRoles?: Maybe<Array<Maybe<Role>>>;
  fetchCollectionShopifyLanguages?: Maybe<Array<Maybe<ShopifyLanguage>>>;
  fetchCollectionShopifyMarkets?: Maybe<Array<Maybe<ShopifyMarket>>>;
  fetchCollectionTags?: Maybe<Array<Maybe<Tag>>>;
  fetchCollectionTeamFonts?: Maybe<Array<Maybe<Font>>>;
  fetchCollectionTeamInvitations?: Maybe<TeamInvitationPageConnection>;
  fetchCollectionTeamLogos?: Maybe<Array<Maybe<Logo>>>;
  fetchCollectionTeamMembers?: Maybe<Array<Maybe<TeamMember>>>;
  fetchCollectionTeamStyles?: Maybe<Array<Maybe<Style>>>;
  fetchCollectionTeamTokens?: Maybe<Array<Maybe<TeamToken>>>;
  fetchCollectionTemplates?: Maybe<TemplatePageConnection>;
  fetchCollectionUserTeams?: Maybe<Array<Maybe<Team>>>;
  fetchDesign?: Maybe<Design>;
  fetchDesignCodes?: Maybe<DesignCodes>;
  fetchDictionary?: Maybe<Dictionary>;
  fetchElementCodes?: Maybe<ElementCodes>;
  fetchFacebookFeed?: Maybe<FacebookFeed>;
  fetchFacebookPermissionReport?: Maybe<FacebookPermissionReport>;
  fetchFavouritesCollectionTemplates?: Maybe<TemplatePageConnection>;
  fetchProfile?: Maybe<Profile>;
  fetchProject?: Maybe<Project>;
  fetchProjectObjectBehavior?: Maybe<ProjectObjectBehavior>;
  fetchTeam?: Maybe<Team>;
  fetchTeamStyle?: Maybe<Style>;
  fetchTemplate?: Maybe<Template>;
  fetchTemplateGroup?: Maybe<TemplateGroup>;
  fetchUser?: Maybe<User>;
  fonts?: Maybe<FontCursorConnection>;
  logos?: Maybe<LogoCursorConnection>;
  node?: Maybe<Node>;
  products?: Maybe<ProductCursorConnection>;
  profile?: Maybe<Profile>;
  project?: Maybe<Project>;
  projectItems?: Maybe<ProjectItemCursorConnection>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
  projectObjectBehaviors?: Maybe<ProjectObjectBehaviorCursorConnection>;
  projectTokens?: Maybe<ProjectTokenCursorConnection>;
  projectUpdates?: Maybe<ProjectUpdateCursorConnection>;
  projects?: Maybe<ProjectCursorConnection>;
  roles?: Maybe<RoleCursorConnection>;
  shopifyLanguages?: Maybe<ShopifyLanguageCursorConnection>;
  shopifyMarkets?: Maybe<ShopifyMarketCursorConnection>;
  style?: Maybe<Style>;
  styles?: Maybe<StyleCursorConnection>;
  team?: Maybe<Team>;
  teamInvitations?: Maybe<TeamInvitationCursorConnection>;
  teamTokens?: Maybe<TeamTokenCursorConnection>;
  teams?: Maybe<TeamCursorConnection>;
  template?: Maybe<Template>;
  templateGroup?: Maybe<TemplateGroup>;
  templates?: Maybe<TemplateCursorConnection>;
  user?: Maybe<User>;
};

export type QueryAdAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminDesignArgs = {
  id: Scalars['ID'];
};

export type QueryAdminDesignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminLogosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminProjectUpdateFileUrlArgs = {
  id: Scalars['ID'];
};

export type QueryAdminProjectUpdateStatisticsArgs = {
  id: Scalars['ID'];
};

export type QueryAdminProjectUpdatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminStyleArgs = {
  id: Scalars['ID'];
};

export type QueryAdminStylesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminTeamArgs = {
  id: Scalars['ID'];
};

export type QueryAdminTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryAdminTemplateGroupArgs = {
  id: Scalars['ID'];
};

export type QueryAdminTemplateGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryAssetImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryBackgroundRemovalStatusArgs = {
  id: Scalars['ID'];
};

export type QueryBusinessClientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryCallApiPaymentArgs = {
  httpParams?: InputMaybe<Array<InputMaybe<HttpParam>>>;
  method: StripeMethod;
  routeParams?: InputMaybe<Array<InputMaybe<HttpParam>>>;
};

export type QueryCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryDesignArgs = {
  id: Scalars['ID'];
};

export type QueryDesignCodesArgs = {
  id: Scalars['ID'];
};

export type QueryDesignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryDictionaryArgs = {
  id: Scalars['ID'];
};

export type QueryElementCodesArgs = {
  id: Scalars['ID'];
};

export type QueryElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryEventLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryFacebookAdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryFetchAdminProjectUpdateStatisticsArgs = {
  projectUpdateId: Scalars['String'];
};

export type QueryFetchAdminStyleArgs = {
  styleId: Scalars['String'];
};

export type QueryFetchAdminTeamArgs = {
  teamId: Scalars['String'];
};

export type QueryFetchAdminTemplateArgs = {
  templateId: Scalars['String'];
};

export type QueryFetchAdminTemplateGroupArgs = {
  templateGroupId: Scalars['String'];
};

export type QueryFetchBackgroundRemovalStatusArgs = {
  projectUpdateId: Scalars['String'];
};

export type QueryFetchClientImageArgs = {
  backgroundRemoved?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['String'];
  url: Scalars['String'];
};

export type QueryFetchCollectionAdAccountsArgs = {
  connectorId: Scalars['String'];
};

export type QueryFetchCollectionAdminBillingUsersArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminElementsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminLogosArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminProjectUpdatesArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  projectId: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminProjectsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminStylesArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminTeamsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminTemplateGroupsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminTemplatesArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionAdminUsersArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionBusinessClientsArgs = {
  accessToken: Scalars['String'];
};

export type QueryFetchCollectionCatalogsArgs = {
  connectorId: Scalars['String'];
};

export type QueryFetchCollectionDesignsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  projectId: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionElementsArgs = {
  elementCategoryId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  withGlobal?: InputMaybe<Scalars['Boolean']>;
};

export type QueryFetchCollectionEventLogsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
};

export type QueryFetchCollectionFacebookAdsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  projectId: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionProjectItemsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  projectId: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionProjectObjectBehaviorsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  projectObjectId: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionProjectTokensArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  projectId: Scalars['String'];
};

export type QueryFetchCollectionProjectUpdatesArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  projectId: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionProjectsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  teamId: Scalars['String'];
};

export type QueryFetchCollectionRecentDesignsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
};

export type QueryFetchCollectionRolesArgs = {
  teamId?: InputMaybe<Scalars['String']>;
};

export type QueryFetchCollectionShopifyLanguagesArgs = {
  connectorId: Scalars['String'];
};

export type QueryFetchCollectionShopifyMarketsArgs = {
  connectorId: Scalars['String'];
};

export type QueryFetchCollectionTagsArgs = {
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryFetchCollectionTeamFontsArgs = {
  teamId: Scalars['String'];
};

export type QueryFetchCollectionTeamInvitationsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  teamId: Scalars['String'];
};

export type QueryFetchCollectionTeamLogosArgs = {
  teamId: Scalars['String'];
};

export type QueryFetchCollectionTeamMembersArgs = {
  teamId: Scalars['String'];
};

export type QueryFetchCollectionTeamStylesArgs = {
  teamId: Scalars['String'];
};

export type QueryFetchCollectionTeamTokensArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  teamId: Scalars['String'];
};

export type QueryFetchCollectionTemplatesArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchCollectionUserTeamsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type QueryFetchDesignArgs = {
  designId: Scalars['String'];
};

export type QueryFetchDesignCodesArgs = {
  designId: Scalars['String'];
};

export type QueryFetchElementCodesArgs = {
  elementId: Scalars['String'];
};

export type QueryFetchFacebookFeedArgs = {
  catalogId: Scalars['String'];
  connectorId: Scalars['String'];
  projectId: Scalars['String'];
};

export type QueryFetchFacebookPermissionReportArgs = {
  projectId: Scalars['String'];
};

export type QueryFetchFavouritesCollectionTemplatesArgs = {
  paginate?: InputMaybe<Paginate>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type QueryFetchProjectArgs = {
  projectId: Scalars['String'];
};

export type QueryFetchProjectObjectBehaviorArgs = {
  projectObjectBehaviorId: Scalars['String'];
};

export type QueryFetchTeamArgs = {
  teamId: Scalars['String'];
};

export type QueryFetchTeamStyleArgs = {
  styleId: Scalars['String'];
};

export type QueryFetchTemplateArgs = {
  templateId: Scalars['String'];
};

export type QueryFetchTemplateGroupArgs = {
  templateGroupId: Scalars['String'];
};

export type QueryFetchUserArgs = {
  userId: Scalars['String'];
};

export type QueryFontsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryLogosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryNodeArgs = {
  id: Scalars['ID'];
};

export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryProfileArgs = {
  id: Scalars['ID'];
};

export type QueryProjectArgs = {
  id: Scalars['ID'];
};

export type QueryProjectItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryProjectObjectBehaviorArgs = {
  id: Scalars['ID'];
};

export type QueryProjectObjectBehaviorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryProjectTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryProjectUpdatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryShopifyLanguagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryShopifyMarketsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryStyleArgs = {
  id: Scalars['ID'];
};

export type QueryStylesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryTeamArgs = {
  id: Scalars['ID'];
};

export type QueryTeamInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryTeamTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryTemplateGroupArgs = {
  id: Scalars['ID'];
};

export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type RateLimit = {
  interval: Scalars['String'];
  limit: Scalars['Int'];
  url_pattern: Scalars['String'];
};

export type Role = Node & {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  permissions?: Maybe<Scalars['Iterable']>;
  roleId?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
};

/** Cursor connection for Role. */
export type RoleCursorConnection = {
  edges?: Maybe<Array<Maybe<RoleEdge>>>;
  pageInfo: RolePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Role. */
export type RoleEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Role>;
};

/** Information about the current page. */
export type RolePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export enum ScheduleFrequency {
  /** Perform update every 2 hours */
  EVERY_2_HOURS = 'EVERY_2_HOURS',
  /** Perform update every 4 hours */
  EVERY_4_HOURS = 'EVERY_4_HOURS',
  /** Perform update every 6 hours */
  EVERY_6_HOURS = 'EVERY_6_HOURS',
  /** Perform update every 8 hours */
  EVERY_8_HOURS = 'EVERY_8_HOURS',
  /** Perform update every 16 hours */
  EVERY_16_HOURS = 'EVERY_16_HOURS',
  /** Perform update every 24 hours */
  EVERY_24_HOURS = 'EVERY_24_HOURS',
  /** Do not perform project update */
  NO_UPDATE = 'NO_UPDATE',
}

export type ShopifyLanguage = Node & {
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
};

/** Cursor connection for ShopifyLanguage. */
export type ShopifyLanguageCursorConnection = {
  edges?: Maybe<Array<Maybe<ShopifyLanguageEdge>>>;
  pageInfo: ShopifyLanguagePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of ShopifyLanguage. */
export type ShopifyLanguageEdge = {
  cursor: Scalars['String'];
  node?: Maybe<ShopifyLanguage>;
};

/** Information about the current page. */
export type ShopifyLanguagePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ShopifyLogin = Node & {
  authorizeUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sessionTokenId?: Maybe<Scalars['String']>;
};

export type ShopifyMarket = Node & {
  handle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marketId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Cursor connection for ShopifyMarket. */
export type ShopifyMarketCursorConnection = {
  edges?: Maybe<Array<Maybe<ShopifyMarketEdge>>>;
  pageInfo: ShopifyMarketPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of ShopifyMarket. */
export type ShopifyMarketEdge = {
  cursor: Scalars['String'];
  node?: Maybe<ShopifyMarket>;
};

/** Information about the current page. */
export type ShopifyMarketPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ShopifyOptionsLanguage = {
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ShopifyOptionsMarket = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Sort = {
  field?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<OrderType>;
};

export enum SourceType {
  API = 'API',
  FILE = 'FILE',
}

export enum StripeMethod {
  INVOICE_LIST = 'invoice_list',
  INVOICE_VIEW = 'invoice_view',
}

export type Style = Node & {
  createdAt?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  styleId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for Style. */
export type StyleCursorConnection = {
  edges?: Maybe<Array<Maybe<StyleEdge>>>;
  pageInfo: StylePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Style. */
export type StyleEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Style>;
};

/** Information about the current page. */
export type StylePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Subscription = Node & {
  id: Scalars['ID'];
  nextSubscription?: Maybe<Scalars['Iterable']>;
  planDetails?: Maybe<Scalars['Iterable']>;
  recurringInterval?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
  validTo?: Maybe<Scalars['String']>;
};

export type Tag = Node & {
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  tagId?: Maybe<Scalars['String']>;
  templatesCount?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Team = Node & {
  active?: Maybe<Scalars['Boolean']>;
  assetImages?: Maybe<Scalars['Iterable']>;
  connectors?: Maybe<Scalars['Iterable']>;
  createdAt?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  fonts?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  invitations?: Maybe<Scalars['Iterable']>;
  logos?: Maybe<Scalars['Iterable']>;
  members?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Iterable']>;
  projects?: Maybe<Scalars['Iterable']>;
  styles?: Maybe<Scalars['Iterable']>;
  subscription?: Maybe<Scalars['Iterable']>;
  teamId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userPermissions?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for Team. */
export type TeamCursorConnection = {
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  pageInfo: TeamPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Team. */
export type TeamEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Team>;
};

export type TeamInvitation = Node & {
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  roleId?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  teamInvitationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type TeamInvitationConfirmation = Node & {
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
};

export type TeamInvitationCreation = Node & {
  id: Scalars['ID'];
  teamInvitations?: Maybe<Scalars['Iterable']>;
};

/** Cursor connection for TeamInvitation. */
export type TeamInvitationCursorConnection = {
  edges?: Maybe<Array<Maybe<TeamInvitationEdge>>>;
  pageInfo: TeamInvitationPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of TeamInvitation. */
export type TeamInvitationEdge = {
  cursor: Scalars['String'];
  node?: Maybe<TeamInvitation>;
};

/** Page connection for TeamInvitation. */
export type TeamInvitationPageConnection = {
  collection?: Maybe<Array<Maybe<TeamInvitation>>>;
  paginationInfo: TeamInvitationPaginationInfo;
};

/** Information about the current page. */
export type TeamInvitationPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type TeamInvitationPaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type TeamInvitationRequest = {
  email?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type TeamMember = Node & {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Information about the current page. */
export type TeamPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TeamToken = Node & {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLoginAt?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  teamTokenId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Cursor connection for TeamToken. */
export type TeamTokenCursorConnection = {
  edges?: Maybe<Array<Maybe<TeamTokenEdge>>>;
  pageInfo: TeamTokenPageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of TeamToken. */
export type TeamTokenEdge = {
  cursor: Scalars['String'];
  node?: Maybe<TeamToken>;
};

/** Information about the current page. */
export type TeamTokenPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TeamUser = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: Maybe<Scalars['Iterable']>;
  team?: Maybe<Scalars['Iterable']>;
  user?: Maybe<Scalars['Iterable']>;
};

export type Template = Node & {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  cropinkCode?: Maybe<Scalars['Iterable']>;
  features?: Maybe<Scalars['Iterable']>;
  figmaCode?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  isFavourite?: Maybe<Scalars['Boolean']>;
  mainSize?: Maybe<Scalars['Iterable']>;
  manageableLayersNested?: Maybe<Scalars['Iterable']>;
  manageableLayersSettings?: Maybe<Scalars['Iterable']>;
  mappedFonts?: Maybe<Scalars['Iterable']>;
  mappedStyles?: Maybe<Scalars['Iterable']>;
  name?: Maybe<Scalars['String']>;
  previewImageId?: Maybe<Scalars['String']>;
  styles?: Maybe<Scalars['Iterable']>;
  stylizable?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['Iterable']>;
  templateGroupId?: Maybe<Scalars['String']>;
  templateGroupName?: Maybe<Scalars['String']>;
  templateGroupTemplates?: Maybe<Scalars['Iterable']>;
  templateId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Cursor connection for Template. */
export type TemplateCursorConnection = {
  edges?: Maybe<Array<Maybe<TemplateEdge>>>;
  pageInfo: TemplatePageInfo;
  totalCount: Scalars['Int'];
};

/** Edge of Template. */
export type TemplateEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Template>;
};

export type TemplateGroup = Node & {
  baseTemplate?: Maybe<Scalars['Iterable']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  templateGroupId?: Maybe<Scalars['String']>;
  templates?: Maybe<Scalars['Iterable']>;
};

/** Page connection for Template. */
export type TemplatePageConnection = {
  collection?: Maybe<Array<Maybe<Template>>>;
  paginationInfo: TemplatePaginationInfo;
};

/** Information about the current page. */
export type TemplatePageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** Information about the pagination. */
export type TemplatePaginationInfo = {
  hasNextPage: Scalars['Boolean'];
  itemsPerPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum TextEngine {
  /** Render text with ImageMagick */
  IMAGICK = 'IMAGICK',
  /** Render text with libvips */
  VIPS = 'VIPS',
}

export type User = Node & {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industryId?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['Iterable']>;
  onboarding?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  tracking?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Websocket = Node & {
  auth?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Activates a AdminElement. */
export type ActivateAdminElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementId: Scalars['String'];
};

/** Activates a AdminElement. */
export type ActivateAdminElementPayload = {
  adminElement?: Maybe<AdminElement>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Activates a AdminProject. */
export type ActivateAdminProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Activates a AdminProject. */
export type ActivateAdminProjectPayload = {
  adminProject?: Maybe<AdminProject>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Activates a AdminStyle. */
export type ActivateAdminStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleId: Scalars['String'];
};

/** Activates a AdminStyle. */
export type ActivateAdminStylePayload = {
  adminStyle?: Maybe<AdminStyle>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Activates a AdminTeam. */
export type ActivateAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Activates a AdminTeam. */
export type ActivateAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Activates a AdminTemplate. */
export type ActivateAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** Activates a AdminTemplate. */
export type ActivateAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** ActivateDesigns a ProjectObjectBehavior. */
export type ActivateDesignProjectObjectBehaviorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectBehaviorId: Scalars['String'];
  usedDesignId: Scalars['String'];
};

/** ActivateDesigns a ProjectObjectBehavior. */
export type ActivateDesignProjectObjectBehaviorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
};

/** Activates a Project. */
export type ActivateProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Activates a Project. */
export type ActivateProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** AddFavourites a Template. */
export type AddFavouriteTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** AddFavourites a Template. */
export type AddFavouriteTemplatePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  template?: Maybe<Template>;
};

/** AssignAdminRoles a AdminUser. */
export type AssignAdminRoleAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** AssignAdminRoles a AdminUser. */
export type AssignAdminRoleAdminUserPayload = {
  adminUser?: Maybe<AdminUser>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** AssignDefaults a Font. */
export type AssignDefaultFontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fontId: Scalars['String'];
  teamId: Scalars['String'];
};

/** AssignDefaults a Font. */
export type AssignDefaultFontPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  font?: Maybe<Font>;
};

/** AssignDefaults a Logo. */
export type AssignDefaultLogoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  logoId: Scalars['String'];
  teamId: Scalars['String'];
};

/** AssignDefaults a Logo. */
export type AssignDefaultLogoPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  logo?: Maybe<Logo>;
};

/** AssignDesignToProjectObjectBehaviors a ProjectObject. */
export type AssignDesignToProjectObjectBehaviorProjectObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designIds: Array<InputMaybe<Scalars['String']>>;
  projectObjectBehaviorId?: InputMaybe<Scalars['String']>;
  projectObjectId: Scalars['String'];
};

/** AssignDesignToProjectObjectBehaviors a ProjectObject. */
export type AssignDesignToProjectObjectBehaviorProjectObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObject?: Maybe<ProjectObject>;
};

/** AssignFacebookCatalogTos a Project. */
export type AssignFacebookCatalogToProjectInput = {
  adAccountId: Scalars['String'];
  catalogId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectorId: Scalars['String'];
  forceDeleteSupplementaryFeed?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};

/** AssignFacebookCatalogTos a Project. */
export type AssignFacebookCatalogToProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** AssignProjectObjectToFacebookAds a Project. */
export type AssignProjectObjectToFacebookAdProjectInput = {
  adId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectId: Scalars['String'];
};

/** AssignProjectObjectToFacebookAds a Project. */
export type AssignProjectObjectToFacebookAdProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** AssignStyles a AdminTemplate. */
export type AssignStyleAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleIds: Array<Scalars['String']>;
  templateId: Scalars['String'];
};

/** AssignStyles a AdminTemplate. */
export type AssignStyleAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** AssignToOnboardings a AdminTemplate. */
export type AssignToOnboardingAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** AssignToOnboardings a AdminTemplate. */
export type AssignToOnboardingAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** AssignToTeams a Connector. */
export type AssignToTeamConnectorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectorId: Scalars['String'];
  teamId: Scalars['String'];
};

/** AssignToTeams a Connector. */
export type AssignToTeamConnectorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  connector?: Maybe<Connector>;
};

/** Auths a Websocket. */
export type AuthWebsocketInput = {
  channelName: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  socketId: Scalars['String'];
};

/** Auths a Websocket. */
export type AuthWebsocketPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  websocket?: Maybe<Websocket>;
};

/** CancelFeedProcessings a Project. */
export type CancelFeedProcessingProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** CancelFeedProcessings a Project. */
export type CancelFeedProcessingProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Cancels a Subscription. */
export type CancelSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Cancels a Subscription. */
export type CancelSubscriptionPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
};

/** Changes a AuthUserPassword. */
export type ChangeAuthUserPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

/** Changes a AuthUserPassword. */
export type ChangeAuthUserPasswordPayload = {
  authUserPassword?: Maybe<AuthUserPassword>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** ChangeOrders a ProjectObjectBehavior. */
export type ChangeOrderProjectObjectBehaviorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['Int']>;
  projectObjectBehaviorId: Scalars['String'];
};

/** ChangeOrders a ProjectObjectBehavior. */
export type ChangeOrderProjectObjectBehaviorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
};

/** ChangeOrders a ProjectObject. */
export type ChangeOrderProjectObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['Int']>;
  projectObjectId: Scalars['String'];
};

/** ChangeOrders a ProjectObject. */
export type ChangeOrderProjectObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObject?: Maybe<ProjectObject>;
};

/** ChangePasswords a AuthResetPasswordToken. */
export type ChangePasswordUserResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

/** ChangePasswords a AuthResetPasswordToken. */
export type ChangePasswordUserResetPasswordPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  userResetPassword?: Maybe<ChangePasswordUserResetPasswordPayloadData>;
};

/** ChangePasswords a AuthResetPasswordToken. */
export type ChangePasswordUserResetPasswordPayloadData = Node & {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

/** ChangeRoles a TeamUser. */
export type ChangeRoleTeamUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

/** ChangeRoles a TeamUser. */
export type ChangeRoleTeamUserPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  teamUser?: Maybe<TeamUser>;
};

/** ClaimShopifyInstallations a Connector. */
export type ClaimShopifyInstallationConnectorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  installationToken: Scalars['String'];
  teamId: Scalars['String'];
};

/** ClaimShopifyInstallations a Connector. */
export type ClaimShopifyInstallationConnectorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  connector?: Maybe<Connector>;
};

/** Clones a Design. */
export type CloneDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** Clones a Design. */
export type CloneDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** Clones a Project. */
export type CloneProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Clones a Project. */
export type CloneProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Clones a Team. */
export type CloneTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  withProjects: Scalars['Boolean'];
  withUsers: Scalars['Boolean'];
};

/** Clones a Team. */
export type CloneTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** CloneToProjects a Designs. */
export type CloneToProjectDesignsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  projectIds: Array<Scalars['String']>;
};

/** CloneToProjects a Designs. */
export type CloneToProjectDesignsPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  designs?: Maybe<Designs>;
};

/** Confirms a TeamInvitationConfirmation. */
export type ConfirmTeamInvitationConfirmationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Confirms a TeamInvitationConfirmation. */
export type ConfirmTeamInvitationConfirmationPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  teamInvitationConfirmation?: Maybe<TeamInvitationConfirmation>;
};

/** Creates a AdminElementCategory. */
export type CreateAdminElementCategoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Creates a AdminElementCategory. */
export type CreateAdminElementCategoryPayload = {
  adminElementCategory?: Maybe<AdminElementCategory>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Creates a AdminStyle. */
export type CreateAdminStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  definition: Scalars['StyleDefinitionJson'];
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Creates a AdminStyle. */
export type CreateAdminStylePayload = {
  adminStyle?: Maybe<AdminStyle>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Creates a AdminTeam. */
export type CreateAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  userId: Scalars['String'];
};

/** Creates a AdminTeam. */
export type CreateAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Creates a AdminTemplateGroup. */
export type CreateAdminTemplateGroupInput = {
  baseTemplateId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  templateIds: Array<Scalars['String']>;
};

/** Creates a AdminTemplateGroup. */
export type CreateAdminTemplateGroupPayload = {
  adminTemplateGroup?: Maybe<AdminTemplateGroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Creates a BillingPortalSession. */
export type CreateBillingPortalSessionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Creates a BillingPortalSession. */
export type CreateBillingPortalSessionPayload = {
  billingPortalSession?: Maybe<BillingPortalSession>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Creates a Connector. */
export type CreateConnectorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectionData: ConnectionData;
  teamId?: InputMaybe<Scalars['String']>;
};

/** Creates a Connector. */
export type CreateConnectorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  connector?: Maybe<Connector>;
};

/** Creates a Design. */
export type CreateDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Creates a Design. */
export type CreateDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** CreateFromDesigns a AdminTemplate. */
export type CreateFromDesignAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
};

/** CreateFromDesigns a AdminTemplate. */
export type CreateFromDesignAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** CreateFromTeamElements a AdminElement. */
export type CreateFromTeamElementAdminElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** CreateFromTeamElements a AdminElement. */
export type CreateFromTeamElementAdminElementPayload = {
  adminElement?: Maybe<AdminElement>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** CreateFromTemplates a Design. */
export type CreateFromTemplateDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  styleId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** CreateFromTemplates a Design. */
export type CreateFromTemplateDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** CreateMultiparts a AdminTemplate. */
export type CreateMultipartAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Scalars['CodeFeatures']>;
  figmaCode: Scalars['FigmaJson'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
  manageableLayersSettings?: InputMaybe<Scalars['LayerSettingsJson']>;
  name?: InputMaybe<Scalars['String']>;
};

/** CreateMultiparts a AdminTemplate. */
export type CreateMultipartAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** CreateMultipartFromFigmaCodes a Element. */
export type CreateMultipartFromFigmaCodeElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  figmaCode: Scalars['FigmaJson'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
  name: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

/** CreateMultipartFromFigmaCodes a Element. */
export type CreateMultipartFromFigmaCodeElementPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  element?: Maybe<Element>;
};

/** CreateMultipartObjectPreviewFromFigmaCodes a Object. */
export type CreateMultipartObjectPreviewFromFigmaCodeObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  figmaCode: Scalars['FigmaJson'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
  productId?: InputMaybe<Scalars['String']>;
  type: ObjectPreviewType;
};

/** CreateMultipartObjectPreviewFromFigmaCodes a Object. */
export type CreateMultipartObjectPreviewFromFigmaCodeObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  object?: Maybe<Object>;
};

/** CreateObjectPreviewFromDesigns a Object. */
export type CreateObjectPreviewFromDesignObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customStyle: Scalars['StyleDefinitionJson'];
  designId: Scalars['String'];
  figmaCode?: InputMaybe<Scalars['FigmaJson']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  manageableLayersSettings: Scalars['LayerSettingsJson'];
  productData?: InputMaybe<Scalars['ProductDataJson']>;
  productId?: InputMaybe<Scalars['String']>;
  styleId?: InputMaybe<Scalars['String']>;
  type: ObjectPreviewType;
};

/** CreateObjectPreviewFromDesigns a Object. */
export type CreateObjectPreviewFromDesignObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  object?: Maybe<Object>;
};

/** CreateObjectPreviewFromTemplates a Object. */
export type CreateObjectPreviewFromTemplateObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customStyle: Scalars['StyleDefinitionJson'];
  figmaCode?: InputMaybe<Scalars['FigmaJson']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  manageableLayersSettings?: InputMaybe<Scalars['LayerSettingsJson']>;
  productData?: InputMaybe<Scalars['ProductDataJson']>;
  styleId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
  type: ObjectPreviewType;
};

/** CreateObjectPreviewFromTemplates a Object. */
export type CreateObjectPreviewFromTemplateObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  object?: Maybe<Object>;
};

/** Creates a Project. */
export type CreateProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['ID'];
};

/** Creates a ProjectObject. */
export type CreateProjectObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectId: Scalars['String'];
};

/** Creates a ProjectObject. */
export type CreateProjectObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObject?: Maybe<ProjectObject>;
};

/** Creates a Project. */
export type CreateProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Creates a ProjectToken. */
export type CreateProjectTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Creates a ProjectToken. */
export type CreateProjectTokenPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectToken?: Maybe<ProjectToken>;
};

/** CreateSamples a Project. */
export type CreateSampleProjectInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  currentUpdate?: InputMaybe<Scalars['Iterable']>;
  currentUpdateId?: InputMaybe<Scalars['String']>;
  designs?: InputMaybe<Scalars['Iterable']>;
  estimatedScheduleAt?: InputMaybe<Scalars['String']>;
  feed?: InputMaybe<Scalars['Iterable']>;
  feedDownloadedAt?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['Iterable']>;
  lastUpdateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  outputSettings?: InputMaybe<Scalars['Iterable']>;
  projectId?: InputMaybe<Scalars['String']>;
  projectInfo?: InputMaybe<Scalars['Iterable']>;
  projectObjects?: InputMaybe<Scalars['Iterable']>;
  projectTokens?: InputMaybe<Scalars['Iterable']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['Iterable']>;
  shouldProjectBeUpdated?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Scalars['Iterable']>;
  teamId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

/** CreateSamples a Project. */
export type CreateSampleProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Creates a Style. */
export type CreateStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
};

/** Creates a Style. */
export type CreateStylePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
};

/** CreateStyledTemplatePreviews a Object. */
export type CreateStyledTemplatePreviewObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleId: Scalars['String'];
  templateId: Scalars['String'];
};

/** CreateStyledTemplatePreviews a Object. */
export type CreateStyledTemplatePreviewObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  object?: Maybe<Object>;
};

/** CreateSubscriptions a CheckoutSession. */
export type CreateSubscriptionCheckoutSessionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  teamProductsLimit?: InputMaybe<Scalars['Int']>;
};

/** CreateSubscriptions a CheckoutSession. */
export type CreateSubscriptionCheckoutSessionPayload = {
  checkoutSession?: Maybe<CheckoutSession>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Creates a Team. */
export type CreateTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Creates a TeamInvitationCreation. */
export type CreateTeamInvitationCreationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  teamInvitations: Array<InputMaybe<TeamInvitationRequest>>;
};

/** Creates a TeamInvitationCreation. */
export type CreateTeamInvitationCreationPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  teamInvitationCreation?: Maybe<TeamInvitationCreation>;
};

/** Creates a Team. */
export type CreateTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** Creates a TeamToken. */
export type CreateTeamTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Creates a TeamToken. */
export type CreateTeamTokenPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  teamToken?: Maybe<TeamToken>;
};

/** Creates a AuthVerificationCode. */
export type CreateUserVerificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Creates a AuthVerificationCode. */
export type CreateUserVerificationPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  userVerification?: Maybe<CreateUserVerificationPayloadData>;
};

/** Creates a AuthVerificationCode. */
export type CreateUserVerificationPayloadData = Node & {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

/** Deactivates a AdminElement. */
export type DeactivateAdminElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementId: Scalars['String'];
};

/** Deactivates a AdminElement. */
export type DeactivateAdminElementPayload = {
  adminElement?: Maybe<AdminElement>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Deactivates a AdminProject. */
export type DeactivateAdminProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Deactivates a AdminProject. */
export type DeactivateAdminProjectPayload = {
  adminProject?: Maybe<AdminProject>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Deactivates a AdminStyle. */
export type DeactivateAdminStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleId: Scalars['String'];
};

/** Deactivates a AdminStyle. */
export type DeactivateAdminStylePayload = {
  adminStyle?: Maybe<AdminStyle>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Deactivates a AdminTeam. */
export type DeactivateAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Deactivates a AdminTeam. */
export type DeactivateAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Deactivates a AdminTemplate. */
export type DeactivateAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** Deactivates a AdminTemplate. */
export type DeactivateAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** DeactivateDesigns a ProjectObjectBehavior. */
export type DeactivateDesignProjectObjectBehaviorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectBehaviorId: Scalars['String'];
  usedDesignId: Scalars['String'];
};

/** DeactivateDesigns a ProjectObjectBehavior. */
export type DeactivateDesignProjectObjectBehaviorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
};

/** Deactivates a Project. */
export type DeactivateProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Deactivates a Project. */
export type DeactivateProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Disconnects a ProjectFeed. */
export type DisconnectProjectFeedInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Disconnects a ProjectFeed. */
export type DisconnectProjectFeedPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectFeed?: Maybe<ProjectFeed>;
};

/** EditNames a AdminTemplateGroup. */
export type EditNameAdminTemplateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  templateGroupId: Scalars['String'];
};

/** EditNames a AdminTemplateGroup. */
export type EditNameAdminTemplateGroupPayload = {
  adminTemplateGroup?: Maybe<AdminTemplateGroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** FinishOnboardings a User. */
export type FinishOnboardingUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** FinishOnboardings a User. */
export type FinishOnboardingUserPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** ForceFeeds a Project. */
export type ForceFeedProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  debug?: InputMaybe<DebugOptions>;
  projectId: Scalars['String'];
};

/** ForceFeeds a Project. */
export type ForceFeedProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Generates a AdminProjectUpdateFileUrl. */
export type GenerateAdminProjectUpdateFileUrlInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  feedType?: InputMaybe<Scalars['String']>;
  fileType: Scalars['String'];
  projectUpdateId: Scalars['String'];
};

/** Generates a AdminProjectUpdateFileUrl. */
export type GenerateAdminProjectUpdateFileUrlPayload = {
  adminProjectUpdateFileUrl?: Maybe<AdminProjectUpdateFileUrl>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** GenerateTokens a AuthResetPasswordToken. */
export type GenerateTokenUserResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** GenerateTokens a AuthResetPasswordToken. */
export type GenerateTokenUserResetPasswordPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  userResetPassword?: Maybe<GenerateTokenUserResetPasswordPayloadData>;
};

/** GenerateTokens a AuthResetPasswordToken. */
export type GenerateTokenUserResetPasswordPayloadData = Node & {
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

/** Initiates a FacebookLogin. */
export type InitiateFacebookLoginInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectorId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Initiates a FacebookLogin. */
export type InitiateFacebookLoginPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  facebookLogin?: Maybe<FacebookLogin>;
};

/** Initiates a ShopifyLogin. */
export type InitiateShopifyLoginInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectorId?: InputMaybe<Scalars['String']>;
  shop: Scalars['String'];
  teamId: Scalars['String'];
};

/** Initiates a ShopifyLogin. */
export type InitiateShopifyLoginPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  shopifyLogin?: Maybe<ShopifyLogin>;
};

/** InvalidateObjects a AdminProject. */
export type InvalidateObjectAdminProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  objectId: Scalars['String'];
  projectId: Scalars['String'];
};

/** InvalidateObjects a AdminProject. */
export type InvalidateObjectAdminProjectPayload = {
  adminProject?: Maybe<AdminProject>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Leaves a Team. */
export type LeaveTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Leaves a Team. */
export type LeaveTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** LoginCredentialss a Auth. */
export type LoginCredentialsUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

/** LoginCredentialss a Auth. */
export type LoginCredentialsUserPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<LoginCredentialsUserPayloadData>;
};

/** LoginCredentialss a Auth. */
export type LoginCredentialsUserPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** Logins a Auth. */
export type LoginProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectToken: Scalars['String'];
};

/** Logins a Auth. */
export type LoginProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<LoginProjectPayloadData>;
};

/** Logins a Auth. */
export type LoginProjectPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** LoginSharedDesigns a Auth. */
export type LoginSharedDesignAuthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  pin?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** LoginSharedDesigns a Auth. */
export type LoginSharedDesignAuthPayload = {
  auth?: Maybe<LoginSharedDesignAuthPayloadData>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** LoginSharedDesigns a Auth. */
export type LoginSharedDesignAuthPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** LoginSharedProjects a Auth. */
export type LoginSharedProjectAuthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  token: Scalars['String'];
};

/** LoginSharedProjects a Auth. */
export type LoginSharedProjectAuthPayload = {
  auth?: Maybe<LoginSharedProjectAuthPayloadData>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** LoginSharedProjects a Auth. */
export type LoginSharedProjectAuthPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** LoginTeams a Auth. */
export type LoginTeamAuthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamToken: Scalars['String'];
};

/** LoginTeams a Auth. */
export type LoginTeamAuthPayload = {
  auth?: Maybe<LoginTeamAuthPayloadData>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** LoginTeams a Auth. */
export type LoginTeamAuthPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** LogoutProjects a Auth. */
export type LogoutProjectAuthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

/** LogoutProjects a Auth. */
export type LogoutProjectAuthPayload = {
  auth?: Maybe<LogoutProjectAuthPayloadData>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** LogoutProjects a Auth. */
export type LogoutProjectAuthPayloadData = Node & {
  id: Scalars['ID'];
};

/** LogoutTeams a Auth. */
export type LogoutTeamAuthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

/** LogoutTeams a Auth. */
export type LogoutTeamAuthPayload = {
  auth?: Maybe<LogoutTeamAuthPayloadData>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** LogoutTeams a Auth. */
export type LogoutTeamAuthPayloadData = Node & {
  id: Scalars['ID'];
};

/** LogoutUsers a Auth. */
export type LogoutUserAuthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

/** LogoutUsers a Auth. */
export type LogoutUserAuthPayload = {
  auth?: Maybe<LogoutUserAuthPayloadData>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** LogoutUsers a Auth. */
export type LogoutUserAuthPayloadData = Node & {
  id: Scalars['ID'];
};

/** RefreshCollectionAdss a Project. */
export type RefreshCollectionAdsProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** RefreshCollectionAdss a Project. */
export type RefreshCollectionAdsProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Refreshs a Auth. */
export type RefreshSessionTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

/** Refreshs a Auth. */
export type RefreshSessionTokenPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  sessionToken?: Maybe<RefreshSessionTokenPayloadData>;
};

/** Refreshs a Auth. */
export type RefreshSessionTokenPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** RegisterTeamInvitations a Auth. */
export type RegisterTeamInvitationConfirmationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

/** RegisterTeamInvitations a Auth. */
export type RegisterTeamInvitationConfirmationPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  confirmation?: Maybe<RegisterTeamInvitationConfirmationPayloadData>;
};

/** RegisterTeamInvitations a Auth. */
export type RegisterTeamInvitationConfirmationPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** Registers a Auth. */
export type RegisterUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['Int'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  onboardingType?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  survey?: InputMaybe<Scalars['Survey']>;
  tracking?: InputMaybe<Scalars['String']>;
};

/** Registers a Auth. */
export type RegisterUserPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<RegisterUserPayloadData>;
};

/** Registers a Auth. */
export type RegisterUserPayloadData = Node & {
  _id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiresAt?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
};

/** Removes a AdminElementCategory. */
export type RemoveAdminElementCategoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementCategoryId: Scalars['String'];
};

/** Removes a AdminElementCategory. */
export type RemoveAdminElementCategoryPayload = {
  adminElementCategory?: Maybe<AdminElementCategory>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminElement. */
export type RemoveAdminElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementId: Scalars['String'];
};

/** Removes a AdminElement. */
export type RemoveAdminElementPayload = {
  adminElement?: Maybe<AdminElement>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminFont. */
export type RemoveAdminFontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fontId: Scalars['String'];
};

/** Removes a AdminFont. */
export type RemoveAdminFontPayload = {
  adminFont?: Maybe<AdminFont>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminProject. */
export type RemoveAdminProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Removes a AdminProject. */
export type RemoveAdminProjectPayload = {
  adminProject?: Maybe<AdminProject>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminStyle. */
export type RemoveAdminStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleId: Scalars['String'];
};

/** Removes a AdminStyle. */
export type RemoveAdminStylePayload = {
  adminStyle?: Maybe<AdminStyle>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminTeam. */
export type RemoveAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Removes a AdminTeam. */
export type RemoveAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminTemplateGroup. */
export type RemoveAdminTemplateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateGroupId: Scalars['String'];
};

/** Removes a AdminTemplateGroup. */
export type RemoveAdminTemplateGroupPayload = {
  adminTemplateGroup?: Maybe<AdminTemplateGroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminTemplate. */
export type RemoveAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** Removes a AdminTemplate. */
export type RemoveAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AdminUser. */
export type RemoveAdminUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** Removes a AdminUser. */
export type RemoveAdminUserPayload = {
  adminUser?: Maybe<AdminUser>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a AssetImage. */
export type RemoveAssetImageInput = {
  assetImageId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Removes a AssetImage. */
export type RemoveAssetImagePayload = {
  assetImage?: Maybe<AssetImage>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Removes a Connector. */
export type RemoveConnectorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectorId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
};

/** Removes a Connector. */
export type RemoveConnectorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  connector?: Maybe<Connector>;
};

/** RemoveDesignFroms a ProjectObjectBehavior. */
export type RemoveDesignFromProjectObjectBehaviorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectBehaviorId: Scalars['String'];
  usedDesignId: Scalars['String'];
};

/** RemoveDesignFroms a ProjectObjectBehavior. */
export type RemoveDesignFromProjectObjectBehaviorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
};

/** Removes a Design. */
export type RemoveDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
};

/** Removes a Design. */
export type RemoveDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** RemoveFavourites a Template. */
export type RemoveFavouriteTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** RemoveFavourites a Template. */
export type RemoveFavouriteTemplatePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  template?: Maybe<Template>;
};

/** Removes a Font. */
export type RemoveFontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fontId: Scalars['String'];
};

/** Removes a Font. */
export type RemoveFontPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  font?: Maybe<Font>;
};

/** Removes a Logo. */
export type RemoveLogoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  logoId: Scalars['String'];
};

/** Removes a Logo. */
export type RemoveLogoPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  logo?: Maybe<Logo>;
};

/** Removes a Project. */
export type RemoveProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** Removes a ProjectObjectBehavior. */
export type RemoveProjectObjectBehaviorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectBehaviorId: Scalars['String'];
};

/** Removes a ProjectObjectBehavior. */
export type RemoveProjectObjectBehaviorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
};

/** Removes a ProjectObject. */
export type RemoveProjectObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  projectObjectId: Scalars['String'];
};

/** Removes a ProjectObject. */
export type RemoveProjectObjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObject?: Maybe<ProjectObject>;
};

/** Removes a Project. */
export type RemoveProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Removes a ProjectToken. */
export type RemoveProjectTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  projectTokenId: Scalars['String'];
};

/** Removes a ProjectToken. */
export type RemoveProjectTokenPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectToken?: Maybe<ProjectToken>;
};

/** Removes a Style. */
export type RemoveStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleId: Scalars['String'];
};

/** Removes a Style. */
export type RemoveStylePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
};

/** RemoveSupplementaryFeedFors a Project. */
export type RemoveSupplementaryFeedForProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** RemoveSupplementaryFeedFors a Project. */
export type RemoveSupplementaryFeedForProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Removes a Team. */
export type RemoveTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Removes a TeamInvitation. */
export type RemoveTeamInvitationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  invitationId: Scalars['String'];
  teamId: Scalars['String'];
};

/** Removes a TeamInvitation. */
export type RemoveTeamInvitationPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  teamInvitation?: Maybe<TeamInvitation>;
};

/** Removes a Team. */
export type RemoveTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** Removes a TeamToken. */
export type RemoveTeamTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  teamTokenId: Scalars['String'];
};

/** Removes a TeamToken. */
export type RemoveTeamTokenPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  teamToken?: Maybe<TeamToken>;
};

/** Removes a User. */
export type RemoveUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Removes a User. */
export type RemoveUserPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** ReplaceImages a AdminTemplate. */
export type ReplaceImageAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  image: Scalars['Upload'];
  templateId: Scalars['String'];
};

/** ReplaceImages a AdminTemplate. */
export type ReplaceImageAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** TransferOwnerships a Team. */
export type TransferOwnershipTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

/** TransferOwnerships a Team. */
export type TransferOwnershipTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** UnassignDefaults a Font. */
export type UnassignDefaultFontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fontId: Scalars['String'];
  teamId: Scalars['String'];
};

/** UnassignDefaults a Font. */
export type UnassignDefaultFontPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  font?: Maybe<Font>;
};

/** UnassignDefaults a Logo. */
export type UnassignDefaultLogoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  logoId: Scalars['String'];
  teamId: Scalars['String'];
};

/** UnassignDefaults a Logo. */
export type UnassignDefaultLogoPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  logo?: Maybe<Logo>;
};

/** UnassignFacebookIntegrationFroms a Project. */
export type UnassignFacebookIntegrationFromProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  forceDeleteSupplementaryFeed?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};

/** UnassignFacebookIntegrationFroms a Project. */
export type UnassignFacebookIntegrationFromProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UnassignFromGroups a AdminTemplate. */
export type UnassignFromGroupAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** UnassignFromGroups a AdminTemplate. */
export type UnassignFromGroupAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UnassignFromOnboardings a AdminTemplate. */
export type UnassignFromOnboardingAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

/** UnassignFromOnboardings a AdminTemplate. */
export type UnassignFromOnboardingAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UnassignProjectObjectFromFacebookAds a Project. */
export type UnassignProjectObjectFromFacebookAdProjectInput = {
  adId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectId: Scalars['String'];
};

/** UnassignProjectObjectFromFacebookAds a Project. */
export type UnassignProjectObjectFromFacebookAdProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UnassignStyles a AdminTemplate. */
export type UnassignStyleAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleId: Scalars['String'];
  templateId: Scalars['String'];
};

/** UnassignStyles a AdminTemplate. */
export type UnassignStyleAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UnassignUsers a AdminTeam. */
export type UnassignUserAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

/** UnassignUsers a AdminTeam. */
export type UnassignUserAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UnassignUsers a Team. */
export type UnassignUserTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

/** UnassignUsers a Team. */
export type UnassignUserTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** Updates a AdminElementCategory. */
export type UpdateAdminElementCategoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementCategoryId: Scalars['String'];
  name: Scalars['String'];
};

/** Updates a AdminElementCategory. */
export type UpdateAdminElementCategoryPayload = {
  adminElementCategory?: Maybe<AdminElementCategory>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Updates a AdminStyle. */
export type UpdateAdminStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  styleId: Scalars['String'];
};

/** Updates a AdminStyle. */
export type UpdateAdminStylePayload = {
  adminStyle?: Maybe<AdminStyle>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Updates a AdminTeam. */
export type UpdateAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
};

/** Updates a AdminTeam. */
export type UpdateAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Updates a AdminTemplate. */
export type UpdateAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  templateId: Scalars['String'];
};

/** Updates a AdminTemplate. */
export type UpdateAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateCategoriess a AdminElement. */
export type UpdateCategoriesAdminElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementCategoryIds: Array<Scalars['String']>;
  elementId: Scalars['String'];
};

/** UpdateCategoriess a AdminElement. */
export type UpdateCategoriesAdminElementPayload = {
  adminElement?: Maybe<AdminElement>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateCodeSettingss a AdminTemplate. */
export type UpdateCodeSettingsAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  figmaCode?: InputMaybe<Scalars['FigmaJson']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  manageableLayersSettings?: InputMaybe<Scalars['LayerSettingsJson']>;
  templateId: Scalars['String'];
};

/** UpdateCodeSettingss a AdminTemplate. */
export type UpdateCodeSettingsAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateCodeSettingss a Design. */
export type UpdateCodeSettingsDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customStyle: Scalars['StyleDefinitionJson'];
  designId: Scalars['String'];
  figmaCode?: InputMaybe<Scalars['FigmaJson']>;
  images?: InputMaybe<Array<Scalars['Upload']>>;
  manageableLayersSettings: Scalars['LayerSettingsJson'];
  styleId?: InputMaybe<Scalars['String']>;
};

/** UpdateCodeSettingss a Design. */
export type UpdateCodeSettingsDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** UpdateCodesMultiparts a AdminTemplate. */
export type UpdateCodesMultipartAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  figmaCode: Scalars['FigmaJson'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
  templateId: Scalars['String'];
};

/** UpdateCodesMultiparts a AdminTemplate. */
export type UpdateCodesMultipartAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateCodesMultiparts a Design. */
export type UpdateCodesMultipartDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  figmaCode: Scalars['FigmaJson'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
};

/** UpdateCodesMultiparts a Design. */
export type UpdateCodesMultipartDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** UpdateCodesMultiparts a Element. */
export type UpdateCodesMultipartElementInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  elementId: Scalars['String'];
  figmaCode: Scalars['FigmaJson'];
  images?: InputMaybe<Array<Scalars['Upload']>>;
  manageableLayersSettings?: InputMaybe<Scalars['LayerSettingsJson']>;
};

/** UpdateCodesMultiparts a Element. */
export type UpdateCodesMultipartElementPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  element?: Maybe<Element>;
};

/** UpdateCustomHeaderss a AdminProject. */
export type UpdateCustomHeadersAdminProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<Array<InputMaybe<CustomHeader>>>;
};

/** UpdateCustomHeaderss a AdminProject. */
export type UpdateCustomHeadersAdminProjectPayload = {
  adminProject?: Maybe<AdminProject>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateDefinitions a AdminStyle. */
export type UpdateDefinitionAdminStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleDefinition: Scalars['StyleDefinitionJson'];
  styleId?: InputMaybe<Scalars['String']>;
};

/** UpdateDefinitions a AdminStyle. */
export type UpdateDefinitionAdminStylePayload = {
  adminStyle?: Maybe<AdminStyle>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateDefinitions a Style. */
export type UpdateDefinitionStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleDefinition: Scalars['StyleDefinitionJson'];
  styleId?: InputMaybe<Scalars['String']>;
};

/** UpdateDefinitions a Style. */
export type UpdateDefinitionStylePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
};

/** Updates a Design. */
export type UpdateDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  name: Scalars['String'];
};

/** Updates a Design. */
export type UpdateDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** UpdateErrorTolerances a Project. */
export type UpdateErrorToleranceProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

/** UpdateErrorTolerances a Project. */
export type UpdateErrorToleranceProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UpdateFeaturess a AdminDesign. */
export type UpdateFeaturesAdminDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  features: Scalars['CodeFeatures'];
};

/** UpdateFeaturess a AdminDesign. */
export type UpdateFeaturesAdminDesignPayload = {
  adminDesign?: Maybe<AdminDesign>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateFeaturess a AdminTemplate. */
export type UpdateFeaturesAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  features: Scalars['CodeFeatures'];
  templateId: Scalars['String'];
};

/** UpdateFeaturess a AdminTemplate. */
export type UpdateFeaturesAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateFeedFieldss a Project. */
export type UpdateFeedFieldsProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value: Scalars['Boolean'];
};

/** UpdateFeedFieldss a Project. */
export type UpdateFeedFieldsProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UpdateFeeds a Project. */
export type UpdateFeedProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  feedDetails: Feed;
  projectId: Scalars['String'];
};

/** UpdateFeeds a Project. */
export type UpdateFeedProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Updates a Logo. */
export type UpdateLogoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  logoId: Scalars['String'];
  name: Scalars['String'];
};

/** Updates a Logo. */
export type UpdateLogoPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  logo?: Maybe<Logo>;
};

/** UpdateNotificationEmailss a Project. */
export type UpdateNotificationEmailsProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<InputMaybe<NotificationEmail>>>;
  projectId: Scalars['String'];
};

/** UpdateNotificationEmailss a Project. */
export type UpdateNotificationEmailsProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UpdateOverrideDatas a Project. */
export type UpdateOverrideDataProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<ProjectSettingsOverrideData>;
};

/** UpdateOverrideDatas a Project. */
export type UpdateOverrideDataProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Updates a Project. */
export type UpdateProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

/** Updates a Project. */
export type UpdateProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UpdateProxiess a AdminProject. */
export type UpdateProxiesAdminProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** UpdateProxiess a AdminProject. */
export type UpdateProxiesAdminProjectPayload = {
  adminProject?: Maybe<AdminProject>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateRateLimitss a AdminTeam. */
export type UpdateRateLimitsAdminTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
  value?: InputMaybe<Array<InputMaybe<RateLimit>>>;
};

/** UpdateRateLimitss a AdminTeam. */
export type UpdateRateLimitsAdminTeamPayload = {
  adminTeam?: Maybe<AdminTeam>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateScheduleFrequencys a Project. */
export type UpdateScheduleFrequencyProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<ScheduleFrequency>;
};

/** UpdateScheduleFrequencys a Project. */
export type UpdateScheduleFrequencyProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UpdateSettingss a Design. */
export type UpdateSettingsDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  name: Scalars['String'];
};

/** UpdateSettingss a Design. */
export type UpdateSettingsDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** UpdateSettingss a ProjectObjectBehavior. */
export type UpdateSettingsProjectObjectBehaviorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectObjectBehaviorId: Scalars['String'];
  settings: ProjectObjectBehaviorSettings;
};

/** UpdateSettingss a ProjectObjectBehavior. */
export type UpdateSettingsProjectObjectBehaviorPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  projectObjectBehavior?: Maybe<ProjectObjectBehavior>;
};

/** UpdateShareSettingss a Project. */
export type UpdateShareSettingsProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  pin?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

/** UpdateShareSettingss a Project. */
export type UpdateShareSettingsProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** UpdateSharedSettingss a Design. */
export type UpdateSharedSettingsDesignInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  designId: Scalars['String'];
  enabled: Scalars['Boolean'];
  pin?: InputMaybe<Scalars['String']>;
};

/** UpdateSharedSettingss a Design. */
export type UpdateSharedSettingsDesignPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
};

/** UpdateStyless a AdminTemplate. */
export type UpdateStylesAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  styleIds: Array<Scalars['String']>;
  templateId: Scalars['String'];
};

/** UpdateStyless a AdminTemplate. */
export type UpdateStylesAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateTagss a AdminTemplate. */
export type UpdateTagsAdminTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  templateId: Scalars['String'];
};

/** UpdateTagss a AdminTemplate. */
export type UpdateTagsAdminTemplatePayload = {
  adminTemplate?: Maybe<AdminTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Updates a Team. */
export type UpdateTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
};

/** Updates a Team. */
export type UpdateTeamPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

/** UpdateTeams a Style. */
export type UpdateTeamStyleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  styleId: Scalars['String'];
};

/** UpdateTeams a Style. */
export type UpdateTeamStylePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
};

/** UpdateTemplatess a AdminTemplateGroup. */
export type UpdateTemplatesAdminTemplateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  templateGroupId: Scalars['String'];
  templateIds: Array<Scalars['String']>;
};

/** UpdateTemplatess a AdminTemplateGroup. */
export type UpdateTemplatesAdminTemplateGroupPayload = {
  adminTemplateGroup?: Maybe<AdminTemplateGroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** UpdateTextEngines a Project. */
export type UpdateTextEngineProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<TextEngine>;
};

/** UpdateTextEngines a Project. */
export type UpdateTextEngineProjectPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
};

/** Updates a User. */
export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  industryId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Updates a User. */
export type UpdateUserPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Uploads a AdminFonts. */
export type UploadAdminFontsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fonts?: InputMaybe<Array<Scalars['Upload']>>;
};

/** Uploads a AdminFonts. */
export type UploadAdminFontsPayload = {
  adminFonts?: Maybe<AdminFonts>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Uploads a AssetImage. */
export type UploadAssetImageInput = {
  assetImage: Scalars['Upload'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

/** Uploads a AssetImage. */
export type UploadAssetImagePayload = {
  assetImage?: Maybe<AssetImage>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Uploads a Font. */
export type UploadFontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  font: Scalars['Upload'];
  teamId: Scalars['String'];
};

/** Uploads a Font. */
export type UploadFontPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  font?: Maybe<Font>;
};

/** Uploads a Logo. */
export type UploadLogoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  logo: Scalars['Upload'];
  teamId: Scalars['String'];
};

/** Uploads a Logo. */
export type UploadLogoPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  logo?: Maybe<Logo>;
};

export type AuthTokenFragment = Pick<
  LoginCredentialsUserPayloadData,
  'id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
>;

export type AuthTokenSharedFragment = Pick<
  LoginSharedProjectAuthPayloadData,
  'id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
>;

export type AddFavouriteTemplateMutationVariables = Exact<{
  input: AddFavouriteTemplateInput;
}>;

export type AddFavouriteTemplateMutation = {
  addFavouriteTemplate?: Maybe<{
    template?: Maybe<Pick<Template, 'id' | 'templateId' | 'isFavourite'>>;
  }>;
};

export type ActivateAdminElementMutationVariables = Exact<{
  input: ActivateAdminElementInput;
}>;

export type ActivateAdminElementMutation = {
  activateAdminElement?: Maybe<{
    adminElement?: Maybe<Pick<AdminElement, 'id' | 'active'>>;
  }>;
};

export type CreateFromTeamElementAdminElementMutationVariables = Exact<{
  input: CreateFromTeamElementAdminElementInput;
}>;

export type CreateFromTeamElementAdminElementMutation = {
  createFromTeamElementAdminElement?: Maybe<{
    adminElement?: Maybe<Pick<AdminElement, 'id' | 'name' | 'active'>>;
  }>;
};

export type DeactivateAdminElementMutationVariables = Exact<{
  input: DeactivateAdminElementInput;
}>;

export type DeactivateAdminElementMutation = {
  deactivateAdminElement?: Maybe<{
    adminElement?: Maybe<Pick<AdminElement, 'id' | 'active'>>;
  }>;
};

export type RemoveAdminElementMutationVariables = Exact<{
  input: RemoveAdminElementInput;
}>;

export type RemoveAdminElementMutation = {
  removeAdminElement?: Maybe<{
    adminElement?: Maybe<Pick<AdminElement, 'id'>>;
  }>;
};

export type UpdateCategoriesAdminElementMutationVariables = Exact<{
  input: UpdateCategoriesAdminElementInput;
}>;

export type UpdateCategoriesAdminElementMutation = {
  updateCategoriesAdminElement?: Maybe<{
    adminElement?: Maybe<Pick<AdminElement, 'id' | 'elementCategoryResources'>>;
  }>;
};

export type CreateAdminElementCategoryMutationVariables = Exact<{
  input: CreateAdminElementCategoryInput;
}>;

export type CreateAdminElementCategoryMutation = {
  createAdminElementCategory?: Maybe<{
    adminElementCategory?: Maybe<
      Pick<AdminElementCategory, 'id' | 'elementCategoryId' | 'name'>
    >;
  }>;
};

export type RemoveAdminElementCategoryMutationVariables = Exact<{
  input: RemoveAdminElementCategoryInput;
}>;

export type RemoveAdminElementCategoryMutation = {
  removeAdminElementCategory?: Maybe<{
    adminElementCategory?: Maybe<Pick<AdminElementCategory, 'id'>>;
  }>;
};

export type UpdateAdminElementCategoryMutationVariables = Exact<{
  input: UpdateAdminElementCategoryInput;
}>;

export type UpdateAdminElementCategoryMutation = {
  updateAdminElementCategory?: Maybe<{
    adminElementCategory?: Maybe<
      Pick<AdminElementCategory, 'id' | 'elementCategoryId' | 'name'>
    >;
  }>;
};

export type RemoveAdminFontMutationVariables = Exact<{
  input: RemoveAdminFontInput;
}>;

export type RemoveAdminFontMutation = {
  removeAdminFont?: Maybe<{ adminFont?: Maybe<Pick<AdminFont, 'id'>> }>;
};

export type UploadAdminFontsMutationVariables = Exact<{
  input: UploadAdminFontsInput;
}>;

export type UploadAdminFontsMutation = {
  uploadAdminFonts?: Maybe<{
    adminFonts?: Maybe<Pick<AdminFonts, 'id' | 'fonts'>>;
  }>;
};

export type ActivateAdminProjectMutationVariables = Exact<{
  input: ActivateAdminProjectInput;
}>;

export type ActivateAdminProjectMutation = {
  activateAdminProject?: Maybe<{
    adminProject?: Maybe<Pick<AdminProject, 'id' | 'active'>>;
  }>;
};

export type DeactivateAdminProjectMutationVariables = Exact<{
  input: DeactivateAdminProjectInput;
}>;

export type DeactivateAdminProjectMutation = {
  deactivateAdminProject?: Maybe<{
    adminProject?: Maybe<Pick<AdminProject, 'id' | 'active'>>;
  }>;
};

export type GenerateAdminProjectUpdateFileUrlMutationVariables = Exact<{
  input: GenerateAdminProjectUpdateFileUrlInput;
}>;

export type GenerateAdminProjectUpdateFileUrlMutation = {
  generateAdminProjectUpdateFileUrl?: Maybe<{
    adminProjectUpdateFileUrl?: Maybe<
      Pick<AdminProjectUpdateFileUrl, 'id' | 'projectUpdateId' | 'url'>
    >;
  }>;
};

export type RemoveAdminProjectMutationVariables = Exact<{
  input: RemoveAdminProjectInput;
}>;

export type RemoveAdminProjectMutation = {
  removeAdminProject?: Maybe<{
    adminProject?: Maybe<Pick<AdminProject, 'id' | 'name'>>;
  }>;
};

export type ActivateAdminStyleMutationVariables = Exact<{
  input: ActivateAdminStyleInput;
}>;

export type ActivateAdminStyleMutation = {
  activateAdminStyle?: Maybe<{
    adminStyle?: Maybe<Pick<AdminStyle, 'id' | 'name' | 'active'>>;
  }>;
};

export type CreateAdminStyleMutationVariables = Exact<{
  input: CreateAdminStyleInput;
}>;

export type CreateAdminStyleMutation = {
  createAdminStyle?: Maybe<{
    adminStyle?: Maybe<
      Pick<AdminStyle, 'id' | 'styleId' | 'definition' | 'name' | 'type'>
    >;
  }>;
};

export type DeactivateAdminStyleMutationVariables = Exact<{
  input: DeactivateAdminStyleInput;
}>;

export type DeactivateAdminStyleMutation = {
  deactivateAdminStyle?: Maybe<{
    adminStyle?: Maybe<Pick<AdminStyle, 'id' | 'name' | 'active'>>;
  }>;
};

export type RemoveAdminStyleMutationVariables = Exact<{
  input: RemoveAdminStyleInput;
}>;

export type RemoveAdminStyleMutation = {
  removeAdminStyle?: Maybe<{
    adminStyle?: Maybe<Pick<AdminStyle, 'id' | 'name'>>;
  }>;
};

export type UpdateDefinitionAdminStyleMutationVariables = Exact<{
  input: UpdateDefinitionAdminStyleInput;
}>;

export type UpdateDefinitionAdminStyleMutation = {
  updateDefinitionAdminStyle?: Maybe<{
    adminStyle?: Maybe<
      Pick<AdminStyle, 'id' | 'styleId' | 'definition' | 'name' | 'type'>
    >;
  }>;
};

export type CreateAdminTeamMutationVariables = Exact<{
  input: CreateAdminTeamInput;
}>;

export type CreateAdminTeamMutation = {
  createAdminTeam?: Maybe<{
    adminTeam?: Maybe<Pick<AdminTeam, 'id' | 'name'>>;
  }>;
};

export type RemoveAdminTeamMutationVariables = Exact<{
  input: RemoveAdminTeamInput;
}>;

export type RemoveAdminTeamMutation = {
  removeAdminTeam?: Maybe<
    Pick<RemoveAdminTeamPayload, 'clientMutationId'> & {
      adminTeam?: Maybe<Pick<AdminTeam, 'id' | 'name'>>;
    }
  >;
};

export type UpdateAdminTeamMutationVariables = Exact<{
  input: UpdateAdminTeamInput;
}>;

export type UpdateAdminTeamMutation = {
  updateAdminTeam?: Maybe<
    Pick<UpdateAdminTeamPayload, 'clientMutationId'> & {
      adminTeam?: Maybe<Pick<AdminTeam, 'id' | 'name'>>;
    }
  >;
};

export type ActivateAdminTemplateMutationVariables = Exact<{
  input: ActivateAdminTemplateInput;
}>;

export type ActivateAdminTemplateMutation = {
  activateAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<
      Pick<AdminTemplate, 'id' | 'name' | 'previewImageId' | 'active'>
    >;
  }>;
};

export type AssignStyleAdminTemplateMutationVariables = Exact<{
  input: AssignStyleAdminTemplateInput;
}>;

export type AssignStyleAdminTemplateMutation = {
  assignStyleAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<
      Pick<AdminTemplate, 'templateId' | 'name' | 'active' | 'stylizable'>
    >;
  }>;
};

export type CreateFromDesignAdminTemplateMutationVariables = Exact<{
  input: CreateFromDesignAdminTemplateInput;
}>;

export type CreateFromDesignAdminTemplateMutation = {
  createFromDesignAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<Pick<AdminTemplate, 'id' | 'templateId' | 'name'>>;
  }>;
};

export type DeactivateAdminTemplateMutationVariables = Exact<{
  input: DeactivateAdminTemplateInput;
}>;

export type DeactivateAdminTemplateMutation = {
  deactivateAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<
      Pick<AdminTemplate, 'id' | 'name' | 'previewImageId' | 'active'>
    >;
  }>;
};

export type RemoveAdminTemplateMutationVariables = Exact<{
  input: RemoveAdminTemplateInput;
}>;

export type RemoveAdminTemplateMutation = {
  removeAdminTemplate?: Maybe<
    Pick<RemoveAdminTemplatePayload, 'clientMutationId'> & {
      adminTemplate?: Maybe<Pick<AdminTemplate, 'id' | 'name'>>;
    }
  >;
};

export type ReplaceImageAdminTemplateMutationVariables = Exact<{
  input: ReplaceImageAdminTemplateInput;
}>;

export type ReplaceImageAdminTemplateMutation = {
  replaceImageAdminTemplate?: Maybe<
    Pick<ReplaceImageAdminTemplatePayload, 'clientMutationId'> & {
      adminTemplate?: Maybe<Pick<AdminTemplate, 'id' | 'name'>>;
    }
  >;
};

export type UnassignStyleAdminTemplateMutationVariables = Exact<{
  input: UnassignStyleAdminTemplateInput;
}>;

export type UnassignStyleAdminTemplateMutation = {
  unassignStyleAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<
      Pick<AdminTemplate, 'templateId' | 'name' | 'active' | 'stylizable'>
    >;
  }>;
};

export type UpdateAdminTemplateMutationVariables = Exact<{
  input: UpdateAdminTemplateInput;
}>;

export type UpdateAdminTemplateMutation = {
  updateAdminTemplate?: Maybe<
    Pick<UpdateAdminTemplatePayload, 'clientMutationId'> & {
      adminTemplate?: Maybe<Pick<AdminTemplate, 'id' | 'name'>>;
    }
  >;
};

export type UpdateTagsAdminTemplateMutationVariables = Exact<{
  input: UpdateTagsAdminTemplateInput;
}>;

export type UpdateTagsAdminTemplateMutation = {
  updateTagsAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<Pick<AdminTemplate, 'id' | 'tags'>>;
  }>;
};

export type CreateAdminTemplateGroupMutationVariables = Exact<{
  input: CreateAdminTemplateGroupInput;
}>;

export type CreateAdminTemplateGroupMutation = {
  createAdminTemplateGroup?: Maybe<{
    adminTemplateGroup?: Maybe<
      Pick<AdminTemplateGroup, 'name' | 'baseTemplate' | 'templates'>
    >;
  }>;
};

export type EditNameAdminTemplateGroupMutationVariables = Exact<{
  input: EditNameAdminTemplateGroupInput;
}>;

export type EditNameAdminTemplateGroupMutation = {
  editNameAdminTemplateGroup?: Maybe<{
    adminTemplateGroup?: Maybe<Pick<AdminTemplateGroup, 'name'>>;
  }>;
};

export type RemoveAdminTemplateGroupMutationVariables = Exact<{
  input: RemoveAdminTemplateGroupInput;
}>;

export type RemoveAdminTemplateGroupMutation = {
  removeAdminTemplateGroup?: Maybe<{
    adminTemplateGroup?: Maybe<Pick<AdminTemplateGroup, 'id' | 'name'>>;
  }>;
};

export type UpdateTemplatesAdminTemplateGroupMutationVariables = Exact<{
  input: UpdateTemplatesAdminTemplateGroupInput;
}>;

export type UpdateTemplatesAdminTemplateGroupMutation = {
  updateTemplatesAdminTemplateGroup?: Maybe<{
    adminTemplateGroup?: Maybe<
      Pick<
        AdminTemplateGroup,
        'id' | 'templateGroupId' | 'name' | 'baseTemplate' | 'templates'
      >
    >;
  }>;
};

export type RemoveAdminUserMutationVariables = Exact<{
  input: RemoveAdminUserInput;
}>;

export type RemoveAdminUserMutation = {
  removeAdminUser?: Maybe<{
    adminUser?: Maybe<Pick<AdminUser, 'id' | 'email'>>;
  }>;
};

export type UploadAssetImageMutationVariables = Exact<{
  input: UploadAssetImageInput;
}>;

export type UploadAssetImageMutation = {
  uploadAssetImage?: Maybe<{
    assetImage?: Maybe<
      Pick<
        AssetImage,
        | 'id'
        | 'assetImageId'
        | 'userId'
        | 'teamId'
        | 'name'
        | 'size'
        | 'mimeType'
        | 'createdAt'
        | 'updatedAt'
        | 'format'
      >
    >;
  }>;
};

export type AssignDefaultLogoMutationVariables = Exact<{
  input: AssignDefaultLogoInput;
}>;

export type AssignDefaultLogoMutation = {
  assignDefaultLogo?: Maybe<{ logo?: Maybe<Pick<Logo, 'id' | 'logoId'>> }>;
};

export type CancelFeedProcessingProjectMutationVariables = Exact<{
  input: CancelFeedProcessingProjectInput;
}>;

export type CancelFeedProcessingProjectMutation = {
  cancelFeedProcessingProject?: Maybe<{
    project?: Maybe<
      Pick<
        Project,
        'id' | 'projectId' | 'feed' | 'currentUpdate' | 'lastUpdate'
      >
    >;
  }>;
};

export type ChangeAuthUserPasswordMutationVariables = Exact<{
  input: ChangeAuthUserPasswordInput;
}>;

export type ChangeAuthUserPasswordMutation = {
  changeAuthUserPassword?: Maybe<{
    authUserPassword?: Maybe<Pick<AuthUserPassword, 'id'>>;
  }>;
};

export type ChangePasswordUserResetPasswordMutationVariables = Exact<{
  input: ChangePasswordUserResetPasswordInput;
}>;

export type ChangePasswordUserResetPasswordMutation = {
  changePasswordUserResetPassword?: Maybe<{
    userResetPassword?: Maybe<
      Pick<ChangePasswordUserResetPasswordPayloadData, 'id' | 'message'>
    >;
  }>;
};

export type ChangeRoleTeamUserMutationVariables = Exact<{
  input: ChangeRoleTeamUserInput;
}>;

export type ChangeRoleTeamUserMutation = {
  changeRoleTeamUser?: Maybe<
    Pick<ChangeRoleTeamUserPayload, 'clientMutationId'>
  >;
};

export type CloneDesignMutationVariables = Exact<{
  input: CloneDesignInput;
}>;

export type CloneDesignMutation = {
  cloneDesign?: Maybe<{
    design?: Maybe<Pick<Design, 'id' | 'designId' | 'name' | 'previewImageId'>>;
  }>;
};

export type CloneProjectMutationVariables = Exact<{
  input: CloneProjectInput;
}>;

export type CloneProjectMutation = {
  cloneProject?: Maybe<{
    project?: Maybe<
      Pick<
        Project,
        | 'id'
        | 'projectId'
        | 'name'
        | 'teamId'
        | 'createdAt'
        | 'updatedAt'
        | 'lastUpdateId'
        | 'currentUpdateId'
        | 'feed'
        | 'status'
        | 'projectTokens'
        | 'designs'
      >
    >;
  }>;
};

export type CloneTeamMutationVariables = Exact<{
  input: CloneTeamInput;
}>;

export type CloneTeamMutation = {
  cloneTeam?: Maybe<{
    team?: Maybe<Pick<Team, 'id' | 'teamId' | 'name' | 'projects'>>;
  }>;
};

export type CloneToProjectDesignsMutationVariables = Exact<{
  input: CloneToProjectDesignsInput;
}>;

export type CloneToProjectDesignsMutation = {
  cloneToProjectDesigns?: Maybe<
    Pick<CloneToProjectDesignsPayload, 'clientMutationId'>
  >;
};

export type ConfirmTeamInvitationConfirmationMutationVariables = Exact<{
  input: ConfirmTeamInvitationConfirmationInput;
}>;

export type ConfirmTeamInvitationConfirmationMutation = {
  confirmTeamInvitationConfirmation?: Maybe<{
    teamInvitationConfirmation?: Maybe<
      Pick<TeamInvitationConfirmation, 'id' | 'status'>
    >;
  }>;
};

export type CreateBillingPortalSessionMutationVariables = Exact<{
  input: CreateBillingPortalSessionInput;
}>;

export type CreateBillingPortalSessionMutation = {
  createBillingPortalSession?: Maybe<
    Pick<CreateBillingPortalSessionPayload, 'clientMutationId'> & {
      billingPortalSession?: Maybe<
        Pick<BillingPortalSession, 'sessionId' | 'sessionUrl'>
      >;
    }
  >;
};

export type CreateFromTemplateDesignMutationVariables = Exact<{
  input: CreateFromTemplateDesignInput;
}>;

export type CreateFromTemplateDesignMutation = {
  createFromTemplateDesign?: Maybe<{
    design?: Maybe<
      Pick<
        Design,
        | 'id'
        | 'designId'
        | 'name'
        | 'previewImageId'
        | 'manageableLayersSettings'
      >
    >;
  }>;
};

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;

export type CreateProjectMutation = {
  createProject?: Maybe<{
    project?: Maybe<
      Pick<
        Project,
        | 'id'
        | 'projectId'
        | 'name'
        | 'teamId'
        | 'createdAt'
        | 'updatedAt'
        | 'lastUpdateId'
        | 'currentUpdateId'
        | 'status'
        | 'projectTokens'
        | 'projectObjects'
      >
    >;
  }>;
};

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;

export type CreateTeamMutation = {
  createTeam?: Maybe<{ team?: Maybe<Pick<Team, 'id' | 'teamId' | 'name'>> }>;
};

export type CreateTeamInvitationsMutationVariables = Exact<{
  input: CreateTeamInvitationCreationInput;
}>;

export type CreateTeamInvitationsMutation = {
  createTeamInvitationCreation?: Maybe<{
    teamInvitationCreation?: Maybe<
      Pick<TeamInvitationCreation, 'id' | 'teamInvitations'>
    >;
  }>;
};

export type CreateProjectTokenMutationVariables = Exact<{
  input: CreateProjectTokenInput;
}>;

export type CreateProjectTokenMutation = {
  createProjectToken?: Maybe<{
    projectToken?: Maybe<
      Pick<ProjectToken, 'id' | 'projectTokenId' | 'value' | 'updatedAt'>
    >;
  }>;
};

export type CreateUserVerificationMutationVariables = Exact<{
  input: CreateUserVerificationInput;
}>;

export type CreateUserVerificationMutation = {
  createUserVerification?: Maybe<
    Pick<CreateUserVerificationPayload, 'clientMutationId'> & {
      userVerification?: Maybe<
        Pick<CreateUserVerificationPayloadData, 'id' | 'message'>
      >;
    }
  >;
};

export type CreateObjectPreviewFromDesignObjectMutationVariables = Exact<{
  input: CreateObjectPreviewFromDesignObjectInput;
}>;

export type CreateObjectPreviewFromDesignObjectMutation = {
  createObjectPreviewFromDesignObject?: Maybe<{
    object?: Maybe<
      Pick<
        Object,
        | 'id'
        | 'objectId'
        | 'message'
        | 'product'
        | 'resolvedFields'
        | 'resolvedManageableLayers'
        | 'resolvedManageableLayersConditions'
      >
    >;
  }>;
};

export type LoginSharedDesignAuthMutationVariables = Exact<{
  input: LoginSharedDesignAuthInput;
}>;

export type LoginSharedDesignAuthMutation = {
  loginSharedDesignAuth?: Maybe<{
    auth?: Maybe<
      Pick<
        LoginSharedDesignAuthPayloadData,
        'id' | '_id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
      >
    >;
  }>;
};

export type UpdateSharedSettingsDesignMutationVariables = Exact<{
  input: UpdateSharedSettingsDesignInput;
}>;

export type UpdateSharedSettingsDesignMutation = {
  updateSharedSettingsDesign?: Maybe<{
    design?: Maybe<Pick<Design, 'designId' | 'settings'>>;
  }>;
};

export type DisconnectProjectFeedMutationVariables = Exact<{
  input: DisconnectProjectFeedInput;
}>;

export type DisconnectProjectFeedMutation = {
  disconnectProjectFeed?: Maybe<{
    projectFeed?: Maybe<Pick<ProjectFeed, 'id' | 'message'>>;
  }>;
};

export type FetchStripeInvoiceListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchStripeInvoiceListQuery = {
  callApiPayment?: Maybe<Pick<Payment, 'data'>>;
};

export type FinishOnboardingUserMutationVariables = Exact<{
  [key: string]: never;
}>;

export type FinishOnboardingUserMutation = {
  finishOnboardingUser?: Maybe<{ user?: Maybe<Pick<User, 'id'>> }>;
};

export type UploadFontMutationVariables = Exact<{
  input: UploadFontInput;
}>;

export type UploadFontMutation = {
  uploadFont?: Maybe<{
    font?: Maybe<
      Pick<
        Font,
        | 'id'
        | 'fontId'
        | 'userId'
        | 'teamId'
        | 'name'
        | 'family'
        | 'style'
        | 'weight'
        | 'weightName'
        | 'postScript'
        | 'format'
        | 'createdAt'
        | 'updatedAt'
      >
    >;
  }>;
};

export type GenerateTokenUserResetPasswordMutationVariables = Exact<{
  input: GenerateTokenUserResetPasswordInput;
}>;

export type GenerateTokenUserResetPasswordMutation = {
  generateTokenUserResetPassword?: Maybe<
    Pick<GenerateTokenUserResetPasswordPayload, 'clientMutationId'>
  >;
};

export type AssignFacebookCatalogToProjectMutationVariables = Exact<{
  input: AssignFacebookCatalogToProjectInput;
}>;

export type AssignFacebookCatalogToProjectMutation = {
  assignFacebookCatalogToProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId'>>;
  }>;
};

export type AssignProjectObjectToFacebookAdProjectMutationVariables = Exact<{
  input: AssignProjectObjectToFacebookAdProjectInput;
}>;

export type AssignProjectObjectToFacebookAdProjectMutation = {
  assignProjectObjectToFacebookAdProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId' | 'outputSettings'>>;
  }>;
};

export type ClaimShopifyInstallationConnectorMutationVariables = Exact<{
  input: ClaimShopifyInstallationConnectorInput;
}>;

export type ClaimShopifyInstallationConnectorMutation = {
  claimShopifyInstallationConnector?: Maybe<{
    connector?: Maybe<Pick<Connector, 'connectorId' | 'teamId' | 'status'>>;
  }>;
};

export type CreateConnectorMutationVariables = Exact<{
  input: CreateConnectorInput;
}>;

export type CreateConnectorMutation = {
  createConnector?: Maybe<{
    connector?: Maybe<
      Pick<Connector, 'connectorId' | 'teamId' | 'userId' | 'status'>
    >;
  }>;
};

export type InitiateFacebookLoginMutationVariables = Exact<{
  input: InitiateFacebookLoginInput;
}>;

export type InitiateFacebookLoginMutation = {
  initiateFacebookLogin?: Maybe<{
    facebookLogin?: Maybe<Pick<FacebookLogin, 'loginUrl' | 'sessionTokenId'>>;
  }>;
};

export type InitiateShopifyLoginMutationVariables = Exact<{
  input: InitiateShopifyLoginInput;
}>;

export type InitiateShopifyLoginMutation = {
  initiateShopifyLogin?: Maybe<{
    shopifyLogin?: Maybe<Pick<ShopifyLogin, 'authorizeUrl' | 'sessionTokenId'>>;
  }>;
};

export type RemoveConnectorMutationVariables = Exact<{
  input: RemoveConnectorInput;
}>;

export type RemoveConnectorMutation = {
  removeConnector?: Maybe<{
    connector?: Maybe<Pick<Connector, 'connectorId'>>;
  }>;
};

export type UnassignFacebookIntegrationFromProjectMutationVariables = Exact<{
  input: UnassignFacebookIntegrationFromProjectInput;
}>;

export type UnassignFacebookIntegrationFromProjectMutation = {
  unassignFacebookIntegrationFromProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId'>>;
  }>;
};

export type UnassignProjectObjectFromFacebookAdProjectMutationVariables =
  Exact<{
    input: UnassignProjectObjectFromFacebookAdProjectInput;
  }>;

export type UnassignProjectObjectFromFacebookAdProjectMutation = {
  unassignProjectObjectFromFacebookAdProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId'>>;
  }>;
};

export type LeaveTeamMutationVariables = Exact<{
  input: LeaveTeamInput;
}>;

export type LeaveTeamMutation = {
  leaveTeam?: Maybe<Pick<LeaveTeamPayload, 'clientMutationId'>>;
};

export type LoginCredentialsUserMutationVariables = Exact<{
  input: LoginCredentialsUserInput;
}>;

export type LoginCredentialsUserMutation = {
  loginCredentialsUser?: Maybe<
    Pick<LoginCredentialsUserPayload, 'clientMutationId'> & {
      user?: Maybe<
        Pick<
          LoginCredentialsUserPayloadData,
          'id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
        >
      >;
    }
  >;
};

export type UpdateLogoMutationVariables = Exact<{
  input: UpdateLogoInput;
}>;

export type UpdateLogoMutation = {
  updateLogo?: Maybe<{ logo?: Maybe<Pick<Logo, 'id' | 'logoId' | 'name'>> }>;
};

export type UploadLogoMutationVariables = Exact<{
  input: UploadLogoInput;
}>;

export type UploadLogoMutation = {
  uploadLogo?: Maybe<{
    logo?: Maybe<
      Pick<
        Logo,
        | 'id'
        | 'logoId'
        | 'userId'
        | 'teamId'
        | 'name'
        | 'size'
        | 'mimeType'
        | 'createdAt'
        | 'updatedAt'
        | 'format'
      >
    >;
  }>;
};

export type LogoutUserAuthMutationVariables = Exact<{
  input: LogoutUserAuthInput;
}>;

export type LogoutUserAuthMutation = {
  logoutUserAuth?: Maybe<
    Pick<LogoutUserAuthPayload, 'clientMutationId'> & {
      auth?: Maybe<Pick<LogoutUserAuthPayloadData, 'id'>>;
    }
  >;
};

export type CreateSampleProjectMutationVariables = Exact<{
  input: CreateSampleProjectInput;
}>;

export type CreateSampleProjectMutation = {
  createSampleProject?: Maybe<{
    project?: Maybe<
      Pick<
        Project,
        | 'teamId'
        | 'projectId'
        | 'name'
        | 'projectInfo'
        | 'shouldProjectBeUpdated'
        | 'scheduledAt'
      >
    >;
  }>;
};

export type LoginSharedProjectAuthMutationVariables = Exact<{
  input: LoginSharedProjectAuthInput;
}>;

export type LoginSharedProjectAuthMutation = {
  loginSharedProjectAuth?: Maybe<{
    auth?: Maybe<
      Pick<
        LoginSharedProjectAuthPayloadData,
        'id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
      >
    >;
  }>;
};

export type ActivateDesignProjectObjectBehaviorMutationVariables = Exact<{
  input: ActivateDesignProjectObjectBehaviorInput;
}>;

export type ActivateDesignProjectObjectBehaviorMutation = {
  activateDesignProjectObjectBehavior?: Maybe<{
    projectObjectBehavior?: Maybe<
      Pick<
        ProjectObjectBehavior,
        'projectObjectBehaviorId' | 'updatedAt' | 'usedDesigns'
      >
    >;
  }>;
};

export type AssignDesignToProjectObjectBehaviorProjectObjectMutationVariables =
  Exact<{
    input: AssignDesignToProjectObjectBehaviorProjectObjectInput;
  }>;

export type AssignDesignToProjectObjectBehaviorProjectObjectMutation = {
  assignDesignToProjectObjectBehaviorProjectObject?: Maybe<{
    projectObject?: Maybe<
      Pick<
        ProjectObject,
        | 'projectObjectId'
        | 'projectId'
        | 'options'
        | 'createdAt'
        | 'updatedAt'
        | 'ordering'
        | 'projectObjectBehaviors'
      >
    >;
  }>;
};

export type ChangeOrderProjectObjectBehaviorMutationVariables = Exact<{
  input: ChangeOrderProjectObjectBehaviorInput;
}>;

export type ChangeOrderProjectObjectBehaviorMutation = {
  changeOrderProjectObjectBehavior?: Maybe<{
    projectObjectBehavior?: Maybe<
      Pick<ProjectObjectBehavior, 'projectObjectBehaviorId' | 'ordering'>
    >;
  }>;
};

export type DeactivateDesignProjectObjectBehaviorMutationVariables = Exact<{
  input: DeactivateDesignProjectObjectBehaviorInput;
}>;

export type DeactivateDesignProjectObjectBehaviorMutation = {
  deactivateDesignProjectObjectBehavior?: Maybe<{
    projectObjectBehavior?: Maybe<
      Pick<
        ProjectObjectBehavior,
        'projectObjectBehaviorId' | 'updatedAt' | 'usedDesigns'
      >
    >;
  }>;
};

export type RemoveDesignFromProjectObjectBehaviorMutationVariables = Exact<{
  input: RemoveDesignFromProjectObjectBehaviorInput;
}>;

export type RemoveDesignFromProjectObjectBehaviorMutation = {
  removeDesignFromProjectObjectBehavior?: Maybe<{
    projectObjectBehavior?: Maybe<
      Pick<ProjectObjectBehavior, 'projectObjectBehaviorId' | 'usedDesigns'>
    >;
  }>;
};

export type RemoveProjectObjectBehaviorMutationVariables = Exact<{
  input: RemoveProjectObjectBehaviorInput;
}>;

export type RemoveProjectObjectBehaviorMutation = {
  removeProjectObjectBehavior?: Maybe<{
    projectObjectBehavior?: Maybe<
      Pick<ProjectObjectBehavior, 'projectObjectBehaviorId'>
    >;
  }>;
};

export type UpdateSettingsProjectObjectBehaviorMutationVariables = Exact<{
  input: UpdateSettingsProjectObjectBehaviorInput;
}>;

export type UpdateSettingsProjectObjectBehaviorMutation = {
  updateSettingsProjectObjectBehavior?: Maybe<{
    projectObjectBehavior?: Maybe<
      Pick<
        ProjectObjectBehavior,
        | 'projectObjectBehaviorId'
        | 'projectObjectId'
        | 'schedule'
        | 'rules'
        | 'ordering'
        | 'createdAt'
        | 'updatedAt'
      >
    >;
  }>;
};

export type ChangeOrderProjectObjectMutationVariables = Exact<{
  input: ChangeOrderProjectObjectInput;
}>;

export type ChangeOrderProjectObjectMutation = {
  changeOrderProjectObject?: Maybe<{
    projectObject?: Maybe<
      Pick<
        ProjectObject,
        | 'projectObjectId'
        | 'projectId'
        | 'options'
        | 'createdAt'
        | 'updatedAt'
        | 'ordering'
        | 'projectObjectBehaviors'
      >
    >;
  }>;
};

export type CreateProjectObjectMutationVariables = Exact<{
  input: CreateProjectObjectInput;
}>;

export type CreateProjectObjectMutation = {
  createProjectObject?: Maybe<{
    projectObject?: Maybe<
      Pick<
        ProjectObject,
        | 'projectObjectId'
        | 'projectId'
        | 'options'
        | 'createdAt'
        | 'updatedAt'
        | 'ordering'
        | 'projectObjectBehaviors'
      >
    >;
  }>;
};

export type RemoveProjectObjectMutationVariables = Exact<{
  input: RemoveProjectObjectInput;
}>;

export type RemoveProjectObjectMutation = {
  removeProjectObject?: Maybe<{
    projectObject?: Maybe<Pick<ProjectObject, 'projectObjectId'>>;
  }>;
};

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;

export type CancelSubscriptionMutation = {
  cancelSubscription?: Maybe<{
    subscription?: Maybe<
      Pick<
        Subscription,
        'subscriptionId' | 'planDetails' | 'validTo' | 'status'
      >
    >;
  }>;
};

export type CreateSubscriptionCheckoutSessionMutationVariables = Exact<{
  input: CreateSubscriptionCheckoutSessionInput;
}>;

export type CreateSubscriptionCheckoutSessionMutation = {
  createSubscriptionCheckoutSession?: Maybe<{
    checkoutSession?: Maybe<
      Pick<CheckoutSession, 'id' | 'clientSecret' | 'status'>
    >;
  }>;
};

export type UpdateErrorToleranceProjectMutationVariables = Exact<{
  input: UpdateErrorToleranceProjectInput;
}>;

export type UpdateErrorToleranceProjectMutation = {
  updateErrorToleranceProject?: Maybe<{
    project?: Maybe<Pick<Project, 'id' | 'projectId' | 'settings'>>;
  }>;
};

export type UpdateFeedFieldsProjectMutationVariables = Exact<{
  input: UpdateFeedFieldsProjectInput;
}>;

export type UpdateFeedFieldsProjectMutation = {
  updateFeedFieldsProject?: Maybe<{
    project?: Maybe<Pick<Project, 'id' | 'projectId' | 'settings'>>;
  }>;
};

export type UpdateNotificationEmailsProjectMutationVariables = Exact<{
  input: UpdateNotificationEmailsProjectInput;
}>;

export type UpdateNotificationEmailsProjectMutation = {
  updateNotificationEmailsProject?: Maybe<{
    project?: Maybe<Pick<Project, 'id' | 'projectId' | 'settings'>>;
  }>;
};

export type UpdateOverrideDataProjectMutationVariables = Exact<{
  input: UpdateOverrideDataProjectInput;
}>;

export type UpdateOverrideDataProjectMutation = {
  updateOverrideDataProject?: Maybe<{
    project?: Maybe<Pick<Project, 'id' | 'projectId' | 'settings'>>;
  }>;
};

export type UpdateScheduleFrequencyProjectMutationVariables = Exact<{
  input: UpdateScheduleFrequencyProjectInput;
}>;

export type UpdateScheduleFrequencyProjectMutation = {
  updateScheduleFrequencyProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId' | 'settings'>>;
  }>;
};

export type UpdateShareSettingsProjectMutationVariables = Exact<{
  input: UpdateShareSettingsProjectInput;
}>;

export type UpdateShareSettingsProjectMutation = {
  updateShareSettingsProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId' | 'settings'>>;
  }>;
};

export type RefreshSessionTokenMutationVariables = Exact<{
  input: RefreshSessionTokenInput;
}>;

export type RefreshSessionTokenMutation = {
  refreshSessionToken?: Maybe<
    Pick<RefreshSessionTokenPayload, 'clientMutationId'> & {
      sessionToken?: Maybe<
        Pick<
          RefreshSessionTokenPayloadData,
          'id' | '_id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
        >
      >;
    }
  >;
};

export type RegisterTeamInvitationConfirmationMutationVariables = Exact<{
  input: RegisterTeamInvitationConfirmationInput;
}>;

export type RegisterTeamInvitationConfirmationMutation = {
  registerTeamInvitationConfirmation?: Maybe<{
    confirmation?: Maybe<
      Pick<
        RegisterTeamInvitationConfirmationPayloadData,
        'id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
      >
    >;
  }>;
};

export type RegisterUserMutationVariables = Exact<{
  input: RegisterUserInput;
}>;

export type RegisterUserMutation = {
  registerUser?: Maybe<{
    user?: Maybe<
      Pick<
        RegisterUserPayloadData,
        'id' | '_id' | 'token' | 'refreshToken' | 'refreshTokenExpiresAt'
      >
    >;
  }>;
};

export type RemoveAssetImageMutationVariables = Exact<{
  input: RemoveAssetImageInput;
}>;

export type RemoveAssetImageMutation = {
  removeAssetImage?: Maybe<{
    assetImage?: Maybe<Pick<AssetImage, 'id' | 'assetImageId'>>;
  }>;
};

export type RemoveDesignMutationVariables = Exact<{
  input: RemoveDesignInput;
}>;

export type RemoveDesignMutation = {
  removeDesign?: Maybe<{ design?: Maybe<Pick<Design, 'id' | 'designId'>> }>;
};

export type RemoveFavouriteTemplateMutationVariables = Exact<{
  input: RemoveFavouriteTemplateInput;
}>;

export type RemoveFavouriteTemplateMutation = {
  removeFavouriteTemplate?: Maybe<{
    template?: Maybe<Pick<Template, 'id' | 'templateId' | 'isFavourite'>>;
  }>;
};

export type RemoveFontMutationVariables = Exact<{
  input: RemoveFontInput;
}>;

export type RemoveFontMutation = {
  removeFont?: Maybe<{ font?: Maybe<Pick<Font, 'id'>> }>;
};

export type RemoveLogoMutationVariables = Exact<{
  input: RemoveLogoInput;
}>;

export type RemoveLogoMutation = {
  removeLogo?: Maybe<{ logo?: Maybe<Pick<Logo, 'id' | 'logoId'>> }>;
};

export type RemoveProjectMutationVariables = Exact<{
  input: RemoveProjectInput;
}>;

export type RemoveProjectMutation = {
  removeProject?: Maybe<{ project?: Maybe<Pick<Project, 'id' | 'projectId'>> }>;
};

export type RemoveTeamMutationVariables = Exact<{
  input: RemoveTeamInput;
}>;

export type RemoveTeamMutation = {
  removeTeam?: Maybe<{ team?: Maybe<Pick<Team, 'id' | 'teamId'>> }>;
};

export type RemoveTeamInvitationMutationVariables = Exact<{
  input: RemoveTeamInvitationInput;
}>;

export type RemoveTeamInvitationMutation = {
  removeTeamInvitation?: Maybe<
    Pick<RemoveTeamInvitationPayload, 'clientMutationId'>
  >;
};

export type RemoveProjectTokenMutationVariables = Exact<{
  input: RemoveProjectTokenInput;
}>;

export type RemoveProjectTokenMutation = {
  removeProjectToken?: Maybe<{
    projectToken?: Maybe<Pick<ProjectToken, 'id' | 'value' | 'updatedAt'>>;
  }>;
};

export type RemoveUserMutationVariables = Exact<{ [key: string]: never }>;

export type RemoveUserMutation = {
  removeUser?: Maybe<
    Pick<RemoveUserPayload, 'clientMutationId'> & {
      user?: Maybe<Pick<User, 'id'>>;
    }
  >;
};

export type CreateStyleMutationVariables = Exact<{
  input: CreateStyleInput;
}>;

export type CreateStyleMutation = {
  createStyle?: Maybe<{
    style?: Maybe<
      Pick<Style, 'id' | 'styleId' | 'definition' | 'name' | 'type'>
    >;
  }>;
};

export type RemoveStyleMutationVariables = Exact<{
  input: RemoveStyleInput;
}>;

export type RemoveStyleMutation = {
  removeStyle?: Maybe<{ style?: Maybe<Pick<Style, 'id' | 'styleId'>> }>;
};

export type UpdateDefinitionStyleMutationVariables = Exact<{
  input: UpdateDefinitionStyleInput;
}>;

export type UpdateDefinitionStyleMutation = {
  updateDefinitionStyle?: Maybe<{
    style?: Maybe<
      Pick<Style, 'id' | 'styleId' | 'definition' | 'name' | 'type'>
    >;
  }>;
};

export type UpdateTeamStyleMutationVariables = Exact<{
  input: UpdateTeamStyleInput;
}>;

export type UpdateTeamStyleMutation = {
  updateTeamStyle?: Maybe<{
    style?: Maybe<
      Pick<Style, 'id' | 'styleId' | 'definition' | 'name' | 'type'>
    >;
  }>;
};

export type TransferOwnershipTeamMutationVariables = Exact<{
  input: TransferOwnershipTeamInput;
}>;

export type TransferOwnershipTeamMutation = {
  transferOwnershipTeam?: Maybe<{
    team?: Maybe<
      Pick<Team, 'teamId' | 'name' | 'active' | 'projects' | 'owner'>
    >;
  }>;
};

export type UnassignUserTeamMutationVariables = Exact<{
  input: UnassignUserTeamInput;
}>;

export type UnassignUserTeamMutation = {
  unassignUserTeam?: Maybe<{
    team?: Maybe<Pick<Team, 'id' | 'teamId' | 'members'>>;
  }>;
};

export type CreateTeamTokenMutationVariables = Exact<{
  input: CreateTeamTokenInput;
}>;

export type CreateTeamTokenMutation = {
  createTeamToken?: Maybe<{
    teamToken?: Maybe<
      Pick<
        TeamToken,
        | 'id'
        | 'teamTokenId'
        | 'name'
        | 'value'
        | 'createdAt'
        | 'updatedAt'
        | 'lastLoginAt'
      >
    >;
  }>;
};

export type RemoveTeamTokenMutationVariables = Exact<{
  input: RemoveTeamTokenInput;
}>;

export type RemoveTeamTokenMutation = {
  removeTeamToken?: Maybe<{ teamToken?: Maybe<Pick<TeamToken, 'id'>> }>;
};

export type CreateObjectPreviewFromTemplateObjectMutationVariables = Exact<{
  input: CreateObjectPreviewFromTemplateObjectInput;
}>;

export type CreateObjectPreviewFromTemplateObjectMutation = {
  createObjectPreviewFromTemplateObject?: Maybe<{
    object?: Maybe<
      Pick<
        Object,
        | 'id'
        | 'objectId'
        | 'message'
        | 'resolvedManageableLayers'
        | 'resolvedManageableLayersConditions'
      >
    >;
  }>;
};

export type UnassignDefaultLogoMutationVariables = Exact<{
  input: UnassignDefaultLogoInput;
}>;

export type UnassignDefaultLogoMutation = {
  unassignDefaultLogo?: Maybe<{ logo?: Maybe<Pick<Logo, 'id' | 'logoId'>> }>;
};

export type UpdateCodeSettingsAdminTemplateMutationVariables = Exact<{
  input: UpdateCodeSettingsAdminTemplateInput;
}>;

export type UpdateCodeSettingsAdminTemplateMutation = {
  updateCodeSettingsAdminTemplate?: Maybe<{
    adminTemplate?: Maybe<
      Pick<AdminTemplate, 'id' | 'templateId' | 'manageableLayersSettings'>
    >;
  }>;
};

export type UpdateCodeSettingsDesignMutationVariables = Exact<{
  input: UpdateCodeSettingsDesignInput;
}>;

export type UpdateCodeSettingsDesignMutation = {
  updateCodeSettingsDesign?: Maybe<{
    design?: Maybe<
      Pick<
        Design,
        'id' | 'designId' | 'customStyle' | 'manageableLayersSettings'
      >
    >;
  }>;
};

export type UpdateFeedForceProjectMutationVariables = Exact<{
  input: ForceFeedProjectInput;
}>;

export type UpdateFeedForceProjectMutation = {
  forceFeedProject?: Maybe<{
    project?: Maybe<
      Pick<
        Project,
        | 'id'
        | 'projectId'
        | 'feed'
        | 'projectInfo'
        | 'shouldProjectBeUpdated'
        | 'currentUpdate'
      >
    >;
  }>;
};

export type UpdateFeedProjectMutationVariables = Exact<{
  input: UpdateFeedProjectInput;
}>;

export type UpdateFeedProjectMutation = {
  updateFeedProject?: Maybe<{
    project?: Maybe<
      Pick<Project, 'id' | 'projectId' | 'feed' | 'currentUpdate'>
    >;
  }>;
};

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;

export type UpdateProjectMutation = {
  updateProject?: Maybe<{
    project?: Maybe<
      Pick<
        Project,
        | 'id'
        | 'projectId'
        | 'name'
        | 'teamId'
        | 'createdAt'
        | 'updatedAt'
        | 'lastUpdateId'
        | 'currentUpdateId'
        | 'feed'
        | 'status'
        | 'projectTokens'
      >
    >;
  }>;
};

export type UpdateSettingsDesignMutationVariables = Exact<{
  input: UpdateSettingsDesignInput;
}>;

export type UpdateSettingsDesignMutation = {
  updateSettingsDesign?: Maybe<{
    design?: Maybe<Pick<Design, 'id' | 'designId' | 'name' | 'updatedAt'>>;
  }>;
};

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;

export type UpdateTeamMutation = {
  updateTeam?: Maybe<{ team?: Maybe<Pick<Team, 'id' | 'teamId' | 'name'>> }>;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  updateUser?: Maybe<
    Pick<UpdateUserPayload, 'clientMutationId'> & {
      user?: Maybe<
        Pick<
          User,
          'id' | 'email' | 'firstName' | 'lastName' | 'phone' | 'industryId'
        >
      >;
    }
  >;
};

export type FetchCollectionAdminElementsQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminElementsQuery = {
  fetchCollectionAdminElements?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminElement,
            | 'id'
            | '_id'
            | 'name'
            | 'active'
            | 'previewImageId'
            | 'elementCategoryResources'
            | 'cropinkCodeMeta'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminElementPaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchAdminProjectUpdateStatisticsQueryVariables = Exact<{
  projectUpdateId: Scalars['String'];
}>;

export type FetchAdminProjectUpdateStatisticsQuery = {
  fetchAdminProjectUpdateStatistics?: Maybe<
    Pick<
      AdminProjectUpdateStatistics,
      | 'projectUpdateId'
      | 'clientProductItems'
      | 'clientImages'
      | 'clientMinimalImagesInProduct'
      | 'clientMaximalImagesInProduct'
      | 'cropinkProductItems'
      | 'cropinkImages'
      | 'objectsToBeProcessed'
      | 'objectsProcessedSuccessfully'
      | 'objectsProcessedUnsuccessfully'
      | 'feedProcessingFinished'
      | 'feedReadingFinished'
      | 'objectsReadFromCache'
    >
  >;
};

export type FetchCollectionAdminProjectUpdatesQueryVariables = Exact<{
  projectId: Scalars['String'];
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminProjectUpdatesQuery = {
  fetchCollectionAdminProjectUpdates?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminProjectUpdate,
            | 'id'
            | 'projectUpdateId'
            | 'status'
            | 'processingMode'
            | 'usedDesigns'
            | 'createdAt'
            | 'updatedAt'
            | 'statistics'
            | 'planDetails'
            | 'message'
            | 'messageArguments'
            | 'messageSeverity'
            | 'isSourceFileExists'
            | 'isTargetFileExists'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminProjectUpdatePaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchCollectionAdminProjectsQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminProjectsQuery = {
  fetchCollectionAdminProjects?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminProject,
            | 'id'
            | 'projectId'
            | 'name'
            | 'teamId'
            | 'createdAt'
            | 'updatedAt'
            | 'lastUpdate'
            | 'currentUpdate'
            | 'status'
            | 'active'
            | 'projectTokens'
            | 'designs'
            | 'subscription'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminProjectPaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchAdminStyleQueryVariables = Exact<{
  styleId: Scalars['String'];
}>;

export type FetchAdminStyleQuery = {
  fetchAdminStyle?: Maybe<
    Pick<AdminStyle, 'id' | 'styleId' | 'definition' | 'name' | 'type'>
  >;
};

export type FetchCollectionAdminStylesQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminStylesQuery = {
  fetchCollectionAdminStyles?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminStyle,
            | 'id'
            | 'styleId'
            | 'name'
            | 'active'
            | 'definition'
            | 'templates'
            | 'type'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminStylePaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchAdminTeamQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchAdminTeamQuery = {
  fetchAdminTeam?: Maybe<
    Pick<
      AdminTeam,
      'id' | 'name' | 'active' | 'projects' | 'members' | 'styles' | 'owner'
    >
  >;
};

export type FetchCollectionAdminTeamsQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminTeamsQuery = {
  fetchCollectionAdminTeams?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminTeam,
            | 'id'
            | 'teamId'
            | 'name'
            | 'isDefault'
            | 'active'
            | 'projects'
            | 'members'
            | 'styles'
            | 'updatedAt'
            | 'createdAt'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminTeamPaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchAdminTemplateQueryVariables = Exact<{
  templateId: Scalars['String'];
}>;

export type FetchAdminTemplateQuery = {
  fetchAdminTemplate?: Maybe<
    Pick<
      AdminTemplate,
      | 'id'
      | 'templateId'
      | 'name'
      | 'previewImageId'
      | 'active'
      | 'styles'
      | 'tags'
      | 'templateGroupId'
      | 'templateGroupName'
      | 'manageableLayersSettings'
      | 'manageableLayersNested'
    >
  >;
};

export type FetchAdminTemplatesForDropdownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchAdminTemplatesForDropdownQuery = {
  fetchCollectionAdminTemplates?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<AdminTemplate, 'id' | 'templateId' | 'name' | 'previewImageId'>
        >
      >
    >;
  }>;
};

export type FetchCollectionAdminTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminTemplatesQuery = {
  fetchCollectionAdminTemplates?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminTemplate,
            | 'id'
            | 'templateId'
            | 'name'
            | 'previewImageId'
            | 'active'
            | 'templateGroupId'
            | 'templateGroupName'
            | 'isBaseTemplate'
            | 'mainSize'
            | 'createdAt'
            | 'updatedAt'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminTemplatePaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchAdminTemplateGroupQueryVariables = Exact<{
  templateGroupId: Scalars['String'];
}>;

export type FetchAdminTemplateGroupQuery = {
  fetchAdminTemplateGroup?: Maybe<
    Pick<
      AdminTemplateGroup,
      'id' | 'templateGroupId' | 'name' | 'baseTemplate' | 'templates'
    >
  >;
};

export type FetchCollectionAdminTemplateGroupsQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminTemplateGroupsQuery = {
  fetchCollectionAdminTemplateGroups?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminTemplateGroup,
            'id' | 'templateGroupId' | 'name' | 'baseTemplate' | 'templates'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminTemplateGroupPaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchCollectionAdminUsersQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionAdminUsersQuery = {
  fetchCollectionAdminUsers?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            AdminUser,
            | 'id'
            | 'userId'
            | 'firstName'
            | 'lastName'
            | 'roles'
            | 'email'
            | 'teams'
            | 'projects'
            | 'survey'
            | 'createdAt'
            | 'lastLoginAt'
            | 'tracking'
            | 'location'
            | 'onboardingType'
          >
        >
      >
    >;
    paginationInfo: Pick<
      AdminUserPaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchCollectionRecentDesignsQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
}>;

export type FetchCollectionRecentDesignsQuery = {
  fetchCollectionRecentDesigns?: Maybe<
    Array<
      Maybe<
        Pick<
          Design,
          | 'id'
          | 'designId'
          | 'updatedAt'
          | 'projectName'
          | 'name'
          | 'previewImageId'
          | 'teamId'
          | 'projectId'
        >
      >
    >
  >;
};

export type FetchDesignQueryVariables = Exact<{
  designId: Scalars['String'];
}>;

export type FetchDesignQuery = {
  fetchDesign?: Maybe<
    Pick<
      Design,
      | 'id'
      | 'designId'
      | 'projectId'
      | 'name'
      | 'styleId'
      | 'previewImageId'
      | 'updatedAt'
      | 'mainSize'
      | 'customStyle'
      | 'mappedStyles'
      | 'stylizable'
      | 'manageableLayersSettings'
      | 'manageableLayersNested'
      | 'currentStyleIdUsedAt'
      | 'isEmpty'
    >
  >;
};

export type FetchDesignCodesQueryVariables = Exact<{
  designId: Scalars['String'];
}>;

export type FetchDesignCodesQuery = {
  fetchDesignCodes?: Maybe<
    Pick<
      DesignCodes,
      'designId' | 'projectId' | 'teamId' | 'figmaCode' | 'cropinkCodeMeta'
    >
  >;
};

export type FetchDesignPreviewQueryVariables = Exact<{
  designId: Scalars['String'];
}>;

export type FetchDesignPreviewQuery = {
  fetchDesign?: Maybe<
    Pick<
      Design,
      | 'id'
      | 'designId'
      | 'projectId'
      | 'name'
      | 'styleId'
      | 'previewImageId'
      | 'updatedAt'
      | 'mainSize'
      | 'customStyle'
      | 'mappedStyles'
      | 'mappedFonts'
      | 'stylizable'
      | 'manageableLayersSettings'
      | 'currentStyleIdUsedAt'
      | 'settings'
      | 'isEmpty'
    >
  >;
};

export type FetchProjectDesignsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type FetchProjectDesignsQuery = {
  fetchCollectionDesigns?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            Design,
            | 'id'
            | 'designId'
            | 'templateId'
            | 'projectId'
            | 'teamId'
            | 'styleId'
            | 'name'
            | 'projectName'
            | 'stylizable'
            | 'style'
            | 'customStyle'
            | 'figmaCode'
            | 'cropinkCode'
            | 'cropinkStyledCode'
            | 'previewImageId'
            | 'images'
            | 'mainSize'
            | 'mappedStyles'
            | 'manageableLayersSettings'
            | 'manageableLayersNested'
            | 'createdAt'
            | 'updatedAt'
            | 'currentStyleIdUsedAt'
            | 'mappedFonts'
            | 'settings'
            | 'isEmpty'
          >
        >
      >
    >;
  }>;
};

export type FetchCollectionElementCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchCollectionElementCategoriesQuery = {
  fetchCollectionElementCategories?: Maybe<
    Array<Maybe<Pick<ElementCategory, 'id' | 'elementCategoryId' | 'name'>>>
  >;
};

export type FetchCollectionElementsQueryVariables = Exact<{
  teamId: Scalars['String'];
  withGlobal?: InputMaybe<Scalars['Boolean']>;
}>;

export type FetchCollectionElementsQuery = {
  fetchCollectionElements?: Maybe<
    Array<
      Maybe<
        Pick<
          Element,
          | 'id'
          | 'elementId'
          | 'name'
          | 'previewImageId'
          | 'active'
          | 'elementCategoryResources'
          | 'cropinkCodeMeta'
        >
      >
    >
  >;
};

export type FetchElementCodesQueryVariables = Exact<{
  elementId: Scalars['String'];
}>;

export type FetchElementCodesQuery = {
  fetchElementCodes?: Maybe<
    Pick<
      ElementCodes,
      | 'id'
      | 'elementId'
      | 'figmaCode'
      | 'cropinkCodeMeta'
      | 'manageableLayersSettings'
    >
  >;
};

export type FetchClientImageQueryVariables = Exact<{
  teamId: Scalars['String'];
  url: Scalars['String'];
}>;

export type FetchClientImageQuery = {
  fetchClientImage?: Maybe<Pick<ClientImage, 'content'>>;
};

export type FetchCollectionAdAccountsQueryVariables = Exact<{
  connectorId: Scalars['String'];
}>;

export type FetchCollectionAdAccountsQuery = {
  fetchCollectionAdAccounts?: Maybe<
    Array<Maybe<Pick<AdAccount, 'adAccountId' | 'name' | 'business'>>>
  >;
};

export type FetchCollectionBusinessClientsQueryVariables = Exact<{
  accessToken: Scalars['String'];
}>;

export type FetchCollectionBusinessClientsQuery = {
  fetchCollectionBusinessClients?: Maybe<
    Array<Maybe<Pick<BusinessClient, 'businessClientId' | 'name'>>>
  >;
};

export type FetchCollectionCatalogsQueryVariables = Exact<{
  connectorId: Scalars['String'];
}>;

export type FetchCollectionCatalogsQuery = {
  fetchCollectionCatalogs?: Maybe<
    Array<Maybe<Pick<Catalog, 'catalogId' | 'name'>>>
  >;
};

export type FetchCollectionFontsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchCollectionFontsQuery = {
  fetchCollectionFonts?: Maybe<
    Array<
      Maybe<
        Pick<
          Font,
          | 'id'
          | 'fontId'
          | 'userId'
          | 'teamId'
          | 'name'
          | 'family'
          | 'style'
          | 'weight'
          | 'weightName'
          | 'postScript'
          | 'format'
          | 'createdAt'
          | 'updatedAt'
        >
      >
    >
  >;
};

export type FetchCollectionRolesQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['String']>;
}>;

export type FetchCollectionRolesQuery = {
  fetchCollectionRoles?: Maybe<
    Array<
      Maybe<
        Pick<Role, 'id' | 'roleId' | 'roleName' | 'description' | 'permissions'>
      >
    >
  >;
};

export type FetchCollectionTagsQueryVariables = Exact<{
  tags?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type FetchCollectionTagsQuery = {
  fetchCollectionTags?: Maybe<
    Array<
      Maybe<Pick<Tag, 'id' | 'tagId' | 'category' | 'value' | 'templatesCount'>>
    >
  >;
};

export type FetchDesignManagerQueriesQueryVariables = Exact<{
  teamId: Scalars['String'];
  designId: Scalars['String'];
}>;

export type FetchDesignManagerQueriesQuery = {
  fetchDictionary?: Maybe<Pick<Dictionary, 'id' | 'dictionary'>>;
  fetchTeam?: Maybe<Pick<Team, 'id' | 'teamId' | 'logos'>>;
  fetchCollectionTeamFonts?: Maybe<
    Array<
      Maybe<
        Pick<
          Font,
          | 'id'
          | 'fontId'
          | 'userId'
          | 'teamId'
          | 'name'
          | 'family'
          | 'style'
          | 'format'
          | 'createdAt'
          | 'updatedAt'
        >
      >
    >
  >;
  fetchCollectionFonts?: Maybe<
    Array<
      Maybe<
        Pick<
          Font,
          | 'id'
          | 'fontId'
          | 'userId'
          | 'teamId'
          | 'name'
          | 'family'
          | 'style'
          | 'format'
          | 'weight'
          | 'createdAt'
          | 'updatedAt'
        >
      >
    >
  >;
  fetchDesign?: Maybe<
    Pick<
      Design,
      | 'id'
      | 'designId'
      | 'name'
      | 'styleId'
      | 'previewImageId'
      | 'updatedAt'
      | 'mainSize'
      | 'customStyle'
      | 'mappedStyles'
      | 'mappedFonts'
      | 'manageableLayersSettings'
      | 'manageableLayersNested'
      | 'currentStyleIdUsedAt'
      | 'isEmpty'
    >
  >;
  fetchDesignCodes?: Maybe<
    Pick<DesignCodes, 'designId' | 'figmaCode' | 'cropinkCodeMeta'>
  >;
};

export type FetchDictionaryQueryVariables = Exact<{ [key: string]: never }>;

export type FetchDictionaryQuery = {
  fetchDictionary?: Maybe<Pick<Dictionary, 'id' | 'dictionary'>>;
};

export type FetchTemplateGroupQueryVariables = Exact<{
  templateGroupId: Scalars['String'];
}>;

export type FetchTemplateGroupQuery = {
  fetchTemplateGroup?: Maybe<
    Pick<
      TemplateGroup,
      'id' | 'templateGroupId' | 'name' | 'baseTemplate' | 'templates'
    >
  >;
};

export type FetchTemplateManagerQueriesQueryVariables = Exact<{
  templateId: Scalars['String'];
}>;

export type FetchTemplateManagerQueriesQuery = {
  fetchDictionary?: Maybe<Pick<Dictionary, 'id' | 'dictionary'>>;
  fetchCollectionFonts?: Maybe<
    Array<
      Maybe<
        Pick<
          Font,
          | 'id'
          | 'fontId'
          | 'userId'
          | 'teamId'
          | 'name'
          | 'family'
          | 'style'
          | 'weight'
          | 'format'
          | 'createdAt'
          | 'updatedAt'
        >
      >
    >
  >;
  fetchAdminTemplate?: Maybe<
    Pick<
      AdminTemplate,
      | 'id'
      | 'templateId'
      | 'templateGroupId'
      | 'name'
      | 'previewImageId'
      | 'styles'
      | 'isFavourite'
      | 'mainSize'
      | 'manageableLayersSettings'
      | 'manageableLayersNested'
    >
  >;
};

export type FetchCollectionShopifyLanguagesQueryVariables = Exact<{
  connectorId: Scalars['String'];
}>;

export type FetchCollectionShopifyLanguagesQuery = {
  fetchCollectionShopifyLanguages?: Maybe<
    Array<
      Maybe<Pick<ShopifyLanguage, 'locale' | 'name' | 'primary' | 'published'>>
    >
  >;
};

export type FetchCollectionShopifyMarketsQueryVariables = Exact<{
  connectorId: Scalars['String'];
}>;

export type FetchCollectionShopifyMarketsQuery = {
  fetchCollectionShopifyMarkets?: Maybe<
    Array<
      Maybe<
        Pick<ShopifyMarket, 'marketId' | 'name' | 'handle' | 'status' | 'type'>
      >
    >
  >;
};

export type FetchFacebookFeedQueryVariables = Exact<{
  connectorId: Scalars['String'];
  catalogId: Scalars['String'];
  projectId: Scalars['String'];
}>;

export type FetchFacebookFeedQuery = {
  fetchFacebookFeed?: Maybe<Pick<FacebookFeed, 'url' | 'username'>>;
};

export type RefreshCollectionAdsProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type RefreshCollectionAdsProjectMutation = {
  refreshCollectionAdsProject?: Maybe<{
    project?: Maybe<Pick<Project, 'projectId' | 'name' | 'outputSettings'>>;
  }>;
};

export type FetchOnboardingTeamStylesQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchOnboardingTeamStylesQuery = {
  fetchCollectionTeamStyles?: Maybe<
    Array<Maybe<Pick<Style, 'id' | 'styleId' | 'definition'>>>
  >;
};

export type FetchOnboardingUserTeamsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchOnboardingUserTeamsQuery = {
  fetchCollectionUserTeams?: Maybe<
    Array<Maybe<Pick<Team, 'id' | 'teamId' | 'name' | 'projects' | 'logos'>>>
  >;
};

export type FetchCollectionSubscriptionPlansQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchCollectionSubscriptionPlansQuery = {
  fetchCollectionProducts?: Maybe<
    Array<
      Maybe<
        Pick<
          Product,
          | 'id'
          | 'productId'
          | 'externalId'
          | 'productLimits'
          | 'productName'
          | 'productFeatures'
          | 'productDescription'
          | 'prices'
        >
      >
    >
  >;
};

export type FetchBackgroundRemovalStatusQueryVariables = Exact<{
  projectUpdateId: Scalars['String'];
}>;

export type FetchBackgroundRemovalStatusQuery = {
  fetchBackgroundRemovalStatus?: Maybe<
    Pick<
      BackgroundRemovalStatus,
      'id' | 'projectUpdateId' | 'all' | 'success' | 'failed' | 'inProgress'
    >
  >;
};

export type FetchCollectionFacebookAdsQueryVariables = Exact<{
  projectId: Scalars['String'];
  filters?: InputMaybe<Array<InputMaybe<Filter>> | InputMaybe<Filter>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>> | InputMaybe<Sort>>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionFacebookAdsQuery = {
  fetchCollectionFacebookAds?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            FacebookAd,
            | 'adId'
            | 'name'
            | 'projectObjectId'
            | 'campaignId'
            | 'campaignName'
            | 'adSetId'
            | 'adSetName'
            | 'effectiveStatus'
            | 'createdAt'
            | 'updatedAt'
            | 'insights'
          >
        >
      >
    >;
    paginationInfo: Pick<FacebookAdPaginationInfo, 'totalCount'>;
  }>;
};

export type FetchCollectionProjectItemsQueryVariables = Exact<{
  projectId: Scalars['String'];
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionProjectItemsQuery = {
  fetchCollectionProjectItems?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            ProjectItem,
            'id' | 'projectItemId' | 'product' | 'projectObjectResults'
          >
        >
      >
    >;
    paginationInfo: Pick<
      ProjectItemPaginationInfo,
      'itemsPerPage' | 'lastPage' | 'totalCount'
    >;
  }>;
};

export type FetchCollectionProjectObjectBehaviorsQueryVariables = Exact<{
  projectObjectId: Scalars['String'];
  filters?: InputMaybe<Array<InputMaybe<Filter>> | InputMaybe<Filter>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>> | InputMaybe<Sort>>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionProjectObjectBehaviorsQuery = {
  fetchCollectionProjectObjectBehaviors?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            ProjectObjectBehavior,
            | 'projectObjectBehaviorId'
            | 'projectObjectId'
            | 'schedule'
            | 'rules'
            | 'ordering'
            | 'usedDesigns'
            | 'updatedAt'
            | 'createdAt'
          >
        >
      >
    >;
  }>;
};

export type FetchCollectionProjectUpdatesQueryVariables = Exact<{
  projectId: Scalars['String'];
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionProjectUpdatesQuery = {
  fetchCollectionProjectUpdates?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            ProjectUpdate,
            | 'id'
            | 'projectUpdateId'
            | 'status'
            | 'processingMode'
            | 'usedDesigns'
            | 'createdAt'
            | 'updatedAt'
            | 'statistics'
            | 'planDetails'
            | 'message'
            | 'messageArguments'
            | 'messageSeverity'
          >
        >
      >
    >;
    paginationInfo: Pick<
      ProjectUpdatePaginationInfo,
      'totalCount' | 'itemsPerPage' | 'lastPage'
    >;
  }>;
};

export type FetchFacebookPermissionReportQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type FetchFacebookPermissionReportQuery = {
  fetchFacebookPermissionReport?: Maybe<
    Pick<FacebookPermissionReport, 'id' | 'items' | 'satisfied'>
  >;
};

export type FetchProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type FetchProjectQuery = {
  fetchProject?: Maybe<
    Pick<
      Project,
      | 'id'
      | 'projectId'
      | 'name'
      | 'teamId'
      | 'createdAt'
      | 'updatedAt'
      | 'feed'
      | 'projectTokens'
      | 'designs'
      | 'currentUpdate'
      | 'lastUpdate'
      | 'subscription'
      | 'scheduledAt'
      | 'projectInfo'
      | 'shouldProjectBeUpdated'
      | 'settings'
      | 'outputSettings'
      | 'projectObjects'
    >
  >;
};

export type FetchProjectObjectBehaviorQueryVariables = Exact<{
  projectObjectBehaviorId: Scalars['String'];
}>;

export type FetchProjectObjectBehaviorQuery = {
  fetchProjectObjectBehavior?: Maybe<
    Pick<
      ProjectObjectBehavior,
      | 'id'
      | 'projectObjectBehaviorId'
      | 'projectObjectId'
      | 'ordering'
      | 'rules'
      | 'schedule'
      | 'updatedAt'
      | 'createdAt'
      | 'usedDesigns'
    >
  >;
};

export type FetchProjectObjectsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type FetchProjectObjectsQuery = {
  fetchProject?: Maybe<Pick<Project, 'id' | 'projectId' | 'projectObjects'>>;
};

export type FetchTeamProjectsQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchTeamProjectsQuery = {
  fetchTeam?: Maybe<Pick<Team, 'id' | 'teamId' | 'projects'>>;
};

export type FetchCollectionTeamStylesQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchCollectionTeamStylesQuery = {
  fetchCollectionTeamStyles?: Maybe<
    Array<
      Maybe<
        Pick<
          Style,
          'id' | 'styleId' | 'definition' | 'name' | 'type' | 'updatedAt'
        >
      >
    >
  >;
};

export type FetchTeamStyleQueryVariables = Exact<{
  styleId: Scalars['String'];
}>;

export type FetchTeamStyleQuery = {
  fetchTeamStyle?: Maybe<
    Pick<Style, 'id' | 'styleId' | 'definition' | 'name' | 'type' | 'updatedAt'>
  >;
};

export type FetchCollectionTeamAssetImagesQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchCollectionTeamAssetImagesQuery = {
  fetchTeam?: Maybe<Pick<Team, 'id' | 'teamId' | 'assetImages'>>;
};

export type FetchTeamQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchTeamQuery = {
  fetchTeam?: Maybe<
    Pick<
      Team,
      | 'id'
      | 'teamId'
      | 'default'
      | 'name'
      | 'owner'
      | 'members'
      | 'projects'
      | 'invitations'
      | 'subscription'
      | 'connectors'
    >
  >;
};

export type FetchTeamBrandKitQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchTeamBrandKitQuery = {
  fetchTeam?: Maybe<
    Pick<Team, 'id' | 'teamId' | 'logos' | 'fonts' | 'assetImages'>
  >;
};

export type FetchUserTeamsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;

export type FetchUserTeamsQuery = {
  fetchCollectionUserTeams?: Maybe<
    Array<
      Maybe<
        Pick<
          Team,
          | 'id'
          | 'teamId'
          | 'name'
          | 'projects'
          | 'default'
          | 'userPermissions'
          | 'owner'
        >
      >
    >
  >;
};

export type FetchCollectionTeamFontsQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchCollectionTeamFontsQuery = {
  fetchCollectionTeamFonts?: Maybe<
    Array<
      Maybe<
        Pick<
          Font,
          | 'id'
          | 'fontId'
          | 'userId'
          | 'teamId'
          | 'name'
          | 'family'
          | 'style'
          | 'weight'
          | 'weightName'
          | 'postScript'
          | 'format'
          | 'createdAt'
          | 'updatedAt'
        >
      >
    >
  >;
};

export type FetchCollectionTeamLogosQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchCollectionTeamLogosQuery = {
  fetchTeam?: Maybe<Pick<Team, 'id' | 'teamId' | 'logos'>>;
};

export type FetchCollectionTeamTokensQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;

export type FetchCollectionTeamTokensQuery = {
  fetchCollectionTeamTokens?: Maybe<
    Array<
      Maybe<
        Pick<
          TeamToken,
          | 'id'
          | 'teamTokenId'
          | 'name'
          | 'value'
          | 'createdAt'
          | 'updatedAt'
          | 'lastLoginAt'
        >
      >
    >
  >;
};

export type FetchCollectionTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<Array<Filter> | Filter>;
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchCollectionTemplatesQuery = {
  fetchCollectionTemplates?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            Template,
            | 'id'
            | 'templateId'
            | 'name'
            | 'previewImageId'
            | 'templateGroupId'
            | 'isFavourite'
            | 'tags'
            | 'styles'
            | 'templateGroupTemplates'
          >
        >
      >
    >;
    paginationInfo: Pick<
      TemplatePaginationInfo,
      'itemsPerPage' | 'lastPage' | 'totalCount'
    >;
  }>;
};

export type FetchFavouritesCollectionTemplatesQueryVariables = Exact<{
  sort?: InputMaybe<Array<Sort> | Sort>;
  paginate?: InputMaybe<Paginate>;
}>;

export type FetchFavouritesCollectionTemplatesQuery = {
  fetchFavouritesCollectionTemplates?: Maybe<{
    collection?: Maybe<
      Array<
        Maybe<
          Pick<
            Template,
            | 'id'
            | 'templateId'
            | 'name'
            | 'previewImageId'
            | 'templateGroupId'
            | 'isFavourite'
          >
        >
      >
    >;
    paginationInfo: Pick<
      TemplatePaginationInfo,
      'itemsPerPage' | 'lastPage' | 'totalCount'
    >;
  }>;
};

export type FetchTemplateQueryVariables = Exact<{
  templateId: Scalars['String'];
}>;

export type FetchTemplateQuery = {
  fetchTemplate?: Maybe<
    Pick<
      Template,
      | 'id'
      | 'templateId'
      | 'templateGroupId'
      | 'name'
      | 'previewImageId'
      | 'styles'
      | 'isFavourite'
      | 'mainSize'
      | 'tags'
    >
  >;
};

export type FetchProfileQueryVariables = Exact<{ [key: string]: never }>;

export type FetchProfileQuery = {
  fetchProfile?: Maybe<
    Pick<
      Profile,
      | 'id'
      | 'userId'
      | 'email'
      | 'firstName'
      | 'lastName'
      | 'phone'
      | 'industryId'
      | 'onboarding'
      | 'defaultTeamId'
    >
  >;
};

export const AuthTokenFragmentDoc = gql`
  fragment AuthToken on loginCredentialsUserPayloadData {
    id
    token
    refreshToken
    refreshTokenExpiresAt
  }
`;
export const AuthTokenSharedFragmentDoc = gql`
  fragment AuthTokenShared on loginSharedProjectAuthPayloadData {
    id
    token
    refreshToken
    refreshTokenExpiresAt
  }
`;
export const AddFavouriteTemplateDocument = gql`
  mutation AddFavouriteTemplate($input: addFavouriteTemplateInput!) {
    addFavouriteTemplate(input: $input) {
      template {
        id
        templateId
        isFavourite
      }
    }
  }
`;
export type AddFavouriteTemplateMutationFn = Apollo.MutationFunction<
  AddFavouriteTemplateMutation,
  AddFavouriteTemplateMutationVariables
>;

/**
 * __useAddFavouriteTemplateMutation__
 *
 * To run a mutation, you first call `useAddFavouriteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavouriteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavouriteTemplateMutation, { data, loading, error }] = useAddFavouriteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFavouriteTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddFavouriteTemplateMutation,
    AddFavouriteTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    AddFavouriteTemplateMutation,
    AddFavouriteTemplateMutationVariables
  >(AddFavouriteTemplateDocument, options);
}

export type AddFavouriteTemplateMutationHookResult = ReturnType<
  typeof useAddFavouriteTemplateMutation
>;
export type AddFavouriteTemplateMutationResult =
  Apollo.MutationResult<AddFavouriteTemplateMutation>;
export type AddFavouriteTemplateMutationOptions = Apollo.BaseMutationOptions<
  AddFavouriteTemplateMutation,
  AddFavouriteTemplateMutationVariables
>;
export const ActivateAdminElementDocument = gql`
  mutation ActivateAdminElement($input: activateAdminElementInput!) {
    activateAdminElement(input: $input) {
      adminElement {
        id
        active
      }
    }
  }
`;
export type ActivateAdminElementMutationFn = Apollo.MutationFunction<
  ActivateAdminElementMutation,
  ActivateAdminElementMutationVariables
>;

/**
 * __useActivateAdminElementMutation__
 *
 * To run a mutation, you first call `useActivateAdminElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAdminElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAdminElementMutation, { data, loading, error }] = useActivateAdminElementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateAdminElementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateAdminElementMutation,
    ActivateAdminElementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ActivateAdminElementMutation,
    ActivateAdminElementMutationVariables
  >(ActivateAdminElementDocument, options);
}

export type ActivateAdminElementMutationHookResult = ReturnType<
  typeof useActivateAdminElementMutation
>;
export type ActivateAdminElementMutationResult =
  Apollo.MutationResult<ActivateAdminElementMutation>;
export type ActivateAdminElementMutationOptions = Apollo.BaseMutationOptions<
  ActivateAdminElementMutation,
  ActivateAdminElementMutationVariables
>;
export const CreateFromTeamElementAdminElementDocument = gql`
  mutation CreateFromTeamElementAdminElement(
    $input: createFromTeamElementAdminElementInput!
  ) {
    createFromTeamElementAdminElement(input: $input) {
      adminElement {
        id
        name
        active
      }
    }
  }
`;
export type CreateFromTeamElementAdminElementMutationFn =
  Apollo.MutationFunction<
    CreateFromTeamElementAdminElementMutation,
    CreateFromTeamElementAdminElementMutationVariables
  >;

/**
 * __useCreateFromTeamElementAdminElementMutation__
 *
 * To run a mutation, you first call `useCreateFromTeamElementAdminElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFromTeamElementAdminElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFromTeamElementAdminElementMutation, { data, loading, error }] = useCreateFromTeamElementAdminElementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFromTeamElementAdminElementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFromTeamElementAdminElementMutation,
    CreateFromTeamElementAdminElementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateFromTeamElementAdminElementMutation,
    CreateFromTeamElementAdminElementMutationVariables
  >(CreateFromTeamElementAdminElementDocument, options);
}

export type CreateFromTeamElementAdminElementMutationHookResult = ReturnType<
  typeof useCreateFromTeamElementAdminElementMutation
>;
export type CreateFromTeamElementAdminElementMutationResult =
  Apollo.MutationResult<CreateFromTeamElementAdminElementMutation>;
export type CreateFromTeamElementAdminElementMutationOptions =
  Apollo.BaseMutationOptions<
    CreateFromTeamElementAdminElementMutation,
    CreateFromTeamElementAdminElementMutationVariables
  >;
export const DeactivateAdminElementDocument = gql`
  mutation DeactivateAdminElement($input: deactivateAdminElementInput!) {
    deactivateAdminElement(input: $input) {
      adminElement {
        id
        active
      }
    }
  }
`;
export type DeactivateAdminElementMutationFn = Apollo.MutationFunction<
  DeactivateAdminElementMutation,
  DeactivateAdminElementMutationVariables
>;

/**
 * __useDeactivateAdminElementMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminElementMutation, { data, loading, error }] = useDeactivateAdminElementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateAdminElementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateAdminElementMutation,
    DeactivateAdminElementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DeactivateAdminElementMutation,
    DeactivateAdminElementMutationVariables
  >(DeactivateAdminElementDocument, options);
}

export type DeactivateAdminElementMutationHookResult = ReturnType<
  typeof useDeactivateAdminElementMutation
>;
export type DeactivateAdminElementMutationResult =
  Apollo.MutationResult<DeactivateAdminElementMutation>;
export type DeactivateAdminElementMutationOptions = Apollo.BaseMutationOptions<
  DeactivateAdminElementMutation,
  DeactivateAdminElementMutationVariables
>;
export const RemoveAdminElementDocument = gql`
  mutation RemoveAdminElement($input: removeAdminElementInput!) {
    removeAdminElement(input: $input) {
      adminElement {
        id
      }
    }
  }
`;
export type RemoveAdminElementMutationFn = Apollo.MutationFunction<
  RemoveAdminElementMutation,
  RemoveAdminElementMutationVariables
>;

/**
 * __useRemoveAdminElementMutation__
 *
 * To run a mutation, you first call `useRemoveAdminElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminElementMutation, { data, loading, error }] = useRemoveAdminElementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminElementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminElementMutation,
    RemoveAdminElementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminElementMutation,
    RemoveAdminElementMutationVariables
  >(RemoveAdminElementDocument, options);
}

export type RemoveAdminElementMutationHookResult = ReturnType<
  typeof useRemoveAdminElementMutation
>;
export type RemoveAdminElementMutationResult =
  Apollo.MutationResult<RemoveAdminElementMutation>;
export type RemoveAdminElementMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminElementMutation,
  RemoveAdminElementMutationVariables
>;
export const UpdateCategoriesAdminElementDocument = gql`
  mutation UpdateCategoriesAdminElement(
    $input: updateCategoriesAdminElementInput!
  ) {
    updateCategoriesAdminElement(input: $input) {
      adminElement {
        id
        elementCategoryResources
      }
    }
  }
`;
export type UpdateCategoriesAdminElementMutationFn = Apollo.MutationFunction<
  UpdateCategoriesAdminElementMutation,
  UpdateCategoriesAdminElementMutationVariables
>;

/**
 * __useUpdateCategoriesAdminElementMutation__
 *
 * To run a mutation, you first call `useUpdateCategoriesAdminElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoriesAdminElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoriesAdminElementMutation, { data, loading, error }] = useUpdateCategoriesAdminElementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoriesAdminElementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCategoriesAdminElementMutation,
    UpdateCategoriesAdminElementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateCategoriesAdminElementMutation,
    UpdateCategoriesAdminElementMutationVariables
  >(UpdateCategoriesAdminElementDocument, options);
}

export type UpdateCategoriesAdminElementMutationHookResult = ReturnType<
  typeof useUpdateCategoriesAdminElementMutation
>;
export type UpdateCategoriesAdminElementMutationResult =
  Apollo.MutationResult<UpdateCategoriesAdminElementMutation>;
export type UpdateCategoriesAdminElementMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCategoriesAdminElementMutation,
    UpdateCategoriesAdminElementMutationVariables
  >;
export const CreateAdminElementCategoryDocument = gql`
  mutation CreateAdminElementCategory(
    $input: createAdminElementCategoryInput!
  ) {
    createAdminElementCategory(input: $input) {
      adminElementCategory {
        id
        elementCategoryId
        name
      }
    }
  }
`;
export type CreateAdminElementCategoryMutationFn = Apollo.MutationFunction<
  CreateAdminElementCategoryMutation,
  CreateAdminElementCategoryMutationVariables
>;

/**
 * __useCreateAdminElementCategoryMutation__
 *
 * To run a mutation, you first call `useCreateAdminElementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminElementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminElementCategoryMutation, { data, loading, error }] = useCreateAdminElementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminElementCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdminElementCategoryMutation,
    CreateAdminElementCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateAdminElementCategoryMutation,
    CreateAdminElementCategoryMutationVariables
  >(CreateAdminElementCategoryDocument, options);
}

export type CreateAdminElementCategoryMutationHookResult = ReturnType<
  typeof useCreateAdminElementCategoryMutation
>;
export type CreateAdminElementCategoryMutationResult =
  Apollo.MutationResult<CreateAdminElementCategoryMutation>;
export type CreateAdminElementCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAdminElementCategoryMutation,
    CreateAdminElementCategoryMutationVariables
  >;
export const RemoveAdminElementCategoryDocument = gql`
  mutation RemoveAdminElementCategory(
    $input: removeAdminElementCategoryInput!
  ) {
    removeAdminElementCategory(input: $input) {
      adminElementCategory {
        id
      }
    }
  }
`;
export type RemoveAdminElementCategoryMutationFn = Apollo.MutationFunction<
  RemoveAdminElementCategoryMutation,
  RemoveAdminElementCategoryMutationVariables
>;

/**
 * __useRemoveAdminElementCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveAdminElementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminElementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminElementCategoryMutation, { data, loading, error }] = useRemoveAdminElementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminElementCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminElementCategoryMutation,
    RemoveAdminElementCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminElementCategoryMutation,
    RemoveAdminElementCategoryMutationVariables
  >(RemoveAdminElementCategoryDocument, options);
}

export type RemoveAdminElementCategoryMutationHookResult = ReturnType<
  typeof useRemoveAdminElementCategoryMutation
>;
export type RemoveAdminElementCategoryMutationResult =
  Apollo.MutationResult<RemoveAdminElementCategoryMutation>;
export type RemoveAdminElementCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveAdminElementCategoryMutation,
    RemoveAdminElementCategoryMutationVariables
  >;
export const UpdateAdminElementCategoryDocument = gql`
  mutation UpdateAdminElementCategory(
    $input: updateAdminElementCategoryInput!
  ) {
    updateAdminElementCategory(input: $input) {
      adminElementCategory {
        id
        elementCategoryId
        name
      }
    }
  }
`;
export type UpdateAdminElementCategoryMutationFn = Apollo.MutationFunction<
  UpdateAdminElementCategoryMutation,
  UpdateAdminElementCategoryMutationVariables
>;

/**
 * __useUpdateAdminElementCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateAdminElementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminElementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminElementCategoryMutation, { data, loading, error }] = useUpdateAdminElementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminElementCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdminElementCategoryMutation,
    UpdateAdminElementCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateAdminElementCategoryMutation,
    UpdateAdminElementCategoryMutationVariables
  >(UpdateAdminElementCategoryDocument, options);
}

export type UpdateAdminElementCategoryMutationHookResult = ReturnType<
  typeof useUpdateAdminElementCategoryMutation
>;
export type UpdateAdminElementCategoryMutationResult =
  Apollo.MutationResult<UpdateAdminElementCategoryMutation>;
export type UpdateAdminElementCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAdminElementCategoryMutation,
    UpdateAdminElementCategoryMutationVariables
  >;
export const RemoveAdminFontDocument = gql`
  mutation RemoveAdminFont($input: removeAdminFontInput!) {
    removeAdminFont(input: $input) {
      adminFont {
        id
      }
    }
  }
`;
export type RemoveAdminFontMutationFn = Apollo.MutationFunction<
  RemoveAdminFontMutation,
  RemoveAdminFontMutationVariables
>;

/**
 * __useRemoveAdminFontMutation__
 *
 * To run a mutation, you first call `useRemoveAdminFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminFontMutation, { data, loading, error }] = useRemoveAdminFontMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminFontMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminFontMutation,
    RemoveAdminFontMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminFontMutation,
    RemoveAdminFontMutationVariables
  >(RemoveAdminFontDocument, options);
}

export type RemoveAdminFontMutationHookResult = ReturnType<
  typeof useRemoveAdminFontMutation
>;
export type RemoveAdminFontMutationResult =
  Apollo.MutationResult<RemoveAdminFontMutation>;
export type RemoveAdminFontMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminFontMutation,
  RemoveAdminFontMutationVariables
>;
export const UploadAdminFontsDocument = gql`
  mutation UploadAdminFonts($input: uploadAdminFontsInput!) {
    uploadAdminFonts(input: $input) {
      adminFonts {
        id
        fonts
      }
    }
  }
`;
export type UploadAdminFontsMutationFn = Apollo.MutationFunction<
  UploadAdminFontsMutation,
  UploadAdminFontsMutationVariables
>;

/**
 * __useUploadAdminFontsMutation__
 *
 * To run a mutation, you first call `useUploadAdminFontsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdminFontsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdminFontsMutation, { data, loading, error }] = useUploadAdminFontsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAdminFontsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAdminFontsMutation,
    UploadAdminFontsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UploadAdminFontsMutation,
    UploadAdminFontsMutationVariables
  >(UploadAdminFontsDocument, options);
}

export type UploadAdminFontsMutationHookResult = ReturnType<
  typeof useUploadAdminFontsMutation
>;
export type UploadAdminFontsMutationResult =
  Apollo.MutationResult<UploadAdminFontsMutation>;
export type UploadAdminFontsMutationOptions = Apollo.BaseMutationOptions<
  UploadAdminFontsMutation,
  UploadAdminFontsMutationVariables
>;
export const ActivateAdminProjectDocument = gql`
  mutation ActivateAdminProject($input: activateAdminProjectInput!) {
    activateAdminProject(input: $input) {
      adminProject {
        id
        active
      }
    }
  }
`;
export type ActivateAdminProjectMutationFn = Apollo.MutationFunction<
  ActivateAdminProjectMutation,
  ActivateAdminProjectMutationVariables
>;

/**
 * __useActivateAdminProjectMutation__
 *
 * To run a mutation, you first call `useActivateAdminProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAdminProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAdminProjectMutation, { data, loading, error }] = useActivateAdminProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateAdminProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateAdminProjectMutation,
    ActivateAdminProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ActivateAdminProjectMutation,
    ActivateAdminProjectMutationVariables
  >(ActivateAdminProjectDocument, options);
}

export type ActivateAdminProjectMutationHookResult = ReturnType<
  typeof useActivateAdminProjectMutation
>;
export type ActivateAdminProjectMutationResult =
  Apollo.MutationResult<ActivateAdminProjectMutation>;
export type ActivateAdminProjectMutationOptions = Apollo.BaseMutationOptions<
  ActivateAdminProjectMutation,
  ActivateAdminProjectMutationVariables
>;
export const DeactivateAdminProjectDocument = gql`
  mutation DeactivateAdminProject($input: deactivateAdminProjectInput!) {
    deactivateAdminProject(input: $input) {
      adminProject {
        id
        active
      }
    }
  }
`;
export type DeactivateAdminProjectMutationFn = Apollo.MutationFunction<
  DeactivateAdminProjectMutation,
  DeactivateAdminProjectMutationVariables
>;

/**
 * __useDeactivateAdminProjectMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminProjectMutation, { data, loading, error }] = useDeactivateAdminProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateAdminProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateAdminProjectMutation,
    DeactivateAdminProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DeactivateAdminProjectMutation,
    DeactivateAdminProjectMutationVariables
  >(DeactivateAdminProjectDocument, options);
}

export type DeactivateAdminProjectMutationHookResult = ReturnType<
  typeof useDeactivateAdminProjectMutation
>;
export type DeactivateAdminProjectMutationResult =
  Apollo.MutationResult<DeactivateAdminProjectMutation>;
export type DeactivateAdminProjectMutationOptions = Apollo.BaseMutationOptions<
  DeactivateAdminProjectMutation,
  DeactivateAdminProjectMutationVariables
>;
export const GenerateAdminProjectUpdateFileUrlDocument = gql`
  mutation GenerateAdminProjectUpdateFileUrl(
    $input: generateAdminProjectUpdateFileUrlInput!
  ) {
    generateAdminProjectUpdateFileUrl(input: $input) {
      adminProjectUpdateFileUrl {
        id
        projectUpdateId
        url
      }
    }
  }
`;
export type GenerateAdminProjectUpdateFileUrlMutationFn =
  Apollo.MutationFunction<
    GenerateAdminProjectUpdateFileUrlMutation,
    GenerateAdminProjectUpdateFileUrlMutationVariables
  >;

/**
 * __useGenerateAdminProjectUpdateFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateAdminProjectUpdateFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAdminProjectUpdateFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAdminProjectUpdateFileUrlMutation, { data, loading, error }] = useGenerateAdminProjectUpdateFileUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAdminProjectUpdateFileUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAdminProjectUpdateFileUrlMutation,
    GenerateAdminProjectUpdateFileUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    GenerateAdminProjectUpdateFileUrlMutation,
    GenerateAdminProjectUpdateFileUrlMutationVariables
  >(GenerateAdminProjectUpdateFileUrlDocument, options);
}

export type GenerateAdminProjectUpdateFileUrlMutationHookResult = ReturnType<
  typeof useGenerateAdminProjectUpdateFileUrlMutation
>;
export type GenerateAdminProjectUpdateFileUrlMutationResult =
  Apollo.MutationResult<GenerateAdminProjectUpdateFileUrlMutation>;
export type GenerateAdminProjectUpdateFileUrlMutationOptions =
  Apollo.BaseMutationOptions<
    GenerateAdminProjectUpdateFileUrlMutation,
    GenerateAdminProjectUpdateFileUrlMutationVariables
  >;
export const RemoveAdminProjectDocument = gql`
  mutation RemoveAdminProject($input: removeAdminProjectInput!) {
    removeAdminProject(input: $input) {
      adminProject {
        id
        name
      }
    }
  }
`;
export type RemoveAdminProjectMutationFn = Apollo.MutationFunction<
  RemoveAdminProjectMutation,
  RemoveAdminProjectMutationVariables
>;

/**
 * __useRemoveAdminProjectMutation__
 *
 * To run a mutation, you first call `useRemoveAdminProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminProjectMutation, { data, loading, error }] = useRemoveAdminProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminProjectMutation,
    RemoveAdminProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminProjectMutation,
    RemoveAdminProjectMutationVariables
  >(RemoveAdminProjectDocument, options);
}

export type RemoveAdminProjectMutationHookResult = ReturnType<
  typeof useRemoveAdminProjectMutation
>;
export type RemoveAdminProjectMutationResult =
  Apollo.MutationResult<RemoveAdminProjectMutation>;
export type RemoveAdminProjectMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminProjectMutation,
  RemoveAdminProjectMutationVariables
>;
export const ActivateAdminStyleDocument = gql`
  mutation ActivateAdminStyle($input: activateAdminStyleInput!) {
    activateAdminStyle(input: $input) {
      adminStyle {
        id
        name
        active
      }
    }
  }
`;
export type ActivateAdminStyleMutationFn = Apollo.MutationFunction<
  ActivateAdminStyleMutation,
  ActivateAdminStyleMutationVariables
>;

/**
 * __useActivateAdminStyleMutation__
 *
 * To run a mutation, you first call `useActivateAdminStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAdminStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAdminStyleMutation, { data, loading, error }] = useActivateAdminStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateAdminStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateAdminStyleMutation,
    ActivateAdminStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ActivateAdminStyleMutation,
    ActivateAdminStyleMutationVariables
  >(ActivateAdminStyleDocument, options);
}

export type ActivateAdminStyleMutationHookResult = ReturnType<
  typeof useActivateAdminStyleMutation
>;
export type ActivateAdminStyleMutationResult =
  Apollo.MutationResult<ActivateAdminStyleMutation>;
export type ActivateAdminStyleMutationOptions = Apollo.BaseMutationOptions<
  ActivateAdminStyleMutation,
  ActivateAdminStyleMutationVariables
>;
export const CreateAdminStyleDocument = gql`
  mutation CreateAdminStyle($input: createAdminStyleInput!) {
    createAdminStyle(input: $input) {
      adminStyle {
        id
        styleId
        definition
        name
        type
      }
    }
  }
`;
export type CreateAdminStyleMutationFn = Apollo.MutationFunction<
  CreateAdminStyleMutation,
  CreateAdminStyleMutationVariables
>;

/**
 * __useCreateAdminStyleMutation__
 *
 * To run a mutation, you first call `useCreateAdminStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminStyleMutation, { data, loading, error }] = useCreateAdminStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdminStyleMutation,
    CreateAdminStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateAdminStyleMutation,
    CreateAdminStyleMutationVariables
  >(CreateAdminStyleDocument, options);
}

export type CreateAdminStyleMutationHookResult = ReturnType<
  typeof useCreateAdminStyleMutation
>;
export type CreateAdminStyleMutationResult =
  Apollo.MutationResult<CreateAdminStyleMutation>;
export type CreateAdminStyleMutationOptions = Apollo.BaseMutationOptions<
  CreateAdminStyleMutation,
  CreateAdminStyleMutationVariables
>;
export const DeactivateAdminStyleDocument = gql`
  mutation DeactivateAdminStyle($input: deactivateAdminStyleInput!) {
    deactivateAdminStyle(input: $input) {
      adminStyle {
        id
        name
        active
      }
    }
  }
`;
export type DeactivateAdminStyleMutationFn = Apollo.MutationFunction<
  DeactivateAdminStyleMutation,
  DeactivateAdminStyleMutationVariables
>;

/**
 * __useDeactivateAdminStyleMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminStyleMutation, { data, loading, error }] = useDeactivateAdminStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateAdminStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateAdminStyleMutation,
    DeactivateAdminStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DeactivateAdminStyleMutation,
    DeactivateAdminStyleMutationVariables
  >(DeactivateAdminStyleDocument, options);
}

export type DeactivateAdminStyleMutationHookResult = ReturnType<
  typeof useDeactivateAdminStyleMutation
>;
export type DeactivateAdminStyleMutationResult =
  Apollo.MutationResult<DeactivateAdminStyleMutation>;
export type DeactivateAdminStyleMutationOptions = Apollo.BaseMutationOptions<
  DeactivateAdminStyleMutation,
  DeactivateAdminStyleMutationVariables
>;
export const RemoveAdminStyleDocument = gql`
  mutation RemoveAdminStyle($input: removeAdminStyleInput!) {
    removeAdminStyle(input: $input) {
      adminStyle {
        id
        name
      }
    }
  }
`;
export type RemoveAdminStyleMutationFn = Apollo.MutationFunction<
  RemoveAdminStyleMutation,
  RemoveAdminStyleMutationVariables
>;

/**
 * __useRemoveAdminStyleMutation__
 *
 * To run a mutation, you first call `useRemoveAdminStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminStyleMutation, { data, loading, error }] = useRemoveAdminStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminStyleMutation,
    RemoveAdminStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminStyleMutation,
    RemoveAdminStyleMutationVariables
  >(RemoveAdminStyleDocument, options);
}

export type RemoveAdminStyleMutationHookResult = ReturnType<
  typeof useRemoveAdminStyleMutation
>;
export type RemoveAdminStyleMutationResult =
  Apollo.MutationResult<RemoveAdminStyleMutation>;
export type RemoveAdminStyleMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminStyleMutation,
  RemoveAdminStyleMutationVariables
>;
export const UpdateDefinitionAdminStyleDocument = gql`
  mutation UpdateDefinitionAdminStyle(
    $input: updateDefinitionAdminStyleInput!
  ) {
    updateDefinitionAdminStyle(input: $input) {
      adminStyle {
        id
        styleId
        definition
        name
        type
      }
    }
  }
`;
export type UpdateDefinitionAdminStyleMutationFn = Apollo.MutationFunction<
  UpdateDefinitionAdminStyleMutation,
  UpdateDefinitionAdminStyleMutationVariables
>;

/**
 * __useUpdateDefinitionAdminStyleMutation__
 *
 * To run a mutation, you first call `useUpdateDefinitionAdminStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefinitionAdminStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefinitionAdminStyleMutation, { data, loading, error }] = useUpdateDefinitionAdminStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDefinitionAdminStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDefinitionAdminStyleMutation,
    UpdateDefinitionAdminStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateDefinitionAdminStyleMutation,
    UpdateDefinitionAdminStyleMutationVariables
  >(UpdateDefinitionAdminStyleDocument, options);
}

export type UpdateDefinitionAdminStyleMutationHookResult = ReturnType<
  typeof useUpdateDefinitionAdminStyleMutation
>;
export type UpdateDefinitionAdminStyleMutationResult =
  Apollo.MutationResult<UpdateDefinitionAdminStyleMutation>;
export type UpdateDefinitionAdminStyleMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateDefinitionAdminStyleMutation,
    UpdateDefinitionAdminStyleMutationVariables
  >;
export const CreateAdminTeamDocument = gql`
  mutation CreateAdminTeam($input: createAdminTeamInput!) {
    createAdminTeam(input: $input) {
      adminTeam {
        id
        name
      }
    }
  }
`;
export type CreateAdminTeamMutationFn = Apollo.MutationFunction<
  CreateAdminTeamMutation,
  CreateAdminTeamMutationVariables
>;

/**
 * __useCreateAdminTeamMutation__
 *
 * To run a mutation, you first call `useCreateAdminTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminTeamMutation, { data, loading, error }] = useCreateAdminTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdminTeamMutation,
    CreateAdminTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateAdminTeamMutation,
    CreateAdminTeamMutationVariables
  >(CreateAdminTeamDocument, options);
}

export type CreateAdminTeamMutationHookResult = ReturnType<
  typeof useCreateAdminTeamMutation
>;
export type CreateAdminTeamMutationResult =
  Apollo.MutationResult<CreateAdminTeamMutation>;
export type CreateAdminTeamMutationOptions = Apollo.BaseMutationOptions<
  CreateAdminTeamMutation,
  CreateAdminTeamMutationVariables
>;
export const RemoveAdminTeamDocument = gql`
  mutation RemoveAdminTeam($input: removeAdminTeamInput!) {
    removeAdminTeam(input: $input) {
      adminTeam {
        id
        name
      }
      clientMutationId
    }
  }
`;
export type RemoveAdminTeamMutationFn = Apollo.MutationFunction<
  RemoveAdminTeamMutation,
  RemoveAdminTeamMutationVariables
>;

/**
 * __useRemoveAdminTeamMutation__
 *
 * To run a mutation, you first call `useRemoveAdminTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminTeamMutation, { data, loading, error }] = useRemoveAdminTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminTeamMutation,
    RemoveAdminTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminTeamMutation,
    RemoveAdminTeamMutationVariables
  >(RemoveAdminTeamDocument, options);
}

export type RemoveAdminTeamMutationHookResult = ReturnType<
  typeof useRemoveAdminTeamMutation
>;
export type RemoveAdminTeamMutationResult =
  Apollo.MutationResult<RemoveAdminTeamMutation>;
export type RemoveAdminTeamMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminTeamMutation,
  RemoveAdminTeamMutationVariables
>;
export const UpdateAdminTeamDocument = gql`
  mutation UpdateAdminTeam($input: updateAdminTeamInput!) {
    updateAdminTeam(input: $input) {
      adminTeam {
        id
        name
      }
      clientMutationId
    }
  }
`;
export type UpdateAdminTeamMutationFn = Apollo.MutationFunction<
  UpdateAdminTeamMutation,
  UpdateAdminTeamMutationVariables
>;

/**
 * __useUpdateAdminTeamMutation__
 *
 * To run a mutation, you first call `useUpdateAdminTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminTeamMutation, { data, loading, error }] = useUpdateAdminTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdminTeamMutation,
    UpdateAdminTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateAdminTeamMutation,
    UpdateAdminTeamMutationVariables
  >(UpdateAdminTeamDocument, options);
}

export type UpdateAdminTeamMutationHookResult = ReturnType<
  typeof useUpdateAdminTeamMutation
>;
export type UpdateAdminTeamMutationResult =
  Apollo.MutationResult<UpdateAdminTeamMutation>;
export type UpdateAdminTeamMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdminTeamMutation,
  UpdateAdminTeamMutationVariables
>;
export const ActivateAdminTemplateDocument = gql`
  mutation ActivateAdminTemplate($input: activateAdminTemplateInput!) {
    activateAdminTemplate(input: $input) {
      adminTemplate {
        id
        name
        previewImageId
        active
      }
    }
  }
`;
export type ActivateAdminTemplateMutationFn = Apollo.MutationFunction<
  ActivateAdminTemplateMutation,
  ActivateAdminTemplateMutationVariables
>;

/**
 * __useActivateAdminTemplateMutation__
 *
 * To run a mutation, you first call `useActivateAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAdminTemplateMutation, { data, loading, error }] = useActivateAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateAdminTemplateMutation,
    ActivateAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ActivateAdminTemplateMutation,
    ActivateAdminTemplateMutationVariables
  >(ActivateAdminTemplateDocument, options);
}

export type ActivateAdminTemplateMutationHookResult = ReturnType<
  typeof useActivateAdminTemplateMutation
>;
export type ActivateAdminTemplateMutationResult =
  Apollo.MutationResult<ActivateAdminTemplateMutation>;
export type ActivateAdminTemplateMutationOptions = Apollo.BaseMutationOptions<
  ActivateAdminTemplateMutation,
  ActivateAdminTemplateMutationVariables
>;
export const AssignStyleAdminTemplateDocument = gql`
  mutation assignStyleAdminTemplate($input: assignStyleAdminTemplateInput!) {
    assignStyleAdminTemplate(input: $input) {
      adminTemplate {
        templateId
        name
        active
        stylizable
      }
    }
  }
`;
export type AssignStyleAdminTemplateMutationFn = Apollo.MutationFunction<
  AssignStyleAdminTemplateMutation,
  AssignStyleAdminTemplateMutationVariables
>;

/**
 * __useAssignStyleAdminTemplateMutation__
 *
 * To run a mutation, you first call `useAssignStyleAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignStyleAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignStyleAdminTemplateMutation, { data, loading, error }] = useAssignStyleAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignStyleAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignStyleAdminTemplateMutation,
    AssignStyleAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    AssignStyleAdminTemplateMutation,
    AssignStyleAdminTemplateMutationVariables
  >(AssignStyleAdminTemplateDocument, options);
}

export type AssignStyleAdminTemplateMutationHookResult = ReturnType<
  typeof useAssignStyleAdminTemplateMutation
>;
export type AssignStyleAdminTemplateMutationResult =
  Apollo.MutationResult<AssignStyleAdminTemplateMutation>;
export type AssignStyleAdminTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    AssignStyleAdminTemplateMutation,
    AssignStyleAdminTemplateMutationVariables
  >;
export const CreateFromDesignAdminTemplateDocument = gql`
  mutation CreateFromDesignAdminTemplate(
    $input: createFromDesignAdminTemplateInput!
  ) {
    createFromDesignAdminTemplate(input: $input) {
      adminTemplate {
        id
        templateId
        name
      }
    }
  }
`;
export type CreateFromDesignAdminTemplateMutationFn = Apollo.MutationFunction<
  CreateFromDesignAdminTemplateMutation,
  CreateFromDesignAdminTemplateMutationVariables
>;

/**
 * __useCreateFromDesignAdminTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFromDesignAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFromDesignAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFromDesignAdminTemplateMutation, { data, loading, error }] = useCreateFromDesignAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFromDesignAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFromDesignAdminTemplateMutation,
    CreateFromDesignAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateFromDesignAdminTemplateMutation,
    CreateFromDesignAdminTemplateMutationVariables
  >(CreateFromDesignAdminTemplateDocument, options);
}

export type CreateFromDesignAdminTemplateMutationHookResult = ReturnType<
  typeof useCreateFromDesignAdminTemplateMutation
>;
export type CreateFromDesignAdminTemplateMutationResult =
  Apollo.MutationResult<CreateFromDesignAdminTemplateMutation>;
export type CreateFromDesignAdminTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    CreateFromDesignAdminTemplateMutation,
    CreateFromDesignAdminTemplateMutationVariables
  >;
export const DeactivateAdminTemplateDocument = gql`
  mutation DeactivateAdminTemplate($input: deactivateAdminTemplateInput!) {
    deactivateAdminTemplate(input: $input) {
      adminTemplate {
        id
        name
        previewImageId
        active
      }
    }
  }
`;
export type DeactivateAdminTemplateMutationFn = Apollo.MutationFunction<
  DeactivateAdminTemplateMutation,
  DeactivateAdminTemplateMutationVariables
>;

/**
 * __useDeactivateAdminTemplateMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminTemplateMutation, { data, loading, error }] = useDeactivateAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateAdminTemplateMutation,
    DeactivateAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DeactivateAdminTemplateMutation,
    DeactivateAdminTemplateMutationVariables
  >(DeactivateAdminTemplateDocument, options);
}

export type DeactivateAdminTemplateMutationHookResult = ReturnType<
  typeof useDeactivateAdminTemplateMutation
>;
export type DeactivateAdminTemplateMutationResult =
  Apollo.MutationResult<DeactivateAdminTemplateMutation>;
export type DeactivateAdminTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeactivateAdminTemplateMutation,
  DeactivateAdminTemplateMutationVariables
>;
export const RemoveAdminTemplateDocument = gql`
  mutation RemoveAdminTemplate($input: removeAdminTemplateInput!) {
    removeAdminTemplate(input: $input) {
      adminTemplate {
        id
        name
      }
      clientMutationId
    }
  }
`;
export type RemoveAdminTemplateMutationFn = Apollo.MutationFunction<
  RemoveAdminTemplateMutation,
  RemoveAdminTemplateMutationVariables
>;

/**
 * __useRemoveAdminTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminTemplateMutation, { data, loading, error }] = useRemoveAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminTemplateMutation,
    RemoveAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminTemplateMutation,
    RemoveAdminTemplateMutationVariables
  >(RemoveAdminTemplateDocument, options);
}

export type RemoveAdminTemplateMutationHookResult = ReturnType<
  typeof useRemoveAdminTemplateMutation
>;
export type RemoveAdminTemplateMutationResult =
  Apollo.MutationResult<RemoveAdminTemplateMutation>;
export type RemoveAdminTemplateMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminTemplateMutation,
  RemoveAdminTemplateMutationVariables
>;
export const ReplaceImageAdminTemplateDocument = gql`
  mutation ReplaceImageAdminTemplate($input: replaceImageAdminTemplateInput!) {
    replaceImageAdminTemplate(input: $input) {
      adminTemplate {
        id
        name
      }
      clientMutationId
    }
  }
`;
export type ReplaceImageAdminTemplateMutationFn = Apollo.MutationFunction<
  ReplaceImageAdminTemplateMutation,
  ReplaceImageAdminTemplateMutationVariables
>;

/**
 * __useReplaceImageAdminTemplateMutation__
 *
 * To run a mutation, you first call `useReplaceImageAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceImageAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceImageAdminTemplateMutation, { data, loading, error }] = useReplaceImageAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceImageAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReplaceImageAdminTemplateMutation,
    ReplaceImageAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ReplaceImageAdminTemplateMutation,
    ReplaceImageAdminTemplateMutationVariables
  >(ReplaceImageAdminTemplateDocument, options);
}

export type ReplaceImageAdminTemplateMutationHookResult = ReturnType<
  typeof useReplaceImageAdminTemplateMutation
>;
export type ReplaceImageAdminTemplateMutationResult =
  Apollo.MutationResult<ReplaceImageAdminTemplateMutation>;
export type ReplaceImageAdminTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    ReplaceImageAdminTemplateMutation,
    ReplaceImageAdminTemplateMutationVariables
  >;
export const UnassignStyleAdminTemplateDocument = gql`
  mutation unassignStyleAdminTemplate(
    $input: unassignStyleAdminTemplateInput!
  ) {
    unassignStyleAdminTemplate(input: $input) {
      adminTemplate {
        templateId
        name
        active
        stylizable
      }
    }
  }
`;
export type UnassignStyleAdminTemplateMutationFn = Apollo.MutationFunction<
  UnassignStyleAdminTemplateMutation,
  UnassignStyleAdminTemplateMutationVariables
>;

/**
 * __useUnassignStyleAdminTemplateMutation__
 *
 * To run a mutation, you first call `useUnassignStyleAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignStyleAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignStyleAdminTemplateMutation, { data, loading, error }] = useUnassignStyleAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignStyleAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignStyleAdminTemplateMutation,
    UnassignStyleAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UnassignStyleAdminTemplateMutation,
    UnassignStyleAdminTemplateMutationVariables
  >(UnassignStyleAdminTemplateDocument, options);
}

export type UnassignStyleAdminTemplateMutationHookResult = ReturnType<
  typeof useUnassignStyleAdminTemplateMutation
>;
export type UnassignStyleAdminTemplateMutationResult =
  Apollo.MutationResult<UnassignStyleAdminTemplateMutation>;
export type UnassignStyleAdminTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    UnassignStyleAdminTemplateMutation,
    UnassignStyleAdminTemplateMutationVariables
  >;
export const UpdateAdminTemplateDocument = gql`
  mutation UpdateAdminTemplate($input: updateAdminTemplateInput!) {
    updateAdminTemplate(input: $input) {
      adminTemplate {
        id
        name
      }
      clientMutationId
    }
  }
`;
export type UpdateAdminTemplateMutationFn = Apollo.MutationFunction<
  UpdateAdminTemplateMutation,
  UpdateAdminTemplateMutationVariables
>;

/**
 * __useUpdateAdminTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminTemplateMutation, { data, loading, error }] = useUpdateAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdminTemplateMutation,
    UpdateAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateAdminTemplateMutation,
    UpdateAdminTemplateMutationVariables
  >(UpdateAdminTemplateDocument, options);
}

export type UpdateAdminTemplateMutationHookResult = ReturnType<
  typeof useUpdateAdminTemplateMutation
>;
export type UpdateAdminTemplateMutationResult =
  Apollo.MutationResult<UpdateAdminTemplateMutation>;
export type UpdateAdminTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdminTemplateMutation,
  UpdateAdminTemplateMutationVariables
>;
export const UpdateTagsAdminTemplateDocument = gql`
  mutation UpdateTagsAdminTemplate($input: updateTagsAdminTemplateInput!) {
    updateTagsAdminTemplate(input: $input) {
      adminTemplate {
        id
        tags
      }
    }
  }
`;
export type UpdateTagsAdminTemplateMutationFn = Apollo.MutationFunction<
  UpdateTagsAdminTemplateMutation,
  UpdateTagsAdminTemplateMutationVariables
>;

/**
 * __useUpdateTagsAdminTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTagsAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsAdminTemplateMutation, { data, loading, error }] = useUpdateTagsAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagsAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTagsAdminTemplateMutation,
    UpdateTagsAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateTagsAdminTemplateMutation,
    UpdateTagsAdminTemplateMutationVariables
  >(UpdateTagsAdminTemplateDocument, options);
}

export type UpdateTagsAdminTemplateMutationHookResult = ReturnType<
  typeof useUpdateTagsAdminTemplateMutation
>;
export type UpdateTagsAdminTemplateMutationResult =
  Apollo.MutationResult<UpdateTagsAdminTemplateMutation>;
export type UpdateTagsAdminTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateTagsAdminTemplateMutation,
  UpdateTagsAdminTemplateMutationVariables
>;
export const CreateAdminTemplateGroupDocument = gql`
  mutation CreateAdminTemplateGroup($input: createAdminTemplateGroupInput!) {
    createAdminTemplateGroup(input: $input) {
      adminTemplateGroup {
        name
        baseTemplate
        templates
      }
    }
  }
`;
export type CreateAdminTemplateGroupMutationFn = Apollo.MutationFunction<
  CreateAdminTemplateGroupMutation,
  CreateAdminTemplateGroupMutationVariables
>;

/**
 * __useCreateAdminTemplateGroupMutation__
 *
 * To run a mutation, you first call `useCreateAdminTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminTemplateGroupMutation, { data, loading, error }] = useCreateAdminTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminTemplateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdminTemplateGroupMutation,
    CreateAdminTemplateGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateAdminTemplateGroupMutation,
    CreateAdminTemplateGroupMutationVariables
  >(CreateAdminTemplateGroupDocument, options);
}

export type CreateAdminTemplateGroupMutationHookResult = ReturnType<
  typeof useCreateAdminTemplateGroupMutation
>;
export type CreateAdminTemplateGroupMutationResult =
  Apollo.MutationResult<CreateAdminTemplateGroupMutation>;
export type CreateAdminTemplateGroupMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAdminTemplateGroupMutation,
    CreateAdminTemplateGroupMutationVariables
  >;
export const EditNameAdminTemplateGroupDocument = gql`
  mutation EditNameAdminTemplateGroup(
    $input: editNameAdminTemplateGroupInput!
  ) {
    editNameAdminTemplateGroup(input: $input) {
      adminTemplateGroup {
        name
      }
    }
  }
`;
export type EditNameAdminTemplateGroupMutationFn = Apollo.MutationFunction<
  EditNameAdminTemplateGroupMutation,
  EditNameAdminTemplateGroupMutationVariables
>;

/**
 * __useEditNameAdminTemplateGroupMutation__
 *
 * To run a mutation, you first call `useEditNameAdminTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNameAdminTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNameAdminTemplateGroupMutation, { data, loading, error }] = useEditNameAdminTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditNameAdminTemplateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditNameAdminTemplateGroupMutation,
    EditNameAdminTemplateGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    EditNameAdminTemplateGroupMutation,
    EditNameAdminTemplateGroupMutationVariables
  >(EditNameAdminTemplateGroupDocument, options);
}

export type EditNameAdminTemplateGroupMutationHookResult = ReturnType<
  typeof useEditNameAdminTemplateGroupMutation
>;
export type EditNameAdminTemplateGroupMutationResult =
  Apollo.MutationResult<EditNameAdminTemplateGroupMutation>;
export type EditNameAdminTemplateGroupMutationOptions =
  Apollo.BaseMutationOptions<
    EditNameAdminTemplateGroupMutation,
    EditNameAdminTemplateGroupMutationVariables
  >;
export const RemoveAdminTemplateGroupDocument = gql`
  mutation RemoveAdminTemplateGroup($input: removeAdminTemplateGroupInput!) {
    removeAdminTemplateGroup(input: $input) {
      adminTemplateGroup {
        id
        name
      }
    }
  }
`;
export type RemoveAdminTemplateGroupMutationFn = Apollo.MutationFunction<
  RemoveAdminTemplateGroupMutation,
  RemoveAdminTemplateGroupMutationVariables
>;

/**
 * __useRemoveAdminTemplateGroupMutation__
 *
 * To run a mutation, you first call `useRemoveAdminTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminTemplateGroupMutation, { data, loading, error }] = useRemoveAdminTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminTemplateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminTemplateGroupMutation,
    RemoveAdminTemplateGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminTemplateGroupMutation,
    RemoveAdminTemplateGroupMutationVariables
  >(RemoveAdminTemplateGroupDocument, options);
}

export type RemoveAdminTemplateGroupMutationHookResult = ReturnType<
  typeof useRemoveAdminTemplateGroupMutation
>;
export type RemoveAdminTemplateGroupMutationResult =
  Apollo.MutationResult<RemoveAdminTemplateGroupMutation>;
export type RemoveAdminTemplateGroupMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveAdminTemplateGroupMutation,
    RemoveAdminTemplateGroupMutationVariables
  >;
export const UpdateTemplatesAdminTemplateGroupDocument = gql`
  mutation UpdateTemplatesAdminTemplateGroup(
    $input: updateTemplatesAdminTemplateGroupInput!
  ) {
    updateTemplatesAdminTemplateGroup(input: $input) {
      adminTemplateGroup {
        id
        templateGroupId
        name
        baseTemplate
        templates
      }
    }
  }
`;
export type UpdateTemplatesAdminTemplateGroupMutationFn =
  Apollo.MutationFunction<
    UpdateTemplatesAdminTemplateGroupMutation,
    UpdateTemplatesAdminTemplateGroupMutationVariables
  >;

/**
 * __useUpdateTemplatesAdminTemplateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTemplatesAdminTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplatesAdminTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplatesAdminTemplateGroupMutation, { data, loading, error }] = useUpdateTemplatesAdminTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplatesAdminTemplateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTemplatesAdminTemplateGroupMutation,
    UpdateTemplatesAdminTemplateGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateTemplatesAdminTemplateGroupMutation,
    UpdateTemplatesAdminTemplateGroupMutationVariables
  >(UpdateTemplatesAdminTemplateGroupDocument, options);
}

export type UpdateTemplatesAdminTemplateGroupMutationHookResult = ReturnType<
  typeof useUpdateTemplatesAdminTemplateGroupMutation
>;
export type UpdateTemplatesAdminTemplateGroupMutationResult =
  Apollo.MutationResult<UpdateTemplatesAdminTemplateGroupMutation>;
export type UpdateTemplatesAdminTemplateGroupMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateTemplatesAdminTemplateGroupMutation,
    UpdateTemplatesAdminTemplateGroupMutationVariables
  >;
export const RemoveAdminUserDocument = gql`
  mutation RemoveAdminUser($input: removeAdminUserInput!) {
    removeAdminUser(input: $input) {
      adminUser {
        id
        email
      }
    }
  }
`;
export type RemoveAdminUserMutationFn = Apollo.MutationFunction<
  RemoveAdminUserMutation,
  RemoveAdminUserMutationVariables
>;

/**
 * __useRemoveAdminUserMutation__
 *
 * To run a mutation, you first call `useRemoveAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminUserMutation, { data, loading, error }] = useRemoveAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdminUserMutation,
    RemoveAdminUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAdminUserMutation,
    RemoveAdminUserMutationVariables
  >(RemoveAdminUserDocument, options);
}

export type RemoveAdminUserMutationHookResult = ReturnType<
  typeof useRemoveAdminUserMutation
>;
export type RemoveAdminUserMutationResult =
  Apollo.MutationResult<RemoveAdminUserMutation>;
export type RemoveAdminUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdminUserMutation,
  RemoveAdminUserMutationVariables
>;
export const UploadAssetImageDocument = gql`
  mutation UploadAssetImage($input: uploadAssetImageInput!) {
    uploadAssetImage(input: $input) {
      assetImage {
        id
        assetImageId
        userId
        teamId
        name
        size
        mimeType
        createdAt
        updatedAt
        format
      }
    }
  }
`;
export type UploadAssetImageMutationFn = Apollo.MutationFunction<
  UploadAssetImageMutation,
  UploadAssetImageMutationVariables
>;

/**
 * __useUploadAssetImageMutation__
 *
 * To run a mutation, you first call `useUploadAssetImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAssetImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAssetImageMutation, { data, loading, error }] = useUploadAssetImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAssetImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAssetImageMutation,
    UploadAssetImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UploadAssetImageMutation,
    UploadAssetImageMutationVariables
  >(UploadAssetImageDocument, options);
}

export type UploadAssetImageMutationHookResult = ReturnType<
  typeof useUploadAssetImageMutation
>;
export type UploadAssetImageMutationResult =
  Apollo.MutationResult<UploadAssetImageMutation>;
export type UploadAssetImageMutationOptions = Apollo.BaseMutationOptions<
  UploadAssetImageMutation,
  UploadAssetImageMutationVariables
>;
export const AssignDefaultLogoDocument = gql`
  mutation AssignDefaultLogo($input: assignDefaultLogoInput!) {
    assignDefaultLogo(input: $input) {
      logo {
        id
        logoId
      }
    }
  }
`;
export type AssignDefaultLogoMutationFn = Apollo.MutationFunction<
  AssignDefaultLogoMutation,
  AssignDefaultLogoMutationVariables
>;

/**
 * __useAssignDefaultLogoMutation__
 *
 * To run a mutation, you first call `useAssignDefaultLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDefaultLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDefaultLogoMutation, { data, loading, error }] = useAssignDefaultLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignDefaultLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignDefaultLogoMutation,
    AssignDefaultLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    AssignDefaultLogoMutation,
    AssignDefaultLogoMutationVariables
  >(AssignDefaultLogoDocument, options);
}

export type AssignDefaultLogoMutationHookResult = ReturnType<
  typeof useAssignDefaultLogoMutation
>;
export type AssignDefaultLogoMutationResult =
  Apollo.MutationResult<AssignDefaultLogoMutation>;
export type AssignDefaultLogoMutationOptions = Apollo.BaseMutationOptions<
  AssignDefaultLogoMutation,
  AssignDefaultLogoMutationVariables
>;
export const CancelFeedProcessingProjectDocument = gql`
  mutation CancelFeedProcessingProject(
    $input: cancelFeedProcessingProjectInput!
  ) {
    cancelFeedProcessingProject(input: $input) {
      project {
        id
        projectId
        feed
        currentUpdate
        lastUpdate
      }
    }
  }
`;
export type CancelFeedProcessingProjectMutationFn = Apollo.MutationFunction<
  CancelFeedProcessingProjectMutation,
  CancelFeedProcessingProjectMutationVariables
>;

/**
 * __useCancelFeedProcessingProjectMutation__
 *
 * To run a mutation, you first call `useCancelFeedProcessingProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFeedProcessingProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFeedProcessingProjectMutation, { data, loading, error }] = useCancelFeedProcessingProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelFeedProcessingProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelFeedProcessingProjectMutation,
    CancelFeedProcessingProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CancelFeedProcessingProjectMutation,
    CancelFeedProcessingProjectMutationVariables
  >(CancelFeedProcessingProjectDocument, options);
}

export type CancelFeedProcessingProjectMutationHookResult = ReturnType<
  typeof useCancelFeedProcessingProjectMutation
>;
export type CancelFeedProcessingProjectMutationResult =
  Apollo.MutationResult<CancelFeedProcessingProjectMutation>;
export type CancelFeedProcessingProjectMutationOptions =
  Apollo.BaseMutationOptions<
    CancelFeedProcessingProjectMutation,
    CancelFeedProcessingProjectMutationVariables
  >;
export const ChangeAuthUserPasswordDocument = gql`
  mutation changeAuthUserPassword($input: changeAuthUserPasswordInput!) {
    changeAuthUserPassword(input: $input) {
      authUserPassword {
        id
      }
    }
  }
`;
export type ChangeAuthUserPasswordMutationFn = Apollo.MutationFunction<
  ChangeAuthUserPasswordMutation,
  ChangeAuthUserPasswordMutationVariables
>;

/**
 * __useChangeAuthUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeAuthUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAuthUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAuthUserPasswordMutation, { data, loading, error }] = useChangeAuthUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeAuthUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeAuthUserPasswordMutation,
    ChangeAuthUserPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ChangeAuthUserPasswordMutation,
    ChangeAuthUserPasswordMutationVariables
  >(ChangeAuthUserPasswordDocument, options);
}

export type ChangeAuthUserPasswordMutationHookResult = ReturnType<
  typeof useChangeAuthUserPasswordMutation
>;
export type ChangeAuthUserPasswordMutationResult =
  Apollo.MutationResult<ChangeAuthUserPasswordMutation>;
export type ChangeAuthUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangeAuthUserPasswordMutation,
  ChangeAuthUserPasswordMutationVariables
>;
export const ChangePasswordUserResetPasswordDocument = gql`
  mutation ChangePasswordUserResetPassword(
    $input: changePasswordUserResetPasswordInput!
  ) {
    changePasswordUserResetPassword(input: $input) {
      userResetPassword {
        id
        message
      }
    }
  }
`;
export type ChangePasswordUserResetPasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordUserResetPasswordMutation,
  ChangePasswordUserResetPasswordMutationVariables
>;

/**
 * __useChangePasswordUserResetPasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordUserResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordUserResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordUserResetPasswordMutation, { data, loading, error }] = useChangePasswordUserResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordUserResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordUserResetPasswordMutation,
    ChangePasswordUserResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ChangePasswordUserResetPasswordMutation,
    ChangePasswordUserResetPasswordMutationVariables
  >(ChangePasswordUserResetPasswordDocument, options);
}

export type ChangePasswordUserResetPasswordMutationHookResult = ReturnType<
  typeof useChangePasswordUserResetPasswordMutation
>;
export type ChangePasswordUserResetPasswordMutationResult =
  Apollo.MutationResult<ChangePasswordUserResetPasswordMutation>;
export type ChangePasswordUserResetPasswordMutationOptions =
  Apollo.BaseMutationOptions<
    ChangePasswordUserResetPasswordMutation,
    ChangePasswordUserResetPasswordMutationVariables
  >;
export const ChangeRoleTeamUserDocument = gql`
  mutation ChangeRoleTeamUser($input: changeRoleTeamUserInput!) {
    changeRoleTeamUser(input: $input) {
      clientMutationId
    }
  }
`;
export type ChangeRoleTeamUserMutationFn = Apollo.MutationFunction<
  ChangeRoleTeamUserMutation,
  ChangeRoleTeamUserMutationVariables
>;

/**
 * __useChangeRoleTeamUserMutation__
 *
 * To run a mutation, you first call `useChangeRoleTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRoleTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRoleTeamUserMutation, { data, loading, error }] = useChangeRoleTeamUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeRoleTeamUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeRoleTeamUserMutation,
    ChangeRoleTeamUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ChangeRoleTeamUserMutation,
    ChangeRoleTeamUserMutationVariables
  >(ChangeRoleTeamUserDocument, options);
}

export type ChangeRoleTeamUserMutationHookResult = ReturnType<
  typeof useChangeRoleTeamUserMutation
>;
export type ChangeRoleTeamUserMutationResult =
  Apollo.MutationResult<ChangeRoleTeamUserMutation>;
export type ChangeRoleTeamUserMutationOptions = Apollo.BaseMutationOptions<
  ChangeRoleTeamUserMutation,
  ChangeRoleTeamUserMutationVariables
>;
export const CloneDesignDocument = gql`
  mutation CloneDesign($input: cloneDesignInput!) {
    cloneDesign(input: $input) {
      design {
        id
        designId
        name
        previewImageId
      }
    }
  }
`;
export type CloneDesignMutationFn = Apollo.MutationFunction<
  CloneDesignMutation,
  CloneDesignMutationVariables
>;

/**
 * __useCloneDesignMutation__
 *
 * To run a mutation, you first call `useCloneDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneDesignMutation, { data, loading, error }] = useCloneDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneDesignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneDesignMutation,
    CloneDesignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CloneDesignMutation, CloneDesignMutationVariables>(
    CloneDesignDocument,
    options,
  );
}

export type CloneDesignMutationHookResult = ReturnType<
  typeof useCloneDesignMutation
>;
export type CloneDesignMutationResult =
  Apollo.MutationResult<CloneDesignMutation>;
export type CloneDesignMutationOptions = Apollo.BaseMutationOptions<
  CloneDesignMutation,
  CloneDesignMutationVariables
>;
export const CloneProjectDocument = gql`
  mutation CloneProject($input: cloneProjectInput!) {
    cloneProject(input: $input) {
      project {
        id
        projectId
        name
        teamId
        createdAt
        updatedAt
        lastUpdateId
        currentUpdateId
        feed
        status
        projectTokens
        designs
      }
    }
  }
`;
export type CloneProjectMutationFn = Apollo.MutationFunction<
  CloneProjectMutation,
  CloneProjectMutationVariables
>;

/**
 * __useCloneProjectMutation__
 *
 * To run a mutation, you first call `useCloneProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectMutation, { data, loading, error }] = useCloneProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneProjectMutation,
    CloneProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CloneProjectMutation,
    CloneProjectMutationVariables
  >(CloneProjectDocument, options);
}

export type CloneProjectMutationHookResult = ReturnType<
  typeof useCloneProjectMutation
>;
export type CloneProjectMutationResult =
  Apollo.MutationResult<CloneProjectMutation>;
export type CloneProjectMutationOptions = Apollo.BaseMutationOptions<
  CloneProjectMutation,
  CloneProjectMutationVariables
>;
export const CloneTeamDocument = gql`
  mutation CloneTeam($input: cloneTeamInput!) {
    cloneTeam(input: $input) {
      team {
        id
        teamId
        name
        projects
      }
    }
  }
`;
export type CloneTeamMutationFn = Apollo.MutationFunction<
  CloneTeamMutation,
  CloneTeamMutationVariables
>;

/**
 * __useCloneTeamMutation__
 *
 * To run a mutation, you first call `useCloneTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTeamMutation, { data, loading, error }] = useCloneTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneTeamMutation,
    CloneTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CloneTeamMutation, CloneTeamMutationVariables>(
    CloneTeamDocument,
    options,
  );
}

export type CloneTeamMutationHookResult = ReturnType<
  typeof useCloneTeamMutation
>;
export type CloneTeamMutationResult = Apollo.MutationResult<CloneTeamMutation>;
export type CloneTeamMutationOptions = Apollo.BaseMutationOptions<
  CloneTeamMutation,
  CloneTeamMutationVariables
>;
export const CloneToProjectDesignsDocument = gql`
  mutation CloneToProjectDesigns($input: cloneToProjectDesignsInput!) {
    cloneToProjectDesigns(input: $input) {
      clientMutationId
    }
  }
`;
export type CloneToProjectDesignsMutationFn = Apollo.MutationFunction<
  CloneToProjectDesignsMutation,
  CloneToProjectDesignsMutationVariables
>;

/**
 * __useCloneToProjectDesignsMutation__
 *
 * To run a mutation, you first call `useCloneToProjectDesignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneToProjectDesignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneToProjectDesignsMutation, { data, loading, error }] = useCloneToProjectDesignsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneToProjectDesignsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneToProjectDesignsMutation,
    CloneToProjectDesignsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CloneToProjectDesignsMutation,
    CloneToProjectDesignsMutationVariables
  >(CloneToProjectDesignsDocument, options);
}

export type CloneToProjectDesignsMutationHookResult = ReturnType<
  typeof useCloneToProjectDesignsMutation
>;
export type CloneToProjectDesignsMutationResult =
  Apollo.MutationResult<CloneToProjectDesignsMutation>;
export type CloneToProjectDesignsMutationOptions = Apollo.BaseMutationOptions<
  CloneToProjectDesignsMutation,
  CloneToProjectDesignsMutationVariables
>;
export const ConfirmTeamInvitationConfirmationDocument = gql`
  mutation ConfirmTeamInvitationConfirmation(
    $input: confirmTeamInvitationConfirmationInput!
  ) {
    confirmTeamInvitationConfirmation(input: $input) {
      teamInvitationConfirmation {
        id
        status
      }
    }
  }
`;
export type ConfirmTeamInvitationConfirmationMutationFn =
  Apollo.MutationFunction<
    ConfirmTeamInvitationConfirmationMutation,
    ConfirmTeamInvitationConfirmationMutationVariables
  >;

/**
 * __useConfirmTeamInvitationConfirmationMutation__
 *
 * To run a mutation, you first call `useConfirmTeamInvitationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTeamInvitationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTeamInvitationConfirmationMutation, { data, loading, error }] = useConfirmTeamInvitationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmTeamInvitationConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmTeamInvitationConfirmationMutation,
    ConfirmTeamInvitationConfirmationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ConfirmTeamInvitationConfirmationMutation,
    ConfirmTeamInvitationConfirmationMutationVariables
  >(ConfirmTeamInvitationConfirmationDocument, options);
}

export type ConfirmTeamInvitationConfirmationMutationHookResult = ReturnType<
  typeof useConfirmTeamInvitationConfirmationMutation
>;
export type ConfirmTeamInvitationConfirmationMutationResult =
  Apollo.MutationResult<ConfirmTeamInvitationConfirmationMutation>;
export type ConfirmTeamInvitationConfirmationMutationOptions =
  Apollo.BaseMutationOptions<
    ConfirmTeamInvitationConfirmationMutation,
    ConfirmTeamInvitationConfirmationMutationVariables
  >;
export const CreateBillingPortalSessionDocument = gql`
  mutation createBillingPortalSession(
    $input: createBillingPortalSessionInput!
  ) {
    createBillingPortalSession(input: $input) {
      clientMutationId
      billingPortalSession {
        sessionId
        sessionUrl
      }
    }
  }
`;
export type CreateBillingPortalSessionMutationFn = Apollo.MutationFunction<
  CreateBillingPortalSessionMutation,
  CreateBillingPortalSessionMutationVariables
>;

/**
 * __useCreateBillingPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateBillingPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingPortalSessionMutation, { data, loading, error }] = useCreateBillingPortalSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingPortalSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBillingPortalSessionMutation,
    CreateBillingPortalSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateBillingPortalSessionMutation,
    CreateBillingPortalSessionMutationVariables
  >(CreateBillingPortalSessionDocument, options);
}

export type CreateBillingPortalSessionMutationHookResult = ReturnType<
  typeof useCreateBillingPortalSessionMutation
>;
export type CreateBillingPortalSessionMutationResult =
  Apollo.MutationResult<CreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBillingPortalSessionMutation,
    CreateBillingPortalSessionMutationVariables
  >;
export const CreateFromTemplateDesignDocument = gql`
  mutation CreateFromTemplateDesign($input: createFromTemplateDesignInput!) {
    createFromTemplateDesign(input: $input) {
      design {
        id
        designId
        name
        previewImageId
        manageableLayersSettings
      }
    }
  }
`;
export type CreateFromTemplateDesignMutationFn = Apollo.MutationFunction<
  CreateFromTemplateDesignMutation,
  CreateFromTemplateDesignMutationVariables
>;

/**
 * __useCreateFromTemplateDesignMutation__
 *
 * To run a mutation, you first call `useCreateFromTemplateDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFromTemplateDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFromTemplateDesignMutation, { data, loading, error }] = useCreateFromTemplateDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFromTemplateDesignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFromTemplateDesignMutation,
    CreateFromTemplateDesignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateFromTemplateDesignMutation,
    CreateFromTemplateDesignMutationVariables
  >(CreateFromTemplateDesignDocument, options);
}

export type CreateFromTemplateDesignMutationHookResult = ReturnType<
  typeof useCreateFromTemplateDesignMutation
>;
export type CreateFromTemplateDesignMutationResult =
  Apollo.MutationResult<CreateFromTemplateDesignMutation>;
export type CreateFromTemplateDesignMutationOptions =
  Apollo.BaseMutationOptions<
    CreateFromTemplateDesignMutation,
    CreateFromTemplateDesignMutationVariables
  >;
export const CreateProjectDocument = gql`
  mutation CreateProject($input: createProjectInput!) {
    createProject(input: $input) {
      project {
        id
        projectId
        name
        teamId
        createdAt
        updatedAt
        lastUpdateId
        currentUpdateId
        status
        projectTokens
        projectObjects
      }
    }
  }
`;
export type CreateProjectMutationFn = Apollo.MutationFunction<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >(CreateProjectDocument, options);
}

export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>;
export type CreateProjectMutationResult =
  Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;
export const CreateTeamDocument = gql`
  mutation CreateTeam($input: createTeamInput!) {
    createTeam(input: $input) {
      team {
        id
        teamId
        name
      }
    }
  }
`;
export type CreateTeamMutationFn = Apollo.MutationFunction<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMutation,
    CreateTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
    CreateTeamDocument,
    options,
  );
}

export type CreateTeamMutationHookResult = ReturnType<
  typeof useCreateTeamMutation
>;
export type CreateTeamMutationResult =
  Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;
export const CreateTeamInvitationsDocument = gql`
  mutation CreateTeamInvitations($input: createTeamInvitationCreationInput!) {
    createTeamInvitationCreation(input: $input) {
      teamInvitationCreation {
        id
        teamInvitations
      }
    }
  }
`;
export type CreateTeamInvitationsMutationFn = Apollo.MutationFunction<
  CreateTeamInvitationsMutation,
  CreateTeamInvitationsMutationVariables
>;

/**
 * __useCreateTeamInvitationsMutation__
 *
 * To run a mutation, you first call `useCreateTeamInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamInvitationsMutation, { data, loading, error }] = useCreateTeamInvitationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamInvitationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamInvitationsMutation,
    CreateTeamInvitationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateTeamInvitationsMutation,
    CreateTeamInvitationsMutationVariables
  >(CreateTeamInvitationsDocument, options);
}

export type CreateTeamInvitationsMutationHookResult = ReturnType<
  typeof useCreateTeamInvitationsMutation
>;
export type CreateTeamInvitationsMutationResult =
  Apollo.MutationResult<CreateTeamInvitationsMutation>;
export type CreateTeamInvitationsMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamInvitationsMutation,
  CreateTeamInvitationsMutationVariables
>;
export const CreateProjectTokenDocument = gql`
  mutation CreateProjectToken($input: createProjectTokenInput!) {
    createProjectToken(input: $input) {
      projectToken {
        id
        projectTokenId
        value
        updatedAt
      }
    }
  }
`;
export type CreateProjectTokenMutationFn = Apollo.MutationFunction<
  CreateProjectTokenMutation,
  CreateProjectTokenMutationVariables
>;

/**
 * __useCreateProjectTokenMutation__
 *
 * To run a mutation, you first call `useCreateProjectTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectTokenMutation, { data, loading, error }] = useCreateProjectTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectTokenMutation,
    CreateProjectTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateProjectTokenMutation,
    CreateProjectTokenMutationVariables
  >(CreateProjectTokenDocument, options);
}

export type CreateProjectTokenMutationHookResult = ReturnType<
  typeof useCreateProjectTokenMutation
>;
export type CreateProjectTokenMutationResult =
  Apollo.MutationResult<CreateProjectTokenMutation>;
export type CreateProjectTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectTokenMutation,
  CreateProjectTokenMutationVariables
>;
export const CreateUserVerificationDocument = gql`
  mutation CreateUserVerification($input: createUserVerificationInput!) {
    createUserVerification(input: $input) {
      userVerification {
        id
        message
      }
      clientMutationId
    }
  }
`;
export type CreateUserVerificationMutationFn = Apollo.MutationFunction<
  CreateUserVerificationMutation,
  CreateUserVerificationMutationVariables
>;

/**
 * __useCreateUserVerificationMutation__
 *
 * To run a mutation, you first call `useCreateUserVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserVerificationMutation, { data, loading, error }] = useCreateUserVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserVerificationMutation,
    CreateUserVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateUserVerificationMutation,
    CreateUserVerificationMutationVariables
  >(CreateUserVerificationDocument, options);
}

export type CreateUserVerificationMutationHookResult = ReturnType<
  typeof useCreateUserVerificationMutation
>;
export type CreateUserVerificationMutationResult =
  Apollo.MutationResult<CreateUserVerificationMutation>;
export type CreateUserVerificationMutationOptions = Apollo.BaseMutationOptions<
  CreateUserVerificationMutation,
  CreateUserVerificationMutationVariables
>;
export const CreateObjectPreviewFromDesignObjectDocument = gql`
  mutation CreateObjectPreviewFromDesignObject(
    $input: createObjectPreviewFromDesignObjectInput!
  ) {
    createObjectPreviewFromDesignObject(input: $input) {
      object {
        id
        objectId
        message
        product
        resolvedFields
        resolvedManageableLayers
        resolvedManageableLayersConditions
      }
    }
  }
`;
export type CreateObjectPreviewFromDesignObjectMutationFn =
  Apollo.MutationFunction<
    CreateObjectPreviewFromDesignObjectMutation,
    CreateObjectPreviewFromDesignObjectMutationVariables
  >;

/**
 * __useCreateObjectPreviewFromDesignObjectMutation__
 *
 * To run a mutation, you first call `useCreateObjectPreviewFromDesignObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectPreviewFromDesignObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectPreviewFromDesignObjectMutation, { data, loading, error }] = useCreateObjectPreviewFromDesignObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObjectPreviewFromDesignObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateObjectPreviewFromDesignObjectMutation,
    CreateObjectPreviewFromDesignObjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateObjectPreviewFromDesignObjectMutation,
    CreateObjectPreviewFromDesignObjectMutationVariables
  >(CreateObjectPreviewFromDesignObjectDocument, options);
}

export type CreateObjectPreviewFromDesignObjectMutationHookResult = ReturnType<
  typeof useCreateObjectPreviewFromDesignObjectMutation
>;
export type CreateObjectPreviewFromDesignObjectMutationResult =
  Apollo.MutationResult<CreateObjectPreviewFromDesignObjectMutation>;
export type CreateObjectPreviewFromDesignObjectMutationOptions =
  Apollo.BaseMutationOptions<
    CreateObjectPreviewFromDesignObjectMutation,
    CreateObjectPreviewFromDesignObjectMutationVariables
  >;
export const LoginSharedDesignAuthDocument = gql`
  mutation LoginSharedDesignAuth($input: loginSharedDesignAuthInput!) {
    loginSharedDesignAuth(input: $input) {
      auth {
        id
        _id
        token
        refreshToken
        refreshTokenExpiresAt
      }
    }
  }
`;
export type LoginSharedDesignAuthMutationFn = Apollo.MutationFunction<
  LoginSharedDesignAuthMutation,
  LoginSharedDesignAuthMutationVariables
>;

/**
 * __useLoginSharedDesignAuthMutation__
 *
 * To run a mutation, you first call `useLoginSharedDesignAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSharedDesignAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSharedDesignAuthMutation, { data, loading, error }] = useLoginSharedDesignAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginSharedDesignAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginSharedDesignAuthMutation,
    LoginSharedDesignAuthMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    LoginSharedDesignAuthMutation,
    LoginSharedDesignAuthMutationVariables
  >(LoginSharedDesignAuthDocument, options);
}

export type LoginSharedDesignAuthMutationHookResult = ReturnType<
  typeof useLoginSharedDesignAuthMutation
>;
export type LoginSharedDesignAuthMutationResult =
  Apollo.MutationResult<LoginSharedDesignAuthMutation>;
export type LoginSharedDesignAuthMutationOptions = Apollo.BaseMutationOptions<
  LoginSharedDesignAuthMutation,
  LoginSharedDesignAuthMutationVariables
>;
export const UpdateSharedSettingsDesignDocument = gql`
  mutation UpdateSharedSettingsDesign(
    $input: updateSharedSettingsDesignInput!
  ) {
    updateSharedSettingsDesign(input: $input) {
      design {
        designId
        settings
      }
    }
  }
`;
export type UpdateSharedSettingsDesignMutationFn = Apollo.MutationFunction<
  UpdateSharedSettingsDesignMutation,
  UpdateSharedSettingsDesignMutationVariables
>;

/**
 * __useUpdateSharedSettingsDesignMutation__
 *
 * To run a mutation, you first call `useUpdateSharedSettingsDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedSettingsDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedSettingsDesignMutation, { data, loading, error }] = useUpdateSharedSettingsDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSharedSettingsDesignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSharedSettingsDesignMutation,
    UpdateSharedSettingsDesignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateSharedSettingsDesignMutation,
    UpdateSharedSettingsDesignMutationVariables
  >(UpdateSharedSettingsDesignDocument, options);
}

export type UpdateSharedSettingsDesignMutationHookResult = ReturnType<
  typeof useUpdateSharedSettingsDesignMutation
>;
export type UpdateSharedSettingsDesignMutationResult =
  Apollo.MutationResult<UpdateSharedSettingsDesignMutation>;
export type UpdateSharedSettingsDesignMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSharedSettingsDesignMutation,
    UpdateSharedSettingsDesignMutationVariables
  >;
export const DisconnectProjectFeedDocument = gql`
  mutation DisconnectProjectFeed($input: disconnectProjectFeedInput!) {
    disconnectProjectFeed(input: $input) {
      projectFeed {
        id
        message
      }
    }
  }
`;
export type DisconnectProjectFeedMutationFn = Apollo.MutationFunction<
  DisconnectProjectFeedMutation,
  DisconnectProjectFeedMutationVariables
>;

/**
 * __useDisconnectProjectFeedMutation__
 *
 * To run a mutation, you first call `useDisconnectProjectFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectProjectFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectProjectFeedMutation, { data, loading, error }] = useDisconnectProjectFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectProjectFeedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisconnectProjectFeedMutation,
    DisconnectProjectFeedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DisconnectProjectFeedMutation,
    DisconnectProjectFeedMutationVariables
  >(DisconnectProjectFeedDocument, options);
}

export type DisconnectProjectFeedMutationHookResult = ReturnType<
  typeof useDisconnectProjectFeedMutation
>;
export type DisconnectProjectFeedMutationResult =
  Apollo.MutationResult<DisconnectProjectFeedMutation>;
export type DisconnectProjectFeedMutationOptions = Apollo.BaseMutationOptions<
  DisconnectProjectFeedMutation,
  DisconnectProjectFeedMutationVariables
>;
export const FetchStripeInvoiceListDocument = gql`
  query FetchStripeInvoiceList {
    callApiPayment(
      method: invoice_list
      routeParams: []
      httpParams: [{ param: "customer", value: "" }]
    ) {
      data
    }
  }
`;

/**
 * __useFetchStripeInvoiceListQuery__
 *
 * To run a query within a React component, call `useFetchStripeInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchStripeInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStripeInvoiceListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchStripeInvoiceListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchStripeInvoiceListQuery,
    FetchStripeInvoiceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchStripeInvoiceListQuery,
    FetchStripeInvoiceListQueryVariables
  >(FetchStripeInvoiceListDocument, options);
}

export function useFetchStripeInvoiceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchStripeInvoiceListQuery,
    FetchStripeInvoiceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchStripeInvoiceListQuery,
    FetchStripeInvoiceListQueryVariables
  >(FetchStripeInvoiceListDocument, options);
}

export type FetchStripeInvoiceListQueryHookResult = ReturnType<
  typeof useFetchStripeInvoiceListQuery
>;
export type FetchStripeInvoiceListLazyQueryHookResult = ReturnType<
  typeof useFetchStripeInvoiceListLazyQuery
>;
export type FetchStripeInvoiceListQueryResult = Apollo.QueryResult<
  FetchStripeInvoiceListQuery,
  FetchStripeInvoiceListQueryVariables
>;
export const FinishOnboardingUserDocument = gql`
  mutation FinishOnboardingUser {
    finishOnboardingUser(input: {}) {
      user {
        id
      }
    }
  }
`;
export type FinishOnboardingUserMutationFn = Apollo.MutationFunction<
  FinishOnboardingUserMutation,
  FinishOnboardingUserMutationVariables
>;

/**
 * __useFinishOnboardingUserMutation__
 *
 * To run a mutation, you first call `useFinishOnboardingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishOnboardingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishOnboardingUserMutation, { data, loading, error }] = useFinishOnboardingUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinishOnboardingUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishOnboardingUserMutation,
    FinishOnboardingUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    FinishOnboardingUserMutation,
    FinishOnboardingUserMutationVariables
  >(FinishOnboardingUserDocument, options);
}

export type FinishOnboardingUserMutationHookResult = ReturnType<
  typeof useFinishOnboardingUserMutation
>;
export type FinishOnboardingUserMutationResult =
  Apollo.MutationResult<FinishOnboardingUserMutation>;
export type FinishOnboardingUserMutationOptions = Apollo.BaseMutationOptions<
  FinishOnboardingUserMutation,
  FinishOnboardingUserMutationVariables
>;
export const UploadFontDocument = gql`
  mutation UploadFont($input: uploadFontInput!) {
    uploadFont(input: $input) {
      font {
        id
        fontId
        userId
        teamId
        name
        family
        style
        weight
        weightName
        postScript
        format
        createdAt
        updatedAt
      }
    }
  }
`;
export type UploadFontMutationFn = Apollo.MutationFunction<
  UploadFontMutation,
  UploadFontMutationVariables
>;

/**
 * __useUploadFontMutation__
 *
 * To run a mutation, you first call `useUploadFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFontMutation, { data, loading, error }] = useUploadFontMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFontMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadFontMutation,
    UploadFontMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UploadFontMutation, UploadFontMutationVariables>(
    UploadFontDocument,
    options,
  );
}

export type UploadFontMutationHookResult = ReturnType<
  typeof useUploadFontMutation
>;
export type UploadFontMutationResult =
  Apollo.MutationResult<UploadFontMutation>;
export type UploadFontMutationOptions = Apollo.BaseMutationOptions<
  UploadFontMutation,
  UploadFontMutationVariables
>;
export const GenerateTokenUserResetPasswordDocument = gql`
  mutation GenerateTokenUserResetPassword(
    $input: generateTokenUserResetPasswordInput!
  ) {
    generateTokenUserResetPassword(input: $input) {
      clientMutationId
    }
  }
`;
export type GenerateTokenUserResetPasswordMutationFn = Apollo.MutationFunction<
  GenerateTokenUserResetPasswordMutation,
  GenerateTokenUserResetPasswordMutationVariables
>;

/**
 * __useGenerateTokenUserResetPasswordMutation__
 *
 * To run a mutation, you first call `useGenerateTokenUserResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTokenUserResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTokenUserResetPasswordMutation, { data, loading, error }] = useGenerateTokenUserResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTokenUserResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateTokenUserResetPasswordMutation,
    GenerateTokenUserResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    GenerateTokenUserResetPasswordMutation,
    GenerateTokenUserResetPasswordMutationVariables
  >(GenerateTokenUserResetPasswordDocument, options);
}

export type GenerateTokenUserResetPasswordMutationHookResult = ReturnType<
  typeof useGenerateTokenUserResetPasswordMutation
>;
export type GenerateTokenUserResetPasswordMutationResult =
  Apollo.MutationResult<GenerateTokenUserResetPasswordMutation>;
export type GenerateTokenUserResetPasswordMutationOptions =
  Apollo.BaseMutationOptions<
    GenerateTokenUserResetPasswordMutation,
    GenerateTokenUserResetPasswordMutationVariables
  >;
export const AssignFacebookCatalogToProjectDocument = gql`
  mutation AssignFacebookCatalogToProject(
    $input: assignFacebookCatalogToProjectInput!
  ) {
    assignFacebookCatalogToProject(input: $input) {
      project {
        projectId
      }
    }
  }
`;
export type AssignFacebookCatalogToProjectMutationFn = Apollo.MutationFunction<
  AssignFacebookCatalogToProjectMutation,
  AssignFacebookCatalogToProjectMutationVariables
>;

/**
 * __useAssignFacebookCatalogToProjectMutation__
 *
 * To run a mutation, you first call `useAssignFacebookCatalogToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignFacebookCatalogToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignFacebookCatalogToProjectMutation, { data, loading, error }] = useAssignFacebookCatalogToProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignFacebookCatalogToProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignFacebookCatalogToProjectMutation,
    AssignFacebookCatalogToProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    AssignFacebookCatalogToProjectMutation,
    AssignFacebookCatalogToProjectMutationVariables
  >(AssignFacebookCatalogToProjectDocument, options);
}

export type AssignFacebookCatalogToProjectMutationHookResult = ReturnType<
  typeof useAssignFacebookCatalogToProjectMutation
>;
export type AssignFacebookCatalogToProjectMutationResult =
  Apollo.MutationResult<AssignFacebookCatalogToProjectMutation>;
export type AssignFacebookCatalogToProjectMutationOptions =
  Apollo.BaseMutationOptions<
    AssignFacebookCatalogToProjectMutation,
    AssignFacebookCatalogToProjectMutationVariables
  >;
export const AssignProjectObjectToFacebookAdProjectDocument = gql`
  mutation AssignProjectObjectToFacebookAdProject(
    $input: assignProjectObjectToFacebookAdProjectInput!
  ) {
    assignProjectObjectToFacebookAdProject(input: $input) {
      project {
        projectId
        outputSettings
      }
    }
  }
`;
export type AssignProjectObjectToFacebookAdProjectMutationFn =
  Apollo.MutationFunction<
    AssignProjectObjectToFacebookAdProjectMutation,
    AssignProjectObjectToFacebookAdProjectMutationVariables
  >;

/**
 * __useAssignProjectObjectToFacebookAdProjectMutation__
 *
 * To run a mutation, you first call `useAssignProjectObjectToFacebookAdProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProjectObjectToFacebookAdProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProjectObjectToFacebookAdProjectMutation, { data, loading, error }] = useAssignProjectObjectToFacebookAdProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignProjectObjectToFacebookAdProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignProjectObjectToFacebookAdProjectMutation,
    AssignProjectObjectToFacebookAdProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    AssignProjectObjectToFacebookAdProjectMutation,
    AssignProjectObjectToFacebookAdProjectMutationVariables
  >(AssignProjectObjectToFacebookAdProjectDocument, options);
}

export type AssignProjectObjectToFacebookAdProjectMutationHookResult =
  ReturnType<typeof useAssignProjectObjectToFacebookAdProjectMutation>;
export type AssignProjectObjectToFacebookAdProjectMutationResult =
  Apollo.MutationResult<AssignProjectObjectToFacebookAdProjectMutation>;
export type AssignProjectObjectToFacebookAdProjectMutationOptions =
  Apollo.BaseMutationOptions<
    AssignProjectObjectToFacebookAdProjectMutation,
    AssignProjectObjectToFacebookAdProjectMutationVariables
  >;
export const ClaimShopifyInstallationConnectorDocument = gql`
  mutation ClaimShopifyInstallationConnector(
    $input: claimShopifyInstallationConnectorInput!
  ) {
    claimShopifyInstallationConnector(input: $input) {
      connector {
        connectorId
        teamId
        status
      }
    }
  }
`;
export type ClaimShopifyInstallationConnectorMutationFn =
  Apollo.MutationFunction<
    ClaimShopifyInstallationConnectorMutation,
    ClaimShopifyInstallationConnectorMutationVariables
  >;

/**
 * __useClaimShopifyInstallationConnectorMutation__
 *
 * To run a mutation, you first call `useClaimShopifyInstallationConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimShopifyInstallationConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimShopifyInstallationConnectorMutation, { data, loading, error }] = useClaimShopifyInstallationConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimShopifyInstallationConnectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClaimShopifyInstallationConnectorMutation,
    ClaimShopifyInstallationConnectorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ClaimShopifyInstallationConnectorMutation,
    ClaimShopifyInstallationConnectorMutationVariables
  >(ClaimShopifyInstallationConnectorDocument, options);
}

export type ClaimShopifyInstallationConnectorMutationHookResult = ReturnType<
  typeof useClaimShopifyInstallationConnectorMutation
>;
export type ClaimShopifyInstallationConnectorMutationResult =
  Apollo.MutationResult<ClaimShopifyInstallationConnectorMutation>;
export type ClaimShopifyInstallationConnectorMutationOptions =
  Apollo.BaseMutationOptions<
    ClaimShopifyInstallationConnectorMutation,
    ClaimShopifyInstallationConnectorMutationVariables
  >;
export const CreateConnectorDocument = gql`
  mutation CreateConnector($input: createConnectorInput!) {
    createConnector(input: $input) {
      connector {
        connectorId
        teamId
        userId
        status
      }
    }
  }
`;
export type CreateConnectorMutationFn = Apollo.MutationFunction<
  CreateConnectorMutation,
  CreateConnectorMutationVariables
>;

/**
 * __useCreateConnectorMutation__
 *
 * To run a mutation, you first call `useCreateConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectorMutation, { data, loading, error }] = useCreateConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConnectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConnectorMutation,
    CreateConnectorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateConnectorMutation,
    CreateConnectorMutationVariables
  >(CreateConnectorDocument, options);
}

export type CreateConnectorMutationHookResult = ReturnType<
  typeof useCreateConnectorMutation
>;
export type CreateConnectorMutationResult =
  Apollo.MutationResult<CreateConnectorMutation>;
export type CreateConnectorMutationOptions = Apollo.BaseMutationOptions<
  CreateConnectorMutation,
  CreateConnectorMutationVariables
>;
export const InitiateFacebookLoginDocument = gql`
  mutation InitiateFacebookLogin($input: initiateFacebookLoginInput!) {
    initiateFacebookLogin(input: $input) {
      facebookLogin {
        loginUrl
        sessionTokenId
      }
    }
  }
`;
export type InitiateFacebookLoginMutationFn = Apollo.MutationFunction<
  InitiateFacebookLoginMutation,
  InitiateFacebookLoginMutationVariables
>;

/**
 * __useInitiateFacebookLoginMutation__
 *
 * To run a mutation, you first call `useInitiateFacebookLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateFacebookLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateFacebookLoginMutation, { data, loading, error }] = useInitiateFacebookLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateFacebookLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateFacebookLoginMutation,
    InitiateFacebookLoginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    InitiateFacebookLoginMutation,
    InitiateFacebookLoginMutationVariables
  >(InitiateFacebookLoginDocument, options);
}

export type InitiateFacebookLoginMutationHookResult = ReturnType<
  typeof useInitiateFacebookLoginMutation
>;
export type InitiateFacebookLoginMutationResult =
  Apollo.MutationResult<InitiateFacebookLoginMutation>;
export type InitiateFacebookLoginMutationOptions = Apollo.BaseMutationOptions<
  InitiateFacebookLoginMutation,
  InitiateFacebookLoginMutationVariables
>;
export const InitiateShopifyLoginDocument = gql`
  mutation InitiateShopifyLogin($input: initiateShopifyLoginInput!) {
    initiateShopifyLogin(input: $input) {
      shopifyLogin {
        authorizeUrl
        sessionTokenId
      }
    }
  }
`;
export type InitiateShopifyLoginMutationFn = Apollo.MutationFunction<
  InitiateShopifyLoginMutation,
  InitiateShopifyLoginMutationVariables
>;

/**
 * __useInitiateShopifyLoginMutation__
 *
 * To run a mutation, you first call `useInitiateShopifyLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateShopifyLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateShopifyLoginMutation, { data, loading, error }] = useInitiateShopifyLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateShopifyLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateShopifyLoginMutation,
    InitiateShopifyLoginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    InitiateShopifyLoginMutation,
    InitiateShopifyLoginMutationVariables
  >(InitiateShopifyLoginDocument, options);
}

export type InitiateShopifyLoginMutationHookResult = ReturnType<
  typeof useInitiateShopifyLoginMutation
>;
export type InitiateShopifyLoginMutationResult =
  Apollo.MutationResult<InitiateShopifyLoginMutation>;
export type InitiateShopifyLoginMutationOptions = Apollo.BaseMutationOptions<
  InitiateShopifyLoginMutation,
  InitiateShopifyLoginMutationVariables
>;
export const RemoveConnectorDocument = gql`
  mutation RemoveConnector($input: removeConnectorInput!) {
    removeConnector(input: $input) {
      connector {
        connectorId
      }
    }
  }
`;
export type RemoveConnectorMutationFn = Apollo.MutationFunction<
  RemoveConnectorMutation,
  RemoveConnectorMutationVariables
>;

/**
 * __useRemoveConnectorMutation__
 *
 * To run a mutation, you first call `useRemoveConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConnectorMutation, { data, loading, error }] = useRemoveConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveConnectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveConnectorMutation,
    RemoveConnectorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveConnectorMutation,
    RemoveConnectorMutationVariables
  >(RemoveConnectorDocument, options);
}

export type RemoveConnectorMutationHookResult = ReturnType<
  typeof useRemoveConnectorMutation
>;
export type RemoveConnectorMutationResult =
  Apollo.MutationResult<RemoveConnectorMutation>;
export type RemoveConnectorMutationOptions = Apollo.BaseMutationOptions<
  RemoveConnectorMutation,
  RemoveConnectorMutationVariables
>;
export const UnassignFacebookIntegrationFromProjectDocument = gql`
  mutation UnassignFacebookIntegrationFromProject(
    $input: unassignFacebookIntegrationFromProjectInput!
  ) {
    unassignFacebookIntegrationFromProject(input: $input) {
      project {
        projectId
      }
    }
  }
`;
export type UnassignFacebookIntegrationFromProjectMutationFn =
  Apollo.MutationFunction<
    UnassignFacebookIntegrationFromProjectMutation,
    UnassignFacebookIntegrationFromProjectMutationVariables
  >;

/**
 * __useUnassignFacebookIntegrationFromProjectMutation__
 *
 * To run a mutation, you first call `useUnassignFacebookIntegrationFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignFacebookIntegrationFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignFacebookIntegrationFromProjectMutation, { data, loading, error }] = useUnassignFacebookIntegrationFromProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignFacebookIntegrationFromProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignFacebookIntegrationFromProjectMutation,
    UnassignFacebookIntegrationFromProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UnassignFacebookIntegrationFromProjectMutation,
    UnassignFacebookIntegrationFromProjectMutationVariables
  >(UnassignFacebookIntegrationFromProjectDocument, options);
}

export type UnassignFacebookIntegrationFromProjectMutationHookResult =
  ReturnType<typeof useUnassignFacebookIntegrationFromProjectMutation>;
export type UnassignFacebookIntegrationFromProjectMutationResult =
  Apollo.MutationResult<UnassignFacebookIntegrationFromProjectMutation>;
export type UnassignFacebookIntegrationFromProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UnassignFacebookIntegrationFromProjectMutation,
    UnassignFacebookIntegrationFromProjectMutationVariables
  >;
export const UnassignProjectObjectFromFacebookAdProjectDocument = gql`
  mutation UnassignProjectObjectFromFacebookAdProject(
    $input: unassignProjectObjectFromFacebookAdProjectInput!
  ) {
    unassignProjectObjectFromFacebookAdProject(input: $input) {
      project {
        projectId
      }
    }
  }
`;
export type UnassignProjectObjectFromFacebookAdProjectMutationFn =
  Apollo.MutationFunction<
    UnassignProjectObjectFromFacebookAdProjectMutation,
    UnassignProjectObjectFromFacebookAdProjectMutationVariables
  >;

/**
 * __useUnassignProjectObjectFromFacebookAdProjectMutation__
 *
 * To run a mutation, you first call `useUnassignProjectObjectFromFacebookAdProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignProjectObjectFromFacebookAdProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignProjectObjectFromFacebookAdProjectMutation, { data, loading, error }] = useUnassignProjectObjectFromFacebookAdProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignProjectObjectFromFacebookAdProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignProjectObjectFromFacebookAdProjectMutation,
    UnassignProjectObjectFromFacebookAdProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UnassignProjectObjectFromFacebookAdProjectMutation,
    UnassignProjectObjectFromFacebookAdProjectMutationVariables
  >(UnassignProjectObjectFromFacebookAdProjectDocument, options);
}

export type UnassignProjectObjectFromFacebookAdProjectMutationHookResult =
  ReturnType<typeof useUnassignProjectObjectFromFacebookAdProjectMutation>;
export type UnassignProjectObjectFromFacebookAdProjectMutationResult =
  Apollo.MutationResult<UnassignProjectObjectFromFacebookAdProjectMutation>;
export type UnassignProjectObjectFromFacebookAdProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UnassignProjectObjectFromFacebookAdProjectMutation,
    UnassignProjectObjectFromFacebookAdProjectMutationVariables
  >;
export const LeaveTeamDocument = gql`
  mutation LeaveTeam($input: leaveTeamInput!) {
    leaveTeam(input: $input) {
      clientMutationId
    }
  }
`;
export type LeaveTeamMutationFn = Apollo.MutationFunction<
  LeaveTeamMutation,
  LeaveTeamMutationVariables
>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveTeamMutation,
    LeaveTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(
    LeaveTeamDocument,
    options,
  );
}

export type LeaveTeamMutationHookResult = ReturnType<
  typeof useLeaveTeamMutation
>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<
  LeaveTeamMutation,
  LeaveTeamMutationVariables
>;
export const LoginCredentialsUserDocument = gql`
  mutation LoginCredentialsUser($input: loginCredentialsUserInput!) {
    loginCredentialsUser(input: $input) {
      user {
        ...AuthToken
      }
      clientMutationId
    }
  }
  ${AuthTokenFragmentDoc}
`;
export type LoginCredentialsUserMutationFn = Apollo.MutationFunction<
  LoginCredentialsUserMutation,
  LoginCredentialsUserMutationVariables
>;

/**
 * __useLoginCredentialsUserMutation__
 *
 * To run a mutation, you first call `useLoginCredentialsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginCredentialsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginCredentialsUserMutation, { data, loading, error }] = useLoginCredentialsUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginCredentialsUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginCredentialsUserMutation,
    LoginCredentialsUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    LoginCredentialsUserMutation,
    LoginCredentialsUserMutationVariables
  >(LoginCredentialsUserDocument, options);
}

export type LoginCredentialsUserMutationHookResult = ReturnType<
  typeof useLoginCredentialsUserMutation
>;
export type LoginCredentialsUserMutationResult =
  Apollo.MutationResult<LoginCredentialsUserMutation>;
export type LoginCredentialsUserMutationOptions = Apollo.BaseMutationOptions<
  LoginCredentialsUserMutation,
  LoginCredentialsUserMutationVariables
>;
export const UpdateLogoDocument = gql`
  mutation UpdateLogo($input: updateLogoInput!) {
    updateLogo(input: $input) {
      logo {
        id
        logoId
        name
      }
    }
  }
`;
export type UpdateLogoMutationFn = Apollo.MutationFunction<
  UpdateLogoMutation,
  UpdateLogoMutationVariables
>;

/**
 * __useUpdateLogoMutation__
 *
 * To run a mutation, you first call `useUpdateLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogoMutation, { data, loading, error }] = useUpdateLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLogoMutation,
    UpdateLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateLogoMutation, UpdateLogoMutationVariables>(
    UpdateLogoDocument,
    options,
  );
}

export type UpdateLogoMutationHookResult = ReturnType<
  typeof useUpdateLogoMutation
>;
export type UpdateLogoMutationResult =
  Apollo.MutationResult<UpdateLogoMutation>;
export type UpdateLogoMutationOptions = Apollo.BaseMutationOptions<
  UpdateLogoMutation,
  UpdateLogoMutationVariables
>;
export const UploadLogoDocument = gql`
  mutation UploadLogo($input: uploadLogoInput!) {
    uploadLogo(input: $input) {
      logo {
        id
        logoId
        userId
        teamId
        name
        size
        mimeType
        createdAt
        updatedAt
        format
      }
    }
  }
`;
export type UploadLogoMutationFn = Apollo.MutationFunction<
  UploadLogoMutation,
  UploadLogoMutationVariables
>;

/**
 * __useUploadLogoMutation__
 *
 * To run a mutation, you first call `useUploadLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLogoMutation, { data, loading, error }] = useUploadLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadLogoMutation,
    UploadLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UploadLogoMutation, UploadLogoMutationVariables>(
    UploadLogoDocument,
    options,
  );
}

export type UploadLogoMutationHookResult = ReturnType<
  typeof useUploadLogoMutation
>;
export type UploadLogoMutationResult =
  Apollo.MutationResult<UploadLogoMutation>;
export type UploadLogoMutationOptions = Apollo.BaseMutationOptions<
  UploadLogoMutation,
  UploadLogoMutationVariables
>;
export const LogoutUserAuthDocument = gql`
  mutation LogoutUserAuth($input: logoutUserAuthInput!) {
    logoutUserAuth(input: $input) {
      auth {
        id
      }
      clientMutationId
    }
  }
`;
export type LogoutUserAuthMutationFn = Apollo.MutationFunction<
  LogoutUserAuthMutation,
  LogoutUserAuthMutationVariables
>;

/**
 * __useLogoutUserAuthMutation__
 *
 * To run a mutation, you first call `useLogoutUserAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserAuthMutation, { data, loading, error }] = useLogoutUserAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutUserAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogoutUserAuthMutation,
    LogoutUserAuthMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    LogoutUserAuthMutation,
    LogoutUserAuthMutationVariables
  >(LogoutUserAuthDocument, options);
}

export type LogoutUserAuthMutationHookResult = ReturnType<
  typeof useLogoutUserAuthMutation
>;
export type LogoutUserAuthMutationResult =
  Apollo.MutationResult<LogoutUserAuthMutation>;
export type LogoutUserAuthMutationOptions = Apollo.BaseMutationOptions<
  LogoutUserAuthMutation,
  LogoutUserAuthMutationVariables
>;
export const CreateSampleProjectDocument = gql`
  mutation CreateSampleProject($input: createSampleProjectInput!) {
    createSampleProject(input: $input) {
      project {
        teamId
        projectId
        name
        projectInfo
        shouldProjectBeUpdated
        scheduledAt
      }
    }
  }
`;
export type CreateSampleProjectMutationFn = Apollo.MutationFunction<
  CreateSampleProjectMutation,
  CreateSampleProjectMutationVariables
>;

/**
 * __useCreateSampleProjectMutation__
 *
 * To run a mutation, you first call `useCreateSampleProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSampleProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSampleProjectMutation, { data, loading, error }] = useCreateSampleProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSampleProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSampleProjectMutation,
    CreateSampleProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateSampleProjectMutation,
    CreateSampleProjectMutationVariables
  >(CreateSampleProjectDocument, options);
}

export type CreateSampleProjectMutationHookResult = ReturnType<
  typeof useCreateSampleProjectMutation
>;
export type CreateSampleProjectMutationResult =
  Apollo.MutationResult<CreateSampleProjectMutation>;
export type CreateSampleProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateSampleProjectMutation,
  CreateSampleProjectMutationVariables
>;
export const LoginSharedProjectAuthDocument = gql`
  mutation LoginSharedProjectAuth($input: loginSharedProjectAuthInput!) {
    loginSharedProjectAuth(input: $input) {
      auth {
        ...AuthTokenShared
      }
    }
  }
  ${AuthTokenSharedFragmentDoc}
`;
export type LoginSharedProjectAuthMutationFn = Apollo.MutationFunction<
  LoginSharedProjectAuthMutation,
  LoginSharedProjectAuthMutationVariables
>;

/**
 * __useLoginSharedProjectAuthMutation__
 *
 * To run a mutation, you first call `useLoginSharedProjectAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSharedProjectAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSharedProjectAuthMutation, { data, loading, error }] = useLoginSharedProjectAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginSharedProjectAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginSharedProjectAuthMutation,
    LoginSharedProjectAuthMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    LoginSharedProjectAuthMutation,
    LoginSharedProjectAuthMutationVariables
  >(LoginSharedProjectAuthDocument, options);
}

export type LoginSharedProjectAuthMutationHookResult = ReturnType<
  typeof useLoginSharedProjectAuthMutation
>;
export type LoginSharedProjectAuthMutationResult =
  Apollo.MutationResult<LoginSharedProjectAuthMutation>;
export type LoginSharedProjectAuthMutationOptions = Apollo.BaseMutationOptions<
  LoginSharedProjectAuthMutation,
  LoginSharedProjectAuthMutationVariables
>;
export const ActivateDesignProjectObjectBehaviorDocument = gql`
  mutation ActivateDesignProjectObjectBehavior(
    $input: activateDesignProjectObjectBehaviorInput!
  ) {
    activateDesignProjectObjectBehavior(input: $input) {
      projectObjectBehavior {
        projectObjectBehaviorId
        updatedAt
        usedDesigns
      }
    }
  }
`;
export type ActivateDesignProjectObjectBehaviorMutationFn =
  Apollo.MutationFunction<
    ActivateDesignProjectObjectBehaviorMutation,
    ActivateDesignProjectObjectBehaviorMutationVariables
  >;

/**
 * __useActivateDesignProjectObjectBehaviorMutation__
 *
 * To run a mutation, you first call `useActivateDesignProjectObjectBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateDesignProjectObjectBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateDesignProjectObjectBehaviorMutation, { data, loading, error }] = useActivateDesignProjectObjectBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateDesignProjectObjectBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateDesignProjectObjectBehaviorMutation,
    ActivateDesignProjectObjectBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ActivateDesignProjectObjectBehaviorMutation,
    ActivateDesignProjectObjectBehaviorMutationVariables
  >(ActivateDesignProjectObjectBehaviorDocument, options);
}

export type ActivateDesignProjectObjectBehaviorMutationHookResult = ReturnType<
  typeof useActivateDesignProjectObjectBehaviorMutation
>;
export type ActivateDesignProjectObjectBehaviorMutationResult =
  Apollo.MutationResult<ActivateDesignProjectObjectBehaviorMutation>;
export type ActivateDesignProjectObjectBehaviorMutationOptions =
  Apollo.BaseMutationOptions<
    ActivateDesignProjectObjectBehaviorMutation,
    ActivateDesignProjectObjectBehaviorMutationVariables
  >;
export const AssignDesignToProjectObjectBehaviorProjectObjectDocument = gql`
  mutation AssignDesignToProjectObjectBehaviorProjectObject(
    $input: assignDesignToProjectObjectBehaviorProjectObjectInput!
  ) {
    assignDesignToProjectObjectBehaviorProjectObject(input: $input) {
      projectObject {
        projectObjectId
        projectId
        options
        createdAt
        updatedAt
        ordering
        projectObjectBehaviors
      }
    }
  }
`;
export type AssignDesignToProjectObjectBehaviorProjectObjectMutationFn =
  Apollo.MutationFunction<
    AssignDesignToProjectObjectBehaviorProjectObjectMutation,
    AssignDesignToProjectObjectBehaviorProjectObjectMutationVariables
  >;

/**
 * __useAssignDesignToProjectObjectBehaviorProjectObjectMutation__
 *
 * To run a mutation, you first call `useAssignDesignToProjectObjectBehaviorProjectObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDesignToProjectObjectBehaviorProjectObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDesignToProjectObjectBehaviorProjectObjectMutation, { data, loading, error }] = useAssignDesignToProjectObjectBehaviorProjectObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignDesignToProjectObjectBehaviorProjectObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignDesignToProjectObjectBehaviorProjectObjectMutation,
    AssignDesignToProjectObjectBehaviorProjectObjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    AssignDesignToProjectObjectBehaviorProjectObjectMutation,
    AssignDesignToProjectObjectBehaviorProjectObjectMutationVariables
  >(AssignDesignToProjectObjectBehaviorProjectObjectDocument, options);
}

export type AssignDesignToProjectObjectBehaviorProjectObjectMutationHookResult =
  ReturnType<
    typeof useAssignDesignToProjectObjectBehaviorProjectObjectMutation
  >;
export type AssignDesignToProjectObjectBehaviorProjectObjectMutationResult =
  Apollo.MutationResult<AssignDesignToProjectObjectBehaviorProjectObjectMutation>;
export type AssignDesignToProjectObjectBehaviorProjectObjectMutationOptions =
  Apollo.BaseMutationOptions<
    AssignDesignToProjectObjectBehaviorProjectObjectMutation,
    AssignDesignToProjectObjectBehaviorProjectObjectMutationVariables
  >;
export const ChangeOrderProjectObjectBehaviorDocument = gql`
  mutation ChangeOrderProjectObjectBehavior(
    $input: changeOrderProjectObjectBehaviorInput!
  ) {
    changeOrderProjectObjectBehavior(input: $input) {
      projectObjectBehavior {
        projectObjectBehaviorId
        ordering
      }
    }
  }
`;
export type ChangeOrderProjectObjectBehaviorMutationFn =
  Apollo.MutationFunction<
    ChangeOrderProjectObjectBehaviorMutation,
    ChangeOrderProjectObjectBehaviorMutationVariables
  >;

/**
 * __useChangeOrderProjectObjectBehaviorMutation__
 *
 * To run a mutation, you first call `useChangeOrderProjectObjectBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderProjectObjectBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderProjectObjectBehaviorMutation, { data, loading, error }] = useChangeOrderProjectObjectBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeOrderProjectObjectBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeOrderProjectObjectBehaviorMutation,
    ChangeOrderProjectObjectBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ChangeOrderProjectObjectBehaviorMutation,
    ChangeOrderProjectObjectBehaviorMutationVariables
  >(ChangeOrderProjectObjectBehaviorDocument, options);
}

export type ChangeOrderProjectObjectBehaviorMutationHookResult = ReturnType<
  typeof useChangeOrderProjectObjectBehaviorMutation
>;
export type ChangeOrderProjectObjectBehaviorMutationResult =
  Apollo.MutationResult<ChangeOrderProjectObjectBehaviorMutation>;
export type ChangeOrderProjectObjectBehaviorMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeOrderProjectObjectBehaviorMutation,
    ChangeOrderProjectObjectBehaviorMutationVariables
  >;
export const DeactivateDesignProjectObjectBehaviorDocument = gql`
  mutation DeactivateDesignProjectObjectBehavior(
    $input: deactivateDesignProjectObjectBehaviorInput!
  ) {
    deactivateDesignProjectObjectBehavior(input: $input) {
      projectObjectBehavior {
        projectObjectBehaviorId
        updatedAt
        usedDesigns
      }
    }
  }
`;
export type DeactivateDesignProjectObjectBehaviorMutationFn =
  Apollo.MutationFunction<
    DeactivateDesignProjectObjectBehaviorMutation,
    DeactivateDesignProjectObjectBehaviorMutationVariables
  >;

/**
 * __useDeactivateDesignProjectObjectBehaviorMutation__
 *
 * To run a mutation, you first call `useDeactivateDesignProjectObjectBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateDesignProjectObjectBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateDesignProjectObjectBehaviorMutation, { data, loading, error }] = useDeactivateDesignProjectObjectBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateDesignProjectObjectBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateDesignProjectObjectBehaviorMutation,
    DeactivateDesignProjectObjectBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DeactivateDesignProjectObjectBehaviorMutation,
    DeactivateDesignProjectObjectBehaviorMutationVariables
  >(DeactivateDesignProjectObjectBehaviorDocument, options);
}

export type DeactivateDesignProjectObjectBehaviorMutationHookResult =
  ReturnType<typeof useDeactivateDesignProjectObjectBehaviorMutation>;
export type DeactivateDesignProjectObjectBehaviorMutationResult =
  Apollo.MutationResult<DeactivateDesignProjectObjectBehaviorMutation>;
export type DeactivateDesignProjectObjectBehaviorMutationOptions =
  Apollo.BaseMutationOptions<
    DeactivateDesignProjectObjectBehaviorMutation,
    DeactivateDesignProjectObjectBehaviorMutationVariables
  >;
export const RemoveDesignFromProjectObjectBehaviorDocument = gql`
  mutation RemoveDesignFromProjectObjectBehavior(
    $input: removeDesignFromProjectObjectBehaviorInput!
  ) {
    removeDesignFromProjectObjectBehavior(input: $input) {
      projectObjectBehavior {
        projectObjectBehaviorId
        usedDesigns
      }
    }
  }
`;
export type RemoveDesignFromProjectObjectBehaviorMutationFn =
  Apollo.MutationFunction<
    RemoveDesignFromProjectObjectBehaviorMutation,
    RemoveDesignFromProjectObjectBehaviorMutationVariables
  >;

/**
 * __useRemoveDesignFromProjectObjectBehaviorMutation__
 *
 * To run a mutation, you first call `useRemoveDesignFromProjectObjectBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDesignFromProjectObjectBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDesignFromProjectObjectBehaviorMutation, { data, loading, error }] = useRemoveDesignFromProjectObjectBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDesignFromProjectObjectBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDesignFromProjectObjectBehaviorMutation,
    RemoveDesignFromProjectObjectBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveDesignFromProjectObjectBehaviorMutation,
    RemoveDesignFromProjectObjectBehaviorMutationVariables
  >(RemoveDesignFromProjectObjectBehaviorDocument, options);
}

export type RemoveDesignFromProjectObjectBehaviorMutationHookResult =
  ReturnType<typeof useRemoveDesignFromProjectObjectBehaviorMutation>;
export type RemoveDesignFromProjectObjectBehaviorMutationResult =
  Apollo.MutationResult<RemoveDesignFromProjectObjectBehaviorMutation>;
export type RemoveDesignFromProjectObjectBehaviorMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveDesignFromProjectObjectBehaviorMutation,
    RemoveDesignFromProjectObjectBehaviorMutationVariables
  >;
export const RemoveProjectObjectBehaviorDocument = gql`
  mutation RemoveProjectObjectBehavior(
    $input: removeProjectObjectBehaviorInput!
  ) {
    removeProjectObjectBehavior(input: $input) {
      projectObjectBehavior {
        projectObjectBehaviorId
      }
    }
  }
`;
export type RemoveProjectObjectBehaviorMutationFn = Apollo.MutationFunction<
  RemoveProjectObjectBehaviorMutation,
  RemoveProjectObjectBehaviorMutationVariables
>;

/**
 * __useRemoveProjectObjectBehaviorMutation__
 *
 * To run a mutation, you first call `useRemoveProjectObjectBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectObjectBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectObjectBehaviorMutation, { data, loading, error }] = useRemoveProjectObjectBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProjectObjectBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectObjectBehaviorMutation,
    RemoveProjectObjectBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveProjectObjectBehaviorMutation,
    RemoveProjectObjectBehaviorMutationVariables
  >(RemoveProjectObjectBehaviorDocument, options);
}

export type RemoveProjectObjectBehaviorMutationHookResult = ReturnType<
  typeof useRemoveProjectObjectBehaviorMutation
>;
export type RemoveProjectObjectBehaviorMutationResult =
  Apollo.MutationResult<RemoveProjectObjectBehaviorMutation>;
export type RemoveProjectObjectBehaviorMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveProjectObjectBehaviorMutation,
    RemoveProjectObjectBehaviorMutationVariables
  >;
export const UpdateSettingsProjectObjectBehaviorDocument = gql`
  mutation UpdateSettingsProjectObjectBehavior(
    $input: updateSettingsProjectObjectBehaviorInput!
  ) {
    updateSettingsProjectObjectBehavior(input: $input) {
      projectObjectBehavior {
        projectObjectBehaviorId
        projectObjectId
        schedule
        rules
        ordering
        createdAt
        updatedAt
      }
    }
  }
`;
export type UpdateSettingsProjectObjectBehaviorMutationFn =
  Apollo.MutationFunction<
    UpdateSettingsProjectObjectBehaviorMutation,
    UpdateSettingsProjectObjectBehaviorMutationVariables
  >;

/**
 * __useUpdateSettingsProjectObjectBehaviorMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsProjectObjectBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsProjectObjectBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsProjectObjectBehaviorMutation, { data, loading, error }] = useUpdateSettingsProjectObjectBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingsProjectObjectBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSettingsProjectObjectBehaviorMutation,
    UpdateSettingsProjectObjectBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateSettingsProjectObjectBehaviorMutation,
    UpdateSettingsProjectObjectBehaviorMutationVariables
  >(UpdateSettingsProjectObjectBehaviorDocument, options);
}

export type UpdateSettingsProjectObjectBehaviorMutationHookResult = ReturnType<
  typeof useUpdateSettingsProjectObjectBehaviorMutation
>;
export type UpdateSettingsProjectObjectBehaviorMutationResult =
  Apollo.MutationResult<UpdateSettingsProjectObjectBehaviorMutation>;
export type UpdateSettingsProjectObjectBehaviorMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSettingsProjectObjectBehaviorMutation,
    UpdateSettingsProjectObjectBehaviorMutationVariables
  >;
export const ChangeOrderProjectObjectDocument = gql`
  mutation ChangeOrderProjectObject($input: changeOrderProjectObjectInput!) {
    changeOrderProjectObject(input: $input) {
      projectObject {
        projectObjectId
        projectId
        options
        createdAt
        updatedAt
        ordering
        projectObjectBehaviors
      }
    }
  }
`;
export type ChangeOrderProjectObjectMutationFn = Apollo.MutationFunction<
  ChangeOrderProjectObjectMutation,
  ChangeOrderProjectObjectMutationVariables
>;

/**
 * __useChangeOrderProjectObjectMutation__
 *
 * To run a mutation, you first call `useChangeOrderProjectObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderProjectObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderProjectObjectMutation, { data, loading, error }] = useChangeOrderProjectObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeOrderProjectObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeOrderProjectObjectMutation,
    ChangeOrderProjectObjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ChangeOrderProjectObjectMutation,
    ChangeOrderProjectObjectMutationVariables
  >(ChangeOrderProjectObjectDocument, options);
}

export type ChangeOrderProjectObjectMutationHookResult = ReturnType<
  typeof useChangeOrderProjectObjectMutation
>;
export type ChangeOrderProjectObjectMutationResult =
  Apollo.MutationResult<ChangeOrderProjectObjectMutation>;
export type ChangeOrderProjectObjectMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeOrderProjectObjectMutation,
    ChangeOrderProjectObjectMutationVariables
  >;
export const CreateProjectObjectDocument = gql`
  mutation CreateProjectObject($input: createProjectObjectInput!) {
    createProjectObject(input: $input) {
      projectObject {
        projectObjectId
        projectId
        options
        createdAt
        updatedAt
        ordering
        projectObjectBehaviors
      }
    }
  }
`;
export type CreateProjectObjectMutationFn = Apollo.MutationFunction<
  CreateProjectObjectMutation,
  CreateProjectObjectMutationVariables
>;

/**
 * __useCreateProjectObjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectObjectMutation, { data, loading, error }] = useCreateProjectObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectObjectMutation,
    CreateProjectObjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateProjectObjectMutation,
    CreateProjectObjectMutationVariables
  >(CreateProjectObjectDocument, options);
}

export type CreateProjectObjectMutationHookResult = ReturnType<
  typeof useCreateProjectObjectMutation
>;
export type CreateProjectObjectMutationResult =
  Apollo.MutationResult<CreateProjectObjectMutation>;
export type CreateProjectObjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectObjectMutation,
  CreateProjectObjectMutationVariables
>;
export const RemoveProjectObjectDocument = gql`
  mutation RemoveProjectObject($input: removeProjectObjectInput!) {
    removeProjectObject(input: $input) {
      projectObject {
        projectObjectId
      }
    }
  }
`;
export type RemoveProjectObjectMutationFn = Apollo.MutationFunction<
  RemoveProjectObjectMutation,
  RemoveProjectObjectMutationVariables
>;

/**
 * __useRemoveProjectObjectMutation__
 *
 * To run a mutation, you first call `useRemoveProjectObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectObjectMutation, { data, loading, error }] = useRemoveProjectObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProjectObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectObjectMutation,
    RemoveProjectObjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveProjectObjectMutation,
    RemoveProjectObjectMutationVariables
  >(RemoveProjectObjectDocument, options);
}

export type RemoveProjectObjectMutationHookResult = ReturnType<
  typeof useRemoveProjectObjectMutation
>;
export type RemoveProjectObjectMutationResult =
  Apollo.MutationResult<RemoveProjectObjectMutation>;
export type RemoveProjectObjectMutationOptions = Apollo.BaseMutationOptions<
  RemoveProjectObjectMutation,
  RemoveProjectObjectMutationVariables
>;
export const CancelSubscriptionDocument = gql`
  mutation CancelSubscription($input: cancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      subscription {
        subscriptionId
        planDetails
        validTo
        status
      }
    }
  }
`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<
  CancelSubscriptionMutation,
  CancelSubscriptionMutationVariables
>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelSubscriptionMutation,
    CancelSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CancelSubscriptionMutation,
    CancelSubscriptionMutationVariables
  >(CancelSubscriptionDocument, options);
}

export type CancelSubscriptionMutationHookResult = ReturnType<
  typeof useCancelSubscriptionMutation
>;
export type CancelSubscriptionMutationResult =
  Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CancelSubscriptionMutation,
  CancelSubscriptionMutationVariables
>;
export const CreateSubscriptionCheckoutSessionDocument = gql`
  mutation CreateSubscriptionCheckoutSession(
    $input: createSubscriptionCheckoutSessionInput!
  ) {
    createSubscriptionCheckoutSession(input: $input) {
      checkoutSession {
        id
        clientSecret
        status
      }
    }
  }
`;
export type CreateSubscriptionCheckoutSessionMutationFn =
  Apollo.MutationFunction<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >;

/**
 * __useCreateSubscriptionCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCheckoutSessionMutation, { data, loading, error }] = useCreateSubscriptionCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionCheckoutSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >(CreateSubscriptionCheckoutSessionDocument, options);
}

export type CreateSubscriptionCheckoutSessionMutationHookResult = ReturnType<
  typeof useCreateSubscriptionCheckoutSessionMutation
>;
export type CreateSubscriptionCheckoutSessionMutationResult =
  Apollo.MutationResult<CreateSubscriptionCheckoutSessionMutation>;
export type CreateSubscriptionCheckoutSessionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSubscriptionCheckoutSessionMutation,
    CreateSubscriptionCheckoutSessionMutationVariables
  >;
export const UpdateErrorToleranceProjectDocument = gql`
  mutation UpdateErrorToleranceProject(
    $input: updateErrorToleranceProjectInput!
  ) {
    updateErrorToleranceProject(input: $input) {
      project {
        id
        projectId
        settings
      }
    }
  }
`;
export type UpdateErrorToleranceProjectMutationFn = Apollo.MutationFunction<
  UpdateErrorToleranceProjectMutation,
  UpdateErrorToleranceProjectMutationVariables
>;

/**
 * __useUpdateErrorToleranceProjectMutation__
 *
 * To run a mutation, you first call `useUpdateErrorToleranceProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorToleranceProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorToleranceProjectMutation, { data, loading, error }] = useUpdateErrorToleranceProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateErrorToleranceProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateErrorToleranceProjectMutation,
    UpdateErrorToleranceProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateErrorToleranceProjectMutation,
    UpdateErrorToleranceProjectMutationVariables
  >(UpdateErrorToleranceProjectDocument, options);
}

export type UpdateErrorToleranceProjectMutationHookResult = ReturnType<
  typeof useUpdateErrorToleranceProjectMutation
>;
export type UpdateErrorToleranceProjectMutationResult =
  Apollo.MutationResult<UpdateErrorToleranceProjectMutation>;
export type UpdateErrorToleranceProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateErrorToleranceProjectMutation,
    UpdateErrorToleranceProjectMutationVariables
  >;
export const UpdateFeedFieldsProjectDocument = gql`
  mutation UpdateFeedFieldsProject($input: updateFeedFieldsProjectInput!) {
    updateFeedFieldsProject(input: $input) {
      project {
        id
        projectId
        settings
      }
    }
  }
`;
export type UpdateFeedFieldsProjectMutationFn = Apollo.MutationFunction<
  UpdateFeedFieldsProjectMutation,
  UpdateFeedFieldsProjectMutationVariables
>;

/**
 * __useUpdateFeedFieldsProjectMutation__
 *
 * To run a mutation, you first call `useUpdateFeedFieldsProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedFieldsProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedFieldsProjectMutation, { data, loading, error }] = useUpdateFeedFieldsProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedFieldsProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFeedFieldsProjectMutation,
    UpdateFeedFieldsProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateFeedFieldsProjectMutation,
    UpdateFeedFieldsProjectMutationVariables
  >(UpdateFeedFieldsProjectDocument, options);
}

export type UpdateFeedFieldsProjectMutationHookResult = ReturnType<
  typeof useUpdateFeedFieldsProjectMutation
>;
export type UpdateFeedFieldsProjectMutationResult =
  Apollo.MutationResult<UpdateFeedFieldsProjectMutation>;
export type UpdateFeedFieldsProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateFeedFieldsProjectMutation,
  UpdateFeedFieldsProjectMutationVariables
>;
export const UpdateNotificationEmailsProjectDocument = gql`
  mutation UpdateNotificationEmailsProject(
    $input: updateNotificationEmailsProjectInput!
  ) {
    updateNotificationEmailsProject(input: $input) {
      project {
        id
        projectId
        settings
      }
    }
  }
`;
export type UpdateNotificationEmailsProjectMutationFn = Apollo.MutationFunction<
  UpdateNotificationEmailsProjectMutation,
  UpdateNotificationEmailsProjectMutationVariables
>;

/**
 * __useUpdateNotificationEmailsProjectMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationEmailsProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationEmailsProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationEmailsProjectMutation, { data, loading, error }] = useUpdateNotificationEmailsProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationEmailsProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationEmailsProjectMutation,
    UpdateNotificationEmailsProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateNotificationEmailsProjectMutation,
    UpdateNotificationEmailsProjectMutationVariables
  >(UpdateNotificationEmailsProjectDocument, options);
}

export type UpdateNotificationEmailsProjectMutationHookResult = ReturnType<
  typeof useUpdateNotificationEmailsProjectMutation
>;
export type UpdateNotificationEmailsProjectMutationResult =
  Apollo.MutationResult<UpdateNotificationEmailsProjectMutation>;
export type UpdateNotificationEmailsProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNotificationEmailsProjectMutation,
    UpdateNotificationEmailsProjectMutationVariables
  >;
export const UpdateOverrideDataProjectDocument = gql`
  mutation UpdateOverrideDataProject($input: updateOverrideDataProjectInput!) {
    updateOverrideDataProject(input: $input) {
      project {
        id
        projectId
        settings
      }
    }
  }
`;
export type UpdateOverrideDataProjectMutationFn = Apollo.MutationFunction<
  UpdateOverrideDataProjectMutation,
  UpdateOverrideDataProjectMutationVariables
>;

/**
 * __useUpdateOverrideDataProjectMutation__
 *
 * To run a mutation, you first call `useUpdateOverrideDataProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOverrideDataProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOverrideDataProjectMutation, { data, loading, error }] = useUpdateOverrideDataProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOverrideDataProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOverrideDataProjectMutation,
    UpdateOverrideDataProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateOverrideDataProjectMutation,
    UpdateOverrideDataProjectMutationVariables
  >(UpdateOverrideDataProjectDocument, options);
}

export type UpdateOverrideDataProjectMutationHookResult = ReturnType<
  typeof useUpdateOverrideDataProjectMutation
>;
export type UpdateOverrideDataProjectMutationResult =
  Apollo.MutationResult<UpdateOverrideDataProjectMutation>;
export type UpdateOverrideDataProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOverrideDataProjectMutation,
    UpdateOverrideDataProjectMutationVariables
  >;
export const UpdateScheduleFrequencyProjectDocument = gql`
  mutation UpdateScheduleFrequencyProject(
    $input: updateScheduleFrequencyProjectInput!
  ) {
    updateScheduleFrequencyProject(input: $input) {
      project {
        projectId
        settings
      }
    }
  }
`;
export type UpdateScheduleFrequencyProjectMutationFn = Apollo.MutationFunction<
  UpdateScheduleFrequencyProjectMutation,
  UpdateScheduleFrequencyProjectMutationVariables
>;

/**
 * __useUpdateScheduleFrequencyProjectMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleFrequencyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleFrequencyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleFrequencyProjectMutation, { data, loading, error }] = useUpdateScheduleFrequencyProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleFrequencyProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScheduleFrequencyProjectMutation,
    UpdateScheduleFrequencyProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateScheduleFrequencyProjectMutation,
    UpdateScheduleFrequencyProjectMutationVariables
  >(UpdateScheduleFrequencyProjectDocument, options);
}

export type UpdateScheduleFrequencyProjectMutationHookResult = ReturnType<
  typeof useUpdateScheduleFrequencyProjectMutation
>;
export type UpdateScheduleFrequencyProjectMutationResult =
  Apollo.MutationResult<UpdateScheduleFrequencyProjectMutation>;
export type UpdateScheduleFrequencyProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateScheduleFrequencyProjectMutation,
    UpdateScheduleFrequencyProjectMutationVariables
  >;
export const UpdateShareSettingsProjectDocument = gql`
  mutation UpdateShareSettingsProject(
    $input: updateShareSettingsProjectInput!
  ) {
    updateShareSettingsProject(input: $input) {
      project {
        projectId
        settings
      }
    }
  }
`;
export type UpdateShareSettingsProjectMutationFn = Apollo.MutationFunction<
  UpdateShareSettingsProjectMutation,
  UpdateShareSettingsProjectMutationVariables
>;

/**
 * __useUpdateShareSettingsProjectMutation__
 *
 * To run a mutation, you first call `useUpdateShareSettingsProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareSettingsProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareSettingsProjectMutation, { data, loading, error }] = useUpdateShareSettingsProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareSettingsProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateShareSettingsProjectMutation,
    UpdateShareSettingsProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateShareSettingsProjectMutation,
    UpdateShareSettingsProjectMutationVariables
  >(UpdateShareSettingsProjectDocument, options);
}

export type UpdateShareSettingsProjectMutationHookResult = ReturnType<
  typeof useUpdateShareSettingsProjectMutation
>;
export type UpdateShareSettingsProjectMutationResult =
  Apollo.MutationResult<UpdateShareSettingsProjectMutation>;
export type UpdateShareSettingsProjectMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateShareSettingsProjectMutation,
    UpdateShareSettingsProjectMutationVariables
  >;
export const RefreshSessionTokenDocument = gql`
  mutation RefreshSessionToken($input: refreshSessionTokenInput!) {
    refreshSessionToken(input: $input) {
      sessionToken {
        id
        _id
        token
        refreshToken
        refreshTokenExpiresAt
      }
      clientMutationId
    }
  }
`;
export type RefreshSessionTokenMutationFn = Apollo.MutationFunction<
  RefreshSessionTokenMutation,
  RefreshSessionTokenMutationVariables
>;

/**
 * __useRefreshSessionTokenMutation__
 *
 * To run a mutation, you first call `useRefreshSessionTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSessionTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSessionTokenMutation, { data, loading, error }] = useRefreshSessionTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshSessionTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshSessionTokenMutation,
    RefreshSessionTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RefreshSessionTokenMutation,
    RefreshSessionTokenMutationVariables
  >(RefreshSessionTokenDocument, options);
}

export type RefreshSessionTokenMutationHookResult = ReturnType<
  typeof useRefreshSessionTokenMutation
>;
export type RefreshSessionTokenMutationResult =
  Apollo.MutationResult<RefreshSessionTokenMutation>;
export type RefreshSessionTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshSessionTokenMutation,
  RefreshSessionTokenMutationVariables
>;
export const RegisterTeamInvitationConfirmationDocument = gql`
  mutation RegisterTeamInvitationConfirmation(
    $input: registerTeamInvitationConfirmationInput!
  ) {
    registerTeamInvitationConfirmation(input: $input) {
      confirmation {
        id
        token
        refreshToken
        refreshTokenExpiresAt
      }
    }
  }
`;
export type RegisterTeamInvitationConfirmationMutationFn =
  Apollo.MutationFunction<
    RegisterTeamInvitationConfirmationMutation,
    RegisterTeamInvitationConfirmationMutationVariables
  >;

/**
 * __useRegisterTeamInvitationConfirmationMutation__
 *
 * To run a mutation, you first call `useRegisterTeamInvitationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterTeamInvitationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerTeamInvitationConfirmationMutation, { data, loading, error }] = useRegisterTeamInvitationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterTeamInvitationConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterTeamInvitationConfirmationMutation,
    RegisterTeamInvitationConfirmationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RegisterTeamInvitationConfirmationMutation,
    RegisterTeamInvitationConfirmationMutationVariables
  >(RegisterTeamInvitationConfirmationDocument, options);
}

export type RegisterTeamInvitationConfirmationMutationHookResult = ReturnType<
  typeof useRegisterTeamInvitationConfirmationMutation
>;
export type RegisterTeamInvitationConfirmationMutationResult =
  Apollo.MutationResult<RegisterTeamInvitationConfirmationMutation>;
export type RegisterTeamInvitationConfirmationMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterTeamInvitationConfirmationMutation,
    RegisterTeamInvitationConfirmationMutationVariables
  >;
export const RegisterUserDocument = gql`
  mutation RegisterUser($input: registerUserInput!) {
    registerUser(input: $input) {
      user {
        id
        _id
        token
        refreshToken
        refreshTokenExpiresAt
      }
    }
  }
`;
export type RegisterUserMutationFn = Apollo.MutationFunction<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterUserMutation,
    RegisterUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RegisterUserMutation,
    RegisterUserMutationVariables
  >(RegisterUserDocument, options);
}

export type RegisterUserMutationHookResult = ReturnType<
  typeof useRegisterUserMutation
>;
export type RegisterUserMutationResult =
  Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;
export const RemoveAssetImageDocument = gql`
  mutation RemoveAssetImage($input: removeAssetImageInput!) {
    removeAssetImage(input: $input) {
      assetImage {
        id
        assetImageId
      }
    }
  }
`;
export type RemoveAssetImageMutationFn = Apollo.MutationFunction<
  RemoveAssetImageMutation,
  RemoveAssetImageMutationVariables
>;

/**
 * __useRemoveAssetImageMutation__
 *
 * To run a mutation, you first call `useRemoveAssetImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssetImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssetImageMutation, { data, loading, error }] = useRemoveAssetImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAssetImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAssetImageMutation,
    RemoveAssetImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveAssetImageMutation,
    RemoveAssetImageMutationVariables
  >(RemoveAssetImageDocument, options);
}

export type RemoveAssetImageMutationHookResult = ReturnType<
  typeof useRemoveAssetImageMutation
>;
export type RemoveAssetImageMutationResult =
  Apollo.MutationResult<RemoveAssetImageMutation>;
export type RemoveAssetImageMutationOptions = Apollo.BaseMutationOptions<
  RemoveAssetImageMutation,
  RemoveAssetImageMutationVariables
>;
export const RemoveDesignDocument = gql`
  mutation RemoveDesign($input: removeDesignInput!) {
    removeDesign(input: $input) {
      design {
        id
        designId
      }
    }
  }
`;
export type RemoveDesignMutationFn = Apollo.MutationFunction<
  RemoveDesignMutation,
  RemoveDesignMutationVariables
>;

/**
 * __useRemoveDesignMutation__
 *
 * To run a mutation, you first call `useRemoveDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDesignMutation, { data, loading, error }] = useRemoveDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDesignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDesignMutation,
    RemoveDesignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveDesignMutation,
    RemoveDesignMutationVariables
  >(RemoveDesignDocument, options);
}

export type RemoveDesignMutationHookResult = ReturnType<
  typeof useRemoveDesignMutation
>;
export type RemoveDesignMutationResult =
  Apollo.MutationResult<RemoveDesignMutation>;
export type RemoveDesignMutationOptions = Apollo.BaseMutationOptions<
  RemoveDesignMutation,
  RemoveDesignMutationVariables
>;
export const RemoveFavouriteTemplateDocument = gql`
  mutation RemoveFavouriteTemplate($input: removeFavouriteTemplateInput!) {
    removeFavouriteTemplate(input: $input) {
      template {
        id
        templateId
        isFavourite
      }
    }
  }
`;
export type RemoveFavouriteTemplateMutationFn = Apollo.MutationFunction<
  RemoveFavouriteTemplateMutation,
  RemoveFavouriteTemplateMutationVariables
>;

/**
 * __useRemoveFavouriteTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveFavouriteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavouriteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavouriteTemplateMutation, { data, loading, error }] = useRemoveFavouriteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFavouriteTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFavouriteTemplateMutation,
    RemoveFavouriteTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveFavouriteTemplateMutation,
    RemoveFavouriteTemplateMutationVariables
  >(RemoveFavouriteTemplateDocument, options);
}

export type RemoveFavouriteTemplateMutationHookResult = ReturnType<
  typeof useRemoveFavouriteTemplateMutation
>;
export type RemoveFavouriteTemplateMutationResult =
  Apollo.MutationResult<RemoveFavouriteTemplateMutation>;
export type RemoveFavouriteTemplateMutationOptions = Apollo.BaseMutationOptions<
  RemoveFavouriteTemplateMutation,
  RemoveFavouriteTemplateMutationVariables
>;
export const RemoveFontDocument = gql`
  mutation RemoveFont($input: removeFontInput!) {
    removeFont(input: $input) {
      font {
        id
      }
    }
  }
`;
export type RemoveFontMutationFn = Apollo.MutationFunction<
  RemoveFontMutation,
  RemoveFontMutationVariables
>;

/**
 * __useRemoveFontMutation__
 *
 * To run a mutation, you first call `useRemoveFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFontMutation, { data, loading, error }] = useRemoveFontMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFontMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFontMutation,
    RemoveFontMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<RemoveFontMutation, RemoveFontMutationVariables>(
    RemoveFontDocument,
    options,
  );
}

export type RemoveFontMutationHookResult = ReturnType<
  typeof useRemoveFontMutation
>;
export type RemoveFontMutationResult =
  Apollo.MutationResult<RemoveFontMutation>;
export type RemoveFontMutationOptions = Apollo.BaseMutationOptions<
  RemoveFontMutation,
  RemoveFontMutationVariables
>;
export const RemoveLogoDocument = gql`
  mutation RemoveLogo($input: removeLogoInput!) {
    removeLogo(input: $input) {
      logo {
        id
        logoId
      }
    }
  }
`;
export type RemoveLogoMutationFn = Apollo.MutationFunction<
  RemoveLogoMutation,
  RemoveLogoMutationVariables
>;

/**
 * __useRemoveLogoMutation__
 *
 * To run a mutation, you first call `useRemoveLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLogoMutation, { data, loading, error }] = useRemoveLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveLogoMutation,
    RemoveLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<RemoveLogoMutation, RemoveLogoMutationVariables>(
    RemoveLogoDocument,
    options,
  );
}

export type RemoveLogoMutationHookResult = ReturnType<
  typeof useRemoveLogoMutation
>;
export type RemoveLogoMutationResult =
  Apollo.MutationResult<RemoveLogoMutation>;
export type RemoveLogoMutationOptions = Apollo.BaseMutationOptions<
  RemoveLogoMutation,
  RemoveLogoMutationVariables
>;
export const RemoveProjectDocument = gql`
  mutation RemoveProject($input: removeProjectInput!) {
    removeProject(input: $input) {
      project {
        id
        projectId
      }
    }
  }
`;
export type RemoveProjectMutationFn = Apollo.MutationFunction<
  RemoveProjectMutation,
  RemoveProjectMutationVariables
>;

/**
 * __useRemoveProjectMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMutation, { data, loading, error }] = useRemoveProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectMutation,
    RemoveProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveProjectMutation,
    RemoveProjectMutationVariables
  >(RemoveProjectDocument, options);
}

export type RemoveProjectMutationHookResult = ReturnType<
  typeof useRemoveProjectMutation
>;
export type RemoveProjectMutationResult =
  Apollo.MutationResult<RemoveProjectMutation>;
export type RemoveProjectMutationOptions = Apollo.BaseMutationOptions<
  RemoveProjectMutation,
  RemoveProjectMutationVariables
>;
export const RemoveTeamDocument = gql`
  mutation RemoveTeam($input: removeTeamInput!) {
    removeTeam(input: $input) {
      team {
        id
        teamId
      }
    }
  }
`;
export type RemoveTeamMutationFn = Apollo.MutationFunction<
  RemoveTeamMutation,
  RemoveTeamMutationVariables
>;

/**
 * __useRemoveTeamMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMutation, { data, loading, error }] = useRemoveTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamMutation,
    RemoveTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<RemoveTeamMutation, RemoveTeamMutationVariables>(
    RemoveTeamDocument,
    options,
  );
}

export type RemoveTeamMutationHookResult = ReturnType<
  typeof useRemoveTeamMutation
>;
export type RemoveTeamMutationResult =
  Apollo.MutationResult<RemoveTeamMutation>;
export type RemoveTeamMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamMutation,
  RemoveTeamMutationVariables
>;
export const RemoveTeamInvitationDocument = gql`
  mutation RemoveTeamInvitation($input: removeTeamInvitationInput!) {
    removeTeamInvitation(input: $input) {
      clientMutationId
    }
  }
`;
export type RemoveTeamInvitationMutationFn = Apollo.MutationFunction<
  RemoveTeamInvitationMutation,
  RemoveTeamInvitationMutationVariables
>;

/**
 * __useRemoveTeamInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamInvitationMutation, { data, loading, error }] = useRemoveTeamInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamInvitationMutation,
    RemoveTeamInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveTeamInvitationMutation,
    RemoveTeamInvitationMutationVariables
  >(RemoveTeamInvitationDocument, options);
}

export type RemoveTeamInvitationMutationHookResult = ReturnType<
  typeof useRemoveTeamInvitationMutation
>;
export type RemoveTeamInvitationMutationResult =
  Apollo.MutationResult<RemoveTeamInvitationMutation>;
export type RemoveTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamInvitationMutation,
  RemoveTeamInvitationMutationVariables
>;
export const RemoveProjectTokenDocument = gql`
  mutation RemoveProjectToken($input: removeProjectTokenInput!) {
    removeProjectToken(input: $input) {
      projectToken {
        id
        value
        updatedAt
      }
    }
  }
`;
export type RemoveProjectTokenMutationFn = Apollo.MutationFunction<
  RemoveProjectTokenMutation,
  RemoveProjectTokenMutationVariables
>;

/**
 * __useRemoveProjectTokenMutation__
 *
 * To run a mutation, you first call `useRemoveProjectTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectTokenMutation, { data, loading, error }] = useRemoveProjectTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProjectTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectTokenMutation,
    RemoveProjectTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveProjectTokenMutation,
    RemoveProjectTokenMutationVariables
  >(RemoveProjectTokenDocument, options);
}

export type RemoveProjectTokenMutationHookResult = ReturnType<
  typeof useRemoveProjectTokenMutation
>;
export type RemoveProjectTokenMutationResult =
  Apollo.MutationResult<RemoveProjectTokenMutation>;
export type RemoveProjectTokenMutationOptions = Apollo.BaseMutationOptions<
  RemoveProjectTokenMutation,
  RemoveProjectTokenMutationVariables
>;
export const RemoveUserDocument = gql`
  mutation RemoveUser {
    removeUser(input: {}) {
      user {
        id
      }
      clientMutationId
    }
  }
`;
export type RemoveUserMutationFn = Apollo.MutationFunction<
  RemoveUserMutation,
  RemoveUserMutationVariables
>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUserMutation,
    RemoveUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(
    RemoveUserDocument,
    options,
  );
}

export type RemoveUserMutationHookResult = ReturnType<
  typeof useRemoveUserMutation
>;
export type RemoveUserMutationResult =
  Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveUserMutation,
  RemoveUserMutationVariables
>;
export const CreateStyleDocument = gql`
  mutation CreateStyle($input: createStyleInput!) {
    createStyle(input: $input) {
      style {
        id
        styleId
        definition
        name
        type
      }
    }
  }
`;
export type CreateStyleMutationFn = Apollo.MutationFunction<
  CreateStyleMutation,
  CreateStyleMutationVariables
>;

/**
 * __useCreateStyleMutation__
 *
 * To run a mutation, you first call `useCreateStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStyleMutation, { data, loading, error }] = useCreateStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStyleMutation,
    CreateStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateStyleMutation, CreateStyleMutationVariables>(
    CreateStyleDocument,
    options,
  );
}

export type CreateStyleMutationHookResult = ReturnType<
  typeof useCreateStyleMutation
>;
export type CreateStyleMutationResult =
  Apollo.MutationResult<CreateStyleMutation>;
export type CreateStyleMutationOptions = Apollo.BaseMutationOptions<
  CreateStyleMutation,
  CreateStyleMutationVariables
>;
export const RemoveStyleDocument = gql`
  mutation RemoveStyle($input: removeStyleInput!) {
    removeStyle(input: $input) {
      style {
        id
        styleId
      }
    }
  }
`;
export type RemoveStyleMutationFn = Apollo.MutationFunction<
  RemoveStyleMutation,
  RemoveStyleMutationVariables
>;

/**
 * __useRemoveStyleMutation__
 *
 * To run a mutation, you first call `useRemoveStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStyleMutation, { data, loading, error }] = useRemoveStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveStyleMutation,
    RemoveStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<RemoveStyleMutation, RemoveStyleMutationVariables>(
    RemoveStyleDocument,
    options,
  );
}

export type RemoveStyleMutationHookResult = ReturnType<
  typeof useRemoveStyleMutation
>;
export type RemoveStyleMutationResult =
  Apollo.MutationResult<RemoveStyleMutation>;
export type RemoveStyleMutationOptions = Apollo.BaseMutationOptions<
  RemoveStyleMutation,
  RemoveStyleMutationVariables
>;
export const UpdateDefinitionStyleDocument = gql`
  mutation UpdateDefinitionStyle($input: updateDefinitionStyleInput!) {
    updateDefinitionStyle(input: $input) {
      style {
        id
        styleId
        definition
        name
        type
      }
    }
  }
`;
export type UpdateDefinitionStyleMutationFn = Apollo.MutationFunction<
  UpdateDefinitionStyleMutation,
  UpdateDefinitionStyleMutationVariables
>;

/**
 * __useUpdateDefinitionStyleMutation__
 *
 * To run a mutation, you first call `useUpdateDefinitionStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefinitionStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefinitionStyleMutation, { data, loading, error }] = useUpdateDefinitionStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDefinitionStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDefinitionStyleMutation,
    UpdateDefinitionStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateDefinitionStyleMutation,
    UpdateDefinitionStyleMutationVariables
  >(UpdateDefinitionStyleDocument, options);
}

export type UpdateDefinitionStyleMutationHookResult = ReturnType<
  typeof useUpdateDefinitionStyleMutation
>;
export type UpdateDefinitionStyleMutationResult =
  Apollo.MutationResult<UpdateDefinitionStyleMutation>;
export type UpdateDefinitionStyleMutationOptions = Apollo.BaseMutationOptions<
  UpdateDefinitionStyleMutation,
  UpdateDefinitionStyleMutationVariables
>;
export const UpdateTeamStyleDocument = gql`
  mutation UpdateTeamStyle($input: updateTeamStyleInput!) {
    updateTeamStyle(input: $input) {
      style {
        id
        styleId
        definition
        name
        type
      }
    }
  }
`;
export type UpdateTeamStyleMutationFn = Apollo.MutationFunction<
  UpdateTeamStyleMutation,
  UpdateTeamStyleMutationVariables
>;

/**
 * __useUpdateTeamStyleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamStyleMutation, { data, loading, error }] = useUpdateTeamStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamStyleMutation,
    UpdateTeamStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateTeamStyleMutation,
    UpdateTeamStyleMutationVariables
  >(UpdateTeamStyleDocument, options);
}

export type UpdateTeamStyleMutationHookResult = ReturnType<
  typeof useUpdateTeamStyleMutation
>;
export type UpdateTeamStyleMutationResult =
  Apollo.MutationResult<UpdateTeamStyleMutation>;
export type UpdateTeamStyleMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamStyleMutation,
  UpdateTeamStyleMutationVariables
>;
export const TransferOwnershipTeamDocument = gql`
  mutation TransferOwnershipTeam($input: transferOwnershipTeamInput!) {
    transferOwnershipTeam(input: $input) {
      team {
        teamId
        name
        active
        projects
        owner
      }
    }
  }
`;
export type TransferOwnershipTeamMutationFn = Apollo.MutationFunction<
  TransferOwnershipTeamMutation,
  TransferOwnershipTeamMutationVariables
>;

/**
 * __useTransferOwnershipTeamMutation__
 *
 * To run a mutation, you first call `useTransferOwnershipTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferOwnershipTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferOwnershipTeamMutation, { data, loading, error }] = useTransferOwnershipTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferOwnershipTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransferOwnershipTeamMutation,
    TransferOwnershipTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    TransferOwnershipTeamMutation,
    TransferOwnershipTeamMutationVariables
  >(TransferOwnershipTeamDocument, options);
}

export type TransferOwnershipTeamMutationHookResult = ReturnType<
  typeof useTransferOwnershipTeamMutation
>;
export type TransferOwnershipTeamMutationResult =
  Apollo.MutationResult<TransferOwnershipTeamMutation>;
export type TransferOwnershipTeamMutationOptions = Apollo.BaseMutationOptions<
  TransferOwnershipTeamMutation,
  TransferOwnershipTeamMutationVariables
>;
export const UnassignUserTeamDocument = gql`
  mutation UnassignUserTeam($input: unassignUserTeamInput!) {
    unassignUserTeam(input: $input) {
      team {
        id
        teamId
        members
      }
    }
  }
`;
export type UnassignUserTeamMutationFn = Apollo.MutationFunction<
  UnassignUserTeamMutation,
  UnassignUserTeamMutationVariables
>;

/**
 * __useUnassignUserTeamMutation__
 *
 * To run a mutation, you first call `useUnassignUserTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignUserTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignUserTeamMutation, { data, loading, error }] = useUnassignUserTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignUserTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignUserTeamMutation,
    UnassignUserTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UnassignUserTeamMutation,
    UnassignUserTeamMutationVariables
  >(UnassignUserTeamDocument, options);
}

export type UnassignUserTeamMutationHookResult = ReturnType<
  typeof useUnassignUserTeamMutation
>;
export type UnassignUserTeamMutationResult =
  Apollo.MutationResult<UnassignUserTeamMutation>;
export type UnassignUserTeamMutationOptions = Apollo.BaseMutationOptions<
  UnassignUserTeamMutation,
  UnassignUserTeamMutationVariables
>;
export const CreateTeamTokenDocument = gql`
  mutation CreateTeamToken($input: createTeamTokenInput!) {
    createTeamToken(input: $input) {
      teamToken {
        id
        teamTokenId
        name
        value
        createdAt
        updatedAt
        lastLoginAt
      }
    }
  }
`;
export type CreateTeamTokenMutationFn = Apollo.MutationFunction<
  CreateTeamTokenMutation,
  CreateTeamTokenMutationVariables
>;

/**
 * __useCreateTeamTokenMutation__
 *
 * To run a mutation, you first call `useCreateTeamTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamTokenMutation, { data, loading, error }] = useCreateTeamTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamTokenMutation,
    CreateTeamTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateTeamTokenMutation,
    CreateTeamTokenMutationVariables
  >(CreateTeamTokenDocument, options);
}

export type CreateTeamTokenMutationHookResult = ReturnType<
  typeof useCreateTeamTokenMutation
>;
export type CreateTeamTokenMutationResult =
  Apollo.MutationResult<CreateTeamTokenMutation>;
export type CreateTeamTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamTokenMutation,
  CreateTeamTokenMutationVariables
>;
export const RemoveTeamTokenDocument = gql`
  mutation RemoveTeamToken($input: removeTeamTokenInput!) {
    removeTeamToken(input: $input) {
      teamToken {
        id
      }
    }
  }
`;
export type RemoveTeamTokenMutationFn = Apollo.MutationFunction<
  RemoveTeamTokenMutation,
  RemoveTeamTokenMutationVariables
>;

/**
 * __useRemoveTeamTokenMutation__
 *
 * To run a mutation, you first call `useRemoveTeamTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamTokenMutation, { data, loading, error }] = useRemoveTeamTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamTokenMutation,
    RemoveTeamTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RemoveTeamTokenMutation,
    RemoveTeamTokenMutationVariables
  >(RemoveTeamTokenDocument, options);
}

export type RemoveTeamTokenMutationHookResult = ReturnType<
  typeof useRemoveTeamTokenMutation
>;
export type RemoveTeamTokenMutationResult =
  Apollo.MutationResult<RemoveTeamTokenMutation>;
export type RemoveTeamTokenMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamTokenMutation,
  RemoveTeamTokenMutationVariables
>;
export const CreateObjectPreviewFromTemplateObjectDocument = gql`
  mutation CreateObjectPreviewFromTemplateObject(
    $input: createObjectPreviewFromTemplateObjectInput!
  ) {
    createObjectPreviewFromTemplateObject(input: $input) {
      object {
        id
        objectId
        message
        resolvedManageableLayers
        resolvedManageableLayersConditions
      }
    }
  }
`;
export type CreateObjectPreviewFromTemplateObjectMutationFn =
  Apollo.MutationFunction<
    CreateObjectPreviewFromTemplateObjectMutation,
    CreateObjectPreviewFromTemplateObjectMutationVariables
  >;

/**
 * __useCreateObjectPreviewFromTemplateObjectMutation__
 *
 * To run a mutation, you first call `useCreateObjectPreviewFromTemplateObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectPreviewFromTemplateObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectPreviewFromTemplateObjectMutation, { data, loading, error }] = useCreateObjectPreviewFromTemplateObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObjectPreviewFromTemplateObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateObjectPreviewFromTemplateObjectMutation,
    CreateObjectPreviewFromTemplateObjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    CreateObjectPreviewFromTemplateObjectMutation,
    CreateObjectPreviewFromTemplateObjectMutationVariables
  >(CreateObjectPreviewFromTemplateObjectDocument, options);
}

export type CreateObjectPreviewFromTemplateObjectMutationHookResult =
  ReturnType<typeof useCreateObjectPreviewFromTemplateObjectMutation>;
export type CreateObjectPreviewFromTemplateObjectMutationResult =
  Apollo.MutationResult<CreateObjectPreviewFromTemplateObjectMutation>;
export type CreateObjectPreviewFromTemplateObjectMutationOptions =
  Apollo.BaseMutationOptions<
    CreateObjectPreviewFromTemplateObjectMutation,
    CreateObjectPreviewFromTemplateObjectMutationVariables
  >;
export const UnassignDefaultLogoDocument = gql`
  mutation UnassignDefaultLogo($input: unassignDefaultLogoInput!) {
    unassignDefaultLogo(input: $input) {
      logo {
        id
        logoId
      }
    }
  }
`;
export type UnassignDefaultLogoMutationFn = Apollo.MutationFunction<
  UnassignDefaultLogoMutation,
  UnassignDefaultLogoMutationVariables
>;

/**
 * __useUnassignDefaultLogoMutation__
 *
 * To run a mutation, you first call `useUnassignDefaultLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignDefaultLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignDefaultLogoMutation, { data, loading, error }] = useUnassignDefaultLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignDefaultLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignDefaultLogoMutation,
    UnassignDefaultLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UnassignDefaultLogoMutation,
    UnassignDefaultLogoMutationVariables
  >(UnassignDefaultLogoDocument, options);
}

export type UnassignDefaultLogoMutationHookResult = ReturnType<
  typeof useUnassignDefaultLogoMutation
>;
export type UnassignDefaultLogoMutationResult =
  Apollo.MutationResult<UnassignDefaultLogoMutation>;
export type UnassignDefaultLogoMutationOptions = Apollo.BaseMutationOptions<
  UnassignDefaultLogoMutation,
  UnassignDefaultLogoMutationVariables
>;
export const UpdateCodeSettingsAdminTemplateDocument = gql`
  mutation UpdateCodeSettingsAdminTemplate(
    $input: updateCodeSettingsAdminTemplateInput!
  ) {
    updateCodeSettingsAdminTemplate(input: $input) {
      adminTemplate {
        id
        templateId
        manageableLayersSettings
      }
    }
  }
`;
export type UpdateCodeSettingsAdminTemplateMutationFn = Apollo.MutationFunction<
  UpdateCodeSettingsAdminTemplateMutation,
  UpdateCodeSettingsAdminTemplateMutationVariables
>;

/**
 * __useUpdateCodeSettingsAdminTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateCodeSettingsAdminTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCodeSettingsAdminTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCodeSettingsAdminTemplateMutation, { data, loading, error }] = useUpdateCodeSettingsAdminTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCodeSettingsAdminTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCodeSettingsAdminTemplateMutation,
    UpdateCodeSettingsAdminTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateCodeSettingsAdminTemplateMutation,
    UpdateCodeSettingsAdminTemplateMutationVariables
  >(UpdateCodeSettingsAdminTemplateDocument, options);
}

export type UpdateCodeSettingsAdminTemplateMutationHookResult = ReturnType<
  typeof useUpdateCodeSettingsAdminTemplateMutation
>;
export type UpdateCodeSettingsAdminTemplateMutationResult =
  Apollo.MutationResult<UpdateCodeSettingsAdminTemplateMutation>;
export type UpdateCodeSettingsAdminTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCodeSettingsAdminTemplateMutation,
    UpdateCodeSettingsAdminTemplateMutationVariables
  >;
export const UpdateCodeSettingsDesignDocument = gql`
  mutation UpdateCodeSettingsDesign($input: updateCodeSettingsDesignInput!) {
    updateCodeSettingsDesign(input: $input) {
      design {
        id
        designId
        customStyle
        manageableLayersSettings
      }
    }
  }
`;
export type UpdateCodeSettingsDesignMutationFn = Apollo.MutationFunction<
  UpdateCodeSettingsDesignMutation,
  UpdateCodeSettingsDesignMutationVariables
>;

/**
 * __useUpdateCodeSettingsDesignMutation__
 *
 * To run a mutation, you first call `useUpdateCodeSettingsDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCodeSettingsDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCodeSettingsDesignMutation, { data, loading, error }] = useUpdateCodeSettingsDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCodeSettingsDesignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCodeSettingsDesignMutation,
    UpdateCodeSettingsDesignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateCodeSettingsDesignMutation,
    UpdateCodeSettingsDesignMutationVariables
  >(UpdateCodeSettingsDesignDocument, options);
}

export type UpdateCodeSettingsDesignMutationHookResult = ReturnType<
  typeof useUpdateCodeSettingsDesignMutation
>;
export type UpdateCodeSettingsDesignMutationResult =
  Apollo.MutationResult<UpdateCodeSettingsDesignMutation>;
export type UpdateCodeSettingsDesignMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCodeSettingsDesignMutation,
    UpdateCodeSettingsDesignMutationVariables
  >;
export const UpdateFeedForceProjectDocument = gql`
  mutation UpdateFeedForceProject($input: forceFeedProjectInput!) {
    forceFeedProject(input: $input) {
      project {
        id
        projectId
        feed
        projectInfo
        shouldProjectBeUpdated
        currentUpdate
      }
    }
  }
`;
export type UpdateFeedForceProjectMutationFn = Apollo.MutationFunction<
  UpdateFeedForceProjectMutation,
  UpdateFeedForceProjectMutationVariables
>;

/**
 * __useUpdateFeedForceProjectMutation__
 *
 * To run a mutation, you first call `useUpdateFeedForceProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedForceProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedForceProjectMutation, { data, loading, error }] = useUpdateFeedForceProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedForceProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFeedForceProjectMutation,
    UpdateFeedForceProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateFeedForceProjectMutation,
    UpdateFeedForceProjectMutationVariables
  >(UpdateFeedForceProjectDocument, options);
}

export type UpdateFeedForceProjectMutationHookResult = ReturnType<
  typeof useUpdateFeedForceProjectMutation
>;
export type UpdateFeedForceProjectMutationResult =
  Apollo.MutationResult<UpdateFeedForceProjectMutation>;
export type UpdateFeedForceProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateFeedForceProjectMutation,
  UpdateFeedForceProjectMutationVariables
>;
export const UpdateFeedProjectDocument = gql`
  mutation UpdateFeedProject($input: updateFeedProjectInput!) {
    updateFeedProject(input: $input) {
      project {
        id
        projectId
        feed
        currentUpdate
      }
    }
  }
`;
export type UpdateFeedProjectMutationFn = Apollo.MutationFunction<
  UpdateFeedProjectMutation,
  UpdateFeedProjectMutationVariables
>;

/**
 * __useUpdateFeedProjectMutation__
 *
 * To run a mutation, you first call `useUpdateFeedProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedProjectMutation, { data, loading, error }] = useUpdateFeedProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFeedProjectMutation,
    UpdateFeedProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateFeedProjectMutation,
    UpdateFeedProjectMutationVariables
  >(UpdateFeedProjectDocument, options);
}

export type UpdateFeedProjectMutationHookResult = ReturnType<
  typeof useUpdateFeedProjectMutation
>;
export type UpdateFeedProjectMutationResult =
  Apollo.MutationResult<UpdateFeedProjectMutation>;
export type UpdateFeedProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateFeedProjectMutation,
  UpdateFeedProjectMutationVariables
>;
export const UpdateProjectDocument = gql`
  mutation UpdateProject($input: updateProjectInput!) {
    updateProject(input: $input) {
      project {
        id
        projectId
        name
        teamId
        createdAt
        updatedAt
        lastUpdateId
        currentUpdateId
        feed
        status
        projectTokens
      }
    }
  }
`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >(UpdateProjectDocument, options);
}

export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>;
export type UpdateProjectMutationResult =
  Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;
export const UpdateSettingsDesignDocument = gql`
  mutation UpdateSettingsDesign($input: updateSettingsDesignInput!) {
    updateSettingsDesign(input: $input) {
      design {
        id
        designId
        name
        updatedAt
      }
    }
  }
`;
export type UpdateSettingsDesignMutationFn = Apollo.MutationFunction<
  UpdateSettingsDesignMutation,
  UpdateSettingsDesignMutationVariables
>;

/**
 * __useUpdateSettingsDesignMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsDesignMutation, { data, loading, error }] = useUpdateSettingsDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingsDesignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSettingsDesignMutation,
    UpdateSettingsDesignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateSettingsDesignMutation,
    UpdateSettingsDesignMutationVariables
  >(UpdateSettingsDesignDocument, options);
}

export type UpdateSettingsDesignMutationHookResult = ReturnType<
  typeof useUpdateSettingsDesignMutation
>;
export type UpdateSettingsDesignMutationResult =
  Apollo.MutationResult<UpdateSettingsDesignMutation>;
export type UpdateSettingsDesignMutationOptions = Apollo.BaseMutationOptions<
  UpdateSettingsDesignMutation,
  UpdateSettingsDesignMutationVariables
>;
export const UpdateTeamDocument = gql`
  mutation UpdateTeam($input: updateTeamInput!) {
    updateTeam(input: $input) {
      team {
        id
        teamId
        name
      }
    }
  }
`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMutation,
    UpdateTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(
    UpdateTeamDocument,
    options,
  );
}

export type UpdateTeamMutationHookResult = ReturnType<
  typeof useUpdateTeamMutation
>;
export type UpdateTeamMutationResult =
  Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($input: updateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        email
        firstName
        lastName
        phone
        industryId
      }
      clientMutationId
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}

export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const FetchCollectionAdminElementsDocument = gql`
  query FetchCollectionAdminElements(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminElements(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        _id
        name
        active
        previewImageId
        elementCategoryResources
        cropinkCodeMeta
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminElementsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminElementsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminElementsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminElementsQuery,
    FetchCollectionAdminElementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminElementsQuery,
    FetchCollectionAdminElementsQueryVariables
  >(FetchCollectionAdminElementsDocument, options);
}

export function useFetchCollectionAdminElementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminElementsQuery,
    FetchCollectionAdminElementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminElementsQuery,
    FetchCollectionAdminElementsQueryVariables
  >(FetchCollectionAdminElementsDocument, options);
}

export type FetchCollectionAdminElementsQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminElementsQuery
>;
export type FetchCollectionAdminElementsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminElementsLazyQuery
>;
export type FetchCollectionAdminElementsQueryResult = Apollo.QueryResult<
  FetchCollectionAdminElementsQuery,
  FetchCollectionAdminElementsQueryVariables
>;
export const FetchAdminProjectUpdateStatisticsDocument = gql`
  query FetchAdminProjectUpdateStatistics($projectUpdateId: String!) {
    fetchAdminProjectUpdateStatistics(projectUpdateId: $projectUpdateId) {
      projectUpdateId
      clientProductItems
      clientImages
      clientMinimalImagesInProduct
      clientMaximalImagesInProduct
      cropinkProductItems
      cropinkImages
      objectsToBeProcessed
      objectsProcessedSuccessfully
      objectsProcessedUnsuccessfully
      feedProcessingFinished
      feedReadingFinished
      objectsReadFromCache
    }
  }
`;

/**
 * __useFetchAdminProjectUpdateStatisticsQuery__
 *
 * To run a query within a React component, call `useFetchAdminProjectUpdateStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminProjectUpdateStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminProjectUpdateStatisticsQuery({
 *   variables: {
 *      projectUpdateId: // value for 'projectUpdateId'
 *   },
 * });
 */
export function useFetchAdminProjectUpdateStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAdminProjectUpdateStatisticsQuery,
    FetchAdminProjectUpdateStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchAdminProjectUpdateStatisticsQuery,
    FetchAdminProjectUpdateStatisticsQueryVariables
  >(FetchAdminProjectUpdateStatisticsDocument, options);
}

export function useFetchAdminProjectUpdateStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAdminProjectUpdateStatisticsQuery,
    FetchAdminProjectUpdateStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchAdminProjectUpdateStatisticsQuery,
    FetchAdminProjectUpdateStatisticsQueryVariables
  >(FetchAdminProjectUpdateStatisticsDocument, options);
}

export type FetchAdminProjectUpdateStatisticsQueryHookResult = ReturnType<
  typeof useFetchAdminProjectUpdateStatisticsQuery
>;
export type FetchAdminProjectUpdateStatisticsLazyQueryHookResult = ReturnType<
  typeof useFetchAdminProjectUpdateStatisticsLazyQuery
>;
export type FetchAdminProjectUpdateStatisticsQueryResult = Apollo.QueryResult<
  FetchAdminProjectUpdateStatisticsQuery,
  FetchAdminProjectUpdateStatisticsQueryVariables
>;
export const FetchCollectionAdminProjectUpdatesDocument = gql`
  query FetchCollectionAdminProjectUpdates(
    $projectId: String!
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminProjectUpdates(
      projectId: $projectId
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        projectUpdateId
        status
        processingMode
        usedDesigns
        createdAt
        updatedAt
        statistics
        planDetails
        message
        messageArguments
        messageSeverity
        isSourceFileExists
        isTargetFileExists
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminProjectUpdatesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminProjectUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminProjectUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminProjectUpdatesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminProjectUpdatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionAdminProjectUpdatesQuery,
    FetchCollectionAdminProjectUpdatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminProjectUpdatesQuery,
    FetchCollectionAdminProjectUpdatesQueryVariables
  >(FetchCollectionAdminProjectUpdatesDocument, options);
}

export function useFetchCollectionAdminProjectUpdatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminProjectUpdatesQuery,
    FetchCollectionAdminProjectUpdatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminProjectUpdatesQuery,
    FetchCollectionAdminProjectUpdatesQueryVariables
  >(FetchCollectionAdminProjectUpdatesDocument, options);
}

export type FetchCollectionAdminProjectUpdatesQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminProjectUpdatesQuery
>;
export type FetchCollectionAdminProjectUpdatesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminProjectUpdatesLazyQuery
>;
export type FetchCollectionAdminProjectUpdatesQueryResult = Apollo.QueryResult<
  FetchCollectionAdminProjectUpdatesQuery,
  FetchCollectionAdminProjectUpdatesQueryVariables
>;
export const FetchCollectionAdminProjectsDocument = gql`
  query FetchCollectionAdminProjects(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminProjects(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        projectId
        name
        teamId
        createdAt
        updatedAt
        lastUpdate
        currentUpdate
        status
        active
        projectTokens
        designs
        subscription
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminProjectsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminProjectsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminProjectsQuery,
    FetchCollectionAdminProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminProjectsQuery,
    FetchCollectionAdminProjectsQueryVariables
  >(FetchCollectionAdminProjectsDocument, options);
}

export function useFetchCollectionAdminProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminProjectsQuery,
    FetchCollectionAdminProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminProjectsQuery,
    FetchCollectionAdminProjectsQueryVariables
  >(FetchCollectionAdminProjectsDocument, options);
}

export type FetchCollectionAdminProjectsQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminProjectsQuery
>;
export type FetchCollectionAdminProjectsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminProjectsLazyQuery
>;
export type FetchCollectionAdminProjectsQueryResult = Apollo.QueryResult<
  FetchCollectionAdminProjectsQuery,
  FetchCollectionAdminProjectsQueryVariables
>;
export const FetchAdminStyleDocument = gql`
  query FetchAdminStyle($styleId: String!) {
    fetchAdminStyle(styleId: $styleId) {
      id
      styleId
      definition
      name
      type
    }
  }
`;

/**
 * __useFetchAdminStyleQuery__
 *
 * To run a query within a React component, call `useFetchAdminStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminStyleQuery({
 *   variables: {
 *      styleId: // value for 'styleId'
 *   },
 * });
 */
export function useFetchAdminStyleQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAdminStyleQuery,
    FetchAdminStyleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchAdminStyleQuery, FetchAdminStyleQueryVariables>(
    FetchAdminStyleDocument,
    options,
  );
}

export function useFetchAdminStyleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAdminStyleQuery,
    FetchAdminStyleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchAdminStyleQuery,
    FetchAdminStyleQueryVariables
  >(FetchAdminStyleDocument, options);
}

export type FetchAdminStyleQueryHookResult = ReturnType<
  typeof useFetchAdminStyleQuery
>;
export type FetchAdminStyleLazyQueryHookResult = ReturnType<
  typeof useFetchAdminStyleLazyQuery
>;
export type FetchAdminStyleQueryResult = Apollo.QueryResult<
  FetchAdminStyleQuery,
  FetchAdminStyleQueryVariables
>;
export const FetchCollectionAdminStylesDocument = gql`
  query FetchCollectionAdminStyles(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminStyles(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        styleId
        name
        active
        definition
        templates
        type
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminStylesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminStylesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminStylesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminStylesQuery,
    FetchCollectionAdminStylesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminStylesQuery,
    FetchCollectionAdminStylesQueryVariables
  >(FetchCollectionAdminStylesDocument, options);
}

export function useFetchCollectionAdminStylesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminStylesQuery,
    FetchCollectionAdminStylesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminStylesQuery,
    FetchCollectionAdminStylesQueryVariables
  >(FetchCollectionAdminStylesDocument, options);
}

export type FetchCollectionAdminStylesQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminStylesQuery
>;
export type FetchCollectionAdminStylesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminStylesLazyQuery
>;
export type FetchCollectionAdminStylesQueryResult = Apollo.QueryResult<
  FetchCollectionAdminStylesQuery,
  FetchCollectionAdminStylesQueryVariables
>;
export const FetchAdminTeamDocument = gql`
  query FetchAdminTeam($teamId: String!) {
    fetchAdminTeam(teamId: $teamId) {
      id
      name
      active
      projects
      members
      styles
      owner
    }
  }
`;

/**
 * __useFetchAdminTeamQuery__
 *
 * To run a query within a React component, call `useFetchAdminTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchAdminTeamQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAdminTeamQuery,
    FetchAdminTeamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchAdminTeamQuery, FetchAdminTeamQueryVariables>(
    FetchAdminTeamDocument,
    options,
  );
}

export function useFetchAdminTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAdminTeamQuery,
    FetchAdminTeamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchAdminTeamQuery, FetchAdminTeamQueryVariables>(
    FetchAdminTeamDocument,
    options,
  );
}

export type FetchAdminTeamQueryHookResult = ReturnType<
  typeof useFetchAdminTeamQuery
>;
export type FetchAdminTeamLazyQueryHookResult = ReturnType<
  typeof useFetchAdminTeamLazyQuery
>;
export type FetchAdminTeamQueryResult = Apollo.QueryResult<
  FetchAdminTeamQuery,
  FetchAdminTeamQueryVariables
>;
export const FetchCollectionAdminTeamsDocument = gql`
  query FetchCollectionAdminTeams(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminTeams(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        teamId
        name
        isDefault
        active
        projects
        members
        styles
        updatedAt
        createdAt
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminTeamsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminTeamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminTeamsQuery,
    FetchCollectionAdminTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminTeamsQuery,
    FetchCollectionAdminTeamsQueryVariables
  >(FetchCollectionAdminTeamsDocument, options);
}

export function useFetchCollectionAdminTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminTeamsQuery,
    FetchCollectionAdminTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminTeamsQuery,
    FetchCollectionAdminTeamsQueryVariables
  >(FetchCollectionAdminTeamsDocument, options);
}

export type FetchCollectionAdminTeamsQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminTeamsQuery
>;
export type FetchCollectionAdminTeamsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminTeamsLazyQuery
>;
export type FetchCollectionAdminTeamsQueryResult = Apollo.QueryResult<
  FetchCollectionAdminTeamsQuery,
  FetchCollectionAdminTeamsQueryVariables
>;
export const FetchAdminTemplateDocument = gql`
  query FetchAdminTemplate($templateId: String!) {
    fetchAdminTemplate(templateId: $templateId) {
      id
      templateId
      name
      previewImageId
      active
      styles
      tags
      templateGroupId
      templateGroupName
      manageableLayersSettings
      manageableLayersNested
    }
  }
`;

/**
 * __useFetchAdminTemplateQuery__
 *
 * To run a query within a React component, call `useFetchAdminTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useFetchAdminTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAdminTemplateQuery,
    FetchAdminTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchAdminTemplateQuery,
    FetchAdminTemplateQueryVariables
  >(FetchAdminTemplateDocument, options);
}

export function useFetchAdminTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAdminTemplateQuery,
    FetchAdminTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchAdminTemplateQuery,
    FetchAdminTemplateQueryVariables
  >(FetchAdminTemplateDocument, options);
}

export type FetchAdminTemplateQueryHookResult = ReturnType<
  typeof useFetchAdminTemplateQuery
>;
export type FetchAdminTemplateLazyQueryHookResult = ReturnType<
  typeof useFetchAdminTemplateLazyQuery
>;
export type FetchAdminTemplateQueryResult = Apollo.QueryResult<
  FetchAdminTemplateQuery,
  FetchAdminTemplateQueryVariables
>;
export const FetchAdminTemplatesForDropdownDocument = gql`
  query FetchAdminTemplatesForDropdown {
    fetchCollectionAdminTemplates(paginate: { limit: 9999, page: 1 }) {
      collection {
        id
        templateId
        name
        previewImageId
      }
    }
  }
`;

/**
 * __useFetchAdminTemplatesForDropdownQuery__
 *
 * To run a query within a React component, call `useFetchAdminTemplatesForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminTemplatesForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminTemplatesForDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAdminTemplatesForDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchAdminTemplatesForDropdownQuery,
    FetchAdminTemplatesForDropdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchAdminTemplatesForDropdownQuery,
    FetchAdminTemplatesForDropdownQueryVariables
  >(FetchAdminTemplatesForDropdownDocument, options);
}

export function useFetchAdminTemplatesForDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAdminTemplatesForDropdownQuery,
    FetchAdminTemplatesForDropdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchAdminTemplatesForDropdownQuery,
    FetchAdminTemplatesForDropdownQueryVariables
  >(FetchAdminTemplatesForDropdownDocument, options);
}

export type FetchAdminTemplatesForDropdownQueryHookResult = ReturnType<
  typeof useFetchAdminTemplatesForDropdownQuery
>;
export type FetchAdminTemplatesForDropdownLazyQueryHookResult = ReturnType<
  typeof useFetchAdminTemplatesForDropdownLazyQuery
>;
export type FetchAdminTemplatesForDropdownQueryResult = Apollo.QueryResult<
  FetchAdminTemplatesForDropdownQuery,
  FetchAdminTemplatesForDropdownQueryVariables
>;
export const FetchCollectionAdminTemplatesDocument = gql`
  query FetchCollectionAdminTemplates(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminTemplates(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        templateId
        name
        previewImageId
        active
        templateGroupId
        templateGroupName
        isBaseTemplate
        mainSize
        createdAt
        updatedAt
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminTemplatesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminTemplatesQuery,
    FetchCollectionAdminTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminTemplatesQuery,
    FetchCollectionAdminTemplatesQueryVariables
  >(FetchCollectionAdminTemplatesDocument, options);
}

export function useFetchCollectionAdminTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminTemplatesQuery,
    FetchCollectionAdminTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminTemplatesQuery,
    FetchCollectionAdminTemplatesQueryVariables
  >(FetchCollectionAdminTemplatesDocument, options);
}

export type FetchCollectionAdminTemplatesQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminTemplatesQuery
>;
export type FetchCollectionAdminTemplatesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminTemplatesLazyQuery
>;
export type FetchCollectionAdminTemplatesQueryResult = Apollo.QueryResult<
  FetchCollectionAdminTemplatesQuery,
  FetchCollectionAdminTemplatesQueryVariables
>;
export const FetchAdminTemplateGroupDocument = gql`
  query FetchAdminTemplateGroup($templateGroupId: String!) {
    fetchAdminTemplateGroup(templateGroupId: $templateGroupId) {
      id
      templateGroupId
      name
      baseTemplate
      templates
    }
  }
`;

/**
 * __useFetchAdminTemplateGroupQuery__
 *
 * To run a query within a React component, call `useFetchAdminTemplateGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminTemplateGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminTemplateGroupQuery({
 *   variables: {
 *      templateGroupId: // value for 'templateGroupId'
 *   },
 * });
 */
export function useFetchAdminTemplateGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAdminTemplateGroupQuery,
    FetchAdminTemplateGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchAdminTemplateGroupQuery,
    FetchAdminTemplateGroupQueryVariables
  >(FetchAdminTemplateGroupDocument, options);
}

export function useFetchAdminTemplateGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAdminTemplateGroupQuery,
    FetchAdminTemplateGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchAdminTemplateGroupQuery,
    FetchAdminTemplateGroupQueryVariables
  >(FetchAdminTemplateGroupDocument, options);
}

export type FetchAdminTemplateGroupQueryHookResult = ReturnType<
  typeof useFetchAdminTemplateGroupQuery
>;
export type FetchAdminTemplateGroupLazyQueryHookResult = ReturnType<
  typeof useFetchAdminTemplateGroupLazyQuery
>;
export type FetchAdminTemplateGroupQueryResult = Apollo.QueryResult<
  FetchAdminTemplateGroupQuery,
  FetchAdminTemplateGroupQueryVariables
>;
export const FetchCollectionAdminTemplateGroupsDocument = gql`
  query FetchCollectionAdminTemplateGroups(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminTemplateGroups(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        templateGroupId
        name
        baseTemplate
        templates
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminTemplateGroupsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminTemplateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminTemplateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminTemplateGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminTemplateGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminTemplateGroupsQuery,
    FetchCollectionAdminTemplateGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminTemplateGroupsQuery,
    FetchCollectionAdminTemplateGroupsQueryVariables
  >(FetchCollectionAdminTemplateGroupsDocument, options);
}

export function useFetchCollectionAdminTemplateGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminTemplateGroupsQuery,
    FetchCollectionAdminTemplateGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminTemplateGroupsQuery,
    FetchCollectionAdminTemplateGroupsQueryVariables
  >(FetchCollectionAdminTemplateGroupsDocument, options);
}

export type FetchCollectionAdminTemplateGroupsQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminTemplateGroupsQuery
>;
export type FetchCollectionAdminTemplateGroupsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminTemplateGroupsLazyQuery
>;
export type FetchCollectionAdminTemplateGroupsQueryResult = Apollo.QueryResult<
  FetchCollectionAdminTemplateGroupsQuery,
  FetchCollectionAdminTemplateGroupsQueryVariables
>;
export const FetchCollectionAdminUsersDocument = gql`
  query FetchCollectionAdminUsers(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionAdminUsers(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        userId
        firstName
        lastName
        roles
        email
        teams
        projects
        survey
        createdAt
        lastLoginAt
        tracking
        location
        onboardingType
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionAdminUsersQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdminUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionAdminUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionAdminUsersQuery,
    FetchCollectionAdminUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdminUsersQuery,
    FetchCollectionAdminUsersQueryVariables
  >(FetchCollectionAdminUsersDocument, options);
}

export function useFetchCollectionAdminUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdminUsersQuery,
    FetchCollectionAdminUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdminUsersQuery,
    FetchCollectionAdminUsersQueryVariables
  >(FetchCollectionAdminUsersDocument, options);
}

export type FetchCollectionAdminUsersQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminUsersQuery
>;
export type FetchCollectionAdminUsersLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdminUsersLazyQuery
>;
export type FetchCollectionAdminUsersQueryResult = Apollo.QueryResult<
  FetchCollectionAdminUsersQuery,
  FetchCollectionAdminUsersQueryVariables
>;
export const FetchCollectionRecentDesignsDocument = gql`
  query FetchCollectionRecentDesigns($filters: [Filter!]) {
    fetchCollectionRecentDesigns(filters: $filters) {
      id
      designId
      updatedAt
      projectName
      name
      previewImageId
      teamId
      projectId
    }
  }
`;

/**
 * __useFetchCollectionRecentDesignsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionRecentDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionRecentDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionRecentDesignsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchCollectionRecentDesignsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionRecentDesignsQuery,
    FetchCollectionRecentDesignsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionRecentDesignsQuery,
    FetchCollectionRecentDesignsQueryVariables
  >(FetchCollectionRecentDesignsDocument, options);
}

export function useFetchCollectionRecentDesignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionRecentDesignsQuery,
    FetchCollectionRecentDesignsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionRecentDesignsQuery,
    FetchCollectionRecentDesignsQueryVariables
  >(FetchCollectionRecentDesignsDocument, options);
}

export type FetchCollectionRecentDesignsQueryHookResult = ReturnType<
  typeof useFetchCollectionRecentDesignsQuery
>;
export type FetchCollectionRecentDesignsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionRecentDesignsLazyQuery
>;
export type FetchCollectionRecentDesignsQueryResult = Apollo.QueryResult<
  FetchCollectionRecentDesignsQuery,
  FetchCollectionRecentDesignsQueryVariables
>;
export const FetchDesignDocument = gql`
  query FetchDesign($designId: String!) {
    fetchDesign(designId: $designId) {
      id
      designId
      projectId
      name
      styleId
      previewImageId
      updatedAt
      mainSize
      customStyle
      mappedStyles
      stylizable
      manageableLayersSettings
      manageableLayersNested
      currentStyleIdUsedAt
      isEmpty
    }
  }
`;

/**
 * __useFetchDesignQuery__
 *
 * To run a query within a React component, call `useFetchDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDesignQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useFetchDesignQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchDesignQuery,
    FetchDesignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchDesignQuery, FetchDesignQueryVariables>(
    FetchDesignDocument,
    options,
  );
}

export function useFetchDesignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDesignQuery,
    FetchDesignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchDesignQuery, FetchDesignQueryVariables>(
    FetchDesignDocument,
    options,
  );
}

export type FetchDesignQueryHookResult = ReturnType<typeof useFetchDesignQuery>;
export type FetchDesignLazyQueryHookResult = ReturnType<
  typeof useFetchDesignLazyQuery
>;
export type FetchDesignQueryResult = Apollo.QueryResult<
  FetchDesignQuery,
  FetchDesignQueryVariables
>;
export const FetchDesignCodesDocument = gql`
  query FetchDesignCodes($designId: String!) {
    fetchDesignCodes(designId: $designId) {
      designId
      projectId
      teamId
      figmaCode
      cropinkCodeMeta
    }
  }
`;

/**
 * __useFetchDesignCodesQuery__
 *
 * To run a query within a React component, call `useFetchDesignCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDesignCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDesignCodesQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useFetchDesignCodesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchDesignCodesQuery,
    FetchDesignCodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchDesignCodesQuery, FetchDesignCodesQueryVariables>(
    FetchDesignCodesDocument,
    options,
  );
}

export function useFetchDesignCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDesignCodesQuery,
    FetchDesignCodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchDesignCodesQuery,
    FetchDesignCodesQueryVariables
  >(FetchDesignCodesDocument, options);
}

export type FetchDesignCodesQueryHookResult = ReturnType<
  typeof useFetchDesignCodesQuery
>;
export type FetchDesignCodesLazyQueryHookResult = ReturnType<
  typeof useFetchDesignCodesLazyQuery
>;
export type FetchDesignCodesQueryResult = Apollo.QueryResult<
  FetchDesignCodesQuery,
  FetchDesignCodesQueryVariables
>;
export const FetchDesignPreviewDocument = gql`
  query FetchDesignPreview($designId: String!) {
    fetchDesign(designId: $designId) {
      id
      designId
      projectId
      name
      styleId
      previewImageId
      updatedAt
      mainSize
      customStyle
      mappedStyles
      mappedFonts
      stylizable
      manageableLayersSettings
      currentStyleIdUsedAt
      settings
      isEmpty
    }
  }
`;

/**
 * __useFetchDesignPreviewQuery__
 *
 * To run a query within a React component, call `useFetchDesignPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDesignPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDesignPreviewQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useFetchDesignPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchDesignPreviewQuery,
    FetchDesignPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchDesignPreviewQuery,
    FetchDesignPreviewQueryVariables
  >(FetchDesignPreviewDocument, options);
}

export function useFetchDesignPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDesignPreviewQuery,
    FetchDesignPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchDesignPreviewQuery,
    FetchDesignPreviewQueryVariables
  >(FetchDesignPreviewDocument, options);
}

export type FetchDesignPreviewQueryHookResult = ReturnType<
  typeof useFetchDesignPreviewQuery
>;
export type FetchDesignPreviewLazyQueryHookResult = ReturnType<
  typeof useFetchDesignPreviewLazyQuery
>;
export type FetchDesignPreviewQueryResult = Apollo.QueryResult<
  FetchDesignPreviewQuery,
  FetchDesignPreviewQueryVariables
>;
export const FetchProjectDesignsDocument = gql`
  query FetchProjectDesigns($projectId: String!) {
    fetchCollectionDesigns(
      projectId: $projectId
      sort: [{ field: "createdAt", order: DESC }]
      paginate: { limit: 9999, page: 1 }
    ) {
      collection {
        id
        designId
        templateId
        projectId
        teamId
        styleId
        name
        projectName
        stylizable
        style
        customStyle
        figmaCode
        cropinkCode
        cropinkStyledCode
        previewImageId
        images
        mainSize
        mappedStyles
        manageableLayersSettings
        manageableLayersNested
        createdAt
        updatedAt
        currentStyleIdUsedAt
        mappedFonts
        settings
        isEmpty
      }
    }
  }
`;

/**
 * __useFetchProjectDesignsQuery__
 *
 * To run a query within a React component, call `useFetchProjectDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectDesignsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchProjectDesignsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchProjectDesignsQuery,
    FetchProjectDesignsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchProjectDesignsQuery,
    FetchProjectDesignsQueryVariables
  >(FetchProjectDesignsDocument, options);
}

export function useFetchProjectDesignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchProjectDesignsQuery,
    FetchProjectDesignsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchProjectDesignsQuery,
    FetchProjectDesignsQueryVariables
  >(FetchProjectDesignsDocument, options);
}

export type FetchProjectDesignsQueryHookResult = ReturnType<
  typeof useFetchProjectDesignsQuery
>;
export type FetchProjectDesignsLazyQueryHookResult = ReturnType<
  typeof useFetchProjectDesignsLazyQuery
>;
export type FetchProjectDesignsQueryResult = Apollo.QueryResult<
  FetchProjectDesignsQuery,
  FetchProjectDesignsQueryVariables
>;
export const FetchCollectionElementCategoriesDocument = gql`
  query FetchCollectionElementCategories {
    fetchCollectionElementCategories {
      id
      elementCategoryId
      name
    }
  }
`;

/**
 * __useFetchCollectionElementCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionElementCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionElementCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionElementCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCollectionElementCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionElementCategoriesQuery,
    FetchCollectionElementCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionElementCategoriesQuery,
    FetchCollectionElementCategoriesQueryVariables
  >(FetchCollectionElementCategoriesDocument, options);
}

export function useFetchCollectionElementCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionElementCategoriesQuery,
    FetchCollectionElementCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionElementCategoriesQuery,
    FetchCollectionElementCategoriesQueryVariables
  >(FetchCollectionElementCategoriesDocument, options);
}

export type FetchCollectionElementCategoriesQueryHookResult = ReturnType<
  typeof useFetchCollectionElementCategoriesQuery
>;
export type FetchCollectionElementCategoriesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionElementCategoriesLazyQuery
>;
export type FetchCollectionElementCategoriesQueryResult = Apollo.QueryResult<
  FetchCollectionElementCategoriesQuery,
  FetchCollectionElementCategoriesQueryVariables
>;
export const FetchCollectionElementsDocument = gql`
  query FetchCollectionElements($teamId: String!, $withGlobal: Boolean) {
    fetchCollectionElements(teamId: $teamId, withGlobal: $withGlobal) {
      id
      elementId
      name
      previewImageId
      active
      elementCategoryResources
      cropinkCodeMeta
    }
  }
`;

/**
 * __useFetchCollectionElementsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionElementsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      withGlobal: // value for 'withGlobal'
 *   },
 * });
 */
export function useFetchCollectionElementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionElementsQuery,
    FetchCollectionElementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionElementsQuery,
    FetchCollectionElementsQueryVariables
  >(FetchCollectionElementsDocument, options);
}

export function useFetchCollectionElementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionElementsQuery,
    FetchCollectionElementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionElementsQuery,
    FetchCollectionElementsQueryVariables
  >(FetchCollectionElementsDocument, options);
}

export type FetchCollectionElementsQueryHookResult = ReturnType<
  typeof useFetchCollectionElementsQuery
>;
export type FetchCollectionElementsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionElementsLazyQuery
>;
export type FetchCollectionElementsQueryResult = Apollo.QueryResult<
  FetchCollectionElementsQuery,
  FetchCollectionElementsQueryVariables
>;
export const FetchElementCodesDocument = gql`
  query FetchElementCodes($elementId: String!) {
    fetchElementCodes(elementId: $elementId) {
      id
      elementId
      figmaCode
      cropinkCodeMeta
      manageableLayersSettings
    }
  }
`;

/**
 * __useFetchElementCodesQuery__
 *
 * To run a query within a React component, call `useFetchElementCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchElementCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchElementCodesQuery({
 *   variables: {
 *      elementId: // value for 'elementId'
 *   },
 * });
 */
export function useFetchElementCodesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchElementCodesQuery,
    FetchElementCodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchElementCodesQuery,
    FetchElementCodesQueryVariables
  >(FetchElementCodesDocument, options);
}

export function useFetchElementCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchElementCodesQuery,
    FetchElementCodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchElementCodesQuery,
    FetchElementCodesQueryVariables
  >(FetchElementCodesDocument, options);
}

export type FetchElementCodesQueryHookResult = ReturnType<
  typeof useFetchElementCodesQuery
>;
export type FetchElementCodesLazyQueryHookResult = ReturnType<
  typeof useFetchElementCodesLazyQuery
>;
export type FetchElementCodesQueryResult = Apollo.QueryResult<
  FetchElementCodesQuery,
  FetchElementCodesQueryVariables
>;
export const FetchClientImageDocument = gql`
  query FetchClientImage($teamId: String!, $url: String!) {
    fetchClientImage(teamId: $teamId, url: $url) {
      content
    }
  }
`;

/**
 * __useFetchClientImageQuery__
 *
 * To run a query within a React component, call `useFetchClientImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchClientImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchClientImageQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFetchClientImageQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchClientImageQuery,
    FetchClientImageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchClientImageQuery, FetchClientImageQueryVariables>(
    FetchClientImageDocument,
    options,
  );
}

export function useFetchClientImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchClientImageQuery,
    FetchClientImageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchClientImageQuery,
    FetchClientImageQueryVariables
  >(FetchClientImageDocument, options);
}

export type FetchClientImageQueryHookResult = ReturnType<
  typeof useFetchClientImageQuery
>;
export type FetchClientImageLazyQueryHookResult = ReturnType<
  typeof useFetchClientImageLazyQuery
>;
export type FetchClientImageQueryResult = Apollo.QueryResult<
  FetchClientImageQuery,
  FetchClientImageQueryVariables
>;
export const FetchCollectionAdAccountsDocument = gql`
  query FetchCollectionAdAccounts($connectorId: String!) {
    fetchCollectionAdAccounts(connectorId: $connectorId) {
      adAccountId
      name
      business
    }
  }
`;

/**
 * __useFetchCollectionAdAccountsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionAdAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionAdAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionAdAccountsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useFetchCollectionAdAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionAdAccountsQuery,
    FetchCollectionAdAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionAdAccountsQuery,
    FetchCollectionAdAccountsQueryVariables
  >(FetchCollectionAdAccountsDocument, options);
}

export function useFetchCollectionAdAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionAdAccountsQuery,
    FetchCollectionAdAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionAdAccountsQuery,
    FetchCollectionAdAccountsQueryVariables
  >(FetchCollectionAdAccountsDocument, options);
}

export type FetchCollectionAdAccountsQueryHookResult = ReturnType<
  typeof useFetchCollectionAdAccountsQuery
>;
export type FetchCollectionAdAccountsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionAdAccountsLazyQuery
>;
export type FetchCollectionAdAccountsQueryResult = Apollo.QueryResult<
  FetchCollectionAdAccountsQuery,
  FetchCollectionAdAccountsQueryVariables
>;
export const FetchCollectionBusinessClientsDocument = gql`
  query FetchCollectionBusinessClients($accessToken: String!) {
    fetchCollectionBusinessClients(accessToken: $accessToken) {
      businessClientId
      name
    }
  }
`;

/**
 * __useFetchCollectionBusinessClientsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionBusinessClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionBusinessClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionBusinessClientsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useFetchCollectionBusinessClientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionBusinessClientsQuery,
    FetchCollectionBusinessClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionBusinessClientsQuery,
    FetchCollectionBusinessClientsQueryVariables
  >(FetchCollectionBusinessClientsDocument, options);
}

export function useFetchCollectionBusinessClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionBusinessClientsQuery,
    FetchCollectionBusinessClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionBusinessClientsQuery,
    FetchCollectionBusinessClientsQueryVariables
  >(FetchCollectionBusinessClientsDocument, options);
}

export type FetchCollectionBusinessClientsQueryHookResult = ReturnType<
  typeof useFetchCollectionBusinessClientsQuery
>;
export type FetchCollectionBusinessClientsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionBusinessClientsLazyQuery
>;
export type FetchCollectionBusinessClientsQueryResult = Apollo.QueryResult<
  FetchCollectionBusinessClientsQuery,
  FetchCollectionBusinessClientsQueryVariables
>;
export const FetchCollectionCatalogsDocument = gql`
  query FetchCollectionCatalogs($connectorId: String!) {
    fetchCollectionCatalogs(connectorId: $connectorId) {
      catalogId
      name
    }
  }
`;

/**
 * __useFetchCollectionCatalogsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionCatalogsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useFetchCollectionCatalogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionCatalogsQuery,
    FetchCollectionCatalogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionCatalogsQuery,
    FetchCollectionCatalogsQueryVariables
  >(FetchCollectionCatalogsDocument, options);
}

export function useFetchCollectionCatalogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionCatalogsQuery,
    FetchCollectionCatalogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionCatalogsQuery,
    FetchCollectionCatalogsQueryVariables
  >(FetchCollectionCatalogsDocument, options);
}

export type FetchCollectionCatalogsQueryHookResult = ReturnType<
  typeof useFetchCollectionCatalogsQuery
>;
export type FetchCollectionCatalogsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionCatalogsLazyQuery
>;
export type FetchCollectionCatalogsQueryResult = Apollo.QueryResult<
  FetchCollectionCatalogsQuery,
  FetchCollectionCatalogsQueryVariables
>;
export const FetchCollectionFontsDocument = gql`
  query FetchCollectionFonts {
    fetchCollectionFonts {
      id
      fontId
      userId
      teamId
      name
      family
      style
      weight
      weightName
      postScript
      format
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useFetchCollectionFontsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionFontsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCollectionFontsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionFontsQuery,
    FetchCollectionFontsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionFontsQuery,
    FetchCollectionFontsQueryVariables
  >(FetchCollectionFontsDocument, options);
}

export function useFetchCollectionFontsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionFontsQuery,
    FetchCollectionFontsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionFontsQuery,
    FetchCollectionFontsQueryVariables
  >(FetchCollectionFontsDocument, options);
}

export type FetchCollectionFontsQueryHookResult = ReturnType<
  typeof useFetchCollectionFontsQuery
>;
export type FetchCollectionFontsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionFontsLazyQuery
>;
export type FetchCollectionFontsQueryResult = Apollo.QueryResult<
  FetchCollectionFontsQuery,
  FetchCollectionFontsQueryVariables
>;
export const FetchCollectionRolesDocument = gql`
  query FetchCollectionRoles($teamId: String) {
    fetchCollectionRoles(teamId: $teamId) {
      id
      roleId
      roleName
      description
      permissions
    }
  }
`;

/**
 * __useFetchCollectionRolesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionRolesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchCollectionRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionRolesQuery,
    FetchCollectionRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionRolesQuery,
    FetchCollectionRolesQueryVariables
  >(FetchCollectionRolesDocument, options);
}

export function useFetchCollectionRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionRolesQuery,
    FetchCollectionRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionRolesQuery,
    FetchCollectionRolesQueryVariables
  >(FetchCollectionRolesDocument, options);
}

export type FetchCollectionRolesQueryHookResult = ReturnType<
  typeof useFetchCollectionRolesQuery
>;
export type FetchCollectionRolesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionRolesLazyQuery
>;
export type FetchCollectionRolesQueryResult = Apollo.QueryResult<
  FetchCollectionRolesQuery,
  FetchCollectionRolesQueryVariables
>;
export const FetchCollectionTagsDocument = gql`
  query FetchCollectionTags($tags: [String]) {
    fetchCollectionTags(tags: $tags) {
      id
      tagId
      category
      value
      templatesCount
    }
  }
`;

/**
 * __useFetchCollectionTagsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTagsQuery({
 *   variables: {
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useFetchCollectionTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionTagsQuery,
    FetchCollectionTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTagsQuery,
    FetchCollectionTagsQueryVariables
  >(FetchCollectionTagsDocument, options);
}

export function useFetchCollectionTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTagsQuery,
    FetchCollectionTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTagsQuery,
    FetchCollectionTagsQueryVariables
  >(FetchCollectionTagsDocument, options);
}

export type FetchCollectionTagsQueryHookResult = ReturnType<
  typeof useFetchCollectionTagsQuery
>;
export type FetchCollectionTagsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTagsLazyQuery
>;
export type FetchCollectionTagsQueryResult = Apollo.QueryResult<
  FetchCollectionTagsQuery,
  FetchCollectionTagsQueryVariables
>;
export const FetchDesignManagerQueriesDocument = gql`
  query FetchDesignManagerQueries($teamId: String!, $designId: String!) {
    fetchDictionary {
      id
      dictionary
    }
    fetchTeam(teamId: $teamId) {
      id
      teamId
      logos
    }
    fetchCollectionTeamFonts(teamId: $teamId) {
      id
      fontId
      userId
      teamId
      name
      family
      style
      format
      createdAt
      updatedAt
    }
    fetchCollectionFonts {
      id
      fontId
      userId
      teamId
      name
      family
      style
      format
      weight
      createdAt
      updatedAt
    }
    fetchDesign(designId: $designId) {
      id
      designId
      name
      styleId
      previewImageId
      updatedAt
      mainSize
      customStyle
      mappedStyles
      mappedFonts
      manageableLayersSettings
      manageableLayersNested
      currentStyleIdUsedAt
      isEmpty
    }
    fetchDesignCodes(designId: $designId) {
      designId
      figmaCode
      cropinkCodeMeta
    }
  }
`;

/**
 * __useFetchDesignManagerQueriesQuery__
 *
 * To run a query within a React component, call `useFetchDesignManagerQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDesignManagerQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDesignManagerQueriesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useFetchDesignManagerQueriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchDesignManagerQueriesQuery,
    FetchDesignManagerQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchDesignManagerQueriesQuery,
    FetchDesignManagerQueriesQueryVariables
  >(FetchDesignManagerQueriesDocument, options);
}

export function useFetchDesignManagerQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDesignManagerQueriesQuery,
    FetchDesignManagerQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchDesignManagerQueriesQuery,
    FetchDesignManagerQueriesQueryVariables
  >(FetchDesignManagerQueriesDocument, options);
}

export type FetchDesignManagerQueriesQueryHookResult = ReturnType<
  typeof useFetchDesignManagerQueriesQuery
>;
export type FetchDesignManagerQueriesLazyQueryHookResult = ReturnType<
  typeof useFetchDesignManagerQueriesLazyQuery
>;
export type FetchDesignManagerQueriesQueryResult = Apollo.QueryResult<
  FetchDesignManagerQueriesQuery,
  FetchDesignManagerQueriesQueryVariables
>;
export const FetchDictionaryDocument = gql`
  query FetchDictionary {
    fetchDictionary {
      id
      dictionary
    }
  }
`;

/**
 * __useFetchDictionaryQuery__
 *
 * To run a query within a React component, call `useFetchDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDictionaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchDictionaryQuery,
    FetchDictionaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchDictionaryQuery, FetchDictionaryQueryVariables>(
    FetchDictionaryDocument,
    options,
  );
}

export function useFetchDictionaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDictionaryQuery,
    FetchDictionaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchDictionaryQuery,
    FetchDictionaryQueryVariables
  >(FetchDictionaryDocument, options);
}

export type FetchDictionaryQueryHookResult = ReturnType<
  typeof useFetchDictionaryQuery
>;
export type FetchDictionaryLazyQueryHookResult = ReturnType<
  typeof useFetchDictionaryLazyQuery
>;
export type FetchDictionaryQueryResult = Apollo.QueryResult<
  FetchDictionaryQuery,
  FetchDictionaryQueryVariables
>;
export const FetchTemplateGroupDocument = gql`
  query fetchTemplateGroup($templateGroupId: String!) {
    fetchTemplateGroup(templateGroupId: $templateGroupId) {
      id
      templateGroupId
      name
      baseTemplate
      templates
    }
  }
`;

/**
 * __useFetchTemplateGroupQuery__
 *
 * To run a query within a React component, call `useFetchTemplateGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTemplateGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTemplateGroupQuery({
 *   variables: {
 *      templateGroupId: // value for 'templateGroupId'
 *   },
 * });
 */
export function useFetchTemplateGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTemplateGroupQuery,
    FetchTemplateGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchTemplateGroupQuery,
    FetchTemplateGroupQueryVariables
  >(FetchTemplateGroupDocument, options);
}

export function useFetchTemplateGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTemplateGroupQuery,
    FetchTemplateGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchTemplateGroupQuery,
    FetchTemplateGroupQueryVariables
  >(FetchTemplateGroupDocument, options);
}

export type FetchTemplateGroupQueryHookResult = ReturnType<
  typeof useFetchTemplateGroupQuery
>;
export type FetchTemplateGroupLazyQueryHookResult = ReturnType<
  typeof useFetchTemplateGroupLazyQuery
>;
export type FetchTemplateGroupQueryResult = Apollo.QueryResult<
  FetchTemplateGroupQuery,
  FetchTemplateGroupQueryVariables
>;
export const FetchTemplateManagerQueriesDocument = gql`
  query FetchTemplateManagerQueries($templateId: String!) {
    fetchDictionary {
      id
      dictionary
    }
    fetchCollectionFonts {
      id
      fontId
      userId
      teamId
      name
      family
      style
      weight
      format
      createdAt
      updatedAt
    }
    fetchAdminTemplate(templateId: $templateId) {
      id
      templateId
      templateGroupId
      name
      previewImageId
      styles
      isFavourite
      mainSize
      manageableLayersSettings
      manageableLayersNested
    }
  }
`;

/**
 * __useFetchTemplateManagerQueriesQuery__
 *
 * To run a query within a React component, call `useFetchTemplateManagerQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTemplateManagerQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTemplateManagerQueriesQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useFetchTemplateManagerQueriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTemplateManagerQueriesQuery,
    FetchTemplateManagerQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchTemplateManagerQueriesQuery,
    FetchTemplateManagerQueriesQueryVariables
  >(FetchTemplateManagerQueriesDocument, options);
}

export function useFetchTemplateManagerQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTemplateManagerQueriesQuery,
    FetchTemplateManagerQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchTemplateManagerQueriesQuery,
    FetchTemplateManagerQueriesQueryVariables
  >(FetchTemplateManagerQueriesDocument, options);
}

export type FetchTemplateManagerQueriesQueryHookResult = ReturnType<
  typeof useFetchTemplateManagerQueriesQuery
>;
export type FetchTemplateManagerQueriesLazyQueryHookResult = ReturnType<
  typeof useFetchTemplateManagerQueriesLazyQuery
>;
export type FetchTemplateManagerQueriesQueryResult = Apollo.QueryResult<
  FetchTemplateManagerQueriesQuery,
  FetchTemplateManagerQueriesQueryVariables
>;
export const FetchCollectionShopifyLanguagesDocument = gql`
  query FetchCollectionShopifyLanguages($connectorId: String!) {
    fetchCollectionShopifyLanguages(connectorId: $connectorId) {
      locale
      name
      primary
      published
    }
  }
`;

/**
 * __useFetchCollectionShopifyLanguagesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionShopifyLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionShopifyLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionShopifyLanguagesQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useFetchCollectionShopifyLanguagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionShopifyLanguagesQuery,
    FetchCollectionShopifyLanguagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionShopifyLanguagesQuery,
    FetchCollectionShopifyLanguagesQueryVariables
  >(FetchCollectionShopifyLanguagesDocument, options);
}

export function useFetchCollectionShopifyLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionShopifyLanguagesQuery,
    FetchCollectionShopifyLanguagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionShopifyLanguagesQuery,
    FetchCollectionShopifyLanguagesQueryVariables
  >(FetchCollectionShopifyLanguagesDocument, options);
}

export type FetchCollectionShopifyLanguagesQueryHookResult = ReturnType<
  typeof useFetchCollectionShopifyLanguagesQuery
>;
export type FetchCollectionShopifyLanguagesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionShopifyLanguagesLazyQuery
>;
export type FetchCollectionShopifyLanguagesQueryResult = Apollo.QueryResult<
  FetchCollectionShopifyLanguagesQuery,
  FetchCollectionShopifyLanguagesQueryVariables
>;
export const FetchCollectionShopifyMarketsDocument = gql`
  query FetchCollectionShopifyMarkets($connectorId: String!) {
    fetchCollectionShopifyMarkets(connectorId: $connectorId) {
      marketId
      name
      handle
      status
      type
    }
  }
`;

/**
 * __useFetchCollectionShopifyMarketsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionShopifyMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionShopifyMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionShopifyMarketsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useFetchCollectionShopifyMarketsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionShopifyMarketsQuery,
    FetchCollectionShopifyMarketsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionShopifyMarketsQuery,
    FetchCollectionShopifyMarketsQueryVariables
  >(FetchCollectionShopifyMarketsDocument, options);
}

export function useFetchCollectionShopifyMarketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionShopifyMarketsQuery,
    FetchCollectionShopifyMarketsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionShopifyMarketsQuery,
    FetchCollectionShopifyMarketsQueryVariables
  >(FetchCollectionShopifyMarketsDocument, options);
}

export type FetchCollectionShopifyMarketsQueryHookResult = ReturnType<
  typeof useFetchCollectionShopifyMarketsQuery
>;
export type FetchCollectionShopifyMarketsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionShopifyMarketsLazyQuery
>;
export type FetchCollectionShopifyMarketsQueryResult = Apollo.QueryResult<
  FetchCollectionShopifyMarketsQuery,
  FetchCollectionShopifyMarketsQueryVariables
>;
export const FetchFacebookFeedDocument = gql`
  query FetchFacebookFeed(
    $connectorId: String!
    $catalogId: String!
    $projectId: String!
  ) {
    fetchFacebookFeed(
      connectorId: $connectorId
      catalogId: $catalogId
      projectId: $projectId
    ) {
      url
      username
    }
  }
`;

/**
 * __useFetchFacebookFeedQuery__
 *
 * To run a query within a React component, call `useFetchFacebookFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFacebookFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFacebookFeedQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      catalogId: // value for 'catalogId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchFacebookFeedQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchFacebookFeedQuery,
    FetchFacebookFeedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchFacebookFeedQuery,
    FetchFacebookFeedQueryVariables
  >(FetchFacebookFeedDocument, options);
}

export function useFetchFacebookFeedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchFacebookFeedQuery,
    FetchFacebookFeedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchFacebookFeedQuery,
    FetchFacebookFeedQueryVariables
  >(FetchFacebookFeedDocument, options);
}

export type FetchFacebookFeedQueryHookResult = ReturnType<
  typeof useFetchFacebookFeedQuery
>;
export type FetchFacebookFeedLazyQueryHookResult = ReturnType<
  typeof useFetchFacebookFeedLazyQuery
>;
export type FetchFacebookFeedQueryResult = Apollo.QueryResult<
  FetchFacebookFeedQuery,
  FetchFacebookFeedQueryVariables
>;
export const RefreshCollectionAdsProjectDocument = gql`
  mutation RefreshCollectionAdsProject($projectId: String!) {
    refreshCollectionAdsProject(input: { projectId: $projectId }) {
      project {
        projectId
        name
        outputSettings
      }
    }
  }
`;
export type RefreshCollectionAdsProjectMutationFn = Apollo.MutationFunction<
  RefreshCollectionAdsProjectMutation,
  RefreshCollectionAdsProjectMutationVariables
>;

/**
 * __useRefreshCollectionAdsProjectMutation__
 *
 * To run a mutation, you first call `useRefreshCollectionAdsProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCollectionAdsProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCollectionAdsProjectMutation, { data, loading, error }] = useRefreshCollectionAdsProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRefreshCollectionAdsProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshCollectionAdsProjectMutation,
    RefreshCollectionAdsProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    RefreshCollectionAdsProjectMutation,
    RefreshCollectionAdsProjectMutationVariables
  >(RefreshCollectionAdsProjectDocument, options);
}

export type RefreshCollectionAdsProjectMutationHookResult = ReturnType<
  typeof useRefreshCollectionAdsProjectMutation
>;
export type RefreshCollectionAdsProjectMutationResult =
  Apollo.MutationResult<RefreshCollectionAdsProjectMutation>;
export type RefreshCollectionAdsProjectMutationOptions =
  Apollo.BaseMutationOptions<
    RefreshCollectionAdsProjectMutation,
    RefreshCollectionAdsProjectMutationVariables
  >;
export const FetchOnboardingTeamStylesDocument = gql`
  query FetchOnboardingTeamStyles($teamId: String!) {
    fetchCollectionTeamStyles(teamId: $teamId) {
      id
      styleId
      definition
    }
  }
`;

/**
 * __useFetchOnboardingTeamStylesQuery__
 *
 * To run a query within a React component, call `useFetchOnboardingTeamStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOnboardingTeamStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOnboardingTeamStylesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchOnboardingTeamStylesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchOnboardingTeamStylesQuery,
    FetchOnboardingTeamStylesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchOnboardingTeamStylesQuery,
    FetchOnboardingTeamStylesQueryVariables
  >(FetchOnboardingTeamStylesDocument, options);
}

export function useFetchOnboardingTeamStylesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchOnboardingTeamStylesQuery,
    FetchOnboardingTeamStylesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchOnboardingTeamStylesQuery,
    FetchOnboardingTeamStylesQueryVariables
  >(FetchOnboardingTeamStylesDocument, options);
}

export type FetchOnboardingTeamStylesQueryHookResult = ReturnType<
  typeof useFetchOnboardingTeamStylesQuery
>;
export type FetchOnboardingTeamStylesLazyQueryHookResult = ReturnType<
  typeof useFetchOnboardingTeamStylesLazyQuery
>;
export type FetchOnboardingTeamStylesQueryResult = Apollo.QueryResult<
  FetchOnboardingTeamStylesQuery,
  FetchOnboardingTeamStylesQueryVariables
>;
export const FetchOnboardingUserTeamsDocument = gql`
  query FetchOnboardingUserTeams {
    fetchCollectionUserTeams {
      id
      teamId
      name
      projects
      logos
    }
  }
`;

/**
 * __useFetchOnboardingUserTeamsQuery__
 *
 * To run a query within a React component, call `useFetchOnboardingUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOnboardingUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOnboardingUserTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchOnboardingUserTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchOnboardingUserTeamsQuery,
    FetchOnboardingUserTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchOnboardingUserTeamsQuery,
    FetchOnboardingUserTeamsQueryVariables
  >(FetchOnboardingUserTeamsDocument, options);
}

export function useFetchOnboardingUserTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchOnboardingUserTeamsQuery,
    FetchOnboardingUserTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchOnboardingUserTeamsQuery,
    FetchOnboardingUserTeamsQueryVariables
  >(FetchOnboardingUserTeamsDocument, options);
}

export type FetchOnboardingUserTeamsQueryHookResult = ReturnType<
  typeof useFetchOnboardingUserTeamsQuery
>;
export type FetchOnboardingUserTeamsLazyQueryHookResult = ReturnType<
  typeof useFetchOnboardingUserTeamsLazyQuery
>;
export type FetchOnboardingUserTeamsQueryResult = Apollo.QueryResult<
  FetchOnboardingUserTeamsQuery,
  FetchOnboardingUserTeamsQueryVariables
>;
export const FetchCollectionSubscriptionPlansDocument = gql`
  query FetchCollectionSubscriptionPlans {
    fetchCollectionProducts {
      id
      productId
      externalId
      productLimits
      productName
      productFeatures
      productDescription
      prices
    }
  }
`;

/**
 * __useFetchCollectionSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useFetchCollectionSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCollectionSubscriptionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionSubscriptionPlansQuery,
    FetchCollectionSubscriptionPlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionSubscriptionPlansQuery,
    FetchCollectionSubscriptionPlansQueryVariables
  >(FetchCollectionSubscriptionPlansDocument, options);
}

export function useFetchCollectionSubscriptionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionSubscriptionPlansQuery,
    FetchCollectionSubscriptionPlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionSubscriptionPlansQuery,
    FetchCollectionSubscriptionPlansQueryVariables
  >(FetchCollectionSubscriptionPlansDocument, options);
}

export type FetchCollectionSubscriptionPlansQueryHookResult = ReturnType<
  typeof useFetchCollectionSubscriptionPlansQuery
>;
export type FetchCollectionSubscriptionPlansLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionSubscriptionPlansLazyQuery
>;
export type FetchCollectionSubscriptionPlansQueryResult = Apollo.QueryResult<
  FetchCollectionSubscriptionPlansQuery,
  FetchCollectionSubscriptionPlansQueryVariables
>;
export const FetchBackgroundRemovalStatusDocument = gql`
  query FetchBackgroundRemovalStatus($projectUpdateId: String!) {
    fetchBackgroundRemovalStatus(projectUpdateId: $projectUpdateId) {
      id
      projectUpdateId
      all
      success
      failed
      inProgress
    }
  }
`;

/**
 * __useFetchBackgroundRemovalStatusQuery__
 *
 * To run a query within a React component, call `useFetchBackgroundRemovalStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBackgroundRemovalStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBackgroundRemovalStatusQuery({
 *   variables: {
 *      projectUpdateId: // value for 'projectUpdateId'
 *   },
 * });
 */
export function useFetchBackgroundRemovalStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchBackgroundRemovalStatusQuery,
    FetchBackgroundRemovalStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchBackgroundRemovalStatusQuery,
    FetchBackgroundRemovalStatusQueryVariables
  >(FetchBackgroundRemovalStatusDocument, options);
}

export function useFetchBackgroundRemovalStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchBackgroundRemovalStatusQuery,
    FetchBackgroundRemovalStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchBackgroundRemovalStatusQuery,
    FetchBackgroundRemovalStatusQueryVariables
  >(FetchBackgroundRemovalStatusDocument, options);
}

export type FetchBackgroundRemovalStatusQueryHookResult = ReturnType<
  typeof useFetchBackgroundRemovalStatusQuery
>;
export type FetchBackgroundRemovalStatusLazyQueryHookResult = ReturnType<
  typeof useFetchBackgroundRemovalStatusLazyQuery
>;
export type FetchBackgroundRemovalStatusQueryResult = Apollo.QueryResult<
  FetchBackgroundRemovalStatusQuery,
  FetchBackgroundRemovalStatusQueryVariables
>;
export const FetchCollectionFacebookAdsDocument = gql`
  query FetchCollectionFacebookAds(
    $projectId: String!
    $filters: [Filter]
    $sort: [Sort]
    $paginate: Paginate
  ) {
    fetchCollectionFacebookAds(
      projectId: $projectId
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        adId
        name
        projectObjectId
        campaignId
        campaignName
        adSetId
        adSetName
        effectiveStatus
        createdAt
        updatedAt
        insights
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useFetchCollectionFacebookAdsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionFacebookAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionFacebookAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionFacebookAdsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionFacebookAdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionFacebookAdsQuery,
    FetchCollectionFacebookAdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionFacebookAdsQuery,
    FetchCollectionFacebookAdsQueryVariables
  >(FetchCollectionFacebookAdsDocument, options);
}

export function useFetchCollectionFacebookAdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionFacebookAdsQuery,
    FetchCollectionFacebookAdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionFacebookAdsQuery,
    FetchCollectionFacebookAdsQueryVariables
  >(FetchCollectionFacebookAdsDocument, options);
}

export type FetchCollectionFacebookAdsQueryHookResult = ReturnType<
  typeof useFetchCollectionFacebookAdsQuery
>;
export type FetchCollectionFacebookAdsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionFacebookAdsLazyQuery
>;
export type FetchCollectionFacebookAdsQueryResult = Apollo.QueryResult<
  FetchCollectionFacebookAdsQuery,
  FetchCollectionFacebookAdsQueryVariables
>;
export const FetchCollectionProjectItemsDocument = gql`
  query FetchCollectionProjectItems(
    $projectId: String!
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionProjectItems(
      projectId: $projectId
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        projectItemId
        product
        projectObjectResults
      }
      paginationInfo {
        itemsPerPage
        lastPage
        totalCount
      }
    }
  }
`;

/**
 * __useFetchCollectionProjectItemsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionProjectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionProjectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionProjectItemsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionProjectItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionProjectItemsQuery,
    FetchCollectionProjectItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionProjectItemsQuery,
    FetchCollectionProjectItemsQueryVariables
  >(FetchCollectionProjectItemsDocument, options);
}

export function useFetchCollectionProjectItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionProjectItemsQuery,
    FetchCollectionProjectItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionProjectItemsQuery,
    FetchCollectionProjectItemsQueryVariables
  >(FetchCollectionProjectItemsDocument, options);
}

export type FetchCollectionProjectItemsQueryHookResult = ReturnType<
  typeof useFetchCollectionProjectItemsQuery
>;
export type FetchCollectionProjectItemsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionProjectItemsLazyQuery
>;
export type FetchCollectionProjectItemsQueryResult = Apollo.QueryResult<
  FetchCollectionProjectItemsQuery,
  FetchCollectionProjectItemsQueryVariables
>;
export const FetchCollectionProjectObjectBehaviorsDocument = gql`
  query FetchCollectionProjectObjectBehaviors(
    $projectObjectId: String!
    $filters: [Filter]
    $sort: [Sort]
    $paginate: Paginate
  ) {
    fetchCollectionProjectObjectBehaviors(
      projectObjectId: $projectObjectId
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        projectObjectBehaviorId
        projectObjectId
        schedule
        rules
        ordering
        usedDesigns
        updatedAt
        createdAt
      }
    }
  }
`;

/**
 * __useFetchCollectionProjectObjectBehaviorsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionProjectObjectBehaviorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionProjectObjectBehaviorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionProjectObjectBehaviorsQuery({
 *   variables: {
 *      projectObjectId: // value for 'projectObjectId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionProjectObjectBehaviorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionProjectObjectBehaviorsQuery,
    FetchCollectionProjectObjectBehaviorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionProjectObjectBehaviorsQuery,
    FetchCollectionProjectObjectBehaviorsQueryVariables
  >(FetchCollectionProjectObjectBehaviorsDocument, options);
}

export function useFetchCollectionProjectObjectBehaviorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionProjectObjectBehaviorsQuery,
    FetchCollectionProjectObjectBehaviorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionProjectObjectBehaviorsQuery,
    FetchCollectionProjectObjectBehaviorsQueryVariables
  >(FetchCollectionProjectObjectBehaviorsDocument, options);
}

export type FetchCollectionProjectObjectBehaviorsQueryHookResult = ReturnType<
  typeof useFetchCollectionProjectObjectBehaviorsQuery
>;
export type FetchCollectionProjectObjectBehaviorsLazyQueryHookResult =
  ReturnType<typeof useFetchCollectionProjectObjectBehaviorsLazyQuery>;
export type FetchCollectionProjectObjectBehaviorsQueryResult =
  Apollo.QueryResult<
    FetchCollectionProjectObjectBehaviorsQuery,
    FetchCollectionProjectObjectBehaviorsQueryVariables
  >;
export const FetchCollectionProjectUpdatesDocument = gql`
  query FetchCollectionProjectUpdates(
    $projectId: String!
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionProjectUpdates(
      projectId: $projectId
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        projectUpdateId
        status
        processingMode
        usedDesigns
        createdAt
        updatedAt
        statistics
        planDetails
        message
        messageArguments
        messageSeverity
      }
      paginationInfo {
        totalCount
        itemsPerPage
        lastPage
      }
    }
  }
`;

/**
 * __useFetchCollectionProjectUpdatesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionProjectUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionProjectUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionProjectUpdatesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionProjectUpdatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionProjectUpdatesQuery,
    FetchCollectionProjectUpdatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionProjectUpdatesQuery,
    FetchCollectionProjectUpdatesQueryVariables
  >(FetchCollectionProjectUpdatesDocument, options);
}

export function useFetchCollectionProjectUpdatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionProjectUpdatesQuery,
    FetchCollectionProjectUpdatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionProjectUpdatesQuery,
    FetchCollectionProjectUpdatesQueryVariables
  >(FetchCollectionProjectUpdatesDocument, options);
}

export type FetchCollectionProjectUpdatesQueryHookResult = ReturnType<
  typeof useFetchCollectionProjectUpdatesQuery
>;
export type FetchCollectionProjectUpdatesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionProjectUpdatesLazyQuery
>;
export type FetchCollectionProjectUpdatesQueryResult = Apollo.QueryResult<
  FetchCollectionProjectUpdatesQuery,
  FetchCollectionProjectUpdatesQueryVariables
>;
export const FetchFacebookPermissionReportDocument = gql`
  query FetchFacebookPermissionReport($projectId: String!) {
    fetchFacebookPermissionReport(projectId: $projectId) {
      id
      items
      satisfied
    }
  }
`;

/**
 * __useFetchFacebookPermissionReportQuery__
 *
 * To run a query within a React component, call `useFetchFacebookPermissionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFacebookPermissionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFacebookPermissionReportQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchFacebookPermissionReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchFacebookPermissionReportQuery,
    FetchFacebookPermissionReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchFacebookPermissionReportQuery,
    FetchFacebookPermissionReportQueryVariables
  >(FetchFacebookPermissionReportDocument, options);
}

export function useFetchFacebookPermissionReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchFacebookPermissionReportQuery,
    FetchFacebookPermissionReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchFacebookPermissionReportQuery,
    FetchFacebookPermissionReportQueryVariables
  >(FetchFacebookPermissionReportDocument, options);
}

export type FetchFacebookPermissionReportQueryHookResult = ReturnType<
  typeof useFetchFacebookPermissionReportQuery
>;
export type FetchFacebookPermissionReportLazyQueryHookResult = ReturnType<
  typeof useFetchFacebookPermissionReportLazyQuery
>;
export type FetchFacebookPermissionReportQueryResult = Apollo.QueryResult<
  FetchFacebookPermissionReportQuery,
  FetchFacebookPermissionReportQueryVariables
>;
export const FetchProjectDocument = gql`
  query FetchProject($projectId: String!) {
    fetchProject(projectId: $projectId) {
      id
      projectId
      name
      teamId
      createdAt
      updatedAt
      feed
      projectTokens
      designs
      currentUpdate
      lastUpdate
      subscription
      scheduledAt
      projectInfo
      shouldProjectBeUpdated
      settings
      outputSettings
      projectObjects
    }
  }
`;

/**
 * __useFetchProjectQuery__
 *
 * To run a query within a React component, call `useFetchProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchProjectQuery,
    FetchProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchProjectQuery, FetchProjectQueryVariables>(
    FetchProjectDocument,
    options,
  );
}

export function useFetchProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchProjectQuery,
    FetchProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchProjectQuery, FetchProjectQueryVariables>(
    FetchProjectDocument,
    options,
  );
}

export type FetchProjectQueryHookResult = ReturnType<
  typeof useFetchProjectQuery
>;
export type FetchProjectLazyQueryHookResult = ReturnType<
  typeof useFetchProjectLazyQuery
>;
export type FetchProjectQueryResult = Apollo.QueryResult<
  FetchProjectQuery,
  FetchProjectQueryVariables
>;
export const FetchProjectObjectBehaviorDocument = gql`
  query FetchProjectObjectBehavior($projectObjectBehaviorId: String!) {
    fetchProjectObjectBehavior(
      projectObjectBehaviorId: $projectObjectBehaviorId
    ) {
      id
      projectObjectBehaviorId
      projectObjectId
      ordering
      rules
      schedule
      updatedAt
      createdAt
      usedDesigns
    }
  }
`;

/**
 * __useFetchProjectObjectBehaviorQuery__
 *
 * To run a query within a React component, call `useFetchProjectObjectBehaviorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectObjectBehaviorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectObjectBehaviorQuery({
 *   variables: {
 *      projectObjectBehaviorId: // value for 'projectObjectBehaviorId'
 *   },
 * });
 */
export function useFetchProjectObjectBehaviorQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchProjectObjectBehaviorQuery,
    FetchProjectObjectBehaviorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchProjectObjectBehaviorQuery,
    FetchProjectObjectBehaviorQueryVariables
  >(FetchProjectObjectBehaviorDocument, options);
}

export function useFetchProjectObjectBehaviorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchProjectObjectBehaviorQuery,
    FetchProjectObjectBehaviorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchProjectObjectBehaviorQuery,
    FetchProjectObjectBehaviorQueryVariables
  >(FetchProjectObjectBehaviorDocument, options);
}

export type FetchProjectObjectBehaviorQueryHookResult = ReturnType<
  typeof useFetchProjectObjectBehaviorQuery
>;
export type FetchProjectObjectBehaviorLazyQueryHookResult = ReturnType<
  typeof useFetchProjectObjectBehaviorLazyQuery
>;
export type FetchProjectObjectBehaviorQueryResult = Apollo.QueryResult<
  FetchProjectObjectBehaviorQuery,
  FetchProjectObjectBehaviorQueryVariables
>;
export const FetchProjectObjectsDocument = gql`
  query FetchProjectObjects($projectId: String!) {
    fetchProject(projectId: $projectId) {
      id
      projectId
      projectObjects
    }
  }
`;

/**
 * __useFetchProjectObjectsQuery__
 *
 * To run a query within a React component, call `useFetchProjectObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectObjectsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchProjectObjectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchProjectObjectsQuery,
    FetchProjectObjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchProjectObjectsQuery,
    FetchProjectObjectsQueryVariables
  >(FetchProjectObjectsDocument, options);
}

export function useFetchProjectObjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchProjectObjectsQuery,
    FetchProjectObjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchProjectObjectsQuery,
    FetchProjectObjectsQueryVariables
  >(FetchProjectObjectsDocument, options);
}

export type FetchProjectObjectsQueryHookResult = ReturnType<
  typeof useFetchProjectObjectsQuery
>;
export type FetchProjectObjectsLazyQueryHookResult = ReturnType<
  typeof useFetchProjectObjectsLazyQuery
>;
export type FetchProjectObjectsQueryResult = Apollo.QueryResult<
  FetchProjectObjectsQuery,
  FetchProjectObjectsQueryVariables
>;
export const FetchTeamProjectsDocument = gql`
  query FetchTeamProjects($teamId: String!) {
    fetchTeam(teamId: $teamId) {
      id
      teamId
      projects
    }
  }
`;

/**
 * __useFetchTeamProjectsQuery__
 *
 * To run a query within a React component, call `useFetchTeamProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamProjectsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchTeamProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTeamProjectsQuery,
    FetchTeamProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchTeamProjectsQuery,
    FetchTeamProjectsQueryVariables
  >(FetchTeamProjectsDocument, options);
}

export function useFetchTeamProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTeamProjectsQuery,
    FetchTeamProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchTeamProjectsQuery,
    FetchTeamProjectsQueryVariables
  >(FetchTeamProjectsDocument, options);
}

export type FetchTeamProjectsQueryHookResult = ReturnType<
  typeof useFetchTeamProjectsQuery
>;
export type FetchTeamProjectsLazyQueryHookResult = ReturnType<
  typeof useFetchTeamProjectsLazyQuery
>;
export type FetchTeamProjectsQueryResult = Apollo.QueryResult<
  FetchTeamProjectsQuery,
  FetchTeamProjectsQueryVariables
>;
export const FetchCollectionTeamStylesDocument = gql`
  query FetchCollectionTeamStyles($teamId: String!) {
    fetchCollectionTeamStyles(teamId: $teamId) {
      id
      styleId
      definition
      name
      type
      updatedAt
    }
  }
`;

/**
 * __useFetchCollectionTeamStylesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTeamStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTeamStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTeamStylesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchCollectionTeamStylesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionTeamStylesQuery,
    FetchCollectionTeamStylesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTeamStylesQuery,
    FetchCollectionTeamStylesQueryVariables
  >(FetchCollectionTeamStylesDocument, options);
}

export function useFetchCollectionTeamStylesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTeamStylesQuery,
    FetchCollectionTeamStylesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTeamStylesQuery,
    FetchCollectionTeamStylesQueryVariables
  >(FetchCollectionTeamStylesDocument, options);
}

export type FetchCollectionTeamStylesQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamStylesQuery
>;
export type FetchCollectionTeamStylesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamStylesLazyQuery
>;
export type FetchCollectionTeamStylesQueryResult = Apollo.QueryResult<
  FetchCollectionTeamStylesQuery,
  FetchCollectionTeamStylesQueryVariables
>;
export const FetchTeamStyleDocument = gql`
  query FetchTeamStyle($styleId: String!) {
    fetchTeamStyle(styleId: $styleId) {
      id
      styleId
      definition
      name
      type
      updatedAt
    }
  }
`;

/**
 * __useFetchTeamStyleQuery__
 *
 * To run a query within a React component, call `useFetchTeamStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamStyleQuery({
 *   variables: {
 *      styleId: // value for 'styleId'
 *   },
 * });
 */
export function useFetchTeamStyleQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTeamStyleQuery,
    FetchTeamStyleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchTeamStyleQuery, FetchTeamStyleQueryVariables>(
    FetchTeamStyleDocument,
    options,
  );
}

export function useFetchTeamStyleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTeamStyleQuery,
    FetchTeamStyleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchTeamStyleQuery, FetchTeamStyleQueryVariables>(
    FetchTeamStyleDocument,
    options,
  );
}

export type FetchTeamStyleQueryHookResult = ReturnType<
  typeof useFetchTeamStyleQuery
>;
export type FetchTeamStyleLazyQueryHookResult = ReturnType<
  typeof useFetchTeamStyleLazyQuery
>;
export type FetchTeamStyleQueryResult = Apollo.QueryResult<
  FetchTeamStyleQuery,
  FetchTeamStyleQueryVariables
>;
export const FetchCollectionTeamAssetImagesDocument = gql`
  query FetchCollectionTeamAssetImages($teamId: String!) {
    fetchTeam(teamId: $teamId) {
      id
      teamId
      assetImages
    }
  }
`;

/**
 * __useFetchCollectionTeamAssetImagesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTeamAssetImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTeamAssetImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTeamAssetImagesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchCollectionTeamAssetImagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionTeamAssetImagesQuery,
    FetchCollectionTeamAssetImagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTeamAssetImagesQuery,
    FetchCollectionTeamAssetImagesQueryVariables
  >(FetchCollectionTeamAssetImagesDocument, options);
}

export function useFetchCollectionTeamAssetImagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTeamAssetImagesQuery,
    FetchCollectionTeamAssetImagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTeamAssetImagesQuery,
    FetchCollectionTeamAssetImagesQueryVariables
  >(FetchCollectionTeamAssetImagesDocument, options);
}

export type FetchCollectionTeamAssetImagesQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamAssetImagesQuery
>;
export type FetchCollectionTeamAssetImagesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamAssetImagesLazyQuery
>;
export type FetchCollectionTeamAssetImagesQueryResult = Apollo.QueryResult<
  FetchCollectionTeamAssetImagesQuery,
  FetchCollectionTeamAssetImagesQueryVariables
>;
export const FetchTeamDocument = gql`
  query FetchTeam($teamId: String!) {
    fetchTeam(teamId: $teamId) {
      id
      teamId
      default
      name
      owner
      members
      projects
      invitations
      subscription
      connectors
    }
  }
`;

/**
 * __useFetchTeamQuery__
 *
 * To run a query within a React component, call `useFetchTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchTeamQuery(
  baseOptions: Apollo.QueryHookOptions<FetchTeamQuery, FetchTeamQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchTeamQuery, FetchTeamQueryVariables>(
    FetchTeamDocument,
    options,
  );
}

export function useFetchTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTeamQuery,
    FetchTeamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchTeamQuery, FetchTeamQueryVariables>(
    FetchTeamDocument,
    options,
  );
}

export type FetchTeamQueryHookResult = ReturnType<typeof useFetchTeamQuery>;
export type FetchTeamLazyQueryHookResult = ReturnType<
  typeof useFetchTeamLazyQuery
>;
export type FetchTeamQueryResult = Apollo.QueryResult<
  FetchTeamQuery,
  FetchTeamQueryVariables
>;
export const FetchTeamBrandKitDocument = gql`
  query FetchTeamBrandKit($teamId: String!) {
    fetchTeam(teamId: $teamId) {
      id
      teamId
      logos
      fonts
      assetImages
    }
  }
`;

/**
 * __useFetchTeamBrandKitQuery__
 *
 * To run a query within a React component, call `useFetchTeamBrandKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamBrandKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamBrandKitQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchTeamBrandKitQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTeamBrandKitQuery,
    FetchTeamBrandKitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchTeamBrandKitQuery,
    FetchTeamBrandKitQueryVariables
  >(FetchTeamBrandKitDocument, options);
}

export function useFetchTeamBrandKitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTeamBrandKitQuery,
    FetchTeamBrandKitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchTeamBrandKitQuery,
    FetchTeamBrandKitQueryVariables
  >(FetchTeamBrandKitDocument, options);
}

export type FetchTeamBrandKitQueryHookResult = ReturnType<
  typeof useFetchTeamBrandKitQuery
>;
export type FetchTeamBrandKitLazyQueryHookResult = ReturnType<
  typeof useFetchTeamBrandKitLazyQuery
>;
export type FetchTeamBrandKitQueryResult = Apollo.QueryResult<
  FetchTeamBrandKitQuery,
  FetchTeamBrandKitQueryVariables
>;
export const FetchUserTeamsDocument = gql`
  query FetchUserTeams($userId: String) {
    fetchCollectionUserTeams(userId: $userId) {
      id
      teamId
      name
      projects
      default
      userPermissions
      owner
    }
  }
`;

/**
 * __useFetchUserTeamsQuery__
 *
 * To run a query within a React component, call `useFetchUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserTeamsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchUserTeamsQuery,
    FetchUserTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchUserTeamsQuery, FetchUserTeamsQueryVariables>(
    FetchUserTeamsDocument,
    options,
  );
}

export function useFetchUserTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchUserTeamsQuery,
    FetchUserTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchUserTeamsQuery, FetchUserTeamsQueryVariables>(
    FetchUserTeamsDocument,
    options,
  );
}

export type FetchUserTeamsQueryHookResult = ReturnType<
  typeof useFetchUserTeamsQuery
>;
export type FetchUserTeamsLazyQueryHookResult = ReturnType<
  typeof useFetchUserTeamsLazyQuery
>;
export type FetchUserTeamsQueryResult = Apollo.QueryResult<
  FetchUserTeamsQuery,
  FetchUserTeamsQueryVariables
>;
export const FetchCollectionTeamFontsDocument = gql`
  query FetchCollectionTeamFonts($teamId: String!) {
    fetchCollectionTeamFonts(teamId: $teamId) {
      id
      fontId
      userId
      teamId
      name
      family
      style
      weight
      weightName
      postScript
      format
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useFetchCollectionTeamFontsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTeamFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTeamFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTeamFontsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchCollectionTeamFontsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionTeamFontsQuery,
    FetchCollectionTeamFontsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTeamFontsQuery,
    FetchCollectionTeamFontsQueryVariables
  >(FetchCollectionTeamFontsDocument, options);
}

export function useFetchCollectionTeamFontsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTeamFontsQuery,
    FetchCollectionTeamFontsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTeamFontsQuery,
    FetchCollectionTeamFontsQueryVariables
  >(FetchCollectionTeamFontsDocument, options);
}

export type FetchCollectionTeamFontsQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamFontsQuery
>;
export type FetchCollectionTeamFontsLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamFontsLazyQuery
>;
export type FetchCollectionTeamFontsQueryResult = Apollo.QueryResult<
  FetchCollectionTeamFontsQuery,
  FetchCollectionTeamFontsQueryVariables
>;
export const FetchCollectionTeamLogosDocument = gql`
  query FetchCollectionTeamLogos($teamId: String!) {
    fetchTeam(teamId: $teamId) {
      id
      teamId
      logos
    }
  }
`;

/**
 * __useFetchCollectionTeamLogosQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTeamLogosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTeamLogosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTeamLogosQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchCollectionTeamLogosQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionTeamLogosQuery,
    FetchCollectionTeamLogosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTeamLogosQuery,
    FetchCollectionTeamLogosQueryVariables
  >(FetchCollectionTeamLogosDocument, options);
}

export function useFetchCollectionTeamLogosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTeamLogosQuery,
    FetchCollectionTeamLogosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTeamLogosQuery,
    FetchCollectionTeamLogosQueryVariables
  >(FetchCollectionTeamLogosDocument, options);
}

export type FetchCollectionTeamLogosQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamLogosQuery
>;
export type FetchCollectionTeamLogosLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamLogosLazyQuery
>;
export type FetchCollectionTeamLogosQueryResult = Apollo.QueryResult<
  FetchCollectionTeamLogosQuery,
  FetchCollectionTeamLogosQueryVariables
>;
export const FetchCollectionTeamTokensDocument = gql`
  query FetchCollectionTeamTokens($teamId: String!) {
    fetchCollectionTeamTokens(teamId: $teamId) {
      id
      teamTokenId
      name
      value
      createdAt
      updatedAt
      lastLoginAt
    }
  }
`;

/**
 * __useFetchCollectionTeamTokensQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTeamTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTeamTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTeamTokensQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFetchCollectionTeamTokensQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCollectionTeamTokensQuery,
    FetchCollectionTeamTokensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTeamTokensQuery,
    FetchCollectionTeamTokensQueryVariables
  >(FetchCollectionTeamTokensDocument, options);
}

export function useFetchCollectionTeamTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTeamTokensQuery,
    FetchCollectionTeamTokensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTeamTokensQuery,
    FetchCollectionTeamTokensQueryVariables
  >(FetchCollectionTeamTokensDocument, options);
}

export type FetchCollectionTeamTokensQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamTokensQuery
>;
export type FetchCollectionTeamTokensLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTeamTokensLazyQuery
>;
export type FetchCollectionTeamTokensQueryResult = Apollo.QueryResult<
  FetchCollectionTeamTokensQuery,
  FetchCollectionTeamTokensQueryVariables
>;
export const FetchCollectionTemplatesDocument = gql`
  query FetchCollectionTemplates(
    $filters: [Filter!]
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchCollectionTemplates(
      filters: $filters
      sort: $sort
      paginate: $paginate
    ) {
      collection {
        id
        templateId
        name
        previewImageId
        templateGroupId
        isFavourite
        tags
        styles
        templateGroupTemplates
      }
      paginationInfo {
        itemsPerPage
        lastPage
        totalCount
      }
    }
  }
`;

/**
 * __useFetchCollectionTemplatesQuery__
 *
 * To run a query within a React component, call `useFetchCollectionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchCollectionTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCollectionTemplatesQuery,
    FetchCollectionTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchCollectionTemplatesQuery,
    FetchCollectionTemplatesQueryVariables
  >(FetchCollectionTemplatesDocument, options);
}

export function useFetchCollectionTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCollectionTemplatesQuery,
    FetchCollectionTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchCollectionTemplatesQuery,
    FetchCollectionTemplatesQueryVariables
  >(FetchCollectionTemplatesDocument, options);
}

export type FetchCollectionTemplatesQueryHookResult = ReturnType<
  typeof useFetchCollectionTemplatesQuery
>;
export type FetchCollectionTemplatesLazyQueryHookResult = ReturnType<
  typeof useFetchCollectionTemplatesLazyQuery
>;
export type FetchCollectionTemplatesQueryResult = Apollo.QueryResult<
  FetchCollectionTemplatesQuery,
  FetchCollectionTemplatesQueryVariables
>;
export const FetchFavouritesCollectionTemplatesDocument = gql`
  query FetchFavouritesCollectionTemplates(
    $sort: [Sort!]
    $paginate: Paginate
  ) {
    fetchFavouritesCollectionTemplates(sort: $sort, paginate: $paginate) {
      collection {
        id
        templateId
        name
        previewImageId
        templateGroupId
        isFavourite
      }
      paginationInfo {
        itemsPerPage
        lastPage
        totalCount
      }
    }
  }
`;

/**
 * __useFetchFavouritesCollectionTemplatesQuery__
 *
 * To run a query within a React component, call `useFetchFavouritesCollectionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFavouritesCollectionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFavouritesCollectionTemplatesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useFetchFavouritesCollectionTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchFavouritesCollectionTemplatesQuery,
    FetchFavouritesCollectionTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    FetchFavouritesCollectionTemplatesQuery,
    FetchFavouritesCollectionTemplatesQueryVariables
  >(FetchFavouritesCollectionTemplatesDocument, options);
}

export function useFetchFavouritesCollectionTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchFavouritesCollectionTemplatesQuery,
    FetchFavouritesCollectionTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    FetchFavouritesCollectionTemplatesQuery,
    FetchFavouritesCollectionTemplatesQueryVariables
  >(FetchFavouritesCollectionTemplatesDocument, options);
}

export type FetchFavouritesCollectionTemplatesQueryHookResult = ReturnType<
  typeof useFetchFavouritesCollectionTemplatesQuery
>;
export type FetchFavouritesCollectionTemplatesLazyQueryHookResult = ReturnType<
  typeof useFetchFavouritesCollectionTemplatesLazyQuery
>;
export type FetchFavouritesCollectionTemplatesQueryResult = Apollo.QueryResult<
  FetchFavouritesCollectionTemplatesQuery,
  FetchFavouritesCollectionTemplatesQueryVariables
>;
export const FetchTemplateDocument = gql`
  query FetchTemplate($templateId: String!) {
    fetchTemplate(templateId: $templateId) {
      id
      templateId
      templateGroupId
      name
      previewImageId
      styles
      isFavourite
      mainSize
      tags
    }
  }
`;

/**
 * __useFetchTemplateQuery__
 *
 * To run a query within a React component, call `useFetchTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useFetchTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTemplateQuery,
    FetchTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchTemplateQuery, FetchTemplateQueryVariables>(
    FetchTemplateDocument,
    options,
  );
}

export function useFetchTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTemplateQuery,
    FetchTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchTemplateQuery, FetchTemplateQueryVariables>(
    FetchTemplateDocument,
    options,
  );
}

export type FetchTemplateQueryHookResult = ReturnType<
  typeof useFetchTemplateQuery
>;
export type FetchTemplateLazyQueryHookResult = ReturnType<
  typeof useFetchTemplateLazyQuery
>;
export type FetchTemplateQueryResult = Apollo.QueryResult<
  FetchTemplateQuery,
  FetchTemplateQueryVariables
>;
export const FetchProfileDocument = gql`
  query fetchProfile {
    fetchProfile {
      id
      userId
      email
      firstName
      lastName
      phone
      industryId
      onboarding
      defaultTeamId
    }
  }
`;

/**
 * __useFetchProfileQuery__
 *
 * To run a query within a React component, call `useFetchProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchProfileQuery,
    FetchProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<FetchProfileQuery, FetchProfileQueryVariables>(
    FetchProfileDocument,
    options,
  );
}

export function useFetchProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchProfileQuery,
    FetchProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<FetchProfileQuery, FetchProfileQueryVariables>(
    FetchProfileDocument,
    options,
  );
}

export type FetchProfileQueryHookResult = ReturnType<
  typeof useFetchProfileQuery
>;
export type FetchProfileLazyQueryHookResult = ReturnType<
  typeof useFetchProfileLazyQuery
>;
export type FetchProfileQueryResult = Apollo.QueryResult<
  FetchProfileQuery,
  FetchProfileQueryVariables
>;
